import { federationSourceHtml } from './federation_source.js?v=4ff0885b';
import {nationalGroupLabel} from './national_groups.js?v=52d7808e';
// Immediate auth token capture from hash or search query params (?token=... or #...&token=...)
try {
  const _tokenM = (location.hash || '').match(/[?&]token=([^&]+)/) || (location.search || '').match(/[?&]token=([^&]+)/);
  if (_tokenM) {
    localStorage.setItem('fmgto_hub_token', decodeURIComponent(_tokenM[1]));
    // токен входа не оставляем в адресной строке и истории браузера
    const clean = location.href.replace(/([?&#])token=[^&#]*&?/, '$1').replace(/[?&#]$/, '').replace(/\?&/, '?').replace(/#&/, '#');
    history.replaceState(history.state, '', clean);
  }
} catch (_) {}
try { installShareUrls(); } catch (_) {}   // до первого перехода: адреса экранов сразу с ?p=

export let GTO_CALENDAR_EVENTS = [];
export let GTO_OFFICIAL_NEWS = [];
export let GTO_RECORDS = [];
export let GTO_VIDEOS = [];
export let GTO_FEDERATIONS = [];
// сколько региональных отделений: без центрального аппарата (code RU)
const regionalFedCount = () => GTO_FEDERATIONS.filter((f) => String(f.code) !== 'RU').length;
export let GTO_FEDERATION_INFO = null;
export let HOME_SUMMARY = null;

// Dynamic CSS loader (v169)
const loadedScreenCss = new Set();
export function loadScreenCss(href) {
  if (loadedScreenCss.has(href)) return Promise.resolve();
  return new Promise((resolve) => {
    const existing = document.querySelector(`link[href*="${href}"]`);
    if (existing) {
      loadedScreenCss.add(href);
      return resolve();
    }
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.onload = () => {
      loadedScreenCss.add(href);
      resolve();
    };
    link.onerror = () => {
      console.warn('Failed to load screen CSS:', href);
      resolve();
    };
    document.head.appendChild(link);
  });
}

import './csp_events.js?v=15c95bed';
import { installShareUrls } from './share_url.js?v=fb7c3a5c';   // ?p= в адресе — превью ссылки на экран (Telegram, VK, iMessage)   // первым: ловит ошибки картинок и клики data-act до отрисовки экранов
import { buildIcs } from './ics.js?v=f832e04d';
import { getTournamentByAlbumId, getTournamentByVideoUrl, getTournamentMedia } from './tournament_media.js?v=d2b98a70';
// Нормативы ГТО (~200 КБ) нужны только калькулятору — грузим при первом открытии, а не в критическом пути старта
export let GTO_STAGES, getStageByAge, getNormsForStage, evaluateTest, getBadgeRequirements, MANDATORY_TEST_IDS, MANDATORY_GROUPS, GTO_OVZ_CATEGORIES, getOvzNorms;
let normsDataPromise = null;
export function ensureNormsData() {
  if (!normsDataPromise) {
    normsDataPromise = Promise.all([import('./gto_norms_data.js?v=a726b772'), import('./gto_ovz_data.js?v=8c20a5b8')]).then(([n, o]) => {
      ({ GTO_STAGES, getStageByAge, getNormsForStage, evaluateTest, getBadgeRequirements, MANDATORY_TEST_IDS, MANDATORY_GROUPS } = n);
      ({ GTO_OVZ_CATEGORIES, getOvzNorms } = o);
    }).catch(err => { normsDataPromise = null; throw err; });
  }
  return normsDataPromise;
}
import { GTO_AMBASSADORS } from './ambassadors_data.js?v=922dcd4f';
import { GTO_FAQ_CATEGORIES, GTO_FAQ_ITEMS } from './faq_data.js?v=61662778';
import { EVSK_DISCIPLINES, EVSK_RANKS } from './evsk_norms_data.js?v=c6719484';
import { GTO_STANDARDS } from './standards_data.js?v=8ee81d9a';
import { GTO_REGIONS, normalizeRegionName, getRegionById, buildRegionStats, getRegionsLeaderboard, DISTRICT_NAMES } from './regions_data.js?v=96483f70';
import { regionalManifest, regionalRecords, regionalRecordById } from './regional_records.js?v=ea5f4281';
import { getUnifiedRecords, addUnifiedRecord, deleteUnifiedRecord, fetchHubRecords, invalidateHubRecordsCache, getUnifiedNews, addUnifiedNews, updateUnifiedNews, deleteUnifiedNews, fetchHubNews, invalidateHubNewsCache, invalidateLegacyOverrides, createHubNews, getUnifiedEvents, saveUnifiedEvent, deleteUnifiedEvent, restoreUnifiedEvent, restoreUnifiedRecord, restoreUnifiedNewsLocal, fetchHubEvents, invalidateHubEventsCache, getUnifiedFederations, getUnifiedStandards, setSyncDataSources } from './ecosystem_sync.js?v=c857ef1a';
import { fetchMasterAthlete, fetchEventParticipants } from './master_api.js?v=636fc1d4';
import { loadSiteContent, overlayList, contentOverride } from './site_content.js?v=26e8643b';
import { isFav, toggleFav, isMe, nameKey } from './results_tools.js?v=f63edcd4';
import { renderPlatforms, renderHeroLanding, partnerBlockHtml, bindPartnerVideo, SPORTUM_DOCS } from './partner_sportum.js?v=3938d264';
import { registerGallery, galleryHtml } from './photo_gallery.js?v=17613b18';
import { bindReportButtons } from './error_report.js?v=9f774d09';
import { skeletonHtml } from './skeleton.js?v=1fbe3b10';
import { isSheetDoc, loadEventSheet, sheetLeadersHtml } from './event_sheet.js?v=ed082b76';
import { applyLive, isEngineEvent, liveCardFor, liveEditHintHtml, openLiveEditNotice, engineStartSlotHtml, mountEngineStart } from './event_live.js?v=d9b03f67';   // турниры на движке live.gto.com.ru
import { withModEdits, aboutPlainText, modEventDocs, docRowHtml, docsFromRows, mountEventPhotos } from './event_mod_edits.js?v=2c4ad8c6';
import { openVideoPlayer, videoEmbedUrl } from './video_player.js?v=095fb9f5';   // YouTube / VK Видео / RUTUBE — плеером поверх страницы, без перехода   // «Редактировать» турнир: правка модератора поверх страницы
// правила показа протокола (место словами, время с часами, направление «Иду на рекорд», пол, одноимённые команды, призёры по категориям,
// таблицы старой страницы, которых нет в протоколе) — по сверке всех протоколов со старым сайтом, 11.10.2026
import { placeOf, cellNumber, hasResult, sortRecordAttempts, hasOfficialPlaces, rowSex, splitSubgroupsBySex, teamGroups, teamsCount, podiumEntries, legacyExtraSections, eventLocation, unitFor, totalsDirection, noProtocolText, noDocsText, isTrainingCamp } from './protocol_rules.js?v=74b037af';
// kinetic-sport слой Главной (GSAP + SplitText, ~100 КБ) — аддитивный, self-init; грузим после первого кадра, а не в критическом пути
// табло цифр главной — когда браузер свободен, но не позже чем через 2,5 с (на занятом телефоне «свободно» могло не наступить долго)
(window.requestIdleCallback ? (cb) => window.requestIdleCallback(cb, { timeout: 2500 }) : (cb) => setTimeout(cb, 1200))(() => { import('./kinetic.js?v=95d3ce16').catch(() => {}); });
// Модуль рейтинга (88 КБ) нужен только на экранах рейтинга/региона/профиля — грузим при первом обращении
let ratingsMod = null, ratingsModPromise = null, ratingsListenersReady = false;
function ensureRatingsModule() {
  if (!ratingsModPromise) import('./ratings_engine.js?v=31754122').catch(() => {});   // зависимость модуля — качаем одновременно, а не после него
  if (!ratingsModPromise) ratingsModPromise = import('./ratings_module.js?v=75c8e9eb').then(m => {
    ratingsMod = m;
    if (!ratingsListenersReady) { ratingsListenersReady = true; m.initRatingsListeners(); }
    return m;
  }).catch(err => { ratingsModPromise = null; throw err; });
  return ratingsModPromise;
}
const loadRatingsData = async (...a) => (await ensureRatingsModule()).loadRatingsData(...a);
const renderRatings = async (...a) => (await ensureRatingsModule()).renderRatings(...a);
const openRatingsRegionDrilldown = async (...a) => (await ensureRatingsModule()).openRatingsRegionDrilldown(...a);
const closeRatingsRegionDrilldown = async (...a) => (await ensureRatingsModule()).closeRatingsRegionDrilldown(...a);
const renderAthleteRatingBlock = (...a) => (ratingsMod ? ratingsMod.renderAthleteRatingBlock(...a) : '');
// состояние рейтинга: чтение — из модуля (если он загружен), запись — после загрузки (порядок сохраняется: те же микрозадачи)
const ratingsState = new Proxy({}, {
  get: (_, k) => (ratingsMod ? ratingsMod.ratingsState[k] : undefined),
  set: (_, k, v) => { ensureRatingsModule().then(m => { m.ratingsState[k] = v; }).catch(() => {}); return true; }
});

// Lazy dataset loaders
let calendarPromise = null;
// Возврат с VK ID: сервер кладёт результат в адрес (#…?vk=ok|linked|busy|error|reg:<билет>) — забираем и чистим адрес до маршрутизации
(function takeVkResult() {
  const m = location.hash.match(/[?&]vk=([^&]+)/); if (!m) return;
  try { sessionStorage.setItem('fmgto_vk', decodeURIComponent(m[1])); } catch (_) {}
  history.replaceState(null, '', location.pathname + location.search + location.hash.replace(/[?&]vk=[^&]+/, ''));
})();

// Открыта ли регистрация на табло ближайших турниров (/api/lb/status, кэш 60 с): календарь и главная показывают
// «Идёт регистрация» и кнопку «Регистрация» у турниров, где заявки принимает наш сайт через табло (свой движок или leaderboards).
// Ответ: events — по номеру мероприятия, items — по номеру leaderboards.ru (старый формат). Храним оба под новым ключом
// fmgto_live_status; прежний fmgto_lb_status (только items) не трогаем.
let lbStatusPromise = null, lbStatusAt = 0;
const liveStatusOf = (x) => (x && (x.items || x.events) ? { items: x.items || {}, events: x.events || {} } : { items: x || {}, events: {} });
export function loadLbStatus() {
  if (lbStatusPromise && Date.now() - lbStatusAt < 60000) return lbStatusPromise;
  if (state.lbStatus === undefined) { try { const raw = JSON.parse(localStorage.getItem('fmgto_live_status') || 'null'); state.lbStatus = raw ? liveStatusOf(raw) : null; } catch (_) { state.lbStatus = null; } }   // последний известный — до ответа API
  lbStatusAt = Date.now();
  lbStatusPromise = fetch('/api/lb/status', { cache: 'no-store' }).then((r) => r.json()).then((d) => {
    if (!d || !d.ok || !(d.items || d.events)) return state.lbStatus;
    const next = liveStatusOf(d);
    const changed = JSON.stringify(next) !== JSON.stringify(state.lbStatus || {});
    state.lbStatus = next;
    if (changed) {   // статус пришёл после отрисовки — перерисовать списки, где он виден
      try { localStorage.setItem('fmgto_live_status', JSON.stringify(next)); } catch (_) {}
      if (state.screen === 'events') renderEvents();
      const box = $('#home-events'); if (box?.dataset.ready) { delete box.dataset.ready; renderHomeEvents(); }
      if ($('#home-main')?.childElementCount) renderHomeMain();
    }
    return state.lbStatus;
  }).catch(() => state.lbStatus);
  return lbStatusPromise;
}

export async function loadCalendar() {
  const hubEventsPromise = fetchHubEvents().catch(() => []);
  const lbStatus = Promise.race([loadLbStatus(), new Promise((res) => setTimeout(res, 2500))]);   // не держим экран дольше 2,5 с
  if (!calendarPromise) {
    calendarPromise = fetch('./data/calendar.json?v=196')
      .then(res => res.json())
      .then(data => {
        GTO_CALENDAR_EVENTS = Array.isArray(data) ? data : [];
        if (typeof window !== 'undefined') window.__GTO_CALENDAR_EVENTS = GTO_CALENDAR_EVENTS;
        setSyncDataSources({ events: GTO_CALENDAR_EVENTS });
        indexTournamentSlugs();
        setupEventYears();
        setupEventFilters();
        setupResultsFilters();
        syncDatasetCounts();
        return GTO_CALENDAR_EVENTS;
      })
      .catch(err => {
        console.warn('Failed to load calendar.json, falling back to gto_data.js', err);
        return import('./gto_data.js?v=c1c82522').then(m => {
          GTO_CALENDAR_EVENTS = m.GTO_CALENDAR_EVENTS || [];
          if (typeof window !== 'undefined') window.__GTO_CALENDAR_EVENTS = GTO_CALENDAR_EVENTS;
          setSyncDataSources({ events: GTO_CALENDAR_EVENTS });
          indexTournamentSlugs();
          setupEventYears();
          setupEventFilters();
          setupResultsFilters();
          syncDatasetCounts();
          return GTO_CALENDAR_EVENTS;
        });
      });
  }
  await Promise.all([calendarPromise, hubEventsPromise, lbStatus]);
  return GTO_CALENDAR_EVENTS;
}

let newsPromise = null;
export async function loadNews() {
  const hubPromise = fetchHubNews().catch(() => []);
  if (!newsPromise) {
    newsPromise = fetch('./data/news.json?v=234')
      .then(res => res.json())
      .catch(err => {
        console.warn('Failed to load news.json, falling back to gto_data.js', err);
        return import('./gto_data.js?v=c1c82522').then(m => m.GTO_OFFICIAL_NEWS || []);
      })
      .then((officialData) => {
        GTO_OFFICIAL_NEWS = Array.isArray(officialData) ? officialData : [];
        if (typeof window !== 'undefined') window.__GTO_OFFICIAL_NEWS = GTO_OFFICIAL_NEWS;
        setSyncDataSources({ news: GTO_OFFICIAL_NEWS });
        setupNewsFilters();
        return GTO_OFFICIAL_NEWS;
      });
  }
  await Promise.all([newsPromise, hubPromise]);
  return GTO_OFFICIAL_NEWS;
}

let recordsPromise = null;
export async function loadRecords() {
  const hubRecordsPromise = fetchHubRecords().catch(() => []);
  if (!recordsPromise) {
    recordsPromise = fetch('./data/records.json?v=196')
      .then(res => res.json())
      .then(data => {
        GTO_RECORDS = Array.isArray(data) ? data : [];
        if (typeof window !== 'undefined') window.__GTO_RECORDS = GTO_RECORDS;
        setSyncDataSources({ records: GTO_RECORDS });
        setupRecordFilters();
        return GTO_RECORDS;
      })
      .catch(err => {
        console.warn('Failed to load records.json, falling back to gto_data.js', err);
        return import('./gto_data.js?v=c1c82522').then(m => {
          GTO_RECORDS = m.GTO_RECORDS || [];
          if (typeof window !== 'undefined') window.__GTO_RECORDS = GTO_RECORDS;
          setSyncDataSources({ records: GTO_RECORDS });
          setupRecordFilters();
          return GTO_RECORDS;
        });
      });
  }
  await Promise.all([recordsPromise, hubRecordsPromise]);
  return GTO_RECORDS;
}

let videosPromise = null;
// видео из data/videos.json + добавленные/исправленные модераторами (скрытые — убраны)
let BASE_VIDEOS = [];
function applyVideoContent() {
  if (!BASE_VIDEOS.length && !GTO_VIDEOS.length) return;
  GTO_VIDEOS = overlayList('videos', BASE_VIDEOS, (v) => 'v-' + v.id).map((v) => (v._custom ? { ...v, id: v._cid } : v));
  if (typeof window !== 'undefined') { window.__GTO_VIDEOS = GTO_VIDEOS; window.__GTO_BASE_VIDEOS = BASE_VIDEOS; }
  setSyncDataSources({ videos: GTO_VIDEOS });
  sortGtoVideos();
}
export async function loadVideos() {
  if (GTO_VIDEOS.length > 0) return GTO_VIDEOS;
  if (!videosPromise) {
    videosPromise = fetch('./data/videos.json?v=197')
      .then(res => res.json())
      .then(data => {
        BASE_VIDEOS = Array.isArray(data) ? data : [];
        applyVideoContent();
        syncDatasetCounts();
        return GTO_VIDEOS;
      })
      .catch(err => {
        console.warn('Failed to load videos.json, falling back to gto_data.js', err);
        return import('./gto_data.js?v=c1c82522').then(m => {
          BASE_VIDEOS = m.GTO_VIDEOS || [];
          applyVideoContent();
          syncDatasetCounts();
          return GTO_VIDEOS;
        });
      });
  }
  return videosPromise;
}

let federationsPromise = null;
export async function loadFederations() {
  if (GTO_FEDERATIONS.length > 0) return GTO_FEDERATIONS;
  if (!federationsPromise) {
    federationsPromise = fetch('./data/federations.json?v=20261103b')
      .then(res => res.json())
      .then(data => {
        GTO_FEDERATIONS = data.federations || [];
        GTO_FEDERATION_INFO = data.info || null;
        if (typeof window !== 'undefined') {
          window.__GTO_FEDERATIONS = GTO_FEDERATIONS;
          window.__GTO_FEDERATION_INFO = GTO_FEDERATION_INFO;
        }
        setSyncDataSources({ federations: GTO_FEDERATIONS });
        syncDatasetCounts();
        return GTO_FEDERATIONS;
      })
      .catch(err => {
        console.warn('Failed to load federations.json, falling back to gto_data.js', err);
        return import('./gto_data.js?v=c1c82522').then(m => {
          GTO_FEDERATIONS = m.GTO_FEDERATIONS || [];
          GTO_FEDERATION_INFO = m.GTO_FEDERATION_INFO || null;
          if (typeof window !== 'undefined') {
            window.__GTO_FEDERATIONS = GTO_FEDERATIONS;
            window.__GTO_FEDERATION_INFO = GTO_FEDERATION_INFO;
          }
          setSyncDataSources({ federations: GTO_FEDERATIONS });
          syncDatasetCounts();
          return GTO_FEDERATIONS;
        });
      });
  }
  return federationsPromise;
}

let homeSummaryPromise = null;
export async function loadHomeSummary() {
  if (HOME_SUMMARY) return HOME_SUMMARY;
  if (!homeSummaryPromise) {
    homeSummaryPromise = fetch('./data/home_summary.json?v=205')
      .then(res => res.json())
      .then(data => {
        HOME_SUMMARY = data;
        syncDatasetCounts();
        return HOME_SUMMARY;
      })
      .catch(err => {
        console.warn('Failed to load home_summary.json', err);
        return null;
      });
  }
  return homeSummaryPromise;
}

let _resultsManifestPromise = null;
export async function loadResultsManifest() {
  if (state.resultsManifest) return state.resultsManifest;
  if (!_resultsManifestPromise) {
    _resultsManifestPromise = fetch('./data/results/manifest.json?v=204')
      .then(r => r.json())
      .then(m => {
        state.resultsManifest = m;
        return m;
      })
      .catch(err => {
        console.warn('Failed to load results manifest:', err);
        return { events: {} };
      });
  }
  return _resultsManifestPromise;
}

// протокол турнира — только если он есть в data/results/manifest.json (иначе 404 в журнале и лишний запрос)
export async function fetchResultsJson(eventId) {
  const m = await loadResultsManifest();
  if (!m.events || !m.events[String(eventId)]) return null;
  const r = await fetch(`./data/results/${eventId}.json?v=92`);
  return r.ok ? r : null;
}

export async function ensureScreenData(screen) {
  switch (screen) {
    case 'home':
      await Promise.all([loadHomeSummary(), loadNews()]);
      break;
    case 'events':
    case 'event':
      await loadCalendar();
      break;
    case 'results':
      await Promise.all([loadCalendar(), loadResultsManifest()]);
      break;
    case 'news':
    case 'article':
      await Promise.all([loadNews(), loadCalendar()]);
      break;
    case 'records':
    case 'record':
      await loadRecords();
      break;
    case 'media':
      await Promise.all([loadVideos(), loadCalendar()]);
      break;
    case 'regions':
    case 'region':
      await Promise.all([loadFederations(), loadCalendar(), loadRecords(), loadRatingsData()]);
      break;
    case 'athlete-search':
      await loadCalendar();
      break;
    case 'athlete':
      // рейтинг (10 МБ) не нужен: место в рейтинге — в карточке data/athletes/<ATH>.json; модуль блока рейтинга — параллельно с календарём
      await Promise.all([loadCalendar(), ensureRatingsModule().catch(() => {})]);
      break;
    case 'ratings':
      await loadRatingsData();
      break;
  }
}



// Ленивая подгрузка фотобазы VK (2.3 МБ) по требованию (v169)
export let GTO_VK_ALBUMS = [];
let _vkAlbumsPromise = null;
export async function getVkAlbums() {
  if (!_vkAlbumsPromise) {
    _vkAlbumsPromise = import('./vk_albums_data.js?v=bcc1fdc7')
      .then(m => {
        GTO_VK_ALBUMS = m.GTO_VK_ALBUMS || [];
        // tournament_media.js ищет альбомы турнира в window — без этого вкладка «Фото» турнира всегда была пустой
        if (typeof window !== 'undefined') window.__GTO_VK_ALBUMS = GTO_VK_ALBUMS;
        return GTO_VK_ALBUMS;
      })
      .catch(err => {
        console.warn('Failed to load vk_albums_data:', err);
        return [];
      });
  }
  return _vkAlbumsPromise;
}

// Ленивая подгрузка модуля «Герой ГТО» (369 КБ) (v169)
let _heroModulePromise = null;
export async function getHeroModule() {
  if (!_heroModulePromise) {
    _heroModulePromise = import('./herogto_module.js?v=034dbe40');
  }
  return _heroModulePromise;
}
export async function initHeroGtoScreen(...args) {
  const m = await getHeroModule();
  return m.initHeroGtoScreen(...args);
}
export async function initHeroHubScreen(...args) {
  const m = await getHeroModule();
  return m.initHeroHubScreen(...args);
}
export async function setHeroActiveTournament(...args) {
  const m = await getHeroModule();
  return m.setHeroActiveTournament(...args);
}
export async function renderPassportScreen(...args) {
  const m = await getHeroModule();
  return m.renderPassportScreen(...args);
}
export async function setActiveHeroTab(...args) {
  const m = await getHeroModule();
  return m.setActiveHeroTab(...args);
}


let adminModulePromise = null;
export function getAdminModule() {
  if (!adminModulePromise) adminModulePromise = import('./admin_module.js?v=06320121');
  return adminModulePromise;
}

let inboxModulePromise = null;
export function getInboxModule() {
  if (!inboxModulePromise) inboxModulePromise = import('./inbox_module.js?v=b0f189fa');
  return inboxModulePromise;
}

function getVideoDateScore(v) {
  let dateStr = v.date && /^\d{4}-\d{2}-\d{2}/.test(v.date) ? v.date.slice(0, 10) : '';   // видео, добавленные модератором, — по дате добавления
  if (!dateStr && v.thumb) {
    const m = v.thumb.match(/(\d{4}-\d{2}-\d{2})/);
    if (m) dateStr = m[1];
  }
  if (!dateStr) {
    dateStr = (v.year || 2020) + '-01-01';
  }
  return dateStr;
}

export let SORTED_GTO_VIDEOS = [];
export function sortGtoVideos() {
  SORTED_GTO_VIDEOS = [...GTO_VIDEOS].sort((a, b) => {
    const da = getVideoDateScore(a);
    const db = getVideoDateScore(b);
    if (da !== db) return db.localeCompare(da);
    const dayA = Number((a.title.match(/день\s*(\d+)/i) || [])[1] || 0);
    const dayB = Number((b.title.match(/день\s*(\d+)/i) || [])[1] || 0);
    if (dayA !== dayB) return dayB - dayA;
    return Number(b.id) - Number(a.id);
  });
}

export const state = {
  screen: (() => {
    let s = (location.hash || '').slice(1).split('?')[0].split('/')[0] || 'home';
    if (s === 'herogto' || s === 'hero-gto') s = 'hero';
    return s;
  })(),
  eventYear: 'all',
  eventLevel: 'all',
  eventStatus: 'all',
  eventFormat: 'all',
  eventProgram: 'all',
  eventCity: 'all',
  eventType: 'all',
  eventQuery: '',
  newsQuery: '',
  newsYear: 'all',
  newsType: 'all',
  newsEvent: 'all',
  recordQuery: '',
  recordLimit: 30,
  sex: 'ALL',
  age: 'all',
  discipline: 'all',
  group: 'discipline',
  media: 'video',
  mediaLinkFilter: 'all',
  videoPlatform: 'all',
  mediaYear: 'all',
  mediaQuery: '',
  videoLimit: 24,
  albumLimit: 24,
  activeMediaVideo: null,
  eventResultQuery: '',
  eventResultCategory: 'all',
  eventResultSex: 'all',
  eventResultAge: 'all',
  eventResultComplex: 'all',
  eventResultStanding: 'all',
  eventResultRegion: 'all',
  eventResultSort: '',
  eventResultPrintAll: false,
  currentEventResults: null,
  currentEventId: null,
  currentEventMediaHtml: '',
  regionQuery: '',
  districtQuery: 'all',
  regionsView: 'catalog',   // первым — реестр отделений, рейтинг второй вкладкой
  regionsSortBy: 'points',
  mapMode: 'athletes',
  selectedRegionId: null,
  currentRegionId: null,
  regionStats: null,
  regionSummary: null,
  mapZoom: 1,
  mapPanX: 0,
  mapPanY: 0,
  mapSvgLoaded: false,
  eventManifest: { events: {} },
  vkLocal: { albums: {} },
  videoThumbs: {},
  gallery: null,
  // Calculator & Athlete Search
  calcAge: 25,
  calcSex: 'M',
  calcValues: {},
  calcSelectedAlt: {
    speed: 'run_short',
    endurance: 'run_long',
    strength: 'pull_up',
    flexibility: 'lean'
  },
  calcMode: 'general', // 'general' | 'ovz'
  calcOvzCategory: 'hearing', // 'hearing' | 'vision' | 'poda_limb' | 'poda_wheelchair' | 'cp' | 'intellect'
  faqCategory: 'all',
  faqQuery: '',
  faqExpanded: new Set(),
  athleteQuery: '',
  athleteIndex: null,
  athleteLoading: false,
  deferredPrompt: null,
  shareData: null,
  // Standards & Timer
  standardCat: 'all',
  // Scroll restoration
  eventsScrollTop: 0,
  lastEventId: null,
  // Navigation return state
  athleteReturnScreen: null,
  athleteReturnEventId: null,
  athleteReturnPane: null,
  selectedAthleteId: null,
  selectedAthlete: null,
  athleteProfileReturnScreen: 'athlete-search',
  selectedRecordId: null,
  selectedRecord: null,
  recordReturnScreen: 'records',
  _lastOverallBadge: 'none'
};
window.state = state;

// Restore calculator state from localStorage (A2)
try {
  const savedCalc = JSON.parse(localStorage.getItem('gto_calc_v1') || 'null');
  if (savedCalc && typeof savedCalc === 'object') {
    if (typeof savedCalc.age === 'number' && savedCalc.age >= 6 && savedCalc.age <= 85) state.calcAge = savedCalc.age;
    if (savedCalc.sex === 'M' || savedCalc.sex === 'W') state.calcSex = savedCalc.sex;
    if (savedCalc.mode === 'general' || savedCalc.mode === 'ovz') state.calcMode = savedCalc.mode;
    if (savedCalc.ovzCategory) state.calcOvzCategory = savedCalc.ovzCategory;
    if (savedCalc.values && typeof savedCalc.values === 'object') state.calcValues = savedCalc.values;
    if (savedCalc.selectedAlt && typeof savedCalc.selectedAlt === 'object') {
      state.calcSelectedAlt = Object.assign(state.calcSelectedAlt, savedCalc.selectedAlt);
    }
  }
} catch (e) {}

export function saveCalculatorState() {
  try {
    localStorage.setItem('gto_calc_v1', JSON.stringify({
      age: state.calcAge,
      sex: state.calcSex,
      mode: state.calcMode,
      ovzCategory: state.calcOvzCategory,
      values: state.calcValues,
      selectedAlt: state.calcSelectedAlt
    }));
  } catch (e) {}
}

const valid = new Set(['team', 
  'home', 'events', 'event', 'results', 'news', 'article', 'media', 'records', 'record', 'more',
  'about', 'history', 'brand', 'disciplines', 'structure', 'documents', 'antidoping', 'platforms',
  'regions', 'region', 'ratings', 'calculator', 'athlete-search', 'athlete', 'timer', 'standards', 'hero', 'herohub', 'passport', 'admin', 'inbox',
  'path', 'ambassadors', 'faq'
]);
// Разделы, временно скрытые с сайта: пункты меню и ссылки убираются со страницы, прямой адрес ведёт на главную.
// Вернуть раздел — убрать его из этого списка (код и данные раздела не тронуты).
const HIDDEN_SCREENS = ['ambassadors'];   // «Звёзды и амбассадоры» скрыты 01.10.2026 по решению Федерации — до обновления состава
HIDDEN_SCREENS.forEach((scr) => { valid.delete(scr); if (typeof document !== 'undefined') document.querySelectorAll(`[data-go="${scr}"]`).forEach((el) => el.remove()); });

export function getTournamentTitleClass(title) {
  const len = (title || '').trim().length;
  if (len > 45) return 'title-extra-long is-long-title';
  if (len >= 28) return 'title-long is-long-title';
  return 'title-normal';
}

export const TOURNAMENT_BY_SLUG = {};
export function indexTournamentSlugs() {
  GTO_CALENDAR_EVENTS.forEach(ev => {
    if (ev.id) {
      TOURNAMENT_BY_SLUG[ev.id] = ev;
      TOURNAMENT_BY_SLUG[String(ev.id)] = ev;
      TOURNAMENT_BY_SLUG[`EVT-${String(ev.id).padStart(4, '0')}`] = ev;
    }
    const slug = (ev.url || '').replace(/.*\/sorevnovaniya\/?/, '').replace(/\/$/, '');
    if (slug) TOURNAMENT_BY_SLUG[slug] = ev;
    if (ev.slug) TOURNAMENT_BY_SLUG[ev.slug] = ev;
  });
}

// Номер турнира на сайте, который сервер положил в выступление (id = legacy_id календаря или 1000 + tournament_id).
// Это точная связь из базы — её не надо угадывать по названию.
export function competitionEventId(c) {
  const n = Number(c && c.id);
  return Number.isInteger(n) && n > 0 ? n : null;
}

function findTournamentForCompetition(c) {
  if (!c) return null;
  const exactId = competitionEventId(c);
  if (exactId) {
    const hit = TOURNAMENT_BY_SLUG[exactId] || GTO_CALENDAR_EVENTS.find(ev => Number(ev.id) === exactId);
    if (hit) return hit;
  }
  if (c.event_id && TOURNAMENT_BY_SLUG[c.event_id]) return TOURNAMENT_BY_SLUG[c.event_id];
  if (c.id && TOURNAMENT_BY_SLUG[c.id]) return TOURNAMENT_BY_SLUG[c.id];
  if (c.tournament_slug && TOURNAMENT_BY_SLUG[c.tournament_slug]) return TOURNAMENT_BY_SLUG[c.tournament_slug];

  const rawSlug = (c.tournament_slug || '').toLowerCase();
  const rawTitle = (c.tournament_title || '').toLowerCase().replace(/[^a-z0-9а-яё]/gi, '');

  return GTO_CALENDAR_EVENTS.find(ev => {
    if (rawSlug && (ev.url || '').toLowerCase().includes(rawSlug)) return true;
    if (rawSlug && ev.slug && ev.slug.toLowerCase() === rawSlug) return true;
    if (rawTitle) {
      const evT = (ev.title || '').toLowerCase().replace(/[^a-z0-9а-яё]/gi, '');
      if (evT && (evT.includes(rawTitle) || rawTitle.includes(evT))) return true;
    }
    return false;
  }) || null;
}

export const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const clean = v => String(v || '').replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
export const esc = v => clean(v).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
// картинки старого сайта Федерации (gto.com.ru), перенесённые к нам: assets/legacy/<путь>.webp, список — data/legacy_images.json.
// Подменяем адрес только для перенесённых файлов; пока список не загрузился (первые мгновения) — остаётся исходный адрес.
let LEGACY_IMAGES = new Set();
fetch('./data/legacy_images.json', { cache: 'no-cache' }).then((r) => (r.ok ? r.json() : [])).then((a) => { LEGACY_IMAGES = new Set(a); }).catch(() => {});
function legacyLocal(u) {
  const m = String(u || '').trim().match(/^https?:\/\/(?:www\.)?gto\.com\.ru\/(.+?)\.(?:jpe?g|png|webp|gif)(\.pagespeed\.[^/]*)?$/i);
  if (!m || !LEGACY_IMAGES.size) return '';
  if (LEGACY_IMAGES.has(m[1])) return `./assets/legacy/${m[1]}.webp`;
  const i = m[1].lastIndexOf('/'); const alt = `${m[1].slice(0, i)}/${m[1].slice(i + 1).replace(/^x/, '')}`;   // «x123.jpg.pagespeed…» — превью оригинала 123.jpg
  return LEGACY_IMAGES.has(alt) ? `./assets/legacy/${alt}.webp` : '';
}
const safeUrl = v => /^https?:\/\//.test(v || '') ? esc(v) : '#';
// проекты Федерации вне Единого календарного плана Минспорта: на странице нет номера реестра и «Официального старта ЕКП»
// (110 — Студенческие игры ГТО: проект при поддержке Минспорта, в реестре соревнований его нет)
const NOT_EKP_EVENTS = new Set(['110']);
// ссылка на файл: внешний https или свой путь на сайте (/uploads/… от модераторов, ./assets/…); «//чужой.сайт» и javascript: — нет
const safeFileUrl = v => /^(https?:\/\/|\/(?!\/)|\.\/)/.test(String(v || '').trim()) ? esc(String(v).trim()) : '#';
const safeImage = v => { const loc = legacyLocal(v); if (loc) return esc(loc); return v && !String(v).startsWith('http') ? esc(v) : (/^https:\/\//.test(v || '') ? esc(v) : './assets/logo-clean.png'); };
// кабинет (herogto_module) открывает профиль атлета через window — функция должна быть доступна сразу,
// а не после первого открытия какого-нибудь профиля (кнопка «Профиль в реестре атлетов» молчала)
window.openAthleteProfile = (...args) => openAthleteProfile(...args);

// Картинки сайта через ресайзер /rs/ (WebP нужной ширины, см. scripts/server/image_resize.py).
// Афиша 434 КБ → ~20 КБ при ширине 480. Внешние URL и заглушки отдаются как есть.
// Если ресайзер не ответил — onerror один раз откатывается на оригинал (window.__rsRetry).
const RS_WIDTHS = [160, 320, 480, 640, 960, 1280];
const RS_PATH = /^(?:\.\/|\/)?((?:assets|files|img|uploads)\/[^?#"'<>]+\.(?:jpe?g|png|webp))(?:[?#][^"'<>]*)?$/i;
export function rsUrl(url, w) {
  const u = String(url || '').trim();
  const loc = legacyLocal(u); if (loc) return rsUrl(loc, w);   // перенесённая картинка старого сайта — наш файл через ресайзер
  // афиши и превью старого сайта (gto.com.ru) — оригиналы по 10–18 МБ; сервер скачает один раз и отдаст WebP нужной ширины
  if (/^https?:\/\/(www\.)?gto\.com\.ru\/.+\.(jpe?g|png|webp)(\.pagespeed\.[^/]*)?$/i.test(u)) {
    try {
      const b64 = btoa(unescape(encodeURIComponent(u))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
      return `/rs/w${RS_WIDTHS.find(x => x >= w) || 1280}/ext/${b64}`;
    } catch (_) { return u; }
  }
  const m = u.match(RS_PATH);
  if (!m || /logo-clean|icon-192/.test(u)) return u;
  return `/rs/w${RS_WIDTHS.find(x => x >= w) || 1280}/${m[1]}`;
}
// атрибуты src/srcset/data-orig для <img>: w — ширина на экране в CSS-пикселях
function rsImgAttrs(url, w) {
  const one = rsUrl(url, w);
  if (one === String(url || '').trim()) return `src="${safeImage(url)}"`;
  const two = rsUrl(url, w * 2);
  return `src="${esc(one)}"${two !== one ? ` srcset="${esc(one)} 1x, ${esc(two)} 2x"` : ''} data-orig="${safeImage(url)}"`;
}
// повтор с оригиналом и запасные картинки — csp_events.js (data-orig / data-fb)


let userActive = false;
addEventListener('pointerdown', () => {
  userActive = true;
}, { capture: true });

// ── Поиск по сайту ⌘K (command_palette.js грузится при первом открытии) ──
window.__fmgtoPalette = {
  ready: () => Promise.all([loadRecords().catch(() => {}), loadCalendar().catch(() => {})]),
  data: () => ({ events: getUnifiedEvents(), records: GTO_RECORDS, regions: GTO_REGIONS, news: getUnifiedNews() })
};
// «потяни, чтобы обновить» — только на сенсорных экранах (модуль маленький, грузится после старта)
if ('ontouchstart' in window) import('./pull_refresh.js?v=fd53bb03').then((m) => m.initPullToRefresh()).catch(() => {});
if (typeof window !== 'undefined') window.fmgtoToast = (m) => showToast(m);
loadSiteContent();
window.addEventListener('gto-site-content', () => {
  applyVideoContent();
  try {
    if (state.screen === 'documents') renderDocuments();
    else if (state.screen === 'home') renderHome();
    else if (state.screen === 'media') renderMedia();
    else if (state.screen === 'region' && state.currentRegionId) openRegion(state.currentRegionId, false);
    else if (state.screen === 'platforms') renderPlatforms($('#platforms-content'));
    else if (state.screen === 'herohub') renderHeroLanding($('#herohub-landing'));
    else if (state.screen === 'about') renderAbout();
  } catch (_) { /* экран перерисуется при следующем переходе */ }
});
// плеер показываем, когда он загрузился (иначе на мгновение видна пустая белая рамка) — load у iframe не всплывает, ловим на погружении
document.addEventListener('load', (e) => { const f = e.target; if (f?.tagName === 'IFRAME') setTimeout(() => f.classList.add('is-ready'), 200); }, true);
let _cmdk = null;
// iPhone открывает клавиатуру, только если поле получает фокус прямо в обработчике нажатия, а модуль поиска
// грузится асинхронно — поэтому сразу фокусируем временное поле, а после загрузки фокус переходит в строку поиска
const openPalette = (q = '') => {
  let temp = null;
  if (!document.querySelector('.cmdk input')) {
    temp = document.createElement('input');
    temp.setAttribute('aria-hidden', 'true'); temp.tabIndex = -1;
    temp.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;font-size:16px;border:0;padding:0';
    document.body.appendChild(temp); temp.focus();
  }
  return (_cmdk ||= import('./command_palette.js?v=bf97bb25')).then((m) => m.open(q))
    .catch(() => { location.hash = '#athlete-search'; })
    .finally(() => { if (temp) setTimeout(() => temp.remove(), 400); });
};
document.addEventListener('keydown', (e) => {
  const typing = e.target?.closest?.('input, textarea, select, [contenteditable="true"]');
  if ((e.key === 'k' || e.key === 'K' || e.key === 'л' || e.key === 'Л') && (e.metaKey || e.ctrlKey)) { e.preventDefault(); openPalette(); }
  else if (e.key === '/' && !typing && !e.metaKey && !e.ctrlKey) { e.preventDefault(); openPalette(); }
});
document.addEventListener('click', (e) => { if (e.target.closest?.('[data-open-palette]')) { e.preventDefault(); openPalette(); } });
// ссылки на видео (результаты, описание турнира) — плеером на сайте; Ctrl/Cmd/Shift-клик и средняя кнопка — как обычная ссылка
document.addEventListener('click', (e) => {
  const a = e.target.closest?.('a.res-video, a.about-ext, a.about-card-link');
  if (!a || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  const title = (a.dataset.videoTitle || a.textContent || '').replace(/[▶↗]/g, '').trim();
  if (openVideoPlayer(a.href, title)) { e.preventDefault(); e.stopPropagation(); }
}, true);
// светлая / тёмная тема: выбор запоминается в браузере (theme-light.css; начальное значение ставит скрипт в <head>)
document.addEventListener('click', (e) => {
  if (!e.target.closest?.('[data-toggle-theme]')) return;
  const light = document.documentElement.dataset.theme !== 'light';
  if (light && !document.querySelector('link[data-light-css]')) {   // стили светлой темы подгружаем при первом включении
    const links = ['./css/theme-light.gen.css?v=c980db21', './css/theme-light.css?v=d786ec27'].map((href) => Object.assign(document.createElement('link'), { rel: 'stylesheet', href }));
    links.forEach((l) => { l.dataset.lightCss = ''; document.head.appendChild(l); });
    Promise.all(links.map((l) => new Promise((r) => { l.onload = r; l.onerror = r; }))).then(() => { document.documentElement.dataset.theme = 'light'; });
  } else if (light) document.documentElement.dataset.theme = 'light'; else delete document.documentElement.dataset.theme;
  try { localStorage.setItem('fmgto_theme', light ? 'light' : 'dark'); } catch (_) { /* приватный режим — тема до перезагрузки */ }
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', light ? '#f4f7fb' : '#07111f');
});

// строки-кнопки (role="button" на не-кнопках): Enter и пробел работают как клик
document.addEventListener('keydown', (e) => {
  if ((e.key === 'Enter' || e.key === ' ') && e.target?.matches?.('[role="button"][data-open-athlete-id], [role="button"][data-record-id]')) { e.preventDefault(); e.target.click(); }
});
document.addEventListener('click', (e) => {
  const j = e.target.closest?.('[data-rb-jump]');
  if (!j) return;
  document.getElementById(j.dataset.rbJump)?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
});

// Magic Card: мягкий свет под курсором на карточках (только мышь; на тач-экранах не включается)
if (typeof matchMedia === 'function' && matchMedia('(hover: hover) and (pointer: fine)').matches) {
  const FX_CARDS = '.event-card, .tl-card, .action-card, .unified-record-card, .story, .nwc';
  document.addEventListener('pointermove', (e) => {
    const card = e.target.closest?.(FX_CARDS);
    if (!card) return;
    if (!card.querySelector(':scope > .fx-spot')) { const sp = document.createElement('span'); sp.className = 'fx-spot'; sp.setAttribute('aria-hidden', 'true'); card.classList.add('fx-card'); card.appendChild(sp); }
    const r = card.getBoundingClientRect();
    card.style.setProperty('--mx', `${e.clientX - r.left}px`);
    card.style.setProperty('--my', `${e.clientY - r.top}px`);
  }, { passive: true });
}

try {
  addEventListener('load', () => {
    setTimeout(() => {
      try {
        console.log(
          'CENTER ELEMENT:',
          document.elementsFromPoint(
            window.innerWidth / 2,
            window.innerHeight / 2
          )
        );
      } catch (_) {}
    }, 500);
  });
} catch (_) {}
export const haptic = (ms = 10) => {
  try {
    if (userActive && 'vibrate' in navigator) navigator.vibrate(ms);
  } catch (_) {}
};

const svgIcon = p => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${p}</svg>`;

// иконки дисциплин — Tabler Icons (MIT, github.com/tabler/tabler-icons), тот же линейный стиль, что Lucide на сайте
const DISC_ICONS = [
  [/лыж/, '<path d="M17 17.5l-5 -4.5v-6l5 4"/><path d="M7 17.5l5 -4.5"/><path d="M15.103 21.58l6.762 -14.502a2 2 0 0 0 -.968 -2.657"/><path d="M8.897 21.58l-6.762 -14.503a2 2 0 0 1 .968 -2.657"/><path d="M7 11l5 -4"/><path d="M10.007 4a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/>'],
  [/турист|поход/, '<path d="M11 14l4 6h6l-9 -16l-9 16h6l4 -6"/>'],
  [/самооборон/, '<path d="M3 9l4.5 1l3 2.5"/><path d="M13 21v-8l3 -5.5"/><path d="M8 4.5l4 2l4 1l4 3.5l-2 3.5"/><path d="M15.007 5a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/>'],
  [/плаван/, '<path d="M15 9a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"/><path d="M6 11l4 -2l3.5 3l-1.5 2"/><path d="M3 16.75a2.4 2.4 0 0 0 1 .25a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 1 -.25"/>'],
  [/стрель|винтов|оружи/, '<path d="M11 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"/><path d="M12 7a5 5 0 1 0 5 5"/><path d="M13 3.055a9 9 0 1 0 7.941 7.945"/><path d="M15 6v3h3l3 -3h-3v-3l-3 3"/><path d="M15 9l-3 3"/>'],
  [/снаряд|метани/, '<path d="M5.636 18.364a9 9 0 1 0 12.728 -12.728a9 9 0 0 0 -12.728 12.728"/><path d="M12.495 3.02a9 9 0 0 1 -9.475 9.475"/><path d="M20.98 11.505a9 9 0 0 0 -9.475 9.475"/><path d="M9 9l2 2"/><path d="M13 13l2 2"/><path d="M11 7l2 1"/><path d="M7 11l1 2"/><path d="M16 11l1 2"/><path d="M11 16l2 1"/>'],
  [/бег|спринт|челнок|дистанц|кросс/, '<path d="M11.007 5a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/><path d="M4 17l5 1l.75 -1.5"/><path d="M15 21v-4l-4 -3l1 -6"/><path d="M7 12v-3l5 -1l3 3l3 1"/>'],
  [/подтяг|перекладин|вис/, '<path d="M7 7a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"/><path d="M13 21l1 -9l7 -6"/><path d="M3 11h6l5 1"/><path d="M11.5 8.5l4.5 -3.5"/>'],
  [/гир|рывок|толч/, '<path d="M9 6a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"/><path d="M6.835 9h10.33a1 1 0 0 1 .984 .821l1.637 9a1 1 0 0 1 -.984 1.179h-13.604a1 1 0 0 1 -.984 -1.179l1.637 -9a1 1 0 0 1 .984 -.821"/>'],
  [/отжим|сгибан|упор/, '<path d="M2 12h1"/><path d="M6 8h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2"/><path d="M6 7v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-10a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1"/><path d="M9 12h6"/><path d="M15 7v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-10a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1"/><path d="M18 8h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-2"/><path d="M22 12h-1"/>'],
  [/прыж|длин/, '<path d="M6.5 21l3.5 -5"/><path d="M5 11l7 -2"/><path d="M16 21l-4 -7v-5l7 -4"/><path d="M9.007 6a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/>'],
  [/наклон|гибк/, '<path d="M4 20h4l1.5 -3"/><path d="M17 20l-1 -5h-5l1 -7"/><path d="M4 10l4 -1l4 -1l4 1.5l4 1.5"/><path d="M10.007 5a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/>'],
  [/пресс|туловищ|поднимани/, '<path d="M15 5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"/><path d="M5 20l5 -.5l1 -2"/><path d="M18 20v-5h-5.5l2.5 -6.5l-5.5 1l1.5 2"/>'],
];
const DISC_ICON_DEFAULT = '<path d="M10 16v5"/><path d="M14 16v5"/><path d="M9 9h6l-1 7h-4l-1 -7"/><path d="M5 11c1.333 -1.333 2.667 -2 4 -2"/><path d="M19 11c-1.333 -1.333 -2.667 -2 -4 -2"/><path d="M10 4a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/>';
export function disciplineIcon(d) {
  const s = (d || '').toLowerCase();
  const hit = DISC_ICONS.find(([re]) => re.test(s));
  return svgIcon(hit ? hit[1] : DISC_ICON_DEFAULT);
}

const regionInitials = r => ((String(r || '').replace(/[«»"().]/g, '').split(/[\s-]+/).filter(Boolean).map(w => w[0]).join('').slice(0, 2)) || 'ГТ').toUpperCase();
const REGION_COAT = {"Россия (Центральный аппарат)":"1705658866","Москва":"1704977561","Московская область":"1705326009","Санкт-Петербург":"1705329839","Ленинградская область":"1729165316","Приморский край":"1705327997","Хабаровский край":"1705331443","Амурская область":"1705304782","Камчатский край":"1705307049","Сахалинская область":"1705329985","Забайкальский край":"1705306639","Республика Саха (Якутия)":"1705328972","Чукотский АО":"1727254924","Еврейская АО":"1747223619","Красноярский край":"1706595605","Кемеровская область — Кузбасс":"1705307383","Новосибирская область":"1717403711","Омская область":"1705326837","Томская область":"1705330768","Алтайский край":"1734942675","Тюменская область":"1705330911","ХМАО — Югра":"1705331574","Челябинская область":"1705331718","Курганская область":"1705325500","Пермский край":"1705327769","Республика Башкортостан":"1705328228","Удмуртская Республика":"1705331063","Ульяновская область":"1705331310","Пензенская область":"1705327220","Оренбургская область":"1734513099","Нижегородская область":"1760439708","Краснодарский край":"1705325313","Ставропольский край":"1705330607","Ростовская область":"1705329146","Волгоградская область":"1705305861","Республика Крым":"1705328776","Севастополь":"1705330438","Республика Ингушетия":"1705328553","Белгородская область":"1710347051","Воронежская область":"1704811639","Брянская область":"1734513572","Смоленская область":"1747822115","Тульская область":"1737638053","Липецкая область":"1717404716","Костромская область":"1760438202","Архангельская область":"1705305650","Мурманская область":"1747648225","Псковская область":"1710346549","Калининградская область":"1760434137"};
const regionCoat = region => REGION_COAT[region] ? `./assets/coats/${REGION_COAT[region]}.png` : '';
const regionLogo = (region, photo) => {
  const coat = regionCoat(region);
  if (coat) return `<span class="region-emblem region-coat"><img loading="lazy" src="${coat}" alt="Герб: ${esc(region)}" data-fb="logo"></span>`;
  // photo отделения — обложка 16:9 (с 14.10.2026), в квадрат эмблемы не годится: без герба — фирменная эмблема с инициалами
  return `<span class="region-emblem region-logo"><svg viewBox="0 0 48 48" aria-hidden="true"><path d="M24 3 41 8.5v13.5c0 10.2-7.2 16.4-17 21.5-9.8-5.1-17-11.3-17-21.5V8.5z" fill="#13253d" stroke="#3979a6" stroke-width="1.6"/><path d="M24 3 41 8.5V15H7V8.5z" fill="#d0272e"/><text x="24" y="26.5" text-anchor="middle" font-family="Unbounded,sans-serif" font-weight="800" font-size="11.5" fill="#fff">ГТО</text><text x="24" y="38" text-anchor="middle" font-family="TT Squares,Arial,sans-serif" font-weight="700" font-size="9" fill="#8fb4ff">${esc(regionInitials(region))}</text></svg></span>`;
};
const realPresident = p => p && !/руководитель\s+регион/i.test(p) ? p : '';
export const formatPhone = phone => {
  if (!phone) return '';
  const digits = String(phone).replace(/\D/g, '');
  if (digits.length === 11 && (digits.startsWith('7') || digits.startsWith('8'))) {
    return `+7 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`;
  }
  return String(phone);
};

// ==========================================================
// v85 — CENTRAL DETERMINISTIC NAVIGATION ARCHITECTURE
// ==========================================================
export const appNavigationStack = [];

export const scrollStore = new Map();

export function getRouteKey(screen, params = {}) {
  if (params && params.id) {
    return `${screen}/${params.id}`;
  }
  return screen;
}

export function currentRoute() {
  return appNavigationStack.length
    ? appNavigationStack[appNavigationStack.length - 1]
    : { screen: state.screen || 'home', params: {}, scrollY: 0 };
}

export function saveCurrentScroll() {
  const top = currentRoute();
  if (!top || !top.screen) return 0;
  const key = getRouteKey(top.screen, top.params);
  const y = window.scrollY || document.documentElement.scrollTop || 0;
  scrollStore.set(key, y);
  top.scrollY = y;
  return y;
}

// страница турнира: человек что-то нажал/прокрутил клавиатурой — поздние альбомы уже не перерисовывают страницу целиком
['pointerdown', 'keydown'].forEach((t) => document.addEventListener(t, (e) => {
  if (state.screen === 'event' && e.target.closest?.('#event-detail')) state.eventTouched = true;
}, { capture: true, passive: true }));

export function resetScrollToTop() {
  window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  const app = $('#app');
  if (app) app.scrollTop = 0;
  const containers = [
    '#region-detail',
    '#athlete-profile-detail',
    '#record-detail-container',
    '#event-detail',
    '.region-page-container',
    '.athlete-profile-container',
    '.record-detail-page'
  ];
  containers.forEach(sel => {
    const el = $(sel);
    if (el) el.scrollTop = 0;
  });
  $$('.screen').forEach(s => { s.scrollTop = 0; });
}

export function pushRoute(route) {
  if (!route || !route.screen) return;
  // Always save current scroll before pushing forward
  saveCurrentScroll();

  const top = currentRoute();
  if (top.screen === route.screen && JSON.stringify(top.params || {}) === JSON.stringify(route.params || {})) {
    return;
  }

  if (top.screen === 'event') {
    const activeTab = $('.detail-tabs button.active');
    top.params = top.params || {};
    top.params.pane = activeTab ? activeTab.dataset.pane : (state.lastEventPane || 'about');
    top.params.filters = {
      query: state.eventResultQuery,
      category: state.eventResultCategory,
      sex: state.eventResultSex,
      age: state.eventResultAge,
      complex: state.eventResultComplex,
      standing: state.eventResultStanding,
      groupBy: state.eventResultGroupBy
    };
  }

  const rootScreens = ['home', 'events', 'news', 'media', 'records', 'more', 'regions', 'hero'];
  if (rootScreens.includes(route.screen) && (!route.params || Object.keys(route.params).length === 0)) {
    appNavigationStack.length = 0;
  }
  appNavigationStack.push({ screen: route.screen, params: { ...route.params }, scrollY: 0 });
  console.log('[NAV:PUSH]', { to: route.screen, params: route.params, stack: appNavigationStack.map(r => `${r.screen}${r.params?.id ? '/' + r.params.id : ''}`) });
}

export function popRoute() {
  if (appNavigationStack.length > 1) {
    const popped = appNavigationStack.pop();
    const prev = appNavigationStack[appNavigationStack.length - 1];
    console.log('[NAV:POP]', { from: popped.screen, to: prev.screen, stack: appNavigationStack.map(r => `${r.screen}${r.params?.id ? '/' + r.params.id : ''}`) });
    return prev;
  }
  return null;
}

export function restoreScrollPosition(restoreScrollY) {
  if (typeof restoreScrollY !== 'number' || restoreScrollY < 0) return;
  const doRestore = () => {
    window.scrollTo({ top: restoreScrollY, left: 0, behavior: 'instant' });
    document.documentElement.scrollTop = restoreScrollY;
    document.body.scrollTop = restoreScrollY;
  };
  requestAnimationFrame(() => {
    doRestore();
    setTimeout(doRestore, 40);
    setTimeout(doRestore, 120);
    setTimeout(doRestore, 260);
  });
}

export function navigateBack() {
  haptic(10);
  // Pop current screen from stack
  const current = appNavigationStack.pop();
  if (current) {
    const curKey = getRouteKey(current.screen, current.params);
    const y = window.scrollY || document.documentElement.scrollTop || 0;
    scrollStore.set(curKey, y);
  }

  const prev = appNavigationStack.length ? appNavigationStack[appNavigationStack.length - 1] : null;
  let restoreScrollY = (prev && typeof prev.scrollY === 'number') ? prev.scrollY : null;
  if (prev && restoreScrollY === null) {
    const prevKey = getRouteKey(prev.screen, prev.params);
    restoreScrollY = scrollStore.get(prevKey) ?? null;
  }

  if (prev) {
    console.log('[NAV:BACK_TO_STACK]', prev, 'restoreScrollY:', restoreScrollY);
    if (prev.screen === 'athlete' && prev.params?.id) openAthleteProfile(prev.params.id, false, restoreScrollY);
    else if (prev.screen === 'record' && prev.params?.id) openRecordDetail(prev.params.id, false, restoreScrollY);
    else if (prev.screen === 'region' && prev.params?.id) openRegion(prev.params.id, false, restoreScrollY);
    else if (prev.screen === 'event' && prev.params?.id) {
      if (prev.params?.filters) {
        state.eventResultQuery = prev.params.filters.query || '';
        state.eventResultCategory = prev.params.filters.category || 'all';
        state.eventResultSex = prev.params.filters.sex || 'all';
        state.eventResultAge = prev.params.filters.age || 'all';
        state.eventResultComplex = prev.params.filters.complex || 'all';
        state.eventResultStanding = prev.params.filters.standing || 'all';
        state.eventResultGroupBy = prev.params.filters.groupBy || 'category';
      }
      openEvent(prev.params.id, prev.params?.pane || 'about', false, restoreScrollY);
    }
    else if (prev.screen === 'article' && prev.params?.id) openArticle(prev.params.id, false, restoreScrollY);
    else go(prev.screen, false, restoreScrollY);
    return;
  }

  // Fallback when accessed directly without history stack
  console.log('[NAV:BACK_FALLBACK]', state.screen, state.athleteProfileReturnScreen);
  if (state.screen === 'athlete') {
    const ret = state.athleteProfileReturnScreen || 'athlete-search';
    if (ret === 'record' && state.selectedRecordId) {
      openRecordDetail(state.selectedRecordId, false);
    } else if (ret === 'region' && state.currentRegionId) {
      openRegion(state.currentRegionId, false);
    } else if (ret === 'event' && state.athleteReturnEventId) {
      openEvent(state.athleteReturnEventId, state.athleteReturnPane || 'results', false);
    } else if (ret === 'records') {
      go('records', false);
    } else {
      go('athlete-search', false);
    }
    return;
  }

  if (state.screen === 'record') {
    const ret = state.recordReturnScreen || 'records';
    if (ret === 'region' && state.currentRegionId) {
      openRegion(state.currentRegionId, false);
    } else if (ret === 'athlete' && state.selectedAthleteId) {
      openAthleteProfile(state.selectedAthleteId, false);
    } else if (ret === 'event' && state.athleteReturnEventId) {
      openEvent(state.athleteReturnEventId, state.athleteReturnPane || 'results', false);
    } else {
      go('records', false);
    }
    return;
  }

  if (state.screen === 'region') {
    if (state.regionReturnScreen === 'event' && state.currentEventId) {
      openEvent(state.currentEventId, state.currentEventPane || 'results', false);
    } else {
      go('regions', false);
    }
    return;
  }

  if (state.screen === 'event') {
    go('events', false);
    return;
  }

  if (state.screen === 'article') {
    go('news', false);
    return;
  }

  if (state.screen === 'athlete-search') {
    if (state.athleteReturnScreen === 'event' && state.athleteReturnEventId) {
      openEvent(state.athleteReturnEventId, state.athleteReturnPane || 'results', false);
    } else {
      go('events', false);
    }
    return;
  }

  if (state.screen === 'calculator' || state.screen === 'timer' || state.screen === 'standards') {
    go('home', false);
    return;
  }

  go('home', false);
}

export function openMobileDrawer() {
  const drawer = $('#mobile-nav-drawer');
  const backdrop = $('#mobile-nav-backdrop');
  const toggleBtn = $('#mobile-menu-toggle');
  if (!drawer || !backdrop) return;
  drawer.hidden = false;
  backdrop.hidden = false;
  requestAnimationFrame(() => {
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    document.body.classList.add('nav-drawer-open');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
  });
}

export function closeMobileDrawer() {
  const drawer = $('#mobile-nav-drawer');
  const backdrop = $('#mobile-nav-backdrop');
  const toggleBtn = $('#mobile-menu-toggle');
  if (!drawer || !backdrop) return;
  drawer.classList.remove('is-open');
  backdrop.classList.remove('is-open');
  document.body.classList.remove('nav-drawer-open');
  if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
  setTimeout(() => {
    if (!drawer.classList.contains('is-open')) {
      drawer.hidden = true;
      backdrop.hidden = true;
    }
  }, 320);
}

// Панель организатора: только с ключом администратора (проверяется на сервере, /api/admin/check)
let adminVerified = false;
async function ensureAdminAccess() {
  // 1) личный вход сотрудника (Telegram через хаб новостей) — роль и имя попадают в журнал; 2) запасной общий ключ
  const hub = localStorage.getItem('fmgto_hub_token') || '';
  if (hub && !localStorage.getItem('fmgto_admin_key')) {
    try {
      const d = await (await fetch('/api/admin/check', { headers: { Authorization: 'Bearer ' + hub }, cache: 'no-store' })).json();
      if (d && d.ok) { window.__staffRole = d.role || 'moderator'; window.__staffName = d.name || ''; return true; }
    } catch (_) {}
  }
  let key = localStorage.getItem('fmgto_admin_key') || '';
  if (!key && !hub) {
    // сотрудники входят лично — по логину и паролю или через Telegram; ключ — только запасной вход владельца
    if (confirm('Панель организатора ФМГТО.\n\nВойти лично — по логину и паролю или через Telegram (рекомендуется)? «Отмена» — ввести общий ключ администратора.')) { go('inbox'); return false; }
  }
  for (let attempt = 0; attempt < 2; attempt++) {
    if (!key) { try { key = (prompt('Общий ключ администратора (запасной вход):') || '').trim(); } catch (_) { key = ''; } if (!key) return false; }
    try {
      const r = await fetch('/api/admin/check', { headers: { Authorization: 'Bearer ' + key }, cache: 'no-store' });
      const d = await r.json();
      if (d && d.ok) { localStorage.setItem('fmgto_admin_key', key); window.__staffRole = d.role || 'superadmin'; return true; }
    } catch (_) {}
    localStorage.removeItem('fmgto_admin_key'); key = '';
    alert('Ключ не подошёл.');
  }
  return false;
}

// View Transitions: у нажатой карточки картинка получает имя «vt-media», у открываемого экрана — шапка (CSS: .screen.active .detail-hero-media)
let sharedEl = null;
function markSharedTransition(el) { clearSharedTransition(); if (el) { el.style.viewTransitionName = 'vt-media'; sharedEl = el; document.documentElement.classList.add('vt-shared'); } }
function clearSharedTransition() { if (sharedEl) { sharedEl.style.viewTransitionName = ''; sharedEl = null; } document.documentElement.classList.remove('vt-shared'); }
// служебные пункты меню (.staff-only) — только после входа модератора или по ключу администратора
function syncStaffClass() { try { document.documentElement.classList.toggle('is-staff', Boolean(localStorage.getItem('fmgto_hub_token') || localStorage.getItem('fmgto_admin_key'))); } catch (_) {} }
function go(screen, push = true, restoreScrollY = null) {
  syncStaffClass();
  if (screen === 'live') {   // #live?to=admin|judge&t=N — «Войти через сайт ГТО» из движка «Турнир» (live_enter.js?v=2f56a62c)
    import('./live_enter.js?v=2f56a62c').then((m) => m.routeLive(location.hash, go)).catch(() => go('home', false));
    return;
  }
  if (screen === 'admin' && !adminVerified) {
    ensureAdminAccess().then((ok) => { if (ok) { adminVerified = true; go('admin', push, restoreScrollY); } else if (state.screen === 'admin' || !state.screen) go('home', false); });
    return;
  }
  if (screen === 'herogto' || screen === 'hero-gto') screen = 'hero';
  if (!valid.has(screen)) screen = 'home';
  if (screen === 'region' && !($('#region-detail') && $('#region-detail').innerHTML.trim())) screen = 'regions';
  state.screen = screen;
  haptic(10);
  if (push) {
    pushRoute({ screen, params: {} });
  }

  // --- смена экрана: View Transitions (кроссфейд + «перетекание» картинки карточки/аватара), иначе — классы CSS ---
  const prevActive = $('.screen.active');
  const nextScreen = $(`.screen[data-screen="${screen}"]`);
  const useVT = push && prevActive && nextScreen && prevActive !== nextScreen && typeof document.startViewTransition === 'function'
    && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && screen !== 'admin';
  const apply = () => {
    document.documentElement.classList.remove('deeplink');   // прямая ссылка: главную прятали до первого переключения (index.html)
    if (!useVT && prevActive && nextScreen && prevActive !== nextScreen) {
      prevActive.classList.add('screen-leaving');
      prevActive.classList.remove('active');
      setTimeout(() => prevActive.classList.remove('screen-leaving'), 180);
      nextScreen.classList.add('screen-entering');
      nextScreen.classList.add('active');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => nextScreen.classList.remove('screen-entering'));
      });
    } else {
      $$('.screen').forEach(x => x.classList.toggle('active', x.dataset.screen === screen));
    }
    const mobileSection = screen === 'event' ? 'events'
      : screen === 'article' ? 'news'
      : screen === 'record' ? 'records'
      : ['hero', 'herohub', 'passport', 'path'].includes(screen) ? 'hero'
      : screen;
    $$('.bottom-nav button').forEach(x => {
      const active = x.dataset.go === mobileSection;
      x.classList.toggle('active', active);
      if (active) x.setAttribute('aria-current', 'page');
      else x.removeAttribute('aria-current');
    });
    const desktopSection = screen === 'event' ? 'events'
      : screen === 'results' ? 'results'
      : screen === 'article' ? 'news'
      : screen === 'region' ? 'regions'
      : screen === 'record' ? 'records'
      : screen === 'ratings' ? 'ratings'
      : ['about', 'history', 'brand', 'disciplines', 'structure', 'documents', 'antidoping', 'platforms', 'more', 'path', 'ambassadors'].includes(screen) ? 'more'
      : screen;
    const toolScreens = ['calculator', 'athlete-search', 'timer', 'standards', 'faq'];
    const isToolActive = toolScreens.includes(desktopSection);
    const toolsBtn = $('#tools-dropdown-btn') || $('#services-dropdown-btn');
    if (toolsBtn) {
      toolsBtn.classList.toggle('active', isToolActive);
    }
    $$('.desktop-main-nav [data-go]').forEach(x => {
      const active = x.dataset.go === desktopSection;
      x.classList.toggle('active', active);
      if (active) x.setAttribute('aria-current', 'page');
      else x.removeAttribute('aria-current');
    });
    $$('#mobile-nav-drawer [data-go]').forEach(x => {
      const active = x.dataset.go === screen ||
        (screen === 'event' && x.dataset.go === 'events') ||
        (screen === 'record' && x.dataset.go === 'records') ||
        (screen === 'article' && x.dataset.go === 'news') ||
        (screen === 'region' && x.dataset.go === 'regions') ||
        (['about', 'history', 'brand', 'disciplines', 'structure', 'documents', 'antidoping', 'platforms', 'path', 'ambassadors'].includes(screen) && x.dataset.go === 'more');
      x.classList.toggle('active', active);
    });
    const isSub = ['event', 'article', 'region', 'record', 'calculator', 'timer', 'standards', 'athlete-search', 'athlete', 'about', 'history', 'brand', 'disciplines', 'structure', 'documents', 'antidoping', 'platforms', 'hero', 'herohub', 'passport', 'path', 'ambassadors', 'faq'].includes(screen);
    const headerBack = $('#header-back-btn');
    if (headerBack) {
      headerBack.hidden = !isSub;
      if (isSub) {
        // Для турнира метка «Назад» отражает реальный экран-источник из стека
        // (например, «Герой ГТО»), а не всегда «Старты».
        const evOrigin = appNavigationStack.length >= 2
          ? appNavigationStack[appNavigationStack.length - 2].screen : null;
        const label = screen === 'event' ? (evOrigin === 'hero' ? 'Герой ГТО' : 'Старты')
          : screen === 'article' ? 'Новости'
          : screen === 'region' ? 'Регионы'
          : screen === 'hero' ? 'Главная'
          : screen === 'herohub' ? 'Главная'
          : screen === 'passport' ? 'Кабинет'
          : screen === 'path' ? 'Главная'
          : screen === 'ambassadors' ? 'Ещё'
          : screen === 'faq' ? 'Ещё'
          : screen === 'record' ? (state.recordReturnScreen === 'region' ? 'Регион' : state.recordReturnScreen === 'athlete' ? 'Атлет' : 'Рекорды')
          : screen === 'athlete' ? (state.athleteProfileReturnScreen === 'record' ? 'Рекорд' : state.athleteProfileReturnScreen === 'records' ? 'Рекорды' : state.athleteProfileReturnScreen === 'event' ? 'Турнир' : state.athleteProfileReturnScreen === 'region' ? 'Регион' : 'Атлеты')
          : screen === 'athlete-search' ? 'Назад'
          : 'Назад';
        const span = headerBack.querySelector('span');
        if (span) span.textContent = label;
      }
    }
    const hashTarget = (screen === 'athlete' && state.selectedAthleteId) ? `#athlete/${state.selectedAthleteId}`
      : (screen === 'record' && state.selectedRecordId) ? `#record/${state.selectedRecordId}`
      : ((screen === 'passport' || screen === 'inbox' || screen === 'admin') && location.hash.includes('?')) ? location.hash
      : (screen === 'records' && location.hash.startsWith('#records?')) ? location.hash   // #records?region=27 — регион в адресе
      : `#${screen}`;
    // Экраны-карточки пишут свой адрес с id сами (openEvent/openArticle/openRegion/openRecordDetail/openAthleteProfile).
    // Если писать здесь, replaceState портит предыдущую запись истории (#events → #event, #records → #record/5),
    // и кнопка «назад» снова открывает ту же карточку или проскакивает список.
    const ownsHash = ['event', 'article', 'region', 'record', 'athlete', 'team'].includes(screen);   // team: openTeam пишет #team/<название>
    if (!ownsHash && push && location.hash !== hashTarget) history.pushState({ screen, athleteId: state.selectedAthleteId, recordId: state.selectedRecordId }, '', hashTarget);
    else if (!ownsHash && !push && location.hash !== hashTarget) history.replaceState({ screen, athleteId: state.selectedAthleteId, recordId: state.selectedRecordId }, '', hashTarget);
    if (push) {
      resetScrollToTop();
    } else if (typeof restoreScrollY === 'number') {
      restoreScrollPosition(restoreScrollY);
    } else if (scrollStore.has(screen)) {
      restoreScrollPosition(scrollStore.get(screen));
    } else if (screen === 'events' && (state.eventsScrollTop > 0 || state.lastEventId)) {
      const restoreY = state.eventsScrollTop;
      const targetId = state.lastEventId;
      const doRestore = () => {
        if (targetId) {
          const card = $(`[data-event="${targetId}"]`);
          if (card) {
            card.scrollIntoView({ block: 'center', inline: 'nearest' });
            return;
          }
        }
        if (restoreY > 0) {
          window.scrollTo({ top: restoreY, behavior: 'instant' });
        }
      };
      requestAnimationFrame(() => {
        doRestore();
        setTimeout(doRestore, 40);
      });
    }
    // фокус — в начало страницы для экранного диктора, но не из открытого окна (поиск ⌘K, окно модератора):
    // экран, догрузившийся позже, иначе выдёргивал курсор из строки поиска
    if (!document.activeElement?.closest?.('.cmdk, [role="dialog"], .mod-edit-dialog')) $('#app').focus({ preventScroll: true });
  
    if (['herohub', 'hero', 'passport'].includes(screen)) {
      loadScreenCss('./css/herogto.css?v=71644e49');
    } else if (screen === 'admin') {
      loadScreenCss('./css/admin.css?v=e236163d');
    } else if (screen === 'inbox') {
      loadScreenCss('./css/inbox.css?v=d1166be2');
    }
    const dataPromise = ensureScreenData(screen).then(() => {
      if (screen === 'home') { renderHome(); }
      else if (screen === 'events') { setupEventYears(); setupEventFilters(); renderEvents(); }
      else if (screen === 'news') { setupNewsFilters(); renderNews(); }
      else if (screen === 'records') { openRecordsScreen(); }
      else if (screen === 'media') { renderMedia(); }
      else if (screen === 'results') { setupResultsFilters(); renderResultsScreen(); }
      else if (screen === 'regions') { renderRegions(); }
      else if (screen === 'ratings') { renderRatings(); }
    });

    if (screen === 'calculator') renderCalculator();

    if (screen === 'athlete-search') {
      const backBtn = $('#athlete-search-back');
      if (backBtn) {
        if (state.athleteReturnScreen === 'event' && state.athleteReturnEventId) {
          backBtn.textContent = '← Назад к турниру';
          backBtn.dataset.returnEvent = String(state.athleteReturnEventId);
          backBtn.dataset.returnPane = state.athleteReturnPane || 'results';
        } else {
          backBtn.textContent = '← Старты';
          delete backBtn.dataset.returnEvent;
          delete backBtn.dataset.returnPane;
        }
      }
      renderAthleteSearch();
    }
    if (screen === 'athlete') {
      const backBtn = $('#athlete-detail-back');
      if (backBtn) {
        const ret = state.athleteProfileReturnScreen || 'athlete-search';
        if (ret === 'records') backBtn.textContent = '← Рекорды России';
        else if (ret === 'event' && state.athleteReturnEventId) backBtn.textContent = '← Назад к турниру';
        else backBtn.textContent = '← К поиску атлетов';
      }
      if (state.selectedAthlete) {
        renderAthleteProfileScreen(state.selectedAthlete);
      } else if (state.selectedAthleteId) {
        openAthleteProfile(state.selectedAthleteId, false);
      }
    }
    if (screen !== 'timer' && timerMod) timerMod.stopCameraIfAny();
    if (screen === 'timer') renderTimer();
    if (screen === 'standards') renderStandards();
    if (screen === 'path') renderAthletePath();
    if (screen === 'ambassadors') renderAmbassadors();
    if (screen === 'faq') renderFaq();
    if (screen === 'about') renderAbout();
    if (screen === 'history') renderHistory();
    if (screen === 'brand') import('./about_screens.js?v=9f48deda').then((m) => m.renderBrandScreen($('#brand-content'))).catch(() => {});
    if (screen === 'disciplines') renderDisciplines();
    if (screen === 'structure') renderStructure();
    if (screen === 'documents') renderDocuments();
    if (screen === 'antidoping') renderAntidoping();
    if (screen === 'platforms') renderPlatforms($('#platforms-content'));
    if (screen === 'hero') initHeroGtoScreen();
    if (screen === 'herohub') { renderHeroLanding($('#herohub-landing')); initHeroHubScreen(); }
    if (screen === 'passport') renderPassportScreen();
    if (screen === 'admin') {
      const matchTab = (location.hash || '').match(/tab=([a-z0-9_-]+)/i);
      if (matchTab && matchTab[1]) {
        try {
          const raw = localStorage.getItem('gto_admin_store_v1');
          const adStore = raw ? JSON.parse(raw) : {};
          if (adStore && typeof adStore === 'object') {
            adStore.activeTab = matchTab[1];
            localStorage.setItem('gto_admin_store_v1', JSON.stringify(adStore));
          }
        } catch (_) {}
      }
      const adminRoot = document.getElementById('admin-root');
      if (adminRoot) getAdminModule().then(m => m.initAdminScreen(adminRoot)).catch(console.error);
    }
    if (screen === 'inbox') {
      const inboxRoot = document.getElementById('inbox-root');
      if (inboxRoot) getInboxModule().then(m => m.initInboxScreen(inboxRoot)).catch(console.error);
    }
    renderModeratorBar();
    syncHeroVideo();
    return dataPromise;
  };
  if (useVT) {
    // снимок старого экрана → в колбэке переключение, меню, адрес и прокрутка (иначе снимок уже прокручен и картинка «прыгает»)
    let ret;
    const vt = document.startViewTransition(() => { ret = apply(); });
    vt.finished.finally(clearSharedTransition);
    return vt.updateCallbackDone.then(() => ret, () => ret);   // как раньше: go() отдаёт обещание загрузки данных экрана
  }
  const ret = apply(); clearSharedTransition(); return ret;

}
window.navigateTo = go;
if (typeof window !== 'undefined') {
  window.go = go;
  window.openEvent = openEvent;
  window.renderPassportScreen = renderPassportScreen;
}

function eventYear(x) {
  // точная дата из календаря важнее года в тексте (у турниров, добавленных из базы, года в названии нет)
  if (/^20\d{2}-\d{2}-\d{2}/.test(x.startDate || '')) return Number(x.startDate.slice(0, 4));
  const text = `${x.title || ''} ${x.period || ''} ${x.location || ''}`;
  const years = [...text.matchAll(/(?:^|\D)(20\d{2})(?!\d)/g)].map(m => Number(m[1])).filter(y => y >= 2020 && y <= new Date().getFullYear() + 2);
  if (years.length) return Math.max(...years);
  // The official calendar is exported in chronological year blocks, but many
  // regional entries omit the year in their visible date.
  const id = Number(x.id);
  if (id >= 8 && id <= 46) return 2024;
  if (id >= 47 && id <= 94) return 2025;
  if (id >= 95 && id <= 113) return 2026;
  return 0;
}

// --- Дизайн-система: Плюрализация, Монограммы атлетов и Бэйджи турниров (v84) ---
export function pluralize(n, [one, few, many]) {
  const num = Math.abs(Number(n) || 0);
  const mod10 = num % 10;
  const mod100 = num % 100;
  if (mod100 >= 11 && mod100 <= 19) return `${num.toLocaleString('ru-RU')} ${many}`;
  if (mod10 === 1) return `${num.toLocaleString('ru-RU')} ${one}`;
  if (mod10 >= 2 && mod10 <= 4) return `${num.toLocaleString('ru-RU')} ${few}`;
  return `${num.toLocaleString('ru-RU')} ${many}`;
}

export function getAthleteInitials(name) {
  if (!name) return 'ГТ';
  const cleanName = String(name).replace(/[«»"().]/g, '').trim();
  const parts = cleanName.split(/\s+/).filter(Boolean);
  if (!parts.length) return 'ГТ';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

export function getAvatarColorIndex(idOrName) {
  if (typeof idOrName === 'number' && !isNaN(idOrName)) return Math.abs(idOrName) % 8;
  let hash = 0;
  const str = String(idOrName || '');
  for (let i = 0; i < str.length; i++) hash = (hash * 31 + str.charCodeAt(i)) & 0xffffffff;
  return Math.abs(hash) % 8;
}

export function getTournamentThumbnailHtml(event) {
  const ev = event || {};
  const poster = ev.localPoster || ev.poster || ev.img;
  const yr = eventYear(ev) || (ev.period && String(ev.period).match(/\d{4}/)?.[0]) || '26';
  const yrShort = String(yr).slice(-2);

  let tag = 'ГТО';
  const titleLower = (ev.title || '').toLowerCase();
  if (titleLower.includes('чемпионат')) tag = 'ЧР';
  else if (titleLower.includes('кубок')) tag = 'КУБОК';
  else if (titleLower.includes('первенство')) tag = 'ПР';
  else if (titleLower.includes('игры')) tag = 'ИГРЫ';
  else if (titleLower.includes('восток') || titleLower.includes('дфо')) tag = 'ДФО';

  const colorIdx = getAvatarColorIndex(ev.id || ev.title);

  if (poster && poster !== './assets/logo-clean.png' && poster !== 'assets/icon-192.png' && !poster.includes('logo-clean')) {
    return `<img loading="lazy" ${rsImgAttrs(poster, 480)} alt="" data-portrait="parent" data-fb="thumb" data-fb-tag="${esc(tag)}" data-fb-yr="${esc(yrShort)}" data-fb-color="${colorIdx}">`;
  }
  return `<span class="tournament-badge-fallback color-${colorIdx}" aria-hidden="true"><span class="tbf-tag">${tag}</span><strong class="tbf-year">'${yrShort}</strong></span>`;
}

export function getAthleteAvatarHtml(athlete, size = 52) {
  const a = athlete || {};
  const name = a.name || 'Спортсмен';
  const initials = getAthleteInitials(name);
  const colorIdx = getAvatarColorIndex(a.id || name);
  const photo = a.photo_url || a.photo || a.avatar;

  if (photo && photo !== './assets/logo-clean.png' && photo !== 'assets/icon-192.png' && !photo.includes('logo-clean')) {
    return `<span class="athlete-avatar-wrap" style="width:${size}px;height:${size}px"><img class="athlete-avatar-img" width="${size}" height="${size}" loading="lazy" referrerpolicy="no-referrer" ${rsImgAttrs(photo, size)} alt="Фото: ${esc(name)}" data-fb="avatar" data-fb-text="${esc(initials)}" data-fb-color="${colorIdx}" data-fb-size="${size}"></span>`;
  }
  return `<span class="athlete-avatar-monogram color-${colorIdx}" style="width:${size}px;height:${size}px" aria-hidden="true">${esc(initials)}</span>`;
}

export function getTournamentBadgeHtml(event, size = 56) {
  const ev = event || {};
  const poster = ev.localPoster || ev.poster || ev.img;
  const yr = eventYear(ev) || (ev.period && String(ev.period).match(/\d{4}/)?.[0]) || '26';
  const yrShort = String(yr).slice(-2);

  let tag = 'ГТО';
  const titleLower = (ev.title || '').toLowerCase();
  if (titleLower.includes('чемпионат')) tag = 'ЧР';
  else if (titleLower.includes('кубок')) tag = 'КУБОК';
  else if (titleLower.includes('первенство')) tag = 'ПР';
  else if (titleLower.includes('игры')) tag = 'ИГРЫ';
  else if (titleLower.includes('восток') || titleLower.includes('дфо')) tag = 'ДФО';

  const colorIdx = getAvatarColorIndex(ev.id || ev.title);

  if (poster && poster !== './assets/logo-clean.png' && poster !== 'assets/icon-192.png' && !poster.includes('logo-clean')) {
    return `<span class="tournament-badge-wrap" style="width:${size}px;height:${size}px"><img class="tournament-badge-img" width="${size}" height="${size}" loading="lazy" ${rsImgAttrs(poster, size)} alt="" data-fb="badge" data-fb-tag="${esc(tag)}" data-fb-yr="${esc(yrShort)}" data-fb-color="${colorIdx}" data-fb-size="${size}"></span>`;
  }
  return `<span class="tournament-badge-fallback color-${colorIdx}" style="width:${size}px;height:${size}px" aria-hidden="true"><span class="tbf-tag">${tag}</span><strong class="tbf-year">'${yrShort}</strong></span>`;
}

export function getResultPlaceBadgeHtml(rank) {
  const raw = String(rank || '').trim();
  const num = parseInt(raw.replace(/[^\d]/g, ''), 10);
  const lower = raw.toLowerCase();

  if (num === 1 || lower.includes('золот') || lower === '1' || lower.includes('1 место') || lower.includes('1-е')) {
    return '<span class="place-badge place-gold"><svg class="ic ic-gold" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg> 1 место</span>';
  }
  if (num === 2 || lower.includes('серебр') || lower === '2' || lower.includes('2 место') || lower.includes('2-е')) {
    return '<span class="place-badge place-silver"><svg class="ic ic-silver" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg> 2 место</span>';
  }
  if (num === 3 || lower.includes('бронз') || lower === '3' || lower.includes('3 место') || lower.includes('3-е')) {
    return '<span class="place-badge place-bronze"><svg class="ic ic-bronze" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg> 3 место</span>';
  }
  if (num && num > 0 && num < 999999) {
    return `<span class="place-badge place-rank">№ ${num}</span>`;
  }
  if (raw && raw !== '-' && raw !== '—') {
    return `<span class="place-badge place-rank">${esc(raw)}</span>`;
  }
  return '<span class="place-badge place-participant">Участник</span>';
}

function getVideoYear(v) {
  if (v.year) return Number(v.year);
  if (v.thumb) {
    const m = String(v.thumb).match(/(20\d{2})-\d{2}-\d{2}/);
    if (m) return Number(m[1]);
  }
  return 0;
}

const linkedEvent = id => GTO_CALENDAR_EVENTS.find(x => Number(x.id) === Number(id));
const mediaMeta = (item, type) => {
  const id = type === 'album' ? getTournamentByAlbumId(item.id) : getTournamentByVideoUrl(item.embedUrl);
  const event = linkedEvent(id);
  const rawYear = (event ? eventYear(event) : 0) || (type === 'video' ? getVideoYear(item) : (item.year || 0)) || (item.title ? eventYear({ title: item.title }) : 0) || (type === 'album' && Number(item.id) === 285395191 ? 2022 : 0) || eventYear(item) || 0;
  return { id, event, year: rawYear };
};

const NOW_Y = new Date().getFullYear(), NOW_M = new Date().getMonth() + 1;
const MONTHS = [['январ', 1], ['феврал', 2], ['март', 3], ['марта', 3], ['апрел', 4], ['мая', 5], ['май', 5], ['июн', 6], ['июл', 7], ['август', 8], ['авгус', 8], ['сентябр', 9], ['октябр', 10], ['ноябр', 11], ['декабр', 12]];

function eventMonth(x) {
  const s = `${x.period || ''}`.toLowerCase();
  for (const [k, m] of MONTHS) if (s.includes(k)) return m;
  return 0;
}

function eventDateRange(x) {
  // точные даты календаря (startDate/endDate) надёжнее текста периода
  const iso = (v) => (/^\d{4}-\d{2}-\d{2}/.test(String(v || '')) ? String(v).slice(0, 10).split('-').map(Number) : null);
  const s = iso(x.startDate), e = iso(x.endDate) || s;
  if (s) return { start: new Date(s[0], s[1] - 1, s[2], 0, 0, 0, 0), end: new Date(e[0], e[1] - 1, e[2], 23, 59, 59, 999) };
  const year = eventYear(x);
  if (!year) return null;
  const text = String(x.period || '').toLowerCase();
  const points = [];
  // «01–30 октября» — оба дня одного месяца (раньше читалось как «30 октября», и идущий турнир был «Предстоит»)
  const re = /(\d{1,2})(?:\s*[–—-]\s*(\d{1,2}))?\s+(январ\w*|феврал\w*|март\w*|апрел\w*|ма[йя]|июн\w*|июл\w*|август\w*|сентябр\w*|октябр\w*|ноябр\w*|декабр\w*)/g;
  for (const match of text.matchAll(re)) {
    const month = MONTHS.find(([stem]) => match[3].startsWith(stem))?.[1];
    if (!month) continue;
    points.push({ day: Number(match[1]), month });
    if (match[2]) points.push({ day: Number(match[2]), month });
  }
  if (!points.length) return null;
  const first = points[0];
  let last = points.at(-1);
  // A few source rows contain a bogus "— 01 января" suffix. It must not
  // prolong a one-day competition into the following year.
  if (last.month < first.month) last = first;
  return {
    start: new Date(year, first.month - 1, first.day, 0, 0, 0, 0),
    end: new Date(year, last.month - 1, last.day, 23, 59, 59, 999)
  };
}

function isPast(x) {
  const range = eventDateRange(x);
  if (range) return new Date() > range.end;
  const y = eventYear(x);
  return Boolean(y && y < NOW_Y);
}

// модератор закрыл приём заявок (regClosed в карточке турнира): без ссылки на форму и без «Идёт регистрация»
const REG_CLOSED_HTML = '<div class="detail-section"><h2>Регистрация участников</h2><p>Приём заявок завершён. Протоколы и фото появятся во вкладках «Результаты» и «Фото».</p></div>';
// «Обзор» турнира: сначала информация (слева), регистрация и разделы — рядом (справа; на телефоне — следом за информацией)
// партнёры мероприятия (event_content/<номер>.partners.json → d.partners, 12.10.2026): белые логотипы на своей тёмной плашке —
// и в светлой теме тоже; размеры картинки заданы (страница не прыгает), высоту выравнивает scale из файла
function eventPartnersBand(list) {
  const items = (Array.isArray(list) ? list : []).filter((p) => p && p.name && /^assets\/partners\/[\w.-]+\.(svg|png|webp)$/.test(p.logo || ''));
  if (!items.length) return '';
  return `<section class="detail-section ev-partners" aria-labelledby="ev-partners-title">
    <h2 id="ev-partners-title">Партнёры</h2>
    <ul class="ev-partners-row">${items.map((p) => `<li class="ev-partner" style="--pt-scale:${Number(p.scale) || 1}">
      <img src="./${esc(p.logo)}" alt="${esc(p.name)}" width="${Number(p.w) || 160}" height="${Number(p.h) || 48}" loading="lazy" decoding="async">
      ${p.role ? `<small>${esc(p.role)}</small>` : ''}</li>`).join('')}</ul>
  </section>`;
}
function overviewLayout(mainHtml, sideHtml) {
  if (!String(sideHtml || '').trim()) return mainHtml;
  if (!String(mainHtml || '').trim()) return sideHtml;
  return `<div class="ev-ov"><div class="ev-ov-main">${mainHtml}</div><aside class="ev-ov-side" aria-label="Регистрация и разделы турнира">${sideHtml}</aside></div>`;
}
// ---------- Описание турнира → оформленные блоки ----------
// Текст описания — обычные абзацы; оформление выводится из их вида (правило одно для всех турниров):
//   первый абзац — вводка (предложение «Организаторы: …» — отдельной строкой);
//   «Метка: текст» — раздел с заголовком и значком; «Метка (пояснение): …» — пояснение мелко рядом с заголовком;
//   «а → б → в» — маршрут по шагам (дистанция/число повторов справа); «10:00 — …; 10:10 — …» — расписание;
//   «соло — …; пары — …» — карточки «термин — пояснение»; прочее через «;» — список;
//   подряд идущие абзацы «Название — описание» — плитки программ; «„Название в кавычках“ — …» — плитка, даже если дальше
//   в тексте есть двоеточие (проверяется раньше «Метка: текст»). Внутри плитки — строки (перенос строки): первая — основной
//   текст; «Метка — текст» — подпункт с заголовком; «Подпись: https://…» — кнопка-ссылка; прочее — абзац (aboutCardHtml).
// Текст экранируется, ссылки кликабельны.
const ABOUT_ICONS = [[/программ|расписан|регламент дня/i, 'i-alarm-clock'], [/когда|где|место|адрес/i, 'i-map-pin'], [/станци|дистанц|трасс|этап|маршрут/i, 'i-footprints'],
  [/стоимост|взнос|цен[аы]|оплат/i, 'i-ticket'], [/допуск|документ/i, 'i-id-card'], [/дивизион|формат/i, 'i-users'], [/категор|зач[её]т|возраст/i, 'i-medal'],
  [/регистрац|заявк/i, 'i-pen-line'], [/награ|приз/i, 'i-trophy'], [/знак|значок/i, 'i-award'], [/организатор|партн[её]р/i, 'i-landmark'], [/как проход|правил/i, 'i-clipboard-list']];
const aboutText = (x) => linkify(esc(x)).replace(/\n/g, '<br>');
// первая буква — заглавная, но только у русского слова: адреса почты и ссылки («info@…», «https://…») не трогаем
const capFirst = (x) => { const t = String(x).trim(); return /^[а-яё]/.test(t) ? t[0].toUpperCase() + t.slice(1) : t; };
// деление по «;» только вне скобок: «стоимость (соло 5 000 ₽; пары 10 000 ₽)» остаётся одним пунктом
function splitOutsideParens(text) {
  const out = []; let depth = 0, cur = '';
  for (const ch of String(text)) {
    if (ch === '(') depth++; else if (ch === ')') depth = Math.max(0, depth - 1);
    if (ch === ';' && depth === 0) { out.push(cur); cur = ''; } else cur += ch;
  }
  out.push(cur);
  return out.map((x) => x.trim()).filter(Boolean);
}
// «перечень. Продолжение с большой буквы…» → [перечень, продолжение]; сокращения («ул. Советская») предложением не считаются
function splitListTail(text) {
  const re = /[.!?]\s+(?=[А-ЯЁ«])/g; let m;
  while ((m = re.exec(text))) {
    const before = text.slice(0, m.index);
    if (/(?:^|[\s(])(?:ул|пр|пер|г|д|им|стр|корп|оф|т|п|с|см|руб|тыс)$/i.test(before)) continue;
    return [before, text.slice(m.index + m[0].length)];
  }
  return [text.replace(/[.!?]\s*$/, ''), ''];
}
// строки-пункты «• …», «– …», «1) …», «2. …» в тексте мероприятия — это список, а не сплошной абзац
// (esc() схлопывает переносы строк, поэтому без этого пункты сливались в одну строку)
const LINE_ITEM = /^\s*(?:[•·▪–—-]|\d{1,2}[).])\s+/;
function lineList(text, { winners = false } = {}) {
  const lines = String(text || '').split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
  const first = lines.findIndex((l) => LINE_ITEM.test(l)), last = lines.length - 1 - [...lines].reverse().findIndex((l) => LINE_ITEM.test(l));
  if (first < 0 || lines.filter((l) => LINE_ITEM.test(l)).length < 2) return '';
  const items = lines.slice(first, last + 1), numbered = items.every((l) => !LINE_ITEM.test(l) || /^\d/.test(l));
  const head = lines.slice(0, first).join(' '), tail = lines.slice(last + 1).join(' ');
  const tag = numbered || winners ? 'ol' : 'ul';
  // список «Подпись: https://…» (видео дней, инструкции) — кнопками с подписью, как ссылки в рамках «О соревновании»
  const links = items.map((l) => l.replace(LINE_ITEM, '').match(ABOUT_LINK_LINE));
  if (links.every(Boolean)) {
    return `${head ? `<p>${aboutText(head)}</p>` : ''}<div class="about-card-links about-link-list">${links.map((m) => (isVideoHref(m[2])
      ? `<a class="about-card-link is-video" href="${esc(m[2])}" title="Смотреть видео" target="_blank" rel="noopener"><span aria-hidden="true">▶</span>${esc(capFirst(m[1]))}</a>`
      : `<a class="about-card-link" href="${esc(m[2])}" title="${esc(m[2])}" target="_blank" rel="noopener">${esc(capFirst(m[1]))}<span aria-hidden="true">↗</span></a>`)).join('')}</div>${tail ? `<p>${aboutText(tail)}</p>` : ''}`;
  }
  return `${head ? `<p>${aboutText(head)}</p>` : ''}<${tag} class="${winners ? 'about-winners' : numbered ? 'about-num' : 'about-bul'}">${items.map((l) => `<li>${aboutText(capFirst(l.replace(LINE_ITEM, '')))}</li>`).join('')}</${tag}>${tail ? `<p class="about-blk-note">${aboutText(tail)}</p>` : ''}`;
}
function aboutSectionBody(text, title = '') {
  const list = lineList(text, { winners: /победител|призёр|призер/i.test(title) });   // список победителей — карточками с номерами
  if (list) return list;
  const [listPart, tail] = splitListTail(text);
  const note = tail ? `<p class="about-blk-note">${aboutText(tail)}</p>` : '';
  const steps = listPart.split(/\s*→\s*/).map((x) => x.trim()).filter(Boolean);
  if (steps.length >= 3) {
    return `<ol class="about-route" style="--rows:${Math.ceil(steps.length / 2)}">${steps.map((x, i) => { const v = x.match(/^(.*?\S)\s+(\d[\d\s.,×x/-]*\s?(?:км|м|раз|кг|мин|сек|с|кал|повт)\.?)$/i);
      return `<li><i aria-hidden="true">${i + 1}</i><span>${aboutText(capFirst(v ? v[1] : x))}</span>${v ? `<b>${esc(v[2])}</b>` : ''}</li>`; }).join('')}</ol>${note}`;
  }
  const items = splitOutsideParens(listPart);
  const timed = items.map((x) => x.match(/^(\d{1,2}:\d{2}(?:[–—-]\d{1,2}:\d{2})?)\s+—\s+(.+)$/));
  if (items.length >= 3 && timed.filter(Boolean).length >= items.length - 1) {
    return `<ul class="about-list">${items.map((x, i) => (timed[i] ? `<li><time>${esc(timed[i][1])}</time><span>${aboutText(capFirst(timed[i][2]))}</span></li>` : `<li><span>${aboutText(x)}</span></li>`)).join('')}</ul>${note}`;
  }
  const defs = items.map((x) => x.match(/^(.{2,48}?)\s+—\s+(.+)$/) || x.match(/^(.{2,48}?)\s+(\(.+\))$/));
  if (items.length >= 2 && defs.filter(Boolean).length >= Math.ceil(items.length / 2) && items.every((x) => x.length < 220)) {
    return `<dl class="about-defs">${items.map((x, i) => (defs[i] ? `<div><dt>${aboutText(capFirst(defs[i][1]))}</dt><dd>${aboutText(capFirst(defs[i][2].replace(/^\((.+)\)$/, '$1')))}</dd></div>` : `<div><dt>${aboutText(capFirst(x))}</dt></div>`)).join('')}</dl>${note}`;
  }
  if (items.length >= 3) return `<ul class="about-bul">${items.map((x) => `<li>${aboutText(capFirst(x))}</li>`).join('')}</ul>${note}`;
  // «Дети 6–9, Юниоры 10–13, Взрослые 18–34, …» — короткий перечень названий через запятую → плашки
  const names = items.length === 1 ? listPart.split(/,\s+/).map((x) => x.trim()).filter(Boolean) : [];
  if (names.length >= 4 && names.every((x) => x.length <= 28 && /^[А-ЯЁA-Z«]/.test(x))) return `<ul class="about-chips">${names.map((x) => `<li>${aboutText(x)}</li>`).join('')}</ul>${note}`;
  return '';   // обычный текст без структуры
}
// ссылка из строки плитки: только https без логина в адресе; свой сайт (gto.com.ru) — относительным путём в той же вкладке.
// Путь «//чужой.сайт/…» («https://gto.com.ru//evil.com», «…/\evil.com» — парсер меняет «\» на «/») относительным не делаем:
// браузер понял бы его как адрес без протокола и увёл бы на чужой сайт под видом своего — такая строка остаётся текстом.
function aboutHref(raw) {
  let u; try { u = new URL(raw); } catch (_) { return null; }
  if (u.protocol !== 'https:' || u.username || u.password) return null;
  const own = /^(?:www\.)?gto\.com\.ru$/i.test(u.hostname) || (typeof location !== 'undefined' && u.host === location.host);
  if (!own) return { href: u.href, own };
  const href = u.pathname + u.search + u.hash;
  return /^\/(?![/\\])/.test(href) ? { href, own } : null;
}
const ABOUT_LINK_LINE = /^([^:\n]{2,80}?):\s+(https:\/\/[^\s<>"']+?)[.,;]?$/;
const ABOUT_SUB_LINE = /^([^—:\n]{2,48}?)\s+—\s+(.+)$/;
// предел длины плитки: одна строка / «„Название“ — …» со строками (длинный абзац «Название — …» без кавычек со строками-пунктами
// плиткой не становится — остаётся списком lineList, как раньше)
const ABOUT_CARD_MAX = 420, ABOUT_CARD_MAX_LINES = 2400;
// фото в тексте мероприятия (12.10.2026: портреты Героев ГТО I степени со старой страницы Финала): строка «![подпись](адрес)» —
// внутри абзаца-плитки это фото плитки, отдельным абзацем — фото на всю ширину; адрес — только наш /files/… или https
const ABOUT_IMG = /^!\[([^\]]{0,120})\]\((\/files\/[^\s)]+|https:\/\/[^\s)]+)\)$/;
const aboutImgHtml = (src, alt, w) => `<img loading="lazy" decoding="async" ${rsImgAttrs(src, w)} alt="${esc(alt)}" data-fb="logo">`;
// плитка «Название — текст»: строки текста → разметка; wide — на всю ширину ряда (есть строки или длинный текст);
// rich — есть подпункты или ссылки (одиночная плитка рисуется рамкой только тогда)
function aboutCardHtml(title, text) {
  const [main = '', ...rest] = String(text).split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
  const lead = main.match(/^«([^»]{2,60})»\s+—\s+(.+)$/);   // «Название» — текст: название жирным, без кавычек (как заголовок)
  const parts = [lead ? `<p class="about-card-lead"><strong>${esc(lead[1])}</strong> — ${aboutText(lead[2])}</p>` : `<p>${aboutText(capFirst(main))}</p>`];
  let subs = [], links = [], items = [], rich = false, photo = null;
  const flushSubs = () => { if (subs.length) parts.push(`<div class="about-card-subs">${subs.join('')}</div>`); subs = []; };
  const flushLinks = () => { if (links.length) parts.push(`<div class="about-card-links">${links.join('')}</div>`); links = []; };
  // строки-пункты «• …», «1) …» подряд — список, как в lineList (маркеры не остаются в тексте)
  const flushItems = () => {
    if (!items.length) return;
    const num = items.every((l) => /^\s*\d/.test(l)), tag = num ? 'ol' : 'ul';
    parts.push(`<${tag} class="${num ? 'about-num' : 'about-bul'}">${items.map((l) => `<li>${aboutText(capFirst(l.replace(LINE_ITEM, '')))}</li>`).join('')}</${tag}>`);
    items = [];
  };
  rest.forEach((line) => {
    const im = line.match(ABOUT_IMG);
    if (im) { photo = { alt: im[1], src: im[2] }; rich = true; return; }
    const ln = line.match(ABOUT_LINK_LINE), to = ln && aboutHref(ln[2]);
    if (to) {
      flushSubs(); flushItems(); rich = true;
      links.push(`<a class="about-card-link" href="${esc(to.href)}"${to.own ? '' : ' target="_blank" rel="noopener"'}>${esc(ln[1])}<span aria-hidden="true">${to.own ? '→' : '↗'}</span></a>`);
      return;
    }
    flushLinks();
    if (LINE_ITEM.test(line)) { flushSubs(); items.push(line); return; }
    flushItems();
    const sub = line.match(ABOUT_SUB_LINE);
    if (sub) {
      rich = true;
      const head = sub[1].match(/^(.*?)\s*\(([^()]+)\)$/);   // «Рекорд дня (для всех)» — пояснение плашкой рядом с меткой
      subs.push(`<div class="about-card-sub"><h5>${esc(head ? head[1] : sub[1])}${head ? ` <small>${esc(head[2])}</small>` : ''}</h5><p>${aboutText(capFirst(sub[2]))}</p></div>`);
      return;
    }
    flushSubs(); parts.push(`<p>${aboutText(line)}</p>`);
  });
  flushSubs(); flushItems(); flushLinks();
  const wide = rest.length > 0 || main.length > 400;
  const head = `<h4>${esc(title.replace(/^«(.+)»$/, '$1'))}</h4>${parts.join('')}`;
  const cls = [wide ? 'is-wide' : '', photo ? 'has-photo' : ''].filter(Boolean).join(' ');
  return { wide, rich, html: photo
    ? `<article class="${cls}"><figure class="about-card-photo">${aboutImgHtml(photo.src, photo.alt || title.replace(/^«(.+)»$/, '$1'), 320)}</figure><div class="about-card-body">${head}</div></article>`
    : `<article${cls ? ` class="${cls}"` : ''}>${head}</article>` };
}
// абзац «Метка: текст» → раздел с заголовком и значком (короткая пара «Организатор: …» — строкой с жирной меткой); иначе null
function aboutLabelBlock(p) {
  const lab = p.match(/^([^:.!?\n]{3,70}):\s+([\s\S]+)$/);
  if (!lab) return null;
  const head = lab[1].match(/^(.*?)\s*\(([^()]+)\)$/); const title = head ? head[1] : lab[1];
  const icon = (ABOUT_ICONS.find(([re]) => re.test(title)) || [0, 'i-diamond'])[1];
  const structured = aboutSectionBody(lab[2], lab[1]);
  // короткая пара «Организатор: …», «Сайт: …» — строкой с жирной меткой; раздел с заголовком — для списков и длинного текста
  if (!structured && lab[2].length < 120) return `<p><b>${esc(lab[1])}:</b> ${aboutText(lab[2])}</p>`;
  return `<section class="about-blk"><h3 class="about-blk-h"><svg class="ic ic-xs" aria-hidden="true"><use href="./assets/icons.svg?v=1#${icon}"/></svg><span>${esc(title)}</span>${head ? `<small>${esc(head[2])}</small>` : ''}</h3>${structured || `<p>${aboutText(capFirst(lab[2]))}</p>`}</section>`;
}
// абзацы одного раздела описания → массив блоков (каждый блок — законченный кусок разметки)
function fmtAbout(paragraphs, { lead = false } = {}) {
  const blocks = []; let cards = [];
  const flush = () => {
    const tiles = cards.map(([t, d]) => aboutCardHtml(t, d));
    // плитки — от двух подряд; одна — тоже плиткой, если в ней строки-подпункты или ссылки
    if (cards.length >= 2 || tiles.some((x) => x.rich)) {
      // есть широкие плитки: узкие — ровно в ряд (столько колонок, сколько узких, не больше трёх), широкие — на всю строку
      const narrow = tiles.filter((x) => !x.wide).length;
      const cols = tiles.some((x) => x.wide) ? ` style="--cols:${narrow === 4 ? 2 : Math.max(1, Math.min(3, narrow))}"` : '';
      blocks.push(`<div class="about-cards${cols ? ' has-wide' : ''}"${cols}>${tiles.map((x) => x.html).join('')}</div>`);
    } else {
      // одна простая — как было до рамок: «„Название“ — …: …» — разделом с меткой, короткая — абзацем с жирным названием,
      // длинная — списком строк-пунктов или абзацем
      cards.forEach(([t, d, p]) => blocks.push(aboutLabelBlock(p) || (d.length < ABOUT_CARD_MAX ? `<p><b>${esc(t)}</b> — ${aboutText(d)}</p>` : lineList(p) || `<p>${aboutText(p)}</p>`)));
    }
    cards = [];
  };
  paragraphs.map((x) => String(x || '').trim()).filter(Boolean).forEach((p, idx) => {
    const img = p.match(ABOUT_IMG);
    if (img) { flush(); blocks.push(`<figure class="about-photo">${aboutImgHtml(img[2], img[1], 960)}${img[1] ? `<figcaption>${esc(img[1])}</figcaption>` : ''}</figure>`); return; }
    const dash = p.match(/^((?:«[^»]{2,40}»|[А-ЯЁA-Z][^—:.!?\n]{2,38}))\s+—\s+([\s\S]+)$/);
    const quoted = Boolean(dash && dash[1].startsWith('«'));
    const cardOk = dash && dash[2].length < (quoted && dash[2].includes('\n') ? ABOUT_CARD_MAX_LINES : ABOUT_CARD_MAX);
    // «Название в кавычках» — … — плитка, даже если дальше в тексте есть двоеточие («…в категориях: четыре …»)
    if (cardOk && quoted && !(lead && idx === 0)) { cards.push([dash[1], dash[2], p]); return; }
    // абзац начинается со списка («• …», «1) …») — это список, а не «метка: текст»: у «• День 1: https://…» первая строка не заголовок (10.10.2026)
    if (LINE_ITEM.test(p)) { const list = lineList(p); if (list) { flush(); blocks.push(list); return; } }
    const labeled = aboutLabelBlock(p);
    if (labeled) { flush(); blocks.push(labeled); return; }
    if (lead && idx === 0) {
      flush();
      const org = p.match(/^([\s\S]*?[.!?])\s+(Организатор[ыа]?):\s+([\s\S]+)$/);
      blocks.push(`<div class="about-intro"><p class="about-lead">${aboutText(org ? org[1] : p)}</p>${org ? `<p class="about-org"><b>${esc(org[2])}</b><span>${aboutText(org[3].replace(/\.\s*$/, ''))}</span></p>` : ''}</div>`);
      return;
    }
    if (cardOk) { cards.push([dash[1], dash[2], p]); return; }
    flush(); blocks.push(lineList(p) || `<p>${aboutText(p)}</p>`);
  });
  flush();
  return blocks;
}

// длинное описание: на телефоне после первых трёх блоков — «Читать полностью» (на компьютере текст виден целиком)
// (плитки форматов сразу за третьим блоком — тоже видны: раздел-вводка «Форматы участия» не обрывается перед своими рамками)
function foldAbout(blocks) {
  const cut = String(blocks[3] || '').startsWith('<div class="about-cards') ? 4 : 3;
  if (blocks.length <= cut + 1) return blocks.join('');
  return `${blocks.slice(0, cut).join('')}<div class="about-rest">${blocks.slice(cut).join('')}</div><button type="button" class="about-more-btn" data-about-more>Читать полностью</button>`;
}
// «Все испытания ступени — в калькуляторе ГТО» со страницы турнира: калькулятор открывается с тем же возрастом и полом
if (typeof document !== 'undefined') document.addEventListener('fmgto:calc', (e) => {
  const { age, sex } = e.detail || {};
  if (Number(age) >= 6 && Number(age) <= 85) state.calcAge = Number(age);
  if (sex === 'M' || sex === 'W') state.calcSex = sex;
  state.calcMode = 'general'; saveCalculatorState(); go('calculator');
});
if (typeof document !== 'undefined') document.addEventListener('click', (e) => {
  const b = e.target.closest?.('[data-about-more]'); if (!b) return;
  b.closest('.event-about-card')?.classList.add('is-open'); b.remove();
});

// ссылки в уже экранированном тексте описаний → кликабельные (только https)
// ссылка в тексте мероприятия — коротким названием сервиса со стрелкой, а не длинным адресом (10.10.2026, владелец: «чтобы всё было
// супер красиво»); полный адрес — в подсказке
const LINK_NAMES = [[/(^|\.)(youtube\.com|youtu\.be)$/, 'YouTube'], [/(^|\.)rutube\.ru$/, 'Rutube'],
  [/(^|\.)(vk\.com|vk\.ru|vkvideo\.ru)$/, (u) => (/vkvideo|\/video|\/clip/.test(u) ? 'VK Видео' : /\/album/.test(u) ? 'Фотоальбом ВКонтакте' : 'ВКонтакте')],
  [/(^|\.)disk\.yandex\.(ru|com)$/, 'Яндекс Диск'], [/^t\.me$/, 'Telegram'], [/(^|\.)drive\.google\.com$/, 'Google Диск'],
  [/(^|\.)docs\.google\.com$/, (u) => (/spreadsheets/.test(u) ? 'Google Таблица' : /forms/.test(u) ? 'Google Форма' : 'Google Документ')]];
export function linkName(url) {
  try {
    const host = new URL(url).hostname.replace(/^www\./, ''), hit = LINK_NAMES.find(([re]) => re.test(host));
    return hit ? (typeof hit[1] === 'function' ? hit[1](url) : hit[1]) : host;
  } catch (_) { return url; }
}
// видео (YouTube, VK, RUTUBE) — значок ▶: откроется плеером на сайте; остальные ссылки — ↗, в новой вкладке
const isVideoHref = (href) => Boolean(videoEmbedUrl(String(href).replace(/&amp;/g, '&')));
const extLink = (href, text) => (isVideoHref(href)
  ? `<a class="about-ext is-video" href="${href}" title="Смотреть видео" target="_blank" rel="noopener"><span aria-hidden="true">▶</span>${text}</a>`
  : `<a class="about-ext" href="${href}" title="${href}" target="_blank" rel="noopener">${text}<span aria-hidden="true">↗</span></a>`);
function linkify(escaped) {
  return String(escaped).replace(/https:\/\/[^\s<>"']+[^\s<>"'.,;:)]/g, (u) => extLink(u, esc(linkName(u.replace(/&amp;/g, '&')))));
}
function eventStatus(x) {
  const meta = state.eventManifest?.events?.[String(x.id)] || {};
  // табло турнира (свой движок или leaderboards.ru): регистрация открыта → заявка через наш сайт
  const lb = state.lbStatus?.events?.[String(x.id)] || (x.lbId ? state.lbStatus?.items?.[String(x.lbId)] : null);
  const hasReg = !x.regClosed && Boolean((Array.isArray(meta.registrations) && meta.registrations.length > 0) || Number(meta.registrations) > 0 || x.regUrl || lb?.registration_open);
  if (!isPast(x) && hasReg) return { k: 'registration', label: 'Идёт регистрация', cls: 'st-reg' };
  if (isPast(x)) return { k: 'past', label: 'Завершено', cls: 'st-past' };
  const range = eventDateRange(x);
  if (range && new Date() >= range.start) return { k: 'upcoming', label: 'Идёт сейчас', cls: 'st-reg' };
  // анонс без регистрации (tournament.status 'soon' → regSoon в календаре): «Скоро регистрация» (Ташкент 1144, 14.10.2026)
  if (x.regSoon) return { k: 'soon', label: 'Скоро регистрация', cls: 'st-soon' };
  return { k: 'upcoming', label: 'Предстоит', cls: 'st-up' };
}
const isOngoing = (x) => { const r = x && eventDateRange(x), now = new Date(); return Boolean(r && now >= r.start && now <= r.end); };
// турнир идёт прямо сейчас: плашка под шапкой — с какого по какое число, какой сегодня день и сколько осталось
function eventNowHtml(x) {
  if (!isOngoing(x)) return '';
  const range = eventDateRange(x), now = new Date();
  const DAY = 864e5, total = Math.round((range.end - range.start) / DAY), day = Math.min(total, Math.floor((now - range.start) / DAY) + 1), left = total - day;
  const dm = (d) => d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' });
  if (total <= 1) return `<section class="ev-now is-oneday" aria-label="Соревнование идёт сегодня"><div class="ev-now-head"><span class="ev-now-dot" aria-hidden="true"></span><b>Идёт сегодня</b><span>${esc(dm(range.start))}</span></div></section>`;
  const leftText = left ? `ещё ${left} ${ruPlural(left, 'день', 'дня', 'дней')}` : 'последний день';
  return `<section class="ev-now" aria-label="Соревнование идёт: с ${esc(dm(range.start))} по ${esc(dm(range.end))}">
    <div class="ev-now-head"><span class="ev-now-dot" aria-hidden="true"></span><b>Идёт сейчас</b><span>${leftText}</span></div>
    <div class="ev-now-range">
      <div><small>Старт</small><b>${esc(dm(range.start))}</b></div>
      <div class="ev-now-bar" role="progressbar" aria-label="Прошло дней" aria-valuemin="1" aria-valuemax="${total}" aria-valuenow="${day}" style="--p:${(day / total).toFixed(3)}"><i></i></div>
      <div class="ev-now-end"><small>Финиш</small><b>${esc(dm(range.end))}</b></div>
    </div>
    <small class="ev-now-day">День ${day} из ${total}</small>
  </section>`;
}

function compareEvents(a, b) {
  const aStatus = eventStatus(a).k;
  const bStatus = eventStatus(b).k;
  const priority = { registration: 0, soon: 1, upcoming: 2, past: 3 };
  const statusOrder = (priority[aStatus] ?? 3) - (priority[bStatus] ?? 3);
  if (statusOrder) return statusOrder;
  const aRange = eventDateRange(a);
  const bRange = eventDateRange(b);
  const aTime = aRange ? (aStatus === 'past' ? aRange.end : aRange.start).getTime() : 0;
  const bTime = bRange ? (bStatus === 'past' ? bRange.end : bRange.start).getTime() : 0;
  return aStatus === 'past' ? bTime - aTime : aTime - bTime;
}

// лента «Стартов» по месяцам: от поздних дат к ранним — каждый месяц один раз (будущие сверху, дальше прошедшие)
// мероприятие уже началось и ещё не закончилось
function isRunningNow(x) {
  const range = eventDateRange(x);
  return Boolean(range && !isPast(x) && new Date() >= range.start);
}
function compareTimeline(a, b) {
  const ta = eventDateRange(a)?.start?.getTime() || 0, tb = eventDateRange(b)?.start?.getTime() || 0;
  return tb - ta;
}
// порядок «Стартов»: идут сейчас → идёт регистрация → предстоят (ближайшие первыми) → прошедшие (свежие первыми, по месяцам)
// главные события (те же, что в блоке «Главные события» на главной) — первой группой, над идущими (14.10.2026,
// владелец: «нужно, чтобы мероприятие было хорошо видно — а то оно сильно внизу»)
const START_GROUPS = { featured: -1, running: 0, registration: 1, soon: 2, upcoming: 3, past: 4 };
const START_HEADS = { featured: '<h3 class="ev-month is-featured"><span>Главные старты</span></h3>', soon: '<h3 class="ev-month is-soon"><span>Скоро регистрация</span></h3>', running: '<h3 class="ev-month is-running"><span>Идут сейчас</span></h3>', registration: '<h3 class="ev-month is-reg"><span>Идёт регистрация</span></h3>', upcoming: '<h3 class="ev-month"><span>Предстоят</span></h3>' };
function startGroup(x) {
  const k = eventStatus(x).k;
  if (isMainEvent(x) && k !== 'past') return 'featured';
  if (isRunningNow(x)) return 'running';
  return k === 'registration' || k === 'past' || k === 'soon' ? k : 'upcoming';
}
function compareStarts(a, b) {
  const ga = startGroup(a), gb = startGroup(b);
  return (START_GROUPS[ga] - START_GROUPS[gb]) || (ga === 'past' ? compareTimeline(a, b) : -compareTimeline(a, b));
}

function renderHomeRegistrations() {
  const container = $('#home-registrations');
  if (container) {
    container.hidden = true;
    container.innerHTML = '';
  }
}

// бегущая лента рекордов России на главной (как Magic UI Marquee): пауза при наведении, без анимации при reduced-motion
function renderHomeTicker() {
  let box = $('#home-ticker');
  const anchor = document.querySelector('[data-screen="home"] .desktop-proof-strip') || document.querySelector('[data-screen="home"] .k-stats');
  if (!box && anchor) {
    box = document.createElement('section'); box.id = 'home-ticker'; box.className = 'hm-ticker'; box.setAttribute('aria-label', 'Свежие рекорды России');
    anchor.after(box);
  }
  if (!box || box.dataset.ready) return;
  loadRecords().then(() => {
    const yearOf = (r) => Number((String(r.event || '').match(/20\d{2}/) || ['0'])[0]);
    const items = (GTO_RECORDS || []).filter(r => r.holder && r.result && r.discipline && !isBeatenRecord(r)).sort((a, b) => yearOf(b) - yearOf(a)).slice(0, 28);
    if (!items.length) { box.remove(); return; }   // заготовка из разметки не должна висеть пустой
    const shortName = (n) => { const w = String(n).split(/\s+/); return w.length > 1 ? `${w[0]} ${w[1][0]}.` : n; };
    const item = (r) => `<button type="button" class="hm-tick" data-go="records" title="${esc(`${r.discipline} — ${r.result} · ${r.holder}${r.event ? ' · ' + r.event : ''}`)}"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-trophy"/></svg><span class="hm-tick-disc">${esc(String(r.discipline).replace(/\s*\(.*?\)\s*/g, ' ').trim())}</span><b>${esc(r.result)}</b><span class="hm-tick-who">${esc(shortName(r.holder))}${r.ageGroup ? ` · ${esc(r.ageGroup)}` : ''}</span></button>`;
    const row = items.map(item).join('');
    box.innerHTML = `<div class="hm-ticker-label"><span class="hm-live"></span>Рекорды России</div><div class="hm-ticker-viewport"><div class="hm-ticker-track">${row}<span class="hm-ticker-dup" aria-hidden="true" inert>${row}</span></div></div>`;
    box.dataset.ready = '1';
  }).catch(() => box.remove());
}

// «Старты» на главной — карусель афиш (home_carousel.js?v=1b2c9b3a): слева архив (последние прошедшие), в центре — идущий сейчас
// или ближайший старт, справа — будущие; по краям — «Весь архив» и «Весь календарь». На карточке: афиша, название,
// даты и кнопка по состоянию — «Заявка» (идёт регистрация), «Смотреть» (идёт сейчас), «Результаты» (прошёл), «Подробнее».
const HOME_ARCHIVE = 8, HOME_SOON = 12;
function homeEventCard(x) {
  const st = eventStatus(x); const d0 = eventDateRange(x).start;
  const past = st.k === 'past', now = !past && isOngoing(x);
  const poster = x.localPoster || x.poster || x.img;
  const hasPoster = poster && !/logo-clean|icon-192/.test(poster);
  const bg = hasPoster ? rsUrl(poster, 640) : '';   // на компьютере карточка до 560px шириной — афиша 640 (на чётком экране 1280)
  const cover = hasPoster ? `<img loading="lazy" ${rsImgAttrs(poster, 640)} alt="" data-fb="logo" data-portrait="parent">`
    : `<div class="event-cover-fallback color-${getAvatarColorIndex(x.id || x.title)}" aria-hidden="true"><span class="tbf-tag">ГТО</span><strong class="tbf-year">'${String(d0.getFullYear()).slice(-2)}</strong></div>`;
  const [cta, pane] = st.k === 'registration' ? ['Заявка', 'reg'] : now ? ['Смотреть', 'results'] : past ? ['Результаты', 'results'] : ['Подробнее', 'about'];
  return `<article class="hev${past ? ' is-past' : ''}"><div class="hev-in"><div class="hev-tilt">
    <button type="button" class="hev-open" data-event="${x.id}" data-event-pane="${past ? 'results' : 'about'}" aria-label="${esc(x.title)}">
      <div class="evc-media" ${bg ? `style="--evc-bg:url('${esc(bg)}')"` : ''}>${cover}
        <span class="evc-date" aria-hidden="true"><b>${d0.getDate()}</b><small>${MONTHS_RU[d0.getMonth()].slice(0, 3).toLowerCase()}</small></span>
        <span class="evc-status event-status ${st.cls}">${past ? 'Архив' : st.label}</span></div>
      <div class="hev-body"><b>${esc(x.title)}</b><small>${esc([x.period, x.location].filter(Boolean).join(' · '))}</small></div>
    </button>
    <button type="button" class="hev-cta${st.k === 'registration' ? ' is-reg' : ''}" data-event="${x.id}" data-event-pane="${pane}" aria-label="${esc(`${cta}: ${x.title}`)}">${cta} <span aria-hidden="true">→</span></button>
  </div></div></article>`;
}
const homeMoreCard = (go, kicker, title, note) => `<article class="hev hev-more"><div class="hev-in"><div class="hev-tilt"><button type="button" class="hev-open" data-go="${go}"><span class="hev-more-k">${kicker}</span><b>${title}</b><small>${note}</small><span class="hev-more-arrow" aria-hidden="true">→</span></button></div></div></article>`;
function renderHomeEvents() {
  const wrap = $('#home-events-wrap'), box = $('#home-events');
  if (!wrap || !box || box.dataset.ready) return;
  loadCalendar().then(() => {
    const all = getUnifiedEvents().filter((x) => x && x.title && eventDateRange(x));
    const t = (x) => eventDateRange(x).start.getTime();
    // строго по датам начала (26.10.2026, владелец: «паровоз должен быть хронологическим»); главные — отдельным блоком выше
    const soon = all.filter((x) => eventStatus(x).k !== 'past').sort((a, b) => t(a) - t(b)).slice(0, HOME_SOON);
    const past = all.filter((x) => eventStatus(x).k === 'past').sort((a, b) => t(b) - t(a)).slice(0, HOME_ARCHIVE).reverse();   // старые — левее
    if (!soon.length && !past.length) { wrap.hidden = true; return; }   // блок стоит видимым с заготовкой высоты (без сдвига) — пусто, прячем
    $('#home-events-title').textContent = soon.length ? 'Ближайшие старты' : 'Последние турниры';
    const cards = [...past.map(homeEventCard), ...soon.map(homeEventCard)];
    box.innerHTML = [past.length ? homeMoreCard('results', 'Архив', 'Все прошедшие старты', 'протоколы и результаты') : '', ...cards,
      homeMoreCard('events', 'Календарь', 'Все соревнования', 'регистрация и даты')].join('');
    box.dataset.ready = '1'; wrap.hidden = false;
    // в центре — первый не прошедший старт (идёт сейчас или ближайший); если будущих нет — последний прошедший
    const start = (past.length ? 1 : 0) + (soon.length ? past.length : past.length - 1);
    import('./home_carousel.js?v=1b2c9b3a').then((m) => m.mountCarousel(box, { start, nav: wrap.querySelector('.hev-nav') }));
  }).catch(() => { wrap.hidden = true; });
}

// «Главные события» — баннеры главных проектов Федерации над «паровозом» стартов, как на старом сайте (26.10.2026, владелец:
// «над паровозом должен быть раздел с баннерами — главные события»). Список и порядок ведёт модератор кнопкой на странице
// турнира (правка home/main: { ids }); пока её нет — список ниже плюс международные фестивали (featured из выгрузки).
// Прошедшие пропадают сами.
const MAIN_EVENTS_DEFAULT = ['1139', '1137', '110', '1144'];   // Минск, «Иду на рекорд» в Павильоне ГТО, Студенческие игры, Ташкент
function mainEventIds() {
  const o = contentOverride('home', 'main');
  if (o && !o.deleted && Array.isArray(o.ids)) return o.ids.map(String);
  const extra = (getUnifiedEvents() || []).filter((x) => x?.featured && !MAIN_EVENTS_DEFAULT.includes(String(x.id))).map((x) => String(x.id));
  return [...MAIN_EVENTS_DEFAULT, ...extra];
}
function isMainEvent(x) { return Boolean(x) && mainEventIds().includes(String(x.id)); }
function homeMainCard(x, i) {
  const st = eventStatus(x), now = isOngoing(x);
  const poster = x.localPoster || x.poster || x.img;
  const hasPoster = poster && !/logo-clean|icon-192/.test(poster);
  const d0 = eventDateRange(x).start;
  const cover = hasPoster ? `<img ${i < 2 ? '' : 'loading="lazy" '}decoding="async" ${rsImgAttrs(poster, 640)} alt="" data-fb="logo">`
    : `<div class="event-cover-fallback color-${getAvatarColorIndex(x.id || x.title)}" aria-hidden="true"><span class="tbf-tag">ГТО</span><strong class="tbf-year">'${String(d0.getFullYear()).slice(-2)}</strong></div>`;
  const label = now ? 'Идёт сейчас' : st.label;
  const [cta, pane] = st.k === 'registration' ? ['Заявка', 'reg'] : ['Подробнее', 'about'];
  return `<article class="hme${now ? ' is-now' : ''}" role="listitem">
    <button type="button" class="hme-open" data-event="${x.id}" data-event-pane="about" aria-label="${esc(`${x.title}, ${x.period || ''}`)}">
      <span class="hme-media">${cover}</span>
      <span class="hme-bar"><span class="hme-st${now ? '' : ` is-${st.k}`}">${now ? '<i aria-hidden="true"></i>' : ''}${esc(label)}</span><span class="hme-when">${esc(x.period || '')}</span></span>
    </button>
    <button type="button" class="hme-cta${pane === 'reg' ? ' is-reg' : ''}" data-event="${x.id}" data-event-pane="${pane}" aria-label="${esc(`${cta}: ${x.title}`)}">${cta} <span aria-hidden="true">→</span></button>
  </article>`;
}
function renderHomeMain() {
  const wrap = $('#home-main-wrap'), box = $('#home-main');
  if (!wrap || !box) return;
  loadCalendar().then(() => {
    const byId = new Map((getUnifiedEvents() || []).filter((x) => x && x.title && eventDateRange(x)).map((x) => [String(x.id), x]));
    const items = mainEventIds().map((id) => byId.get(id)).filter((x) => x && !isPast(x));
    const sig = items.map((x) => `${x.id}:${eventStatus(x).k}`).join(',');
    if (box.dataset.sig === sig && box.childElementCount) return;   // перерисовка главной без перемен — ленту не трогаем
    box.dataset.sig = sig;
    if (!items.length) { wrap.hidden = true; box.innerHTML = ''; return; }
    box.innerHTML = items.map(homeMainCard).join('');
    box.classList.toggle('is-few', items.length < 3);
    wrap.hidden = false;
    bindHomeMainNav(wrap, box);
  }).catch(() => { if (!box.childElementCount) wrap.hidden = true; });
}
// листать: крупные стрелки по бокам ленты, на середине баннера (26.10.2026, заказчик: «стрелочки долго искала… сделать
// более явно, по бокам») — на компьютере; точки под лентой — везде (на телефоне ещё и свайп). Всё — когда баннеры не помещаются
function bindHomeMainNav(wrap, box) {
  const arrows = [...wrap.querySelectorAll('.hme-arrow')], dots = wrap.querySelector('.hme-dots');
  const cards = () => [...box.querySelectorAll('.hme')];
  const smooth = () => (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');
  const goTo = (i) => { const c = cards()[i]; if (c) box.scrollTo({ left: c.offsetLeft - cards()[0].offsetLeft, behavior: smooth() }); };
  const current = () => { const list = cards(); if (!list.length) return 0; const x0 = list[0].offsetLeft;
    return list.reduce((best, c, i) => (Math.abs(c.offsetLeft - x0 - box.scrollLeft) < Math.abs(list[best].offsetLeft - x0 - box.scrollLeft) ? i : best), 0); };
  const sync = () => {
    const over = box.scrollWidth > box.clientWidth + 2, atStart = box.scrollLeft < 4, atEnd = box.scrollLeft + box.clientWidth > box.scrollWidth - 4;
    arrows.forEach((a) => { a.hidden = !over; a.classList.toggle('is-off', a.dataset.hmeNav === '-1' ? atStart : atEnd); a.tabIndex = (a.dataset.hmeNav === '-1' ? atStart : atEnd) ? -1 : 0; });
    if (!dots) return;
    dots.hidden = !over;
    // последняя точка — когда лента докручена до конца (на компьютере видно два баннера, и последний не встаёт первым)
    const n = cards().length, cur = atEnd ? n - 1 : current();
    if (dots.childElementCount !== n) dots.innerHTML = cards().map((c, i) => `<button type="button" data-hme-dot="${i}" aria-label="Событие ${i + 1} из ${n}"></button>`).join('');
    [...dots.children].forEach((d, i) => d.setAttribute('aria-current', i === cur ? 'true' : 'false'));
  };
  if (!wrap.dataset.navBound) {
    wrap.dataset.navBound = '1';
    wrap.addEventListener('click', (e) => {
      const a = e.target.closest('[data-hme-nav]'), d = e.target.closest('[data-hme-dot]');
      if (d) { goTo(Number(d.dataset.hmeDot)); return; }
      const card = box.querySelector('.hme'); if (!a || !card) return;
      const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(box).columnGap || '0');
      box.scrollBy({ left: Number(a.dataset.hmeNav) * step, behavior: smooth() });
    });
    box.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    window.addEventListener('resize', sync, { passive: true });
  }
  if (dots) dots.innerHTML = '';   // набор баннеров мог смениться
  sync();
}

// объявление модератора на главной (под обложкой): текст, ссылка, цвет; «убрать» — скрывает
function renderHomeAnnouncement() {
  const hero = document.querySelector('[data-screen="home"] > .hero'); if (!hero) return;
  let box = document.getElementById('home-announce');
  const b = contentOverride('home', 'banner');
  if (!b || b.deleted || !b.text) { box?.remove(); return; }
  // даты показа: вне окна объявление видит только модератор — с пометкой, когда оно появится или когда закончилось
  const today = new Date().toLocaleDateString('sv-SE');   // YYYY-MM-DD по местному времени
  const dm = (iso) => new Date(iso + 'T00:00:00').toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' });
  const off = (b.from && today < b.from) ? `Посетители увидят с ${dm(b.from)}` : (b.to && today > b.to) ? `Показ закончился ${dm(b.to)}` : '';
  if (off && !isModMode()) { box?.remove(); return; }
  if (!box) { box = document.createElement('aside'); box.id = 'home-announce'; box.setAttribute('role', 'status'); hero.after(box); }
  const tone = ['info', 'important', 'success'].includes(b.tone) ? b.tone : 'info';
  const link = b.link ? (b.link.startsWith('#') ? b.link : safeUrl(b.link)) : '';
  box.className = `home-announce ${tone}${off ? ' is-off' : ''}`;
  box.innerHTML = `<span class="home-announce-ico" aria-hidden="true"><svg class="ic"><use href="./assets/icons.svg?v=1#i-megaphone"/></svg></span><p>${off ? `<small class="home-announce-off">${esc(off)}</small>` : ''}${esc(b.text)}</p>${link ? `<a class="home-announce-go" href="${esc(link)}" ${link.startsWith('#') ? '' : 'target="_blank" rel="noopener"'}>Подробнее →</a>` : ''}`;
}

// нижние блоки главной грузятся своими модулями, когда до них докрутили: «Мы всегда рядом» (home_federations.js?v=6b778802),
// «Станьте частью большего» (contact_form.js?v=fce5d70b)
function mountHomeLazy(id, load) {
  const el = document.getElementById(id);
  if (!el || el.dataset.mounted || el.dataset.watch) return;
  el.dataset.watch = '1';
  const go = () => load(el).catch(() => { delete el.dataset.watch; });
  if (!('IntersectionObserver' in window)) { go(); return; }
  const io = new IntersectionObserver((es) => { if (es.some((x) => x.isIntersecting)) { io.disconnect(); go(); } }, { rootMargin: '600px' });
  io.observe(el);
}
function mountHomeContact() {
  mountHomeLazy('home-federations', (el) => import('./home_federations.js?v=6b778802').then((m) => m.mountFederations(el)));
  mountHomeLazy('home-contact', (el) => import('./contact_form.js?v=fce5d70b').then((m) => m.mountContact(el)));
}

function renderHome() {
  mountHomeContact();
  renderHomeRegistrations();
  renderHomeTicker();
  renderHomeMain();
  renderHomeEvents();
  let news = getUnifiedNews();
  if ((!news || !news.length) && HOME_SUMMARY?.latestNews?.length) {
    news = HOME_SUMMARY.latestNews;
  }
  renderHomeAnnouncement();
  // закреплённая модератором новость — первой в ленте «Сейчас важно»
  const pin = contentOverride('home', 'pinned');
  if (pin && !pin.deleted && pin.newsId) {
    const i = (news || []).findIndex((x) => String(x.id) === String(pin.newsId));
    if (i > 0) news = [news[i], ...news.slice(0, i), ...news.slice(i + 1)];
  }
  const pinnedId = pin && !pin.deleted ? String(pin.newsId) : '';
  const rail = $('#home-news');
  if (rail) {
    rail.innerHTML = (news || []).slice(0, 5).map(x => `
      <button class="story ${String(x.id) === pinnedId ? 'is-pinned' : ''}" data-article="${x.id}">${String(x.id) === pinnedId ? '<span class="story-pin">Закреплено</span>' : ''}
        <img ${rsImgAttrs(x.img, 320)} alt="" data-fb="logo">
        <div><small>${esc(x.date)}</small><b>${esc(x.title)}</b></div>
      </button>
    `).join('');
  }
}

function setupEventYears() {
  const el = $('#event-years');
  if (!el) return;
  const years = [...new Set(GTO_CALENDAR_EVENTS.map(eventYear).filter(Boolean))].sort((a, b) => b - a);
  el.innerHTML = [['all', 'Все годы']].concat(years.map(y => [String(y), String(y)]))
    .map(([v, l]) => `<button type="button" data-event-year="${v}" class="${String(state.eventYear) === v ? 'active' : ''}">${l}</button>`).join('');
}

// уровень как на gto.com.ru: федеральные (всероссийские/межрегиональные/международные) и региональные
function eventLevelKey(ev) {
  const c = String(ev?.category || '').toLowerCase();
  if (ev?.isMajor || /всеросс|межрегион|международ|федерал/.test(c)) return 'federal';
  return 'regional';
}

const MONTHS_RU = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
function eventMonthKey(ev) {
  const r = eventDateRange(ev);
  if (!r) return '';
  const d = r.start;
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

function setupEventFilters() {
  const citySelect = $('#event-city');
  if (!citySelect) return;
  const cities = new Set();
  GTO_CALENDAR_EVENTS.forEach(x => {
    if (!x.location) return;
    const parts = x.location.split(',').map(p => p.trim());
    if (parts[0] && parts[0].length > 2) cities.add(parts[0]);
  });
  const sortedCities = [...cities].sort((a, b) => a.localeCompare(b, 'ru'));
  citySelect.innerHTML = '<option value="all">Все регионы и города</option>' + sortedCities.map(c => `<option value="${esc(c)}">${esc(c)}</option>`).join('');
}

function getEventFormat(ev) {
  if (!ev) return 'OFFLINE';
  if (ev.format) {
    const f = String(ev.format).trim().toUpperCase();
    if (f === 'HYBRID' || f.includes('ГИБРИД')) return 'HYBRID';
    if (f === 'ONLINE' || f.includes('ОНЛАЙН')) return 'ONLINE';
    return 'OFFLINE';
  }
  const loc = String(ev.location || '').toLowerCase();
  const tit = String(ev.title || '').toLowerCase();
  if (ev.hasOnline && loc && !loc.includes('онлайн')) return 'HYBRID';
  if (ev.hasOnline || tit.includes('онлайн') || loc.includes('онлайн')) return 'ONLINE';
  return 'OFFLINE';
}

function getEventPrograms(ev) {
  if (!ev) return ['allround'];
  if (Array.isArray(ev.programs) && ev.programs.length) return ev.programs;
  const progs = ['allround'];
  const t = `${ev.title || ''} ${ev.location || ''} ${ev.description || ''}`.toLowerCase();
  // только по прямому упоминанию: раньше «Герой ГТО» ставился любому онлайн-турниру и отбору (Народные Игры, отборы на Кубок ДВ — 8 турниров),
  // «Иду на рекорд» — любому тексту со словом «силовой» (10.10.2026)
  if (/герой\s+гто/.test(t)) progs.push('herogto');
  if (/иду на рекорд/.test(t)) progs.push('records');
  return progs;
}
// программа турнира на карточке: подпись «В программе» и пояснение к каждому значку (10.10.2026, владелец: «непонятно, что они значат»)
const PROG_INFO = {
  allround: { name: 'Многоборье ГТО', tip: 'Многоборье ГТО — соревнования по видам комплекса ГТО: личный и командный зачёт' },
  herogto: { name: 'Герой ГТО', icon: 'i-zap', tip: '«Герой ГТО» — забег и комплекс функционально-силовых упражнений' },
  records: { name: 'Иду на рекорд', icon: 'i-trophy', tip: '«Иду на рекорд» — попытки установить рекорд соревнований в одном упражнении' },
};
function eventProgChipsHtml(progs) {
  const chips = progs.filter((p) => PROG_INFO[p]).map((p) => { const i = PROG_INFO[p];
    return `<span class="event-prog-chip ${p}" title="${esc(i.tip)}">${i.icon ? `<svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#${i.icon}"/></svg> ` : ''}${i.name}</span>`; });
  return chips.length ? `<span class="event-prog-label">В программе:</span>${chips.join('')}` : '';
}

function updateEventsActiveChips() {
  const bar = $('#events-active-bar');
  const container = $('#events-active-chips');
  if (!bar || !container) return;

  const chips = [];
  if (state.eventYear && state.eventYear !== 'all') {
    chips.push({ key: 'year', label: `Год: ${state.eventYear}` });
  }
  if (state.eventLevel && state.eventLevel !== 'all') {
    chips.push({ key: 'level', label: state.eventLevel === 'federal' ? 'Федеральные' : 'Региональные' });
  }
  if (state.eventStatus && state.eventStatus !== 'all') {
    const stMap = { registration: 'Регистрация', upcoming: 'Предстоящие', past: 'Прошедшие' };
    chips.push({ key: 'status', label: `Статус: ${stMap[state.eventStatus] || state.eventStatus}` });
  }
  if (state.eventCity && state.eventCity !== 'all') {
    chips.push({ key: 'city', label: `Город: ${state.eventCity}` });
  }
  if (state.eventFormat && state.eventFormat !== 'all') {
    const fmtMap = { offline: 'Очный', online: 'Онлайн', hybrid: 'Гибридный' };
    chips.push({ key: 'format', label: `Формат: ${fmtMap[state.eventFormat] || state.eventFormat}` });
  }
  if (state.eventProgram && state.eventProgram !== 'all') {
    const progMap = { allround: 'Многоборье', herogto: 'Герой ГТО', records: 'Иду на рекорд' };
    chips.push({ key: 'program', label: `Программа: ${progMap[state.eventProgram] || state.eventProgram}` });
  }
  if (state.eventType && state.eventType !== 'all') {
    const typeMap = { cup: 'Кубок / Первенство', champ: 'Чемпионат России', games: 'Игры ГТО', vostok: 'Дальний Восток' };
    chips.push({ key: 'type', label: `Уровень: ${typeMap[state.eventType] || state.eventType}` });
  }
  if (state.eventQuery) {
    chips.push({ key: 'query', label: `Поиск: «${state.eventQuery}»` });
  }

  // кнопка «Фильтры» на телефоне: число выбранных фильтров из панели (уровень, регион, год)
  const inSheet = chips.filter((c) => ['year', 'level', 'city'].includes(c.key)).length;
  const badge = document.querySelector('.ev-filter-count');
  if (badge) { badge.hidden = !inSheet; badge.textContent = String(inSheet); }
  if (chips.length > 0) {
    bar.style.display = 'flex';
    container.innerHTML = chips.map(c => `
      <span class="active-chip" data-event-chip="${c.key}">
        <span>${esc(c.label)}</span>
        <span class="active-chip-remove" aria-label="Удалить фильтр">✕</span>
      </span>
    `).join('');
  } else {
    bar.style.display = 'none';
    container.innerHTML = '';
  }
}

// телефон: уровень, регион и год — в выдвижной панели снизу (на первом экране — только статусы и кнопка «Фильтры»)
function setEventSheet(open) {
  const sheet = document.getElementById('ev-filters-sheet'); const btn = document.querySelector('.ev-filter-toggle'); const bd = document.querySelector('.ev-sheet-backdrop');
  if (!sheet || !btn) return;
  sheet.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', String(open)); if (bd) bd.hidden = !open;
  document.body.classList.toggle('ev-sheet-open', open);
  if (open) sheet.querySelector('.ev-sheet-done')?.focus(); else btn.focus({ preventScroll: true });
}
document.addEventListener('click', (e) => {
  if (e.target.closest('.ev-filter-toggle')) { setEventSheet(!document.getElementById('ev-filters-sheet')?.classList.contains('is-open')); return; }
  if (e.target.closest('.ev-sheet-done') || e.target.closest('.ev-sheet-backdrop')) { setEventSheet(false); return; }
  if (e.target.closest('.ev-sheet-reset')) { resetEventsFilters(); setEventSheet(false); }
});
document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && document.getElementById('ev-filters-sheet')?.classList.contains('is-open')) setEventSheet(false); });
window.addEventListener('hashchange', () => { if (document.body.classList.contains('ev-sheet-open')) setEventSheet(false); });

export function resetEventsFilters() {
  state.eventYear = 'all';
  state.eventLevel = 'all';
  state.eventStatus = 'all';
  state.eventCity = 'all';
  state.eventFormat = 'all';
  state.eventProgram = 'all';
  state.eventType = 'all';
  state.eventQuery = '';
  state.eventsDisplayLimit = 20;

  const sInput = $('#event-search');
  if (sInput) sInput.value = '';
  const ySel = $('#event-year');
  if (ySel) ySel.value = 'all';
  const cSel = $('#event-city');
  if (cSel) cSel.value = 'all';
  const fSel = $('#event-format');
  if (fSel) fSel.value = 'all';
  const pSel = $('#event-program');
  if (pSel) pSel.value = 'all';
  const tSel = $('#event-type');
  if (tSel) tSel.value = 'all';
  $$('#event-status button').forEach(b => b.classList.toggle('active', b.dataset.eventStatus === 'all'));
  $$('[data-event-year]').forEach(b => b.classList.toggle('active', b.dataset.eventYear === 'all'));
  $$('[data-event-level]').forEach(b => b.classList.toggle('active', b.dataset.eventLevel === 'all'));

  renderEvents();
}

function renderEvents() {
  const isMod = Boolean(localStorage.getItem('fmgto_hub_token'));
  const q = state.eventQuery.toLowerCase();
  const allEvents = getUnifiedEvents();
  const items = allEvents.filter(x => {
    if (state.eventYear !== 'all' && eventYear(x) !== Number(state.eventYear)) return false;
    if (state.eventLevel && state.eventLevel !== 'all' && eventLevelKey(x) !== state.eventLevel) return false;
    if (state.eventStatus !== 'all' && eventStatus(x).k !== state.eventStatus && !(state.eventStatus === 'upcoming' && ['registration', 'soon'].includes(eventStatus(x).k))) return false;
    if (state.eventCity !== 'all' && !String(x.location || '').toLowerCase().includes(state.eventCity.toLowerCase())) return false;
    if (state.eventFormat !== 'all') {
      const fmt = getEventFormat(x).toLowerCase();
      if (fmt !== state.eventFormat.toLowerCase()) return false;
    }
    if (state.eventProgram !== 'all') {
      const progs = getEventPrograms(x);
      if (!progs.includes(state.eventProgram)) return false;
    }
    if (state.eventType !== 'all') {
      const t = `${x.title} ${x.location}`.toLowerCase();
      if (state.eventType === 'cup' && !/кубок|первенств/i.test(t)) return false;
      if (state.eventType === 'champ' && !/чемпионат/i.test(t)) return false;
      if (state.eventType === 'games' && !/игры гто/i.test(t)) return false;
      if (state.eventType === 'vostok' && !/восток|дфо|владивосток|хабаровск/i.test(t)) return false;
    }
    return `${x.title} ${x.period} ${x.location}`.toLowerCase().includes(q);
  }).sort(compareStarts);

  state.eventsDisplayLimit = state.eventsDisplayLimit || 20;
  const totalEvents = items.length;
  // выбран год — весь год сразу (за год до полусотни стартов): по 20 видны были только сентябрь–декабрь, и казалось,
  // что остальных месяцев нет (проверка Федерации, 07.10.2026); без года — по 20 с кнопкой «Показать ещё»
  const visibleEvents = state.eventYear !== 'all' ? items : items.slice(0, state.eventsDisplayLimit);

  const countEl = $('#event-count');
  if (countEl) {
    const modCountTag = isMod
      ? `<span style="display:inline-flex;align-items:center;gap:6px;margin-left:10px;"><b style="color:#38bdf8;font-size:11px;background:rgba(56,189,248,0.12);padding:2px 8px;border-radius:6px;border:1px solid rgba(56,189,248,0.3)"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-shield"/></svg> Модератор</b></span>`
      : '';
    countEl.innerHTML = `${totalEvents} ${ruPlural(totalEvents, 'событие', 'события', 'событий')}${totalEvents > visibleEvents.length ? ` (показано ${visibleEvents.length})` : ''} ${modCountTag}`;
  }

  updateEventsActiveChips();

  let loadMoreHtml = '';
  if (totalEvents > visibleEvents.length) {
    const remaining = totalEvents - visibleEvents.length;
    const chunk = Math.min(20, remaining);
    loadMoreHtml = `<button type="button" class="load-more" id="events-load-more">Показать ещё ${chunk} (осталось ${remaining})</button>`;
  }

  const modBannerHtml = isMod ? `
    <div class="mod-action-banner" style="grid-column: 1 / -1; margin-bottom: 14px;">
      <div>
        <b style="color:#38bdf8;font-size:13px;display:block;">Управление календарем соревнований</b>
        <span style="font-size:12px;color:#94a3b8;">Вы можете добавить новое соревнование или изменить существующие</span>
      </div>
      <button type="button" class="mod-top-btn" id="btn-mod-add-event-feed"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-plus"/></svg> Добавить турнир</button>
    </div>
  ` : '';

  let lastMonth = '';
  $('#event-list').innerHTML = modBannerHtml + (visibleEvents.length ? visibleEvents.map(x => {
    // лента по месяцам, как на gto.com.ru: «Сентябрь 2024»
    const group = startGroup(x), mk = group === 'past' ? eventMonthKey(x) : group;
    const monthHead = mk && mk !== lastMonth ? (START_HEADS[mk] || `<h3 class="ev-month"><span>${MONTHS_RU[Number(mk.slice(5)) - 1]}</span><b>${mk.slice(0, 4)}</b></h3>`) : '';
    if (mk) lastMonth = mk;
    const meta = state.eventManifest?.events?.[String(x.id)] || {};
    const media = getTournamentMedia(x.id, x);
    const hasResults = Boolean(meta.results || (state.resultsManifest?.events?.[String(x.id)]));
    const hasPhotos = Boolean((media.albums && media.albums.length > 0) || ((x.media || []).length > 0));
    const hasVideos = Boolean(media.videos && media.videos.length > 0);
    const st = eventStatus(x);
    const poster = x.localPoster || x.poster || x.img;
    const yr = eventYear(x) || (x.period && String(x.period).match(/\d{4}/)?.[0]) || '26';
    const yrShort = String(yr).slice(-2);
    let tag = 'ГТО';
    const titleLower = (x.title || '').toLowerCase();
    if (titleLower.includes('чемпионат')) tag = 'ЧР';
    else if (titleLower.includes('кубок')) tag = 'КУБОК';
    else if (titleLower.includes('первенство')) tag = 'ПР';
    else if (titleLower.includes('игры')) tag = 'ИГРЫ';
    else if (titleLower.includes('восток') || titleLower.includes('дфо')) tag = 'ДФО';
    const colorIdx = getAvatarColorIndex(x.id || x.title);
    const coverHtml = (poster && poster !== './assets/logo-clean.png' && poster !== 'assets/icon-192.png' && !poster.includes('logo-clean'))
      ? `<img loading="lazy" ${rsImgAttrs(poster, 480)} alt="" data-fb="cover" data-portrait="parent" data-fb-tag="${esc(tag)}" data-fb-yr="${esc(yrShort)}" data-fb-color="${colorIdx}">`
      : `<div class="event-cover-fallback color-${colorIdx}" aria-hidden="true"><span class="tbf-tag">${tag}</span><strong class="tbf-year">'${yrShort}</strong></div>`;

    const evFmt = getEventFormat(x);
    const evFmtBadge = evFmt === 'HYBRID'
      ? '<span class="event-fmt-badge hybrid" title="Гибридный турнир: онлайн-отбор + очный финал"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-zap"/></svg> Гибрид</span>'
      : (evFmt === 'ONLINE' ? '<span class="event-fmt-badge online" title="Дистанционный онлайн-турнир"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-globe"/></svg> Онлайн</span>' : '<span class="event-fmt-badge offline" title="Очный турнир на арене"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-landmark"/></svg> Офлайн</span>');

    const evProgs = getEventPrograms(x);
    const progChipsHtml = eventProgChipsHtml(evProgs);

    const hasReg = !x.regClosed && Boolean(st.k === 'registration' || x.regUrl);
    const regBtn = hasReg ? `<button type="button" class="ec-btn ec-btn-reg" data-event="${x.id}" data-event-pane="reg" aria-label="Регистрация на турнир"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M12 20h9M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg><span>Регистрация</span></button>` : '';
    const resultsBtn = hasResults ? `<button type="button" class="ec-btn ec-btn-results" data-event="${x.id}" data-event-pane="results" aria-label="Протоколы и результаты"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M9 11l3 3L22 4M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg><span>Протоколы</span></button>` : '';
    const photosBtn = hasPhotos ? `<button type="button" class="ec-btn ec-btn-photos" data-event="${x.id}" data-event-pane="event-photos" aria-label="Фотографии"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/></svg><span>Фото</span></button>` : '';
    const videosBtn = hasVideos ? `<button type="button" class="ec-btn ec-btn-videos" data-event="${x.id}" data-event-pane="event-videos" aria-label="Видеозаписи"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="2" y="4" width="20" height="16" rx="3"/><path d="m10 9 5 3-5 3z"/></svg><span>Видео</span></button>` : '';
    const overviewBtn = `<button type="button" class="ec-btn ec-btn-overview" data-event="${x.id}" data-event-pane="about" aria-label="Подробнее о турнире"><span>О турнире</span> <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg></button>`;

    return `${monthHead}<article class="event-card" data-event="${x.id}" data-status="${st.k}">
      ${isMod ? `
        <div class="event-card-mod-bar">
          <span class="btn-card-mod-edit-event" data-event-id="${x.id}" title="Редактировать соревнование" style="display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:8px;background:rgba(14,165,233,0.9);color:#fff;font-size:12px;font-weight:700;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,0.4);border:1px solid rgba(255,255,255,0.2);"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-pencil"/></svg></span>
          <span class="btn-card-mod-del-event" data-event-id="${x.id}" title="Удалить соревнование" style="display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:8px;background:rgba(239,68,68,0.9);color:#fff;font-size:12px;font-weight:700;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,0.4);border:1px solid rgba(255,255,255,0.2);"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-trash-2"/></svg></span>
        </div>
      ` : ''}
      <button type="button" class="event-card-main" data-event="${x.id}" data-event-pane="about" aria-label="${esc(x.title)}">
        ${(() => {
          // афиша: размытая подложка из той же картинки (квадратные афиши без пустых полей) + плашка даты и статус поверх
          const d0 = eventDateRange(x)?.start;
          const bg = poster && !/logo-clean/.test(poster) ? rsUrl(poster, 480) : '';
          return `<div class="evc-media" ${bg ? `style="--evc-bg:url('${esc(bg)}')"` : ''}>${coverHtml}
            ${d0 ? `<span class="evc-date" aria-hidden="true"><b>${d0.getDate()}</b><small>${MONTHS_RU[d0.getMonth()].slice(0, 3).toLowerCase()}</small></span>` : ''}
            <span class="evc-status event-status ${st.cls}">${st.label}</span></div>`;
        })()}
        <div class="event-card-content">
          <div class="event-card-head-row">
            <div class="event-head-tags">
              <time><svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg><span>${esc(x.period || eventYear(x) || 'Дата на странице')}${eventYear(x) ? ' · ' + eventYear(x) : ''}</span></time>
              ${evFmtBadge}
            </div>
          </div>
          <b>${esc(x.title)}</b>
          <p class="event-card-location"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg><span>${esc(x.location)}</span></p>
          <div class="event-card-programs">${progChipsHtml}</div>
        </div>
      </button>
      <div class="event-card-btn-bar" role="toolbar" aria-label="Разделы турнира">
        ${regBtn}
        ${resultsBtn}
        ${photosBtn}
        ${videosBtn}
        ${overviewBtn}
      </div>
    </article>`;
  }).join('') + loadMoreHtml : `
    <div class="empty" style="text-align:center;padding:32px 16px;">
      <p style="font-weight:600;font-size:15px;margin-bottom:8px;color:#fff;">Ничего не найдено по выбранным параметрам</p>
      <p style="font-size:13px;color:#94a3b8;margin-bottom:16px;">Попробуйте смягчить условия поиска или сбросить фильтры</p>
      <button type="button" class="reset-filters-btn" id="events-empty-reset" style="margin:0 auto;display:inline-flex;padding:8px 16px;font-size:13px;">✕ Сбросить все фильтры</button>
    </div>
  `);
}


let resultsFiltersInitialized = false;
function setupResultsFilters() {
  if (resultsFiltersInitialized) return;
  const yearSelect = $('#results-year-filter');
  const citySelect = $('#results-city-filter');
  if (!yearSelect || !citySelect) return;
  
  const years = [...new Set(GTO_CALENDAR_EVENTS.map(eventYear).filter(Boolean))].sort((a, b) => b - a);
  yearSelect.innerHTML = `<option value="all">Все годы</option>${years.map(y => `<option value="${y}">${y}</option>`).join('')}`;

  const cities = new Set();
  GTO_CALENDAR_EVENTS.forEach(x => {
    if (x.city) cities.add(x.city.trim());
    else if (x.location) {
      const parts = x.location.split(',').map(p => p.trim());
      if (parts[0] && parts[0].length < 40) cities.add(parts[0].replace(/^г\.\s*/i, ''));
    }
  });
  const sortedCities = [...cities].filter(Boolean).sort((a, b) => a.localeCompare(b, 'ru'));
  citySelect.innerHTML = `<option value="all">Все регионы и города</option>${sortedCities.map(c => `<option value="${esc(c)}">${esc(c)}</option>`).join('')}`;
  resultsFiltersInitialized = true;
}

export function renderResultsScreen() {
  const q = (state.resultsQuery || '').toLowerCase();
  const manifestEvents = state.resultsManifest?.events || {};
  setupResultsFilters();

  const items = GTO_CALENDAR_EVENTS.filter(x => {
    const hasManifest = Boolean(manifestEvents[String(x.id)]);
    const hasResults = Boolean((x.results && x.results.length > 0) || (x.actionText && /результат|протокол/i.test(x.actionText)));
    const isPastEv = x.status === 'past' || isPast(x);
    if (!hasManifest && !hasResults && !isPastEv) return false;

    if (state.resultsYear && state.resultsYear !== 'all' && String(eventYear(x)) !== String(state.resultsYear)) return false;
    if (state.resultsProgram && state.resultsProgram !== 'all') {
      const progs = getEventPrograms(x);
      if (!progs.includes(state.resultsProgram)) return false;
    }
    if (state.resultsCity && state.resultsCity !== 'all') {
      const loc = `${x.location || ''} ${x.city || ''}`.toLowerCase();
      if (!loc.includes(state.resultsCity.toLowerCase())) return false;
    }

    if (q) {
      const haystack = `${x.title} ${x.location || ''} ${x.city || ''} ${x.period || ''} ${x.year || ''}`.toLowerCase();
      if (!haystack.includes(q)) return false;
    }
    return true;
  }).sort((a, b) => {
    const yA = Number(eventYear(a)) || 0;
    const yB = Number(eventYear(b)) || 0;
    if (yA !== yB) return yB - yA;
    return (b.id || 0) - (a.id || 0);
  });

  state.resultsDisplayLimit = state.resultsDisplayLimit || 20;
  const total = items.length;
  const visible = items.slice(0, state.resultsDisplayLimit);

  const countEl = $('#results-count');
  if (countEl) countEl.textContent = `${total} турниров с результатами${total > visible.length ? ` (показано ${visible.length})` : ''}`;

  let loadMoreHtml = '';
  if (total > visible.length) {
    const remaining = total - visible.length;
    const chunk = Math.min(20, remaining);
    loadMoreHtml = `<button type="button" class="load-more" id="results-load-more">Показать ещё ${chunk} (осталось ${remaining})</button>`;
  }

  const listEl = $('#results-catalog-list');
  if (!listEl) return;

  listEl.innerHTML = visible.length ? visible.map(x => {
    const manifestInfo = manifestEvents[String(x.id)];
    const poster = x.localPoster || x.poster || x.img;
    const yr = eventYear(x) || (x.period && String(x.period).match(/\d{4}/)?.[0]) || '26';
    const yrShort = String(yr).slice(-2);
    const colorIdx = getAvatarColorIndex(x.id || x.title);
    const coverHtml = (poster && poster !== './assets/logo-clean.png' && poster !== 'assets/icon-192.png' && !poster.includes('logo-clean'))
      ? `<img loading="lazy" ${rsImgAttrs(poster, 480)} alt="" data-fb="cover" data-portrait="parent" data-fb-tag="ПРОТОКОЛ" data-fb-yr="${esc(yrShort)}" data-fb-color="${colorIdx}">`
      : `<div class="event-cover-fallback color-${colorIdx}" aria-hidden="true"><span class="tbf-tag">ПРОТОКОЛ</span><strong class="tbf-year">'${yrShort}</strong></div>`;

    const countText = manifestInfo ? `${manifestInfo.count} результатов` : 'Официальный протокол';
    const evProgs = getEventPrograms(x);
    const progChipsHtml = eventProgChipsHtml(evProgs);

    const d0 = eventDateRange(x)?.start;
    const bg = poster && !/logo-clean/.test(poster) ? rsUrl(poster, 480) : '';
    return `<article class="event-card" data-event="${x.id}" data-event-pane="results" data-status="past">
      <button type="button" class="event-card-main" data-event="${x.id}" data-event-pane="results" aria-label="Протокол: ${esc(x.title)}">
        <div class="evc-media" ${bg ? `style="--evc-bg:url('${esc(bg)}')"` : ''}>${coverHtml}
          ${d0 ? `<span class="evc-date" aria-hidden="true"><b>${d0.getDate()}</b><small>${MONTHS_RU[d0.getMonth()].slice(0, 3).toLowerCase()}</small></span>` : ''}
          <span class="evc-status event-status st-past">${manifestInfo ? `${manifestInfo.count} ${ruPlural(manifestInfo.count, 'результат', 'результата', 'результатов')}` : 'Протокол'}</span></div>
        <div class="event-card-content">
          <div class="event-card-head-row">
            <div class="event-head-tags">
              <time><svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg><span>${esc(x.period || eventYear(x) || '')}${eventYear(x) ? ' · ' + eventYear(x) : ''}</span></time>
            </div>
          </div>
          <b>${esc(x.title)}</b>
          <p class="event-card-location"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg><span>${esc(x.city || x.location || '')}</span></p>
          <div class="event-card-programs">${progChipsHtml}</div>
        </div>
      </button>
      <div class="event-card-btn-bar" role="toolbar" aria-label="Действия">
        <button type="button" class="ec-btn ec-btn-results" data-event="${x.id}" data-event-pane="results" aria-label="Смотреть протокол"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M9 11l3 3L22 4M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg><span>Протокол</span></button>
        <button type="button" class="ec-btn ec-btn-overview" data-event="${x.id}" data-event-pane="about" aria-label="О турнире"><span>О турнире</span> <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg></button>
      </div>
    </article>`;
  }).join('') + loadMoreHtml : '<div class="empty">Протоколов по заданным критериям не найдено.</div>';
}

const HEADER_TOKENS = /^(№|n|nn|no|место|п\/п|пп|фамилия|команда|участник|имя|отчество|фио|ф\.и\.о|регион|город|результат|очки|балл|баллы|время|пол|возраст|категория|дисциплина|разряд|итог|сумма|звание)\.?$/i;

function tableHtml(rows) {
  if (!rows || !rows.length) return '';
  const maxCols = Math.max(1, ...rows.map(r => r.length));
  let headerDone = false;
  let athleteCol = -1;
  const body = rows.map(row => {
    const cells = row.map(c => String(c == null ? '' : c));
    if (cells.filter(c => c.trim()).length === 1 && maxCols > 1) {
      headerDone = false;
      athleteCol = -1;
      return `<tr class="tbl-group"><td colspan="${maxCols}">${esc(cells.find(c => c.trim()) || '')}</td></tr>`;
    }
    const hits = cells.filter(c => HEADER_TOKENS.test(c.trim())).length;
    const firstNum = /^\d+$/.test((cells[0] || '').trim());
    const isHeader = !headerDone && cells.length > 1 && hits >= 2 && !firstNum;
    if (isHeader) {
      headerDone = true;
      const lower = cells.map(c => c.trim().toLowerCase());
      athleteCol = lower.findIndex(h => /^(фамилия|участник|спортсмен|атлет|фио|ф\.и\.о)$/i.test(h));
      if (athleteCol < 0) athleteCol = lower.findIndex(h => /фамилия|участник|спортсмен/i.test(h));
      return `<tr class="tbl-head">${cells.map(c => `<th>${esc(c)}</th>`).join('')}</tr>`;
    }
    return `<tr>${cells.map((c, colIdx) => {
      const val = c.trim();
      if (colIdx === athleteCol && val && val.length >= 3 && !/^\d+$/.test(val) && !HEADER_TOKENS.test(val)) {
        return `<td><button type="button" class="athlete-table-link" data-athlete-query="${esc(val)}"><b>${esc(c)}</b> <span class="athlete-link-icon">↗</span></button></td>`;
      }
      return `<td>${esc(c)}</td>`;
    }).join('')}</tr>`;
  }).join('');
  return `<div class="table-scroll-wrap"><div class="table-scroll-hint"><span>↔ Листайте вправо для просмотра всех колонок таблицы</span></div><div class="table-scroll"><table class="result-table">${body}</table></div></div>`;
}

const MEDAL_RE = /^(золото|серебро|бронза)$/i;
const medalCls = v => /золото/i.test(v) ? 'm-gold' : /серебро/i.test(v) ? 'm-silver' : /бронза/i.test(v) ? 'm-bronze' : '';

const findHeaderRow = rows => {
  for (let i = 0; i < rows.length; i++) {
    const c = rows[i].map(x => String(x == null ? '' : x));
    if (c.filter(x => x.trim()).length <= 1) continue;
    if (c.filter(x => HEADER_TOKENS.test(x.trim())).length >= 2) return i;
  }
  return -1;
};

function resultsView(rows) {
  if (!rows || rows.length < 2) return null;
  const hi = findHeaderRow(rows);
  if (hi < 0) return null;
  const H = rows[hi].map(x => String(x == null ? '' : x).trim().toLowerCase());
  const find = re => H.findIndex(h => re.test(h));
  const iSurname = find(/фамил/), iName = find(/^имя|^ф\.?и\.?о/);
  if (iSurname < 0 && iName < 0) return null;
  const iRegion = find(/регион|город|субъект|область|край/), iCat = find(/категор/), iAge = find(/возраст/);
  let iGender = find(/^пол$/);
  const data = rows.filter((r, i) => i !== hi && r.map(x => String(x == null ? '' : x)).filter(x => x.trim()).length > 1);
  const col = idx => data.map(r => String(r[idx] == null ? '' : r[idx]).trim());
  if (iGender < 0) {
    for (let j = 0; j < H.length; j++) {
      if (j === iSurname || j === iName) continue;
      const vals = col(j).filter(Boolean);
      if (vals.length && vals.filter(v => /^(м|ж|муж|жен|m|w|f)\.?$/i.test(v)).length / vals.length > 0.6) {
        iGender = j;
        break;
      }
    }
  }
  let iRank = H.findIndex(h => /^(№|nn|n|п\/п|пп|место)$/i.test(h));
  if (iRank >= 0 && col(iRank).filter(Boolean).some(v => MEDAL_RE.test(v))) iRank = -1;
  if (iRank < 0) {
    for (let j = 0; j < H.length; j++) {
      const vals = col(j).filter(Boolean);
      if (vals.length && vals.filter(v => /^\d{1,3}$/.test(v)).length / vals.length > 0.7) {
        iRank = j;
        break;
      }
    }
  }
  const iResult = find(/результат|очки|балл|сумма|итог|время|разряд|звание/);
  let n = 0, out = '';
  for (let i = 0; i < rows.length; i++) {
    if (i === hi) continue;
    const cells = rows[i].map(x => String(x == null ? '' : x));
    const filled = cells.filter(x => x.trim());
    if (filled.length <= 1) {
      if (filled.length === 1) out += `<div class="rc-group">${esc(filled[0])}</div>`;
      continue;
    }
    n++;
    const rank = iRank >= 0 && cells[iRank] ? esc(cells[iRank].trim()) : String(n);
    const nm = [iSurname, iName].filter(x => x >= 0).map(x => cells[x]).filter(v => v && v.trim()).join(' ') || '—';
    const g = iGender >= 0 && cells[iGender] ? cells[iGender].trim().toUpperCase().replace(/^М.*/, 'М').replace(/^(Ж|W|F).*/, 'Ж') : '';
    const meta = [iRegion >= 0 ? cells[iRegion] : '', [iCat >= 0 ? cells[iCat] : '', iAge >= 0 ? cells[iAge] : ''].filter(v => v && String(v).trim()).join(' '), g].filter(v => v && String(v).trim()).map(esc).join(' · ');
    const medal = cells.find(c => MEDAL_RE.test(String(c).trim()));
    const mc = medal ? medalCls(medal) : '';
    const right = medal ? `<span class="rc-medal ${mc}">${esc(medal)}</span>` : (iResult >= 0 && cells[iResult] && cells[iResult].trim() ? `<span class="rc-res">${esc(cells[iResult])}</span>` : '');
    out += `<div class="rcard ${mc}"><span class="rc-rank">${rank}</span><div class="rc-main"><button type="button" class="athlete-name-btn" data-athlete-query="${esc(nm)}"><b>${esc(nm)}</b><span class="athlete-link-icon">↗</span></button>${meta ? `<small>${meta}</small>` : ''}</div>${right}</div>`;
  }
  return `<div class="result-cards">${out}</div>`;
}

function formatSectionParagraph(p) {
  if (!p) return '';
  const text = String(p).trim();
  if (!text) return '';
  if (/^[•·\-\*]\s+/.test(text)) {
    const lines = text.split(/\r?\n/).map(l => l.replace(/^[•·\-\*]\s+/, '').trim()).filter(Boolean);
    return `<ul class="detail-list">${lines.map(li => `<li>${esc(li)}</li>`).join('')}</ul>`;
  }
  const clean = esc(text).replace(/\s+([вскониудапообза])\s+/gi, ' $1&nbsp;');
  return `<p>${clean}</p>`;
}

const sectionsHtml = sections => (sections && sections.length) ? sections.map(s => {
  // Таблицы, снятые со старого сайта, дублируют официальный протокол из базы (и несут его старые опечатки —
  // «два Кулиева Ильяса»). Если протокол в базе есть, показываем только его (вкладка «Результаты»).
  if (Array.isArray(state.currentEventResults) && state.currentEventResults.length && (s.tables || []).length) {
    s = { ...s, tables: [], paragraphs: (s.paragraphs || []).filter(p => String(p).length <= 280) };
  }
  const hasTables = (s.tables || []).length > 0;
  const rawParas = (s.paragraphs || []).filter(p => !(hasTables && String(p).length > 280));
  const paras = rawParas.flatMap(p => String(p).split(/\r?\n\s*\r?\n/)).filter(Boolean);
  return `<section class="detail-section"><h2>${esc(s.title)}</h2>${paras.map(formatSectionParagraph).join('')}${(s.tables || []).map(t => resultsView(t) || tableHtml(t)).join('')}</section>`;
}).join('') : '<div class="empty">На официальной странице этот раздел пока не заполнен.</div>';

function ruPlural(n, one, two, five) {
  const abs = Math.abs(Number(n) || 0) % 100;
  const rem = abs % 10;
  if (abs > 10 && abs < 20) return five;
  if (rem > 1 && rem < 5) return two;
  if (rem === 1) return one;
  return five;
}

function exportToIcal(ev) {
  // точные даты из календаря (startDate/endDate) и напоминание за день — ics.js; раньше старт всегда ставился на 1-е число месяца
  haptic(15);
  if (!ev || !ev.startDate) { showToast('У этого турнира нет точной даты'); return; }
  const blob = new Blob([buildIcs(ev)], { type: 'text/calendar;charset=utf-8' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `gto-${ev.id}.ics`;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 4000);
  showToast('Файл для календаря скачан — откройте его, чтобы добавить старт');
}

// место строки: «1», «1 место», «золото» (призёры онлайн-этапов записаны словами) — protocol_rules.placeOf
function parseRank(rank) { return placeOf(rank); }

function extractEventAthletes(protocol, eventData) {
  const map = new Map();

  if (protocol && Array.isArray(protocol.results)) {
    // одноимённые команды одной категории с разными местами — разные участники (Техноспорт Первых: три «Краснодарских края»)
    const teamKey = new Map();
    const byCat = new Map();
    protocol.results.forEach((r) => { if (r && r.team && (r.participant_type === 'team' || r.participant_type === 'regional_team')) { const c = r.category || ''; if (!byCat.has(c)) byCat.set(c, []); byCat.get(c).push(r); } });
    byCat.forEach((list) => teamGroups(list).forEach((g) => g.rows.forEach((r) => teamKey.set(r, g.key))));
    for (const r of protocol.results) {
      const name = (r.participant || '').trim();
      if (!name || name.length < 3 || HEADER_TOKENS.test(name) || (/^(команда|сборная|регион)/i.test(name) && !r.details?.фамилия)) continue;

      const numRank = parseRank(r.rank);
      const key = teamKey.get(r) || name;
      if (!map.has(key)) {
        map.set(key, {
          name,
          region: r.region && r.region !== name ? r.region : '',
          categories: new Set(),
          bestRank: numRank,
          bestResult: r.result || '',
          medals: { gold: 0, silver: 0, bronze: 0 }
        });
      }
      const a = map.get(key);
      if (r.category) a.categories.add(r.category);
      if (r.region && !a.region && r.region !== name) a.region = r.region;
      if (numRank < a.bestRank) {
        a.bestRank = numRank;
        if (r.result) a.bestResult = r.result;
      }
      if (numRank === 1) a.medals.gold++;
      else if (numRank === 2) a.medals.silver++;
      else if (numRank === 3) a.medals.bronze++;
    }
  }

  if (map.size === 0 && eventData && Array.isArray(eventData.results)) {
    for (const sec of eventData.results) {
      for (const tbl of (sec.tables || [])) {
        const hi = findHeaderRow(tbl);
        if (hi < 0) continue;
        const H = tbl[hi].map(x => String(x || '').trim().toLowerCase());
        const find = re => H.findIndex(h => re.test(h));
        const iSurname = find(/фамил/);
        const iName = find(/^имя|^ф\.?и\.?о/);
        if (iSurname < 0 && iName < 0) continue;
        const iRank = find(/^(№|n|место|п\/п)$/);
        const iRes = find(/результат|очки|балл|сумма|итог/);
        const iReg = find(/регион|город|субъект/);
        const iCat = find(/категор|группа|возраст/);

        for (let i = hi + 1; i < tbl.length; i++) {
          const row = tbl[i];
          const name = [iSurname, iName].filter(x => x >= 0).map(x => row[x]).filter(Boolean).join(' ').trim();
          if (!name || name.length < 3 || HEADER_TOKENS.test(name)) continue;
          const rankStr = iRank >= 0 && row[iRank] ? String(row[iRank]).trim() : '';
          const numRank = parseRank(rankStr);
          const resStr = iRes >= 0 && row[iRes] ? String(row[iRes]).trim() : '';
          const regStr = iReg >= 0 && row[iReg] ? String(row[iReg]).trim() : '';
          const catStr = iCat >= 0 && row[iCat] ? String(row[iCat]).trim() : '';

          if (!map.has(name)) {
            map.set(name, {
              name,
              region: regStr,
              categories: new Set(),
              bestRank: numRank,
              bestResult: resStr,
              medals: { gold: 0, silver: 0, bronze: 0 }
            });
          }
          const a = map.get(name);
          if (catStr) a.categories.add(catStr);
          if (regStr && !a.region) a.region = regStr;
          if (numRank < a.bestRank) {
            a.bestRank = numRank;
            if (resStr) a.bestResult = resStr;
          }
          if (numRank === 1) a.medals.gold++;
          else if (numRank === 2) a.medals.silver++;
          else if (numRank === 3) a.medals.bronze++;
        }
      }
    }
  }

  const list = Array.from(map.values());
  list.forEach(a => {
    a.categoriesStr = Array.from(a.categories).slice(0, 2).join(', ');
  });
  list.sort((a, b) => {
    if (a.bestRank !== b.bestRank) return a.bestRank - b.bestRank;
    return a.name.localeCompare(b.name, 'ru');
  });
  return list;
}

function renderEventAthletesTab(athletes) {
  if (!athletes.length) {
    return '<div class="empty">Именной список участников для этого турнира ещё обрабатывается судейской коллегией.</div>';
  }

  const medalistsCount = athletes.filter(a => a.bestRank >= 1 && a.bestRank <= 3).length;

  return `
    <div class="event-athletes-header">
      <div class="event-athletes-stats">
        <div class="stat-pill">
          <small>УЧАСТНИКОВ</small>
          <strong>${athletes.length}</strong>
        </div>
        ${medalistsCount ? `
          <div class="stat-pill">
            <small>МЕДАЛИСТОВ</small>
            <strong>${medalistsCount}</strong>
          </div>
        ` : ''}
      </div>
      <label class="search event-athletes-search-wrap">
        <span>⌕</span>
        <input id="event-athletes-filter" type="search" placeholder="Быстрый поиск по участникам турнира..." aria-label="Фильтр участников">
      </label>
    </div>
    <div id="event-athletes-list" class="event-athletes-grid">
      ${athletes.map(renderEventAthleteCard).join('')}
    </div>
  `;
}

function renderEventAthleteCard(a) {
  const cardCls = a.bestRank === 1 ? 'gold-athlete' : a.bestRank === 2 ? 'silver-athlete' : a.bestRank === 3 ? 'bronze-athlete' : '';

  return `
    <article class="event-athlete-card ${cardCls}">
      <div class="athlete-card-top">
        ${getAthleteAvatarHtml(a, 44)}
        <div class="athlete-name-wrap">
          <button type="button" class="athlete-name-btn" data-athlete-query="${esc(a.name)}">
            <b>${esc(a.name)}</b>
            <span class="athlete-link-icon">↗</span>
          </button>
          ${a.region ? `<small class="athlete-region">${esc(a.region)}</small>` : ''}
        </div>
        ${getResultPlaceBadgeHtml(a.bestRank)}
      </div>
      <div class="athlete-card-meta">
        ${a.categoriesStr ? `<span class="athlete-cat-badge">${esc(a.categoriesStr)}</span>` : ''}
        ${a.bestResult ? `<span class="athlete-res-badge"><small>Результат:</small> <b>${esc(a.bestResult)}</b></span>` : ''}
      </div>
      <div class="athlete-card-foot">
        <button type="button" class="athlete-profile-link-btn" data-athlete-query="${esc(a.name)}">
          <span>Профиль спортсмена</span>
          <strong>→</strong>
        </button>
      </div>
    </article>
  `;
}

function renderEventPodiumWidget(athletes, protocolRows = null) {
  // есть протокол — призёры по каждой категории (и группе) отдельно, с подписью категории: место из одной категории
  // не переносится на другую (раньше «2 — Санкт-Петербург, Командный зачёт, Финал гонки команд», хотя в финале он 4-й)
  const medalists = protocolRows && protocolRows.length
    ? podiumEntries(protocolRows.map(normalizeProtocolRow).filter(Boolean)).map((e) => ({ name: e.name, isTeam: e.isTeam, bestRank: e.place, region: e.region && e.region !== e.name ? e.region : '',
      categoriesStr: [e.category, e.subgroup].filter(Boolean).join(' · '), bestResult: e.result }))
    : athletes.filter(a => a.bestRank >= 1 && a.bestRank <= 3).slice(0, 6);
  if (!medalists.length) return '';

  return `
    <section class="detail-section event-podium-section">
      <div class="event-podium-head">
        <div>
          <small>ПЬЕДЕСТАЛ ПОЧЁТА</small>
          <h2>Призёры соревнований</h2>
        </div>
        <button type="button" class="podium-view-all" data-pane="results">Все результаты (${athletes.length}) →</button>
      </div>
      <div class="event-podium-grid">
        ${medalists.map(m => `
          <div class="podium-card rank-${m.bestRank === 1 ? 'gold' : m.bestRank === 2 ? 'silver' : 'bronze'}">
            ${getResultPlaceBadgeHtml(m.bestRank)}
            <button type="button" class="athlete-name-btn" ${m.isTeam ? `data-open-team="${esc(m.name)}"` : `data-athlete-query="${esc(m.name)}"`}>
              <b>${esc(m.name)}</b>
              <span class="athlete-link-icon">↗</span>
            </button>
            <div class="podium-card-sub">
              ${m.region ? `<small>${esc(m.region)}</small>` : ''}
              ${m.categoriesStr ? `<span>${esc(m.categoriesStr)}</span>` : ''}
            </div>
            ${resultMainText(m.bestResult) ? `<div class="podium-res"><strong>${esc(resultMainText(m.bestResult))}</strong></div>` : ''}
          </div>
        `).join('')}
      </div>
    </section>
  `;
}

function isEventSavedOffline(evId) {
  try {
    const list = JSON.parse(localStorage.getItem('gto_saved_offline_events') || '[]');
    return list.some(x => String(x.id) === String(evId));
  } catch (e) {
    return false;
  }
}
window.isEventSavedOffline = isEventSavedOffline;

async function toggleOfflineEvent(evId, btnEl) {
  const isSaved = isEventSavedOffline(evId);
  try {
    let list = JSON.parse(localStorage.getItem('gto_saved_offline_events') || '[]');
    if (isSaved) {
      list = list.filter(x => String(x.id) !== String(evId));
      localStorage.setItem('gto_saved_offline_events', JSON.stringify(list));
      if (btnEl) {
        btnEl.classList.remove('saved');
        btnEl.style.borderColor = 'rgba(59,130,246,0.35)';
        btnEl.style.background = 'linear-gradient(135deg,#17365d 0%,#0d223c 100%)';
        btnEl.innerHTML = `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg><span>Сохранить офлайн</span>`;
      }
      showToast('Турнир удален из офлайн-памяти');
    } else {
      const ev = GTO_CALENDAR_EVENTS.find(x => String(x.id) === String(evId)) || { id: evId, title: 'Турнир ГТО' };
      list.unshift({
        id: evId,
        title: ev.title || 'Соревнование',
        period: ev.period || '',
        location: ev.location || '',
        savedAt: Date.now()
      });
      localStorage.setItem('gto_saved_offline_events', JSON.stringify(list));

      if ('caches' in window) {
        try {
          const cache = await caches.open('gto-offline-v1');
          await Promise.allSettled([
            fetch(`./data/events/${evId}.json?v=18`).then(r => r.ok && cache.put(`./data/events/${evId}.json?v=18`, r.clone())),
            fetchResultsJson(evId).then(r => r && cache.put(`./data/results/${evId}.json?v=92`, r.clone()))
          ]);
        } catch (_) {}
      }

      if (btnEl) {
        btnEl.classList.add('saved');
        btnEl.style.borderColor = 'rgba(34,197,94,0.4)';
        btnEl.style.background = 'rgba(34,197,94,0.12)';
        btnEl.innerHTML = `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#22c55e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg><span style="color:#22c55e">✓ Сохранено офлайн</span>`;
      }
      showToast('✓ Протокол и материалы сохранены для работы без интернета!');
    }
    haptic(15);
  } catch (err) {
    console.error('Offline save error:', err);
    showToast('Ошибка при сохранении офлайн');
  }
}
window.toggleOfflineEvent = toggleOfflineEvent;

// список турниров с опубликованной сеткой — один запрос за визит
let bracketEventsPromise = null;
function eventHasBracket(id) {
  if (!bracketEventsPromise) {
    bracketEventsPromise = fetch('/api/brackets', { cache: 'no-store' }).then(r => r.json())
      .then(d => new Set((d.events || []).map(String))).catch(() => new Set());
  }
  return bracketEventsPromise.then(set => set.has(String(id)));
}

// табло турнира: свой движок (liveId, раздел «Турнир») важнее leaderboards.ru (lbId). id — признак «табло есть»; запросы
// идут по номеру мероприятия (/api/lb/standings?event=), lbId — запасной номер для сервера без привязки (t=)
function liveOf(d, base) {
  const liveId = Number(d?.liveId || base?.liveId) || 0, lbId = Number(d?.lbId || base?.lbId) || 0;
  return { id: liveId || lbId, lbId, own: Boolean(liveId), url: d?.liveUrl || base?.liveUrl || d?.lbUrl || base?.lbUrl || '' };
}
// плашка «живое табло / регистрация» → вкладка «Результаты» (табло и протокол — одно и то же)
function lbLiveLinkHtml(live, past) {
  if (!live.url && !live.id) return '';
  const title = past ? 'Итоговое табло' : 'Живое табло и регистрация';
  const sub = past ? 'результаты по станциям, составы команд' : 'онлайн-результаты по станциям, заявка на участие';
  if (live.id) return `<button type="button" class="lb-live-link ${past ? 'is-past' : 'is-soon'}" data-pane="results">
        <span class="lb-live-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-chart-column"/></svg>${past ? '' : '<i class="lb-live-dot"></i>'}</span>
        <span class="lb-live-text"><b>${title}</b><small>${sub}</small></span>
        <span class="lb-live-arrow" aria-hidden="true">›</span></button>`;
  return `<a class="lb-live-link" href="${safeUrl(live.url)}" target="_blank" rel="noopener">
        <svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-chart-column"/></svg>
        <span><b>${title} на leaderboards.ru</b><small>${sub}</small></span>
        <span class="lb-live-arrow" aria-hidden="true">↗</span></a>`;
}
// единая шапка вкладки «Результаты» для всех турниров: афиша, статус, название, цифры; у leaderboards — живой статус и обновление
function resultsHeroHtml(meta) {
  const stats = (meta.stats || []).map((x) => `<div class="lb-stat ${x.cls || ''}"><b>${esc(x.v)}</b><span>${esc(x.l)}</span></div>`).join('');
  return `<section class="lb-hero res-hero">
      ${meta.cover ? `<img class="lb-hero-bg" ${rsImgAttrs(meta.cover, 640)} alt="" loading="lazy" data-fb="remove">` : ''}
      <div class="lb-hero-shade"></div>
      <div class="lb-hero-body">
        <div class="lb-hero-row" data-res-status>${meta.pill || ''}</div>
        ${meta.showTitle ? `<h2 class="lb-title">${esc(meta.title || '')}</h2>` : ''}
        <div class="lb-stats" data-res-stats>${stats}</div>
        ${meta.actions ? `<div class="res-hero-actions">${meta.actions}</div>` : ''}
      </div>
    </section>`;
}
function lbExtrasRootHtml(live, past, hasProtocol, format = '', reg = null) {
  return live.id ? `<div class="lb-extras-root" data-reg-url="${esc(reg?.url || '')}" data-reg-title="${esc(reg?.title || '')}" data-lb-id="${live.lbId}" data-live-t="${live.own ? live.id : ''}" data-lb-url="${esc(live.own ? '' : live.url)}" data-past="${past ? 'true' : 'false'}" data-has-protocol="${hasProtocol ? '1' : '0'}" data-format="${String(format || '').slice(0, 6000).split(/\n{2,}/).map((x) => esc(x)).join('&#10;&#10;')}"></div>` : '';
}
// x: regUrl/regTitle — заявки принимает организатор на своём сайте; hasAbout — у сайта есть своё описание (блок «по данным табло» не нужен)
function lbOverviewRootHtml(live, past, x = {}) {
  return live.id ? `<div class="lb-overview-root" data-lb-id="${live.lbId}" data-lb-url="${esc(live.own ? '' : live.url)}" data-past="${past ? 'true' : 'false'}" data-reg-url="${esc(x.regUrl || '')}" data-reg-title="${esc(x.regTitle || '')}" data-has-about="${x.hasAbout ? '1' : ''}"></div>` : '';
}
function mountLbOverviewRoot() {
  const root = $('#event-detail .lb-overview-root:not([data-mounted])');
  if (!root) return;
  root.dataset.mounted = '1';
  if (!lbLiveModPromise) lbLiveModPromise = import('./lb_live_module.js?v=b69788d2');
  lbLiveModPromise.then((m) => m.mountLbOverview(root, { eventId: state.currentEventId, lbId: root.dataset.lbId, lbUrl: root.dataset.lbUrl, past: root.dataset.past, regUrl: root.dataset.regUrl || '', regTitle: root.dataset.regTitle || '', hasAbout: root.dataset.hasAbout === '1', onMeta: (meta) => { state.lbMeta = meta; } })).catch(() => { root.innerHTML = ''; });
}
// живые данные табло внутри вкладки «Результаты»: статус в шапке, заявка/заходы, а строки табло — тем же протокольным рендером
// панель модератора турнира со своим движком (liveId): «Турнир: админка / судейская» по роли сотрудника (live_enter.js?v=2f56a62c)
function mountLiveStaff() {
  const slot = $('#event-detail .live-staff-slot:not([data-mounted])');
  if (!slot) return;
  slot.dataset.mounted = '1';
  import('./live_enter.js?v=2f56a62c').then((m) => m.mountStaffButtons(slot, { className: 'mod-btn' })).catch(() => {});
}

function mountLbExtras() {
  mountEngineStart($('#event-detail .live-start-slot'));   // «Вести на движке» (event_live.js?v=d9b03f67)
  mountLiveStaff();
  const root = $('#event-detail .lb-extras-root:not([data-mounted])');
  if (!root) return;
  root.dataset.mounted = '1';
  const eventId = state.currentEventId;
  if (!lbLiveModPromise) lbLiveModPromise = import('./lb_live_module.js?v=b69788d2');
  lbLiveModPromise.then((m) => m.mountLbResults(root, {
    eventId,   // номер турнира на сайте — заявка сохраняется у нас с привязкой к нему
    lbId: root.dataset.lbId, lbUrl: root.dataset.lbUrl, past: root.dataset.past, hasProtocol: root.dataset.hasProtocol === '1', format: root.dataset.format || '',
    regUrl: root.dataset.regUrl || '', regTitle: root.dataset.regTitle || '',
    onMeta: (meta) => { if (state.currentEventId === eventId) state.lbMeta = meta; },
    onStatus: (html, stats) => {
      const box = $('#event-detail [data-res-status]'); if (box) box.innerHTML = html;
      const st = $('#event-detail [data-res-stats]'); if (st && (stats || st.querySelector('.lb-sk'))) st.innerHTML = stats || '';   // заглушки не оставляем
    },
    onRows: (rows, title) => {
      if (state.currentEventId !== eventId) return;
      const pane = $('#event-detail .detail-pane[data-pane-content="results"]');
      if (!pane) return;
      state.currentEventResults = { title, count: rows.length, results: rows, live: true, liveT: Number(root.dataset.liveT) || 0 };
      if (!pane.querySelector('#event-result-list')) {
        const extras = pane.querySelector('.lb-extras-root'); const hero = pane.querySelector('.res-hero');
        const shell = document.createElement('div'); shell.innerHTML = tournamentResultsShell(state.currentEventResults, { noHead: true });
        pane.querySelectorAll('.tournament-results, .res-empty-note').forEach((x) => x.remove());
        (extras || hero || pane).insertAdjacentElement('afterend', shell.firstElementChild);
      }
      renderEventResults();
    }
  })).catch(() => { root.innerHTML = ''; });
}
let lbLiveModPromise = null;

// ссылка на протокол с выбранным: #event/109/results?cat=…&reg=…&sort=…&q=… (роутер часть после «?» не трогает)
function resultsQueryFromHash(hash) {
  const q = new URLSearchParams(String(hash || '').split('?')[1] || '');
  const out = {};
  if (q.get('cat')) out.eventResultCategory = q.get('cat').slice(0, 120);
  if (q.get('reg')) out.eventResultRegion = q.get('reg').slice(0, 120);
  if (q.get('sort')) out.eventResultSort = q.get('sort').slice(0, 200);
  if (q.get('q')) out.eventResultQuery = q.get('q').slice(0, 80);
  if (q.get('hl')) out.eventResultHighlight = q.get('hl').slice(0, 120);   // «мой результат»: подсветить строку по ссылке
  return Object.keys(out).length ? out : null;
}
// переход к строке протокола: раскрыть «Показать всех», если строка скрыта, прокрутить и подсветить
function jumpToResultRow(key, cat, persist = false) {
  const smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const find = () => $$('.rt-block').filter((b) => !cat || b.dataset.rtCat === cat).flatMap((b) => [...b.querySelectorAll('[data-rt-name]')])
    .find((x) => x.dataset.rtName === key && x.getClientRects().length);
  let target = find();
  if (!target && cat) { (state.rtExpanded ||= new Set()).add(`${state.currentEventId}|${cat}`); renderEventResults(); target = find(); }
  if (!target) return false;
  target.scrollIntoView({ block: 'center', behavior: smooth });
  target.classList.remove('rt-flash'); void target.offsetWidth; target.classList.add('rt-flash');
  if (persist) target.classList.add('rt-hl');   // открыли по ссылке «мой результат» — строка остаётся выделенной
  return true;
}
// «поделиться результатом»: ссылка на протокол с категорией и подсветкой строки
function shareResultRow(key, cat, label) {
  const q = new URLSearchParams();
  if (cat) q.set('cat', cat);
  q.set('hl', key);
  const url = `${location.origin}/#event/${state.currentEventId}/results?${q}`;
  const title = `${label || 'Результат'} — протокол ФМГТО`;
  if (navigator.share) { navigator.share({ title, url }).catch(() => {}); return; }
  (navigator.clipboard?.writeText(url) || Promise.reject()).then(() => showToast('Ссылка на результат скопирована')).catch(() => prompt('Скопируйте ссылку:', url));
}
function resultsShareHash() {
  const q = new URLSearchParams();
  if (state.eventResultCategory && state.eventResultCategory !== 'all') q.set('cat', state.eventResultCategory);
  if (state.eventResultRegion && state.eventResultRegion !== 'all') q.set('reg', state.eventResultRegion);
  if (state.eventResultSort) q.set('sort', state.eventResultSort);
  if (state.eventResultQuery) q.set('q', state.eventResultQuery);
  // открыли по ссылке «мой результат» — выделение остаётся и в адресе (обновление страницы, пересылка)
  if (state.rtHighlightKey && String(state.rtHighlightEvent) === String(state.currentEventId)) q.set('hl', state.rtHighlightKey);
  const qs = q.toString();
  return `#event/${state.currentEventId}/results${qs ? '?' + qs : ''}`;
}
// выбор в протоколе — сразу в адрес (без перехода и без записи в историю): ссылку можно скопировать из строки браузера
function syncResultsHash() {
  if (state.screen !== 'event' || !state.currentEventId || !/^#event\/[^/]+\/results/.test(location.hash)) return;
  const h = resultsShareHash();
  if (h !== location.hash) history.replaceState(history.state, '', h);
}

async function openEvent(id, initialPane = 'about', push = true, restoreScrollY = null) {
  if (!id) return;
  const sharedFilters = initialPane === 'results' ? resultsQueryFromHash(location.hash) : null;
  if (state.rtHighlightEvent && String(state.rtHighlightEvent) !== String(id).replace(/^EVT-0*/i, '')) state.rtHighlightKey = null;
  const cleanId = String(id).replace(/^EVT-0*/i, '') || String(id);
  const numId = Number(cleanId) || id;
  if (state.screen === 'events') {
    state.eventsScrollTop = window.scrollY || document.documentElement.scrollTop || 0;
  }
  if (push) {
    pushRoute({ screen: 'event', params: { id: numId, pane: initialPane } });
    resetScrollToTop();
  }
  state.lastEventId = numId;
  state.lastEventPane = initialPane;
  state.eventResultQuery = '';
  state.eventResultCategory = 'all'; state.eventResultProgram = ''; state.eventResultSub = ''; state.recDisc = ''; state.recSub = '';
  state.eventResultSex = 'all';
  state.eventResultAge = 'all';
  state.eventResultComplex = 'all';
  state.eventResultStanding = 'all';
  state.eventResultRegion = 'all';
  state.eventResultSort = '';
  if (sharedFilters) Object.assign(state, sharedFilters);   // открыли по ссылке «вот наш край» — выбор из ссылки
  state.eventResultGroupBy = state.eventResultGroupBy || 'category';
  state.eventResultLimit = 120;

  if (state.currentEventId === numId && $('#event-detail .detail-tabs')) {
    go('event', false, restoreScrollY);
    let targetInitial = initialPane;
    if (targetInitial === 'event-media') targetInitial = 'event-photos';
    const pane = $(`.detail-tabs [data-pane="${targetInitial}"]:not([hidden])`);
    if (pane) {
      $$('.detail-tabs button').forEach(x => x.classList.toggle('active', x === pane));
      $$('.detail-pane').forEach(x => x.classList.toggle('active', x.dataset.paneContent === targetInitial));
    }
    if (targetInitial === 'results') {
      renderEventResults();
    }
    const hashTarget = `#event/${numId}` + (initialPane && initialPane !== 'about' ? `/${initialPane}` : '');
    if (push && location.hash !== hashTarget) {
      history.pushState({ screen: 'event', id: numId, pane: initialPane }, '', hashTarget);
    } else if (location.hash !== hashTarget && !location.hash.startsWith(hashTarget + '?')) {   // ?cat=…&hl=… из ссылки не теряем (обновление страницы, копирование адреса)
      history.replaceState({ screen: 'event', id: numId, pane: initialPane }, '', hashTarget);
    }
    if (push) {
      resetScrollToTop();
    } else {
      const finalY = (typeof restoreScrollY === 'number') ? restoreScrollY : scrollStore.get(`event/${numId}`);
      if (typeof finalY === 'number') restoreScrollPosition(finalY);
    }
    return;
  }

  state.currentEventResults = null;
  state.currentEventId = numId;
  state.currentEventPhotosHtml = '';
  state.currentEventVideosHtml = '';
  go('event', false, restoreScrollY);
  const hashTarget = `#event/${numId}` + (initialPane && initialPane !== 'about' ? `/${initialPane}` : '');
  if (push && location.hash !== hashTarget) {
    history.pushState({ screen: 'event', id: numId, pane: initialPane }, '', hashTarget);
  } else if (location.hash !== hashTarget && !location.hash.startsWith(hashTarget + '?')) {   // ?cat=…&hl=… из ссылки не теряем (обновление страницы, копирование адреса)
    history.replaceState({ screen: 'event', id: numId, pane: initialPane }, '', hashTarget);
  }
  $('#event-detail').innerHTML = skeletonHtml('detail', 'Загружаем официальные материалы турнира…');
  const allEventsList = getUnifiedEvents();
  const base = allEventsList.find(x => String(x.id) === String(numId)) || GTO_CALENDAR_EVENTS.find(x => Number(x.id) === Number(numId));
  const isModerator = Boolean(localStorage.getItem('fmgto_hub_token'));
  const modEventToolbarHtml = isModerator ? `
    <div class="moderator-toolbar" id="mod-event-toolbar" style="margin-bottom:14px;">
      <div class="mod-info">
        <span class="mod-tag"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-shield"/></svg> Модератор</span>
        <span class="mod-meta">Правка турнира «${esc(base?.title || 'без названия')}»</span>
      </div>
      <div class="mod-actions">
        ${isEngineEvent(base) ? liveEditHintHtml(base) : `<button type="button" class="mod-btn" id="btn-mod-edit-event-detail"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-pencil"/></svg> Редактировать</button>`}${engineStartSlotHtml(base, isPast(base))}
        <button type="button" class="mod-btn" id="btn-mod-main-event" aria-pressed="${isMainEvent(base) ? 'true' : 'false'}">★ ${isMainEvent(base) ? 'Убрать из главных событий' : 'В главные события'}</button>
        <button type="button" class="mod-btn danger" id="btn-mod-del-event-detail"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-trash-2"/></svg> Удалить из календаря</button>
        ${Number(base?.liveId) > 0 ? `<span class="live-staff-slot" data-live-t="${Number(base.liveId)}" hidden></span>` : ''}
      </div>
    </div>
  ` : '';
  try {
    // Альбомы VK (≈400 КБ) нужны только для фото-вкладки. Раньше турнир (≈2 КБ) не показывался, пока они
    // не скачаются — на мобильном интернете это 10+ секунд «Загружаем…». Ждём их не дольше 1,5 с,
    // а если не успели — показываем турнир сразу и перерисовываем, когда альбомы придут.
    // Сначала турнир и протокол (единицы КБ), потом альбомы: если качать вместе, альбомы забирают канал и протокол
    // на мобильном приходит на 11-й секунде (Lighthouse 30.09). Альбомам даём 300 мс — не успели, дорисуем позже.
    const [response, protocolResponse] = await Promise.all([
      fetch(`./data/events/${numId}.json?v=18`).catch(() => ('caches' in window ? caches.match(`./data/events/${numId}.json?v=18`) : null)),
      // протокола нет в списке (manifest уже загружен) — не запрашиваем: иначе 404 в консоли и лишний запрос
      fetchResultsJson(numId).catch(() => ('caches' in window ? caches.match(`./data/results/${numId}.json?v=92`) : null))
    ]);
    const albumsReady = Promise.all([getVkAlbums(), loadVideos()]).then(() => true, () => false);   // фото и видео турнира
    const albumsLoaded = await Promise.race([albumsReady, new Promise(r => setTimeout(() => r(false), 300))]);
    if (!albumsLoaded) {
      state.eventTouched = false;   // ставит обработчик ниже: человек уже что-то нажал на странице турнира
      albumsReady.then((ok) => {
        if (!ok || state.currentEventId !== numId || state.screen !== 'event') return;
        const lm = getTournamentMedia(id, base); if (!lm.albums.length && !lm.videos.length) return; // у турнира нет медиа — перерисовывать нечего
        // перерисовка сбросила бы выбранную вкладку категории, раскрытые блоки и т. п. — если человек уже нажимал,
        // фото дорисуем, когда он откроет вкладку «Фото»
        const activePane = $('.detail-tabs button.active')?.dataset.pane || initialPane;
        // протокол и прочие вкладки фото не показывают — перерисовка сбила бы прокрутку к строке по ссылке ?hl=
        if (state.eventTouched || !['about', 'event-photos'].includes(activePane)) { state.eventMediaStale = numId; return; }
        const y = window.scrollY;
        state.currentEventId = null; // иначе openEvent только переключит вкладку, не перерисовав фото
        openEvent(numId, activePane, false, y);
      });
    }
    if (!response || !response.ok) throw Error('not imported');
    const file = await response.json();
    // турнир на движке: карточка из админки live.gto.com.ru главнее файла и правок модератора (event_live.js?v=d9b03f67)
    const d = isEngineEvent(base) || isEngineEvent(file) ? applyLive(withModEdits(file, base), await liveCardFor(numId, file.live)) : withModEdits(file, base);
    const protocol = protocolResponse?.ok ? await protocolResponse.json() : null;
    state.currentEventResults = protocol;
    // протокола нет, а организаторы ведут результаты в Google Таблице — её копия с сервера (обновляется раз в 10 минут)
    const sheet = !protocol && (d.documents || []).some(isSheetDoc) ? await loadEventSheet(numId).catch(() => null) : null;
    const sheetRecs = sheet ? await loadRecords().catch(() => []) : [];
    const sheetHtml = (titleId) => (sheet ? sheetLeadersHtml(sheet, sheetRecs, { titleId }) : '');
    const past = isPast(base || d);
    const hasReg = !base?.regClosed && Boolean((d.registrations && d.registrations.length) || d.status === 'registration' || (base && base.status === 'registration'));
    const firstRegUrl = (d.registrations && d.registrations.length) ? d.registrations[0].url : '';
    // заявки на этот турнир через сайт не принимаются (нет табло, формы и ссылки) — вкладку «Регистрация» не показываем:
    // типовой текст про программы и видеоотбор к такому мероприятию не относится
    const live = liveOf(d, base);   // табло турнира: свой движок или leaderboards.ru
    const regTabHidden = !past && !hasReg && !live.id && !firstRegUrl && !(d.regUrl || base?.regUrl) && !base?.regClosed;
    const regs = past ? '' : (d.registrations || []).map(x => `<a class="document-link reg-link" href="${safeUrl(x.url)}" target="_blank" rel="noopener"><span>${esc(x.title || 'Регистрация открыта')}</span><small>зарегистрироваться ↗</small></a>`).join('');
    const regBlock = regs ? `<section class="detail-section"><h2>Регистрация</h2>${regs}</section>` : (past ? '<section class="detail-section"><div class="event-closed">Соревнование завершено — регистрация закрыта. Смотрите результаты во вкладке «Результаты».</div></section>' : '');
    const linkedMedia = getTournamentMedia(id, base || d);
    const localAl = localEventAlbums(id);
    const localPhotos = localAl.reduce((n, a) => n + a.count, 0);
    // есть перенесённый альбом — обложка альбома со старого сайта (d.media) не нужна
    const eventPhotos = localAl.length ? '' : (d.media || []).map(x => `<img loading="lazy" src="${safeImage(x)}" alt="Фото соревнования" data-fb="logo">`).join('');
    const eventAlbums = linkedMedia.albums.map(album => {
      const albumIndex = GTO_VK_ALBUMS.findIndex(x => String(x.id) === String(album.id) || (x.vkUrl && album.vkUrl && x.vkUrl === album.vkUrl));
      const idxAttr = albumIndex >= 0 ? `data-album="${albumIndex}"` : `data-pane="event-photos"`;
      const full = albumIndex >= 0 ? GTO_VK_ALBUMS[albumIndex] : null;
      const thumbs = ((full && full.photos) || album.previewPhotos || []).slice(0, 8);
      return `<article class="ev-album">
        <header class="ev-album-head"><div><b>${esc(album.title)}</b><small>${esc(album.totalPhotosText || '')}</small></div>
          <div class="ev-album-actions">${albumIndex >= 0 ? `<button type="button" class="tl-btn" data-album="${albumIndex}">Смотреть все фото</button>` : ''}${album.vkUrl ? `<a class="tl-link" href="${safeUrl(album.vkUrl)}" target="_blank" rel="noopener">Альбом во VK <i>↗</i></a>` : ''}</div></header>
        ${thumbs.length ? `<div class="ev-album-grid">${thumbs.map((ph, k) => `<button type="button" class="ev-album-ph" ${albumIndex >= 0 ? `data-album="${albumIndex}"` : idxAttr} aria-label="Фото ${k + 1}"><img loading="lazy" referrerpolicy="no-referrer" src="${safeImage(ph.thumb || ph.src || ph.url || ph)}" alt="" data-fb="album">${k === thumbs.length - 1 && album.count > thumbs.length ? `<span class="ev-album-more">+${album.count - thumbs.length}</span>` : ''}</button>`).join('')}</div>`
          : `<button class="event-media-album" ${idxAttr}><img loading="lazy" src="${safeImage(localAlbum(album).cover || album.cover)}" alt="${esc(album.title)}"><span><b>${esc(album.title)}</b><small>${esc(album.totalPhotosText)}</small></span></button>`}
      </article>`;
    }).join('');
    const eventVideos = linkedMedia.videos.map(video => `<button class="media-card" data-video="${safeUrl(video.embedUrl)}"><div class="media-thumb-wrap">${vkImg(state.videoThumbs[video.embedUrl] || video.thumb, video.title)}<span class="media-play-icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true"><path d="M8 5.14v13.72a1 1 0 0 0 1.5.86l11-6.86a1 1 0 0 0 0-1.72l-11-6.86A1 1 0 0 0 8 5.14z"/></svg></span></div><span><b>${esc(video.title)}</b><small>${esc((video.platform || 'video').toUpperCase())}${video.duration ? ' · ' + esc(video.duration) : ''}</small></span></button>`).join('');
    const photosCount = linkedMedia.albums.length + (localAl.length ? localPhotos : (d.media || []).length);
    const videosCount = linkedMedia.videos.length;

    // Athletes Extraction and Podium
    const athletes = extractEventAthletes(protocol, d);
    const eventPodium = renderEventPodiumWidget(athletes, protocol?.count ? protocol.results : null);

    const hasProtocols = Boolean(protocol?.count || (d.results && d.results.length));
    const docsCount = (d.documents || []).length;
    const eventMaterialsNav = (hasReg || hasProtocols || docsCount || photosCount || videosCount) ? `
      <section class="event-materials-nav" aria-label="Разделы турнира">
        <div class="event-materials-head">
          <small>НАВИГАЦИЯ ПО ТУРНИРУ</small>
          <b>Материалы и разделы</b>
          <span>Выберите раздел для быстрого перехода</span>
        </div>
        <div class="event-materials-grid">
          ${hasReg ? `
            <button class="event-mat-card reg" data-pane="reg" type="button">
              <span class="mat-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-notebook-pen"/></svg></span>
              <span class="mat-info">
                <strong>Регистрация</strong>
                <small>${past ? 'Завершена' : 'Приём заявок открыт'}</small>
              </span>
              <b>Подать заявку →</b>
            </button>` : ''}
          ${hasProtocols ? `
            <button class="event-mat-card results" data-pane="results" type="button">
              <span class="mat-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-chart-column"/></svg></span>
              <span class="mat-info">
                <strong>${protocol?.count || d.results.length}</strong>
                <small>${ruPlural(protocol?.count || d.results.length, 'результат', 'результата', 'результатов')} в протоколе</small>
              </span>
              <b>Смотреть протоколы →</b>
            </button>` : ''}
          ${docsCount ? `
            <button class="event-mat-card docs" data-pane="docs" type="button">
              <span class="mat-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-file-text"/></svg></span>
              <span class="mat-info">
                <strong>${docsCount}</strong>
                <small>${ruPlural(docsCount, 'документ', 'документа', 'документов')}</small>
              </span>
              <b>Документы турнира →</b>
            </button>` : ''}
          ${photosCount ? `
            <button class="event-mat-card photos" data-pane="event-photos" type="button">
              <span class="mat-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-camera"/></svg></span>
              <span class="mat-info">
                <strong>${photosCount}</strong>
                <small>${localAl.length ? 'фото' : ruPlural(photosCount, 'фотоальбом', 'фотоальбома', 'фотоальбомов')}${linkedMedia.totalPhotosText ? ' · ' + linkedMedia.totalPhotosText : ''}</small>
              </span>
              <b>Смотреть фото →</b>
            </button>` : ''}
          ${videosCount ? `
            <button class="event-mat-card videos" data-pane="event-videos" type="button">
              <span class="mat-icon"><svg class="ic ic-play" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" stroke="none" d="M8 5.14v13.72a1 1 0 0 0 1.5.86l11-6.86a1 1 0 0 0 0-1.72l-11-6.86A1 1 0 0 0 8 5.14z"/></svg></span>
              <span class="mat-info">
                <strong>${videosCount}</strong>
                <small>${ruPlural(videosCount, 'видеозапись', 'видеозаписи', 'видеозаписей')}</small>
              </span>
              <b>Смотреть видео →</b>
            </button>` : ''}
        </div>
      </section>` : '';

    const eventPhotosHtml = photosCount ? `
      ${localAlbumsHtml(id)}
      ${linkedMedia.albums.length ? `<h2>Фотоальбомы <span class="section-count">${linkedMedia.albums.length}</span></h2><div class="event-album-list">${eventAlbums}</div>` : ''}
      ${eventPhotos ? `<h2>Фотографии турнира <span class="section-count">${(d.media || []).length}</span></h2><div class="media-grid">${eventPhotos}</div>` : ''}
    ` : `
      <div class="detail-section" style="text-align:center;padding:32px 16px;">
        <span style="font-size:32px;display:block;margin-bottom:8px;"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-camera"/></svg></span>
        <h2>Фотографии соревнований</h2>
        <p>Фотографии с этого старта готовятся к публикации медиа-службой ФМГТО.</p>
        <div style="margin-top:14px;"><button class="primary-action" data-go="media" data-media-tab="photo" style="height:44px;font-size:13px;"><span>Перейти в фотобанк ФМГТО</span><span>→</span></button></div>
      </div>
    `;
    state.currentEventPhotosHtml = eventPhotosHtml;

    const eventVideosHtml = videosCount ? `
      <h2>Видео и трансляции <span class="section-count">${videosCount}</span></h2>
      <div id="event-video-player-slot"></div>
      <div class="media-list">${eventVideos}</div>
    ` : `
      <div class="detail-section" style="text-align:center;padding:32px 16px;">
        <span style="font-size:32px;display:block;margin-bottom:8px;"><svg class="ic ic-play" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" stroke="none" d="M8 5.14v13.72a1 1 0 0 0 1.5.86l11-6.86a1 1 0 0 0 0-1.72l-11-6.86A1 1 0 0 0 8 5.14z"/></svg></span>
        <h2>Видеозаписи и трансляции</h2>
        <p>Видеозаписи соревнований и прямые трансляции готовятся к публикации.</p>
        <div style="margin-top:14px;"><button class="primary-action" data-go="media" data-media-tab="video" style="height:44px;font-size:13px;"><span>Перейти в видео-архив</span><span>→</span></button></div>
      </div>
    `;
    state.currentEventVideosHtml = eventVideosHtml;

    const eventAboutAlbums = linkedMedia.albums.length ? `
      <section class="detail-section">
        <h2>Фотоальбомы соревнований <span class="section-count">${linkedMedia.albums.length}</span></h2>
        <div class="event-album-list">${eventAlbums}</div>
      </section>
    ` : '';

    const eventAboutVideos = linkedMedia.videos.length ? `
      <section class="detail-section">
        <h2>Видеозаписи и трансляции <span class="section-count">${linkedMedia.videos.length}</span></h2>
        <div class="media-list">${eventVideos}</div>
      </section>
    ` : '';

    // «Место проведения» со старой карточки бывает абзацем анонса («С 3 по 8 сентября … пройдёт …») — тогда место из календаря;
    // раньше к первому предложению дописывалось «· Всероссийские соревнования» — и у сборов, и у региональных стартов
    const heroLocation = eventLocation(d.location, base?.location || base?.city);

    // турнир, заведённый из базы/табло без программ (гонка организатора, старт в другой стране) — типовые блоки программ ФМГТО не показываем
    const hasFmgtoPrograms = !((base?.source === 'gto.db') && !(Array.isArray(base?.programs) && base.programs.length));
    // тренировочные сборы — не соревнование: без номера реестра, «старта ЕКП» и «Соревнование завершено» (сборы в Гудермесе, 2024)
    const camp = isTrainingCamp(base?.title || d.title);
    const inEkp = hasFmgtoPrograms && !camp && !NOT_EKP_EVENTS.has(String(id));   // номер реестра Минспорта и «старт ЕКП» — только у стартов календаря Минспорта
    const eventInfoSummary = `
      <section class="detail-section event-summary-passport">
        <div class="event-passport-grid">
          <div class="passport-item">
            <span class="passport-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-calendar"/></svg></span>
            <div>
              <small>Сроки проведения</small>
              <b>${esc([d.period || base?.period, eventYear(base || d)].filter(Boolean).join(' ') || 'Дата уточняется')}</b>
            </div>
          </div>
          <div class="passport-item">
            <span class="passport-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-map-pin"/></svg></span>
            <div>
              <small>Место проведения</small>
              <b>${esc(heroLocation || 'Российская Федерация')}</b>
            </div>
          </div>
          <div class="passport-item">
            <span class="passport-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-trophy"/></svg></span>
            <div>
              <small>${camp ? 'Статус' : 'Статус соревнования'}</small>
              <b>${past ? (camp ? 'Сборы завершены' : 'Соревнование завершено') : inEkp ? 'Официальный старт ЕКП' : esc(eventStatus(base || d).label)}</b>
            </div>
          </div>
          ${inEkp ? `<div class="passport-item">
            <span class="passport-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-landmark"/></svg></span>
            <div>
              <small>Реестр Минспорта РФ</small>
              <b>ВРВС № 1810001411Я</b>
            </div>
          </div>` : ''}
        </div>
      </section>
    `;

    // все разделы карточки целиком (раньше — два абзаца первого раздела, остальное со старого сайта не показывалось):
    // заголовки разделов, абзацы (переносы строк и списки «•» сохраняются), таблицы, ссылки кликабельны
    // служебные подписи со старого сайта («Партнеры», «Генеральный партнер», согласие, политика) — прочь; но абзац редакции «Генеральный
    // партнёр проекта — бренд „Спортлото“…» (длинный, с тире) — это текст страницы: раньше он пропадал у Народных Игр и финала «Героя ГТО» (10.10.2026)
    const boilerplate = (t) => /^(согласие|политик)/i.test(t) || (/^(партн[её]р|спонсор|генеральный)/i.test(t) && !(t.length >= 120 && /\s—\s/.test(t)));
    const usefulPara = (p) => typeof p === 'string' && p.trim().length > 20 && !boilerplate(p.trim())
      && !/пользуясь сайтом|cookies|политик\w* конфиденциальности/i.test(p)   // служебный текст со старого сайта
      && !(base?.regClosed && base?.regUrl && p.includes(base.regUrl))   // приём заявок завершён — ссылку на форму не повторяем
      && !(p.length > 400 && (p.match(/\d/g) || []).length > p.length / 4);   // «абзац»-слепок таблицы протокола со старого сайта (сплошные цифры)
    const aboutSections = (Array.isArray(d.about) ? d.about : []).map((sec) => ({ title: String(sec?.title || ''), paragraphs: (Array.isArray(sec?.paragraphs) ? sec.paragraphs : []).filter(usefulPara),
      tables: (Array.isArray(sec?.tables) ? sec.tables : []).filter((t) => Array.isArray(t) && t.length > 1) })).filter((sec) => sec.paragraphs.length || sec.tables.length);
    const aboutTable = (rows) => `<div class="about-table-wrap"><table class="about-table"><thead><tr>${rows[0].map((c) => `<th>${esc(c)}</th>`).join('')}</tr></thead><tbody>${rows.slice(1, 61).map((r) => `<tr>${r.map((c) => `<td>${esc(c)}</td>`).join('')}</tr>`).join('')}</tbody></table>${rows.length > 61 ? `<small>Показаны первые 60 строк из ${rows.length - 1}</small>` : ''}</div>`;
    // таблицы со старого сайта — это протоколы; если протокол есть во вкладке «Результаты», не дублируем, иначе показываем свёрнутыми
    const hasProtocolTab = Boolean(protocol?.count);
    const aboutBlocks = aboutSections.length
      ? aboutSections.filter((sec) => sec.paragraphs.length || (sec.tables.length && !hasProtocolTab)).flatMap((sec, i) => [
        sec.title && !(i === 0 && /^о соревновани/i.test(sec.title)) && (sec.paragraphs.length || !hasProtocolTab) ? `<h3 class="about-sec-title">${esc(sec.title)}</h3>` : '',
        ...fmtAbout(sec.paragraphs, { lead: i === 0 }),
        ...(hasProtocolTab ? [] : sec.tables.map((t) => `<details class="about-tables"><summary>Таблица${sec.title ? ': ' + esc(sec.title) : ''} · ${t.length - 1} ${pluralize(t.length - 1, ['строка', 'строки', 'строк'])}</summary>${aboutTable(t)}</details>`))].filter(Boolean))
      : (base?.description ? fmtAbout(base.description.split(/\n\s*\n/), { lead: true }) : []);
    const aboutHtml = aboutBlocks.join('');
    // без собственного описания блок не показываем (раньше — шаблонный абзац «Официальные всероссийские соревнования…»)
    const eventAboutCard = aboutHtml ? `
      <section class="detail-section event-about-card">
        <h2>О соревновании</h2>
        ${foldAbout(aboutBlocks)}
      </section>
    ` : '';
    const eventPartnersHtml = eventPartnersBand(d.partners);

    const isOnlineStage = Boolean(d.hasOnline === true || d.format === 'ONLINE' || d.format === 'Онлайн-турнир' || (base && (base.hasOnline === true || base.format === 'ONLINE' || base.format === 'Онлайн-турнир')));
    const heroGtoBanner = isOnlineStage ? `
      <section class="detail-section online-hero-banner" style="background:linear-gradient(135deg,rgba(56,189,248,0.12) 0%,rgba(168,85,247,0.12) 100%);border:1px solid rgba(56,189,248,0.3);border-radius:16px;padding:20px;margin-bottom:20px">
        <div style="display:flex;align-items:center;gap:10px;margin-bottom:8px">
          <span style="font-size:24px"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-zap"/></svg></span>
          <div>
            <span style="font-size:11px;font-weight:700;color:#38bdf8;text-transform:uppercase;letter-spacing:0.06em">ЕДИНАЯ ЭКОСИСТЕМА ФМГТО</span>
            <h3 style="margin:0;font-size:16px;color:#f8fafc;font-weight:800">Онлайн-турнир · Видеоотбор через «Герой ГТО»</h3>
          </div>
        </div>
        <p style="font-size:13px;color:#cbd5e1;line-height:1.5;margin:0 0 14px">
          Для участия в данном турнире запишите соревновательный комплекс из 3 обязательных упражнений на видеокамеру через специальный таймер «Герой ГТО» и выгрузите видеопопытку в Главную судейскую коллегию.
        </p>
        <div style="display:flex;gap:10px;flex-wrap:wrap">
          <button type="button" class="primary-action" data-go-herogto-tourn="${id}" style="height:42px;padding:0 18px;font-size:13px;background:linear-gradient(135deg,#0284c7,#2563eb);color:#fff;border-radius:10px;border:none;cursor:pointer;font-weight:700;display:inline-flex;align-items:center;gap:6px">
            <span><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-video"/></svg> Записать комплекс в Герой ГТО</span><span>→</span>
          </button>
          <button type="button" class="secondary-action" data-pane="results" style="height:42px;padding:0 16px;font-size:13px;border-radius:10px;cursor:pointer;display:inline-flex;align-items:center;gap:6px">
            <span><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-users"/></svg> Участники и протоколы</span>
          </button>
        </div>
      </section>
    ` : '';

    const recordRunCount = protocol?.results ? protocol.results.filter(isRecordRunRow).length : 0;
    const resultsHeroMeta = resultsHeroMetaFor(d, base, protocol, past);
    const stationLabels = protocolStationLabels(protocol);
    let resultsPaneHtml = '';
    if (protocol?.count) {
      resultsPaneHtml = tournamentResultsShell(protocol, { noHead: true });   // сырые таблицы карточки не дублируем: протокол уже в едином табличном виде
      // …но таблицы старой страницы, которых в протоколе нет (этапы, личный зачёт без ФИО, протоколы по дням, стартовые листы), — показываем
      // свёрнутыми под протоколом: раньше они пропадали целиком (Игры ГТО 2021 — индивидуальная гонка, Кубок Москвы 2022 — полуфиналы)
      const extra = legacyExtraSections(d.results, protocol.results);
      if (extra.length) resultsPaneHtml += legacyTablesHtml(extra, { title: 'Таблицы старой страницы, которых нет в протоколе', note: 'Этапы и разделы со страницы турнира на старом сайте — как они были опубликованы. Итоговые места — в протоколе выше.' });
    } else if (d.results && d.results.length) {
      resultsPaneHtml = legacyTablesHtml(d.results, { openFirst: true }) || sectionsHtml(d.results);
    } else if (sheet) {
      resultsPaneHtml = sheetHtml('sheet-rec-title');   // таблица организаторов (в ней же ссылка на оригинал) — реестр участников тут пуст
    } else {
      // протокол ведётся во внешней таблице (Google Таблицы и т. п. — документ вида protocol по ссылке): кнопка прямо в «Результатах»
      const sheetLinks = (d.documents || []).filter(x => x && x.kind === 'protocol' && /^https:\/\//.test(x.url || ''));
      resultsPaneHtml = `
        <div class="detail-section">
          <h2>Реестр участников и протоколы</h2>
          ${sheetLinks.length ? `<div class="results-sheet-links">${sheetLinks.map(x => `<a class="primary-action" href="${safeUrl(x.url)}" target="_blank" rel="noopener"><span>${esc(x.title || 'Таблица результатов')}</span><span>↗</span></a>`).join('')}</div>` : ''}
          <div id="event-live-participants-slot">
            ${skeletonHtml('list', 'Загружаем реестр участников…', { rows: 4 })}
          </div>
          ${isOnlineStage ? `
            <div style="margin-top:16px;padding:16px;background:rgba(56,189,248,0.06);border:1px dashed rgba(56,189,248,0.3);border-radius:12px">
              <b style="color:#f8fafc;display:block;margin-bottom:6px">Участвуйте в онлайн-этапе</b>
              <p style="font-size:13px;color:#94a3b8;margin:0 0 10px">Запишите видеокомплекс через мобильный таймер и отправьте судьям.</p>
              <button class="primary-action" data-go-herogto-tourn="${id}" style="height:40px;font-size:13px;">
                <span>Записать комплекс в Герой ГТО</span><span>→</span>
              </button>
            </div>
          ` : `
            <div style="margin-top:14px;">
              <button class="primary-action" data-go="athlete-search" style="height:44px;font-size:13px;">
                <span>Поиск атлетов по базе участников</span><span>→</span>
              </button>
            </div>
          `}
        </div>
      `;
    }

    // у документов со старого сайта названий часто нет — подписываем по типу и расширению, внешние ссылки (Яндекс.Диск) — «открыть»
    const docTitle = x => x.title || (`${x.kind === 'regulation' ? 'Положение' : x.kind === 'protocol' ? 'Протокол' : 'Документ'}${(String(x.url || '').match(/\.(pdf|docx?|xlsx?)$/i) || [])[1] ? ` (${String(x.url).match(/\.(pdf|docx?|xlsx?)$/i)[1].toUpperCase()})` : ''}`);
    // свои файлы — путём на сайте (/files/…): safeUrl пропускал только https:// и превращал их в «#» — по клику открывалась вкладка сайта, а не PDF
    const docLink = x => `<a class="document-link" href="${safeFileUrl(x.url)}" target="_blank" rel="noopener"><span>${esc(docTitle(x))}</span><small>${/^https?:\/\/(disk\.yandex|cloud\.mail|drive\.google|docs\.google)/.test(x.url || '') ? 'открыть ↗' : 'скачать ↗'}</small></a>`;
    // инструкции по категориям (kind = instruction) — отдельной группой под документами
    const docsMain = (d.documents || []).filter(x => x.kind !== 'instruction'), docsGuides = (d.documents || []).filter(x => x.kind === 'instruction');
    // инструкции одной категории («„Любители“, 18–19 лет», «„Иду на рекорд“: пресс») — группой с кнопками возрастов/упражнений, а не
    // лентой из десятков строк (Народные Игры 2026 — 76 инструкций; 10.10.2026, «чтобы всё было супер красиво»)
    const guideGroups = [];
    docsGuides.forEach((x) => {
      const m = docTitle(x).match(/^(«[^»]+»(?:\s*—\s*[^,:]+?)?)\s*[,:]\s*(.+)$/);
      const key = m ? m[1] : null, g = key && guideGroups.find((y) => y.key === key);
      if (g) g.items.push([m[2], x]); else guideGroups.push({ key, items: [[m ? m[2] : '', x]] });
    });
    const guideHtml = (g) => (g.key && g.items.length > 1
      ? `<div class="doc-group"><b>${esc(g.key)}</b><div class="doc-chips">${g.items.map(([label, x]) => `<a class="doc-chip" href="${safeFileUrl(x.url)}" target="_blank" rel="noopener" aria-label="Инструкция: ${esc(g.key)}, ${esc(label)}">${esc(label)}<span aria-hidden="true">↓</span></a>`).join('')}</div></div>`
      : g.items.map(([, x]) => docLink(x)).join(''));
    const docsLinks = docsMain.map(docLink).join('') + (docsGuides.length ? `<h3 class="about-sec-title">Инструкции</h3>${guideGroups.map(guideHtml).join('')}` : '');
    const docsPaneHtml = docsLinks ? `
      <div class="detail-section">
        <h2>Официальные документы турнира</h2>
        ${docsLinks}
      </div>
    ` : `
      <div class="detail-section">
        <h2>Официальные документы турнира</h2>
        <p>${esc(noDocsText(eventDateRange(base || d)?.end))}</p>
        <a class="document-link" href="https://gto.com.ru/data/1703837629/files/1759417287.pdf" target="_blank" rel="noopener"><span>Правила вида спорта «Многоборье ГТО»</span><small>скачать ↗</small></a>
        <a class="document-link" href="./privacy.html" target="_blank" rel="noopener"><span>Политика обработки персональных данных</span><small>скачать ↗</small></a>
      </div>
    `;

    const evFormat = getEventFormat(d.format ? d : (base || d));
    const evPrograms = getEventPrograms(d.programs ? d : (base || d));

    const formatPillHtml = evFormat === 'HYBRID'
      ? '<span class="event-format-pill hybrid"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-zap"/></svg> Гибрид (онлайн + арена)</span>'
      : (evFormat === 'ONLINE' ? '<span class="event-format-pill online"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-globe"/></svg> Онлайн-турнир</span>' : '<span class="event-format-pill offline"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-landmark"/></svg> Очный старт</span>');

    const eventProgramsSection = `
      <section class="detail-section event-programs-showcase">
        <div class="eps-header">
          <small>ПРОГРАММЫ СОРЕВНОВАНИЙ ФМГТО</small>
          <h2>Дисциплины и программы турнира</h2>
          <p>В данном турнире участники соревнуются в следующих официальных программах Федерации:</p>
        </div>
        <div class="eps-cards">
          ${evPrograms.includes('allround') ? `
            <div class="eps-card allround">
              <div class="eps-top">
                <span class="eps-badge allround">Многоборье</span>
                <span class="eps-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg></span>
              </div>
              <h3>Многоборье ГТО</h3>
              <p>Классическое спортивное многоборье: бег, плавание, стрельба, гимнастический комплекс и полоса препятствий (ВРВС № 1810001411Я).</p>
              <div class="eps-tag">Очный зачёт · Награды ЕКП Минспорта</div>
            </div>
          ` : ''}
          ${evPrograms.includes('herogto') ? `
            <div class="eps-card herogto">
              <div class="eps-top">
                <span class="eps-badge herogto"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-zap"/></svg> Герой ГТО</span>
                <span class="eps-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-video"/></svg></span>
              </div>
              <h3>Герой ГТО</h3>
              <p>Дистанционный WOD-комплекс и квалификационный отбор. Записывается на видеокамеру смартфона через встроенный видеотаймер.</p>
              <div class="eps-tag">Видеофиксация · Главная судейская коллегия</div>
              <button type="button" class="eps-btn" data-go-herogto-tourn="${id}">
                <span>Записать WOD в Герой ГТО</span><span>→</span>
              </button>
            </div>
          ` : ''}
          ${evPrograms.includes('records') ? `
            <div class="eps-card records">
              <div class="eps-top">
                <span class="eps-badge records"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-trophy"/></svg> Рекорды</span>
                <span class="eps-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-biceps-flexed"/></svg></span>
              </div>
              <h3>Иду на рекорд</h3>
              <p>Официальная попытка установления рекорда России в силовых упражнениях (рывок гири 16 кг, отжимания, подтягивания, наклон).</p>
              <div class="eps-tag">Книга рекордов России ГТО</div>
              <button type="button" class="eps-btn secondary" data-go="records">
                <span>Рекорды России</span><span>→</span>
              </button>
            </div>
          ` : ''}
        </div>
      </section>
    `;

    const regCalloutBanner = (!past && hasReg) ? `
      <section class="detail-section event-reg-callout" style="background:linear-gradient(135deg,rgba(249,115,22,0.12) 0%,rgba(234,88,12,0.18) 100%);border:1.5px solid rgba(249,115,22,0.4);border-radius:16px;padding:18px 20px;margin-bottom:20px">
        <div style="display:flex;align-items:center;gap:10px;margin-bottom:8px">
          <span style="font-size:24px"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-notebook-pen"/></svg></span>
          <div>
            <span style="font-size:11px;font-weight:700;color:#fb923c;text-transform:uppercase;letter-spacing:0.06em">ПРИЁМ ЗАЯВОК ОТКРЫТ</span>
            <h3 style="margin:0;font-size:16px;color:#fff;font-weight:800">Регистрация на соревнование</h3>
          </div>
        </div>
        <p style="font-size:13px;color:#fed7aa;line-height:1.5;margin:0 0 14px">
          Подайте официальную заявку на участие в турнире. Для прохождения квалификации запишите комплекс WOD через видеотаймер «Герой ГТО».
        </p>
        <div style="display:flex;gap:10px;flex-wrap:wrap">
          ${firstRegUrl ? `
            <a href="${safeUrl(firstRegUrl)}" target="_blank" rel="noopener" class="primary-action" style="height:42px;padding:0 18px;font-size:13px;background:linear-gradient(135deg,#f97316,#ea580c);color:#fff;border-radius:10px;border:none;cursor:pointer;font-weight:700;display:inline-flex;align-items:center;gap:6px;text-decoration:none">
              <span>Подать заявку ↗</span>
            </a>
          ` : ''}
          <button type="button" class="primary-action" data-go-herogto-tourn="${id}" style="height:42px;padding:0 18px;font-size:13px;background:linear-gradient(135deg,#0284c7,#2563eb);color:#fff;border-radius:10px;border:none;cursor:pointer;font-weight:700;display:inline-flex;align-items:center;gap:6px">
            <span><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-zap"/></svg> Видеоотбор WOD →</span>
          </button>
          <button type="button" class="secondary-action" data-pane="reg" style="height:42px;padding:0 16px;font-size:13px;border-radius:10px;cursor:pointer;display:inline-flex;align-items:center;gap:6px">
            <span>Вкладка регистрации →</span>
          </button>
        </div>
      </section>
    ` : '';

    const regPaneHtml = `
      <div class="detail-section">
        <h2>Регистрация участников турнира</h2>
        ${!past ? `
          <div class="event-reg-programs-box" style="background:rgba(255,255,255,0.03);border:1px solid rgba(255,255,255,0.08);border-radius:14px;padding:16px;margin-bottom:16px">
            <div style="font-size:11px;font-weight:700;color:#38bdf8;text-transform:uppercase;letter-spacing:0.06em;margin-bottom:4px">ВЫБОР ПРОГРАММ УЧАСТИЯ</div>
            <h4 style="margin:0 0 10px;font-size:15px;color:#fff;font-weight:700">Программы соревнований для атлета:</h4>
            <div style="display:flex;flex-direction:column;gap:10px">
              <label style="display:flex;align-items:flex-start;gap:10px;cursor:pointer;padding:10px 12px;background:rgba(255,255,255,0.02);border:1px solid rgba(255,255,255,0.06);border-radius:10px">
                <input type="checkbox" checked style="margin-top:3px;accent-color:#0284c7">
                <div>
                  <b style="color:#f8fafc;font-size:14px">Многоборье ГТО</b>
                  <p style="margin:2px 0 0;font-size:12px;color:#94a3b8">Классические виды многоборья на спортивной арене</p>
                </div>
              </label>
              <label style="display:flex;align-items:flex-start;gap:10px;cursor:pointer;padding:10px 12px;background:rgba(56,189,248,0.05);border:1px solid rgba(56,189,248,0.25);border-radius:10px">
                <input type="checkbox" ${evPrograms.includes('herogto') ? 'checked' : ''} style="margin-top:3px;accent-color:#0284c7">
                <div>
                  <b style="color:#38bdf8;font-size:14px"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-zap"/></svg> Герой ГТО (Онлайн-отбор WOD)</b>
                  <p style="margin:2px 0 0;font-size:12px;color:#cbd5e1">Видеофиксация соревновательного комплекса с оценкой судей</p>
                </div>
              </label>
              <label style="display:flex;align-items:flex-start;gap:10px;cursor:pointer;padding:10px 12px;background:rgba(245,158,11,0.05);border:1px solid rgba(245,158,11,0.25);border-radius:10px">
                <input type="checkbox" ${evPrograms.includes('records') ? 'checked' : ''} style="margin-top:3px;accent-color:#f59e0b">
                <div>
                  <b style="color:#fbbf24;font-size:14px"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-trophy"/></svg> Иду на рекорд</b>
                  <p style="margin:2px 0 0;font-size:12px;color:#cbd5e1">Индивидуальная заявка на рекорд турнира</p>
                </div>
              </label>
            </div>
          </div>

          <div style="background:linear-gradient(135deg,rgba(249,115,22,0.12) 0%,rgba(234,88,12,0.18) 100%);border:1.5px solid rgba(249,115,22,0.4);border-radius:14px;padding:16px;margin-bottom:16px">
            <div style="font-size:11px;font-weight:700;color:#fb923c;text-transform:uppercase;letter-spacing:0.06em;margin-bottom:4px">ОФИЦИАЛЬНАЯ ПОДАЧА ЗАЯВОК</div>
            <h3 style="margin:0 0 8px;font-size:15px;color:#fff;font-weight:800">Электронная форма регистрации</h3>
            <p style="font-size:13px;color:#fed7aa;line-height:1.45;margin:0 0 14px">
              Заполните официальную форму заявки на участие. Выберите категорию участия и прикрепите необходимые документы согласно регламенту соревнований.
            </p>
            ${(d.registrations || []).map(x => `
              <a class="primary-action" href="${safeUrl(x.url)}" target="_blank" rel="noopener" style="height:44px;font-size:13.5px;background:linear-gradient(135deg,#f97316,#ea580c);color:#fff;border-radius:10px;display:flex;align-items:center;justify-content:center;gap:8px;text-decoration:none;font-weight:700;margin-bottom:8px">
                <span><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-notebook-pen"/></svg> ${esc(x.title || 'Заполнить форму регистрации')}</span><span>↗</span>
              </a>
            `).join('')}
          </div>

          <div style="background:linear-gradient(135deg,rgba(56,189,248,0.1) 0%,rgba(168,85,247,0.1) 100%);border:1.5px solid rgba(56,189,248,0.35);border-radius:14px;padding:16px;margin-bottom:16px">
            <div style="font-size:11px;font-weight:700;color:#38bdf8;text-transform:uppercase;letter-spacing:0.06em;margin-bottom:4px">ВИДЕООТБОР И КВАЛИФИКАЦИЯ</div>
            <h3 style="margin:0 0 8px;font-size:15px;color:#fff;font-weight:800">Онлайн-этап в модуле «Герой ГТО»</h3>
            <p style="font-size:13px;color:#cbd5e1;line-height:1.45;margin:0 0 14px">
              Для подтверждения квалификации или дистанционного участия запишите соревновательный комплекс из 3 упражнений на камеру телефона через специальный таймер «Герой ГТО». Видеопопытки передаются сертифицированным судьям ФМГТО.
            </p>
            <button type="button" class="primary-action" data-go-herogto-tourn="${id}" style="width:100%;height:44px;font-size:13.5px;background:linear-gradient(135deg,#0284c7,#2563eb);color:#fff;border-radius:10px;border:none;cursor:pointer;font-weight:700;display:flex;align-items:center;justify-content:center;gap:8px">
              <span><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-video"/></svg> Открыть комплекс WOD в Герой ГТО</span><span>→</span>
            </button>
          </div>

          <div style="background:rgba(255,255,255,0.03);border:1px solid rgba(255,255,255,0.08);border-radius:14px;padding:16px">
            <h4 style="margin:0 0 10px;font-size:14px;color:#f8fafc">Порядок подачи и проверки заявок:</h4>
            <ol style="margin:0;padding-left:18px;font-size:13px;color:#94a3b8;line-height:1.6">
              <li>Заполните электронную форму заявки по кнопке выше.</li>
              <li>При наличии квалификационного отбора запишите 3 видео упражнений в модуле «Герой ГТО».</li>
              <li>Видео поступает в раздел «Видеосудейство» панели организаторов ФМГТО.</li>
              <li>После подтверждения судьями ваш статус отобразится во вкладке «Результаты».</li>
            </ol>
          </div>
        ` : `
          <div class="event-closed">Соревнование завершено — приём заявок закрыт. Итоговые протоколы доступны во вкладке «Результаты».</div>
        `}
      </div>
    `;

    const evNews = getUnifiedNews().filter(n => (n.eventId && String(n.eventId) === String(numId)) || (n.event_id && String(n.event_id) === String(numId)));
    const eventNewsHtml = evNews.length ? `
      <div class="detail-section" style="margin-top:20px;">
        <h2>Новости турнира (${evNews.length})</h2>
        <div class="news-list" style="margin-top:12px;display:grid;gap:12px;">
          ${evNews.map(x => `
            <button type="button" class="nwc" data-article="${x.id}">
              <div>
                <div style="display:flex;align-items:center;gap:6px;margin-bottom:4px;">
                  <time>${esc(x.date)}</time>
                  ${x.isHub ? `<span class="event-fmt-badge" style="font-size:10px;padding:2px 6px;background:rgba(56,189,248,0.15);color:#38bdf8;">Новостной хаб</span>` : ''}
                </div>
                <b>${esc(x.title)}</b>
                <p>${esc(x.text)}</p>
              </div>
              <img loading="lazy" ${rsImgAttrs(x.img, 480)} alt="" data-fb="logo">
            </button>
          `).join('')}
        </div>
      </div>
    ` : '';

    $('#event-detail').innerHTML = `
      ${modEventToolbarHtml}
      <div class="detail-hero tournament-media--hero">
        <div class="detail-hero-media">
          <img ${rsImgAttrs((d.cover && !/logo-clean/.test(d.cover)) ? d.cover : (base?.localPoster || base?.img || d.cover), 1280)} alt="" fetchpriority="high" decoding="async" data-fb="none" data-portrait="hero">
        </div>
        <div class="detail-hero-copy">
          <div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:6px">
            <time>${esc(d.period)}</time>
            ${formatPillHtml}
          </div>
          <h1 class="tournament-hero-title ${getTournamentTitleClass(d.title)}">${esc(d.title)}</h1>
          <p>${esc(heroLocation)}</p>
        </div>
      </div>
      ${eventNowHtml(base || d)}
      <div class="event-actions-bar" style="display:grid;grid-template-columns:1fr 1fr auto;gap:8px;margin:12px 0">
        <button class="ics-export-btn" data-event-ics="${id}" style="margin:0;width:100%">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
          <span>В календарь (.ics)</span>
        </button>
        <button class="ics-export-btn ${isEventSavedOffline(id) ? 'saved' : ''}" data-event-offline="${id}" style="margin:0;width:100%${isEventSavedOffline(id) ? ';border-color:rgba(34,197,94,0.4);background:rgba(34,197,94,0.12)' : ''}">
          ${isEventSavedOffline(id) ? `
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#22c55e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
            <span style="color:#22c55e">✓ Офлайн-доступ</span>
          ` : `
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            <span>Сохранить офлайн</span>
          `}
        </button>
        <button type="button" class="ics-export-btn ev-share-btn" data-share-event="${id}" data-share-title="${esc(d.title)}" aria-label="Поделиться турниром" title="Поделиться: ссылка с превью для Telegram и VK"><svg class="ic" aria-hidden="true" viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="m8.6 13.5 6.8 4M15.4 6.5l-6.8 4"/></svg></button>
      </div>
      ${lbLiveLinkHtml(live, past)}
      <div class="detail-tabs">
        <button class="active" data-pane="about">О турнире</button>
        <button data-pane="complexes" ${stationLabels.length || live.id || numId === 1144 ? '' : 'hidden'}>${numId === 1144 ? 'Категории и нормативы' : 'Упражнения'} ${stationLabels.length ? '· ' + protocolStagesCount(protocol) : ''}</button>
        <button data-pane="reg" ${regTabHidden ? 'hidden' : ''}>Регистрация ${!past && hasReg ? '<svg class="ic ic-live" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-circle"/></svg>' : ''}</button>
        <button data-pane="heats" hidden>Заходы</button>
        <button data-pane="results">${!past && !isOngoing(base || d) && !protocol?.count ? 'Участники' : 'Результаты'} ${protocol?.count ? '· ' + protocol.count : (d.results && d.results.length ? '· ' + d.results.length : '')}</button>
        <button data-pane="event-photos">Фото ${photosCount ? '· ' + photosCount : ''}</button>
        <button data-pane="event-videos">Видео ${videosCount ? '· ' + videosCount : ''}</button>
        <button data-pane="docs">Документы ${docsCount ? '· ' + docsCount : ''}</button>
        ${recordRunCount || evPrograms.includes('records') ? `<button data-pane="record-run">Иду на рекорд ${recordRunCount ? '· ' + recordRunCount : ''}</button>` : ''}
      </div>
      ${recordRunCount || evPrograms.includes('records') ? `<div class="detail-pane" data-pane-content="record-run">${!recordRunCount && sheet ? sheetHtml('sheet-rec-run-title') : tournamentRecordsHtml(protocol, { past })}</div>` : ''}
      <div class="detail-pane active" data-pane-content="about">${overviewLayout(eventAboutCard + eventPartnersHtml + eventInfoSummary, regCalloutBanner + lbOverviewRootHtml(live, past, { regUrl: d.regUrl || base?.regUrl, regTitle: d.regTitle || base?.regTitle, hasAbout: Boolean(aboutHtml) }) + eventMaterialsNav)}${hasFmgtoPrograms ? eventProgramsSection + heroGtoBanner : ''}${eventAboutAlbums}${eventAboutVideos}${eventPodium}${eventNewsHtml}${regBlock}</div>
      <div class="detail-pane" data-pane-content="complexes"><div class="lb-complexes-root"></div>${protocolStationsHtml(protocol, { guides: categoryGuides(aboutSections.flatMap((sec) => sec.paragraphs)) })}</div>
      <div class="detail-pane" data-pane-content="reg"><div class="lb-reg-root"></div>${live.id ? '' : (base?.regClosed && !past) ? REG_CLOSED_HTML : regPaneHtml}</div>
      <div class="detail-pane" data-pane-content="heats"><div class="lb-heats-root"></div></div>
      <div class="detail-pane" data-pane-content="results">${sheet ? '' : resultsHeroHtml(resultsHeroMeta)}${lbExtrasRootHtml(live, past, Boolean(protocol?.count), (d.about || []).map(a => (a.paragraphs || []).join('\n\n')).join('\n\n') || base?.description || '', (d.regUrl || base?.regUrl) ? { url: d.regUrl || base.regUrl, title: d.regTitle || base?.regTitle || '' } : null)}${resultsPaneHtml}</div>
      <div class="detail-pane event-photos-pane" data-pane-content="event-photos">${eventPhotosHtml}</div>
      <div class="detail-pane event-videos-pane" data-pane-content="event-videos">${eventVideosHtml}</div>
      <div class="detail-pane" data-pane-content="docs">${docsPaneHtml}</div>
    `;

    const partSlot = $('#event-live-participants-slot');
    if (partSlot) {
      fetchEventParticipants(numId).then(parts => {
        if (!parts || !parts.length) {
          partSlot.innerHTML = `<div class="empty" style="padding:14px 0">${esc(noProtocolText(eventDateRange(base || d)?.end, undefined, camp))}</div>`;   // давно прошедший — «не публиковался»
          return;
        }
        partSlot.innerHTML = `
          <div style="display:flex;flex-direction:column;gap:8px;margin-top:10px">
            ${parts.some((p) => p.status === 'confirmed')
              ? `<div style="font-size:12px;color:#94a3b8;margin-bottom:4px">Всего атлетов в реестре: <b style="color:#38bdf8">${parts.length}</b></div>`
              : `<div style="font-size:12px;color:#94a3b8;margin-bottom:4px">Протокола нет — это заявки (${parts.length}), а не результаты</div>`}
            ${parts.map(p => `
              <div style="display:flex;justify-content:space-between;align-items:center;padding:10px 14px;background:rgba(255,255,255,0.03);border:1px solid rgba(255,255,255,0.07);border-radius:12px">
                <div>
                  <b style="font-size:14px;color:#f8fafc;cursor:pointer" data-athlete="${esc(p.athlete_id)}">${esc(p.name)}</b>
                  <div style="font-size:12px;color:#94a3b8;margin-top:2px">${esc(p.region || 'Россия')} · <span style="color:#cbd5e1">${esc(p.category || 'Любители')}</span></div>
                </div>
                <div style="text-align:right;display:flex;align-items:center;gap:8px">
                  <div>
                    <strong style="color:#38bdf8;font-size:14px;display:block">${esc(p.result || '—')}</strong>
                    <small style="color:#94a3b8">${esc(p.status === 'confirmed' ? 'В протоколе' : p.status === 'registration' ? 'Заявка' : 'Видео на судействе')}</small>
                  </div>
                  ${p.videos && p.videos.length ? `
                    <a href="${esc(p.videos[0].url)}" target="_blank" rel="noopener" style="padding:4px 8px;font-size:11px;background:rgba(56,189,248,0.12);color:#38bdf8;border:1px solid rgba(56,189,248,0.3);border-radius:6px;text-decoration:none"><svg class="ic ic-play" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" stroke="none" d="M8 5.14v13.72a1 1 0 0 0 1.5.86l11-6.86a1 1 0 0 0 0-1.72l-11-6.86A1 1 0 0 0 8 5.14z"/></svg> Видео</a>
                  ` : ''}
                </div>
              </div>
            `).join('')}
          </div>
        `;
      }).catch(() => {});
    }
    renderEventResults();
    if (numId === 1144) import('./tashkent_norms.js?v=dc58487f').then(m => {
      if (state.currentEventId === numId) {
        const tab = $('#event-detail [data-pane="complexes"]');
        if (tab) { tab.hidden = false; tab.textContent = 'Категории и нормативы'; }
        m.mountTashkentNorms($('#event-detail .detail-pane[data-pane-content="complexes"]'));
        const about = $('#event-detail .detail-pane[data-pane-content="about"]');
        if (about && !about.querySelector('[data-tz-entry]')) {
          const entry = document.createElement('button'); entry.type = 'button'; entry.className = 'gto-need-all'; entry.dataset.pane = 'complexes'; entry.dataset.tzEntry = '';
          entry.textContent = 'ГТО / Спортивные испытания — определить ступень и посмотреть нормативы →'; about.prepend(entry);
        }
      }
    }).catch(() => {});
    // турнирная сетка (Салки ГТО и т.п.), если судьи опубликовали её в админке
    eventHasBracket(numId).then((has) => {
      if (!has || state.currentEventId !== numId) return;
      import('./brackets.js?v=bb84be38').then((m) => m.mountEventBracket(numId, $('#event-detail .detail-pane[data-pane-content="about"]'))).catch(() => {});
    });
    let targetInitial = initialPane;
    if (targetInitial === 'event-media') targetInitial = 'event-photos';
    if (targetInitial && targetInitial !== 'about') {
      const pane = $(`.detail-tabs [data-pane="${targetInitial}"]:not([hidden])`);
      if (pane) {
        $$('.detail-tabs button').forEach(x => x.classList.toggle('active', x === pane));
        $$('.detail-pane').forEach(x => x.classList.toggle('active', x.dataset.paneContent === targetInitial));
      }
    }
    mountLbOverviewRoot();
    mountLbExtras();
    if (push) {
      resetScrollToTop();
    } else {
      const finalY = (typeof restoreScrollY === 'number') ? restoreScrollY : scrollStore.get(`event/${id}`);
      if (typeof finalY === 'number') restoreScrollPosition(finalY);
    }
  } catch (e) {
    if (!base) {
      $('#event-detail').innerHTML = '<div class="detail-error">Событие не найдено.</div>';
      return;
    }
    const st = eventStatus(base);
    const linkedMedia = getTournamentMedia(id, base);
    const eventAlbums = linkedMedia.albums.map(album => {
      const albumIndex = GTO_VK_ALBUMS.findIndex(x => String(x.id) === String(album.id) || (x.vkUrl && album.vkUrl && x.vkUrl === album.vkUrl));
      const idxAttr = albumIndex >= 0 ? `data-album="${albumIndex}"` : `data-pane="event-photos"`;
      const full = albumIndex >= 0 ? GTO_VK_ALBUMS[albumIndex] : null;
      const thumbs = ((full && full.photos) || album.previewPhotos || []).slice(0, 8);
      return `<article class="ev-album">
        <header class="ev-album-head"><div><b>${esc(album.title)}</b><small>${esc(album.totalPhotosText || '')}</small></div>
          <div class="ev-album-actions">${albumIndex >= 0 ? `<button type="button" class="tl-btn" data-album="${albumIndex}">Смотреть все фото</button>` : ''}${album.vkUrl ? `<a class="tl-link" href="${safeUrl(album.vkUrl)}" target="_blank" rel="noopener">Альбом во VK <i>↗</i></a>` : ''}</div></header>
        ${thumbs.length ? `<div class="ev-album-grid">${thumbs.map((ph, k) => `<button type="button" class="ev-album-ph" ${albumIndex >= 0 ? `data-album="${albumIndex}"` : idxAttr} aria-label="Фото ${k + 1}"><img loading="lazy" referrerpolicy="no-referrer" src="${safeImage(ph.thumb || ph.src || ph.url || ph)}" alt="" data-fb="album">${k === thumbs.length - 1 && album.count > thumbs.length ? `<span class="ev-album-more">+${album.count - thumbs.length}</span>` : ''}</button>`).join('')}</div>`
          : `<button class="event-media-album" ${idxAttr}><img loading="lazy" src="${safeImage(localAlbum(album).cover || album.cover)}" alt="${esc(album.title)}"><span><b>${esc(album.title)}</b><small>${esc(album.totalPhotosText)}</small></span></button>`}
      </article>`;
    }).join('');
    const eventVideos = linkedMedia.videos.map(video => `<button class="media-card" data-video="${safeUrl(video.embedUrl)}"><div class="media-thumb-wrap">${vkImg(state.videoThumbs[video.embedUrl] || video.thumb, video.title)}<span class="media-play-icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true"><path d="M8 5.14v13.72a1 1 0 0 0 1.5.86l11-6.86a1 1 0 0 0 0-1.72l-11-6.86A1 1 0 0 0 8 5.14z"/></svg></span></div><span><b>${esc(video.title)}</b><small>${esc((video.platform || 'video').toUpperCase())}${video.duration ? ' · ' + esc(video.duration) : ''}</small></span></button>`).join('');
    const localAl = localEventAlbums(id);
    const photosCount = linkedMedia.albums.length + localAl.reduce((n, a) => n + a.count, 0);
    const videosCount = linkedMedia.videos.length;
    const eventPhotosHtml = photosCount ? `${localAlbumsHtml(id)}${linkedMedia.albums.length ? `<h2>Фотоальбомы <span class="section-count">${linkedMedia.albums.length}</span></h2><div class="event-album-list">${eventAlbums}</div>` : ''}` : `
      <div class="detail-section" style="text-align:center;padding:32px 16px;">
        <span style="font-size:32px;display:block;margin-bottom:8px;"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-camera"/></svg></span>
        <h2>Фотографии соревнований</h2>
        <p>Фотографии с этого старта готовятся к публикации медиа-службой ФМГТО.</p>
        <div style="margin-top:14px;"><button class="primary-action" data-go="media" data-media-tab="photo" style="height:44px;font-size:13px;"><span>Перейти в фотобанк ФМГТО</span><span>→</span></button></div>
      </div>
    `;
    state.currentEventPhotosHtml = eventPhotosHtml;
    const eventVideosHtml = videosCount ? `<h2>Видео и трансляции <span class="section-count">${videosCount}</span></h2><div id="event-video-player-slot"></div><div class="media-list">${eventVideos}</div>` : `
      <div class="detail-section" style="text-align:center;padding:32px 16px;">
        <span style="font-size:32px;display:block;margin-bottom:8px;"><svg class="ic ic-play" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" stroke="none" d="M8 5.14v13.72a1 1 0 0 0 1.5.86l11-6.86a1 1 0 0 0 0-1.72l-11-6.86A1 1 0 0 0 8 5.14z"/></svg></span>
        <h2>Видеозаписи и трансляции</h2>
        <p>Видеозаписи соревнований и прямые трансляции готовятся к публикации.</p>
        <div style="margin-top:14px;"><button class="primary-action" data-go="media" data-media-tab="video" style="height:44px;font-size:13px;"><span>Перейти в видео-архив</span><span>→</span></button></div>
      </div>
    `;
    state.currentEventVideosHtml = eventVideosHtml;

    const eventMaterialsNav = `
      <section class="event-materials-nav" aria-label="Разделы турнира">
        <div class="event-materials-head">
          <small>НАВИГАЦИЯ ПО ТУРНИРУ</small>
          <b>Материалы и протоколы</b>
          <span>Все материалы и документы соревнований</span>
        </div>
        <div class="event-materials-grid">
          <button class="event-mat-card results" data-pane="results" type="button">
            <span class="mat-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-chart-column"/></svg></span>
            <span class="mat-info">
              <strong>Протоколы</strong>
              <small>Реестр результатов</small>
            </span>
            <b>Смотреть протоколы →</b>
          </button>
          <button class="event-mat-card docs" data-pane="docs" type="button">
            <span class="mat-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-file-text"/></svg></span>
            <span class="mat-info">
              <strong>Документы</strong>
              <small>Положения и правила</small>
            </span>
            <b>Документы турнира →</b>
          </button>
          ${photosCount ? `
            <button class="event-mat-card photos" data-pane="event-photos" type="button">
              <span class="mat-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-camera"/></svg></span>
              <span class="mat-info">
                <strong>${photosCount}</strong>
                <small>${localAl.length ? 'фото' : ruPlural(photosCount, 'фотоальбом', 'фотоальбома', 'фотоальбомов')}</small>
              </span>
              <b>Смотреть фото →</b>
            </button>` : ''}
          ${videosCount ? `
            <button class="event-mat-card videos" data-pane="event-videos" type="button">
              <span class="mat-icon"><svg class="ic ic-play" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" stroke="none" d="M8 5.14v13.72a1 1 0 0 0 1.5.86l11-6.86a1 1 0 0 0 0-1.72l-11-6.86A1 1 0 0 0 8 5.14z"/></svg></span>
              <span class="mat-info">
                <strong>${videosCount}</strong>
                <small>${ruPlural(videosCount, 'видеозапись', 'видеозаписи', 'видеозаписей')}</small>
              </span>
              <b>Смотреть видео →</b>
            </button>` : ''}
        </div>
      </section>`;

    const eventInfoSummary = `
      <section class="detail-section event-summary-passport">
        <div class="event-passport-grid">
          <div class="passport-item">
            <span class="passport-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-calendar"/></svg></span>
            <div>
              <small>Сроки проведения</small>
              <b>${esc([base.period, eventYear(base)].filter(Boolean).join(' ') || 'Дата уточняется')}</b>
            </div>
          </div>
          <div class="passport-item">
            <span class="passport-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-map-pin"/></svg></span>
            <div>
              <small>Место проведения</small>
              <b>${esc(base.location || 'Российская Федерация')}</b>
            </div>
          </div>
          <div class="passport-item">
            <span class="passport-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-trophy"/></svg></span>
            <div>
              <small>Статус соревнования</small>
              <b>${esc(st.label || 'Официальный старт ЕКП')}</b>
            </div>
          </div>
          <div class="passport-item">
            <span class="passport-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-landmark"/></svg></span>
            <div>
              <small>Реестр Минспорта РФ</small>
              <b>ВРВС № 1810001411Я</b>
            </div>
          </div>
        </div>
      </section>
    `;

    const eventAboutCard = base.description ? `
      <section class="detail-section event-about-card">
        <h2>О соревновании</h2>
        ${foldAbout(fmtAbout(base.description.split(/\n\s*\n/), { lead: true }))}
      </section>
    ` : '';

    const eventAboutAlbums = linkedMedia.albums.length ? `
      <section class="detail-section">
        <h2>Фотоальбомы соревнований <span class="section-count">${linkedMedia.albums.length}</span></h2>
        <div class="event-album-list">${eventAlbums}</div>
      </section>
    ` : '';

    const eventAboutVideos = linkedMedia.videos.length ? `
      <section class="detail-section">
        <h2>Видеозаписи и трансляции <span class="section-count">${linkedMedia.videos.length}</span></h2>
        <div class="media-list">${eventVideos}</div>
      </section>
    ` : '';

    $('#event-detail').innerHTML = `
      ${modEventToolbarHtml}
      <div class="detail-hero tournament-media--hero">
        <div class="detail-hero-media">
          <img ${rsImgAttrs(base.localPoster || GTO_CALENDAR_EVENTS.find(x => String(x.id) === String(base.id))?.localPoster || base.poster || base.img, 960)} alt="" data-fb="logo" data-portrait="hero">
        </div>
        <div class="detail-hero-copy">
          <time>${esc(base.period || eventYear(base) || '')}</time>
          <h1 class="tournament-hero-title ${getTournamentTitleClass(base.title)}">${esc(base.title)}</h1>
          <p>${esc(base.location || '')}</p>
        </div>
      </div>
      ${eventNowHtml(base)}
      <div class="event-actions-bar" style="display:grid;grid-template-columns:1fr 1fr auto;gap:8px;margin:12px 0">
        <button class="ics-export-btn" data-event-ics="${id}" style="margin:0;width:100%">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
          <span>В календарь (.ics)</span>
        </button>
        <button class="ics-export-btn ${isEventSavedOffline(id) ? 'saved' : ''}" data-event-offline="${id}" style="margin:0;width:100%${isEventSavedOffline(id) ? ';border-color:rgba(34,197,94,0.4);background:rgba(34,197,94,0.12)' : ''}">
          ${isEventSavedOffline(id) ? `
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#22c55e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
            <span style="color:#22c55e">✓ Офлайн-доступ</span>
          ` : `
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            <span>Сохранить офлайн</span>
          `}
        </button>
        <button type="button" class="ics-export-btn ev-share-btn" data-share-event="${id}" data-share-title="${esc(base.title)}" aria-label="Поделиться турниром" title="Поделиться: ссылка с превью для Telegram и VK"><svg class="ic" aria-hidden="true" viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="m8.6 13.5 6.8 4M15.4 6.5l-6.8 4"/></svg></button>
      </div>
      ${lbLiveLinkHtml(liveOf(null, base), isPast(base))}
      <div class="detail-tabs">
        <button class="active" data-pane="about">О турнире</button>
        <button data-pane="complexes" ${liveOf(null, base).id ? '' : 'hidden'}>Упражнения</button>
        <button data-pane="reg" ${liveOf(null, base).id || base.regUrl || (!isPast(base) && eventStatus(base).k === 'registration') ? '' : 'hidden'}>Регистрация ${!isPast(base) && !base.regClosed && (liveOf(null, base).id || base.regUrl) ? '<svg class="ic ic-live" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-circle"/></svg>' : ''}</button>
        <button data-pane="heats" hidden>Заходы</button>
        <button data-pane="results">Результаты</button>
        <button data-pane="docs">Документы</button>
        <button data-pane="event-photos">Фото ${photosCount ? '· ' + photosCount : ''}</button>
        <button data-pane="event-videos">Видео ${videosCount ? '· ' + videosCount : ''}</button>
      </div>
      <div class="detail-pane active" data-pane-content="about">${overviewLayout(eventAboutCard + eventInfoSummary, lbOverviewRootHtml(liveOf(null, base), isPast(base), { regUrl: base.regUrl, regTitle: base.regTitle, hasAbout: Boolean(base.description) }) + eventMaterialsNav)}${eventAboutAlbums}${eventAboutVideos}</div>
      <div class="detail-pane" data-pane-content="complexes"><div class="lb-complexes-root"></div></div>
      <div class="detail-pane" data-pane-content="reg"><div class="lb-reg-root"></div>${base.regClosed && !isPast(base) ? REG_CLOSED_HTML : base.regUrl && !liveOf(null, base).id ? `<div class="detail-section"><h2>Регистрация участников</h2><p>Регистрация проходит на площадке организатора.</p><a class="primary-action" href="${safeUrl(base.regUrl)}" target="_blank" rel="noopener" style="display:inline-flex;height:44px;align-items:center;padding:0 18px;margin-top:10px"><span>Перейти к регистрации ↗</span></a></div>` : ''}</div>
      <div class="detail-pane" data-pane-content="heats"><div class="lb-heats-root"></div></div>
      <div class="detail-pane" data-pane-content="results">
        ${resultsHeroHtml(resultsHeroMetaFor(base, base, null, isPast(base)))}${lbExtrasRootHtml(liveOf(null, base), isPast(base), false, base.description || '', base.regUrl ? { url: base.regUrl, title: base.regTitle || '' } : null)}
        <div class="detail-section res-empty-note" ${liveOf(null, base).id ? 'hidden' : ''}>
          <h2>Протоколы и результаты</h2>
          <p>${esc(noProtocolText(eventDateRange(base)?.end))} Вы можете найти результаты атлетов через сквозной поиск по базе.</p>
          <div style="margin-top:14px;"><button class="primary-action" data-go="athlete-search" style="height:44px;font-size:13px;"><span>Поиск атлетов по базе участников</span><span>→</span></button></div>
        </div>
      </div>
      <div class="detail-pane" data-pane-content="docs">
        <div class="detail-section">
          <h2>Официальные документы</h2>
          <a class="document-link" href="https://gto.com.ru/data/1703837629/files/1759417287.pdf" target="_blank" rel="noopener"><span>Правила вида спорта «Многоборье ГТО»</span><small>скачать ↗</small></a>
          <a class="document-link" href="https://gto.com.ru/docs/soglasie_na_obrabotku_PD_Narodnye_igry.pdf" target="_blank" rel="noopener"><span>Политика обработки персональных данных</span><small>скачать ↗</small></a>
        </div>
      </div>
      <div class="detail-pane event-photos-pane" data-pane-content="event-photos">${eventPhotosHtml}</div>
      <div class="detail-pane event-videos-pane" data-pane-content="event-videos">${eventVideosHtml}</div>
    `;
    let targetInitial = initialPane;
    if (targetInitial === 'event-media') targetInitial = 'event-photos';
    if (targetInitial && targetInitial !== 'about') {
      const pane = $(`.detail-tabs [data-pane="${targetInitial}"]:not([hidden])`);
      if (pane) {
        $$('.detail-tabs button').forEach(x => x.classList.toggle('active', x === pane));
        $$('.detail-pane').forEach(x => x.classList.toggle('active', x.dataset.paneContent === targetInitial));
      }
    }
    mountLbOverviewRoot();
    mountLbExtras();
    if (push) {
      resetScrollToTop();
    } else {
      const finalY = (typeof restoreScrollY === 'number') ? restoreScrollY : scrollStore.get(`event/${id}`);
      if (typeof finalY === 'number') restoreScrollPosition(finalY);
    }
  }
}

export function normalizeProtocolRow(row) {
  if (!row || typeof row !== 'object') return null;

  // 1. Detect and discard junk table headers parsed as rows
  const rawParticipant = (row.participant || '').trim();
  const rawTeam = (row.team || '').trim();
  const rawResult = (row.result || '').trim();
  const rawRank = String(row.rank || '').trim().toLowerCase();

  const isHeaderString = str => /^(название\s*команд|имя\s*участника|фио|спортсмен|участник|место|время|очки|балл|сумма|итоговая\s*сумма|сумма\s*мест|триатлон\s*гто)$/i.test(str.trim());

  if (isHeaderString(rawParticipant) || (rawParticipant === '' && isHeaderString(rawTeam))) {
    return null;
  }
  if (rawRank === 'место' || rawRank === 'rank') {
    return null;
  }
  if (isHeaderString(rawResult) && isHeaderString(rawTeam)) {
    return null;
  }

  // 2. Identify participant_type and clean fields
  let participantType = row.participant_type;
  let regionId = row.region_id || null;
  let teamId = row.team_id || null;
  let athleteId = row.athlete_id || null;
  let displayName = row.display_name;

  if (!participantType) {
    if (rawParticipant) {
      participantType = 'individual';
      displayName = rawParticipant;
    } else if (rawTeam) {
      const reg = normalizeRegionName(rawTeam);
      if (reg) {
        participantType = 'regional_team';
        regionId = reg;
        displayName = rawTeam;
      } else {
        participantType = 'team';
        displayName = rawTeam;
      }
    } else {
      participantType = 'individual';
      displayName = 'Не указано';
    }
  }

  if (!displayName || displayName === 'Команда' || displayName === 'Участник') {
    if (participantType === 'regional_team' && (row.region || row.team)) {
      displayName = row.region || row.team;
    } else if (rawParticipant) {
      displayName = rawParticipant;
    } else if (rawTeam && rawTeam !== 'Команда') {
      displayName = rawTeam;
    } else {
      displayName = 'Не указано';
    }
  }

  if (participantType === 'regional_team' && !regionId) {
    regionId = normalizeRegionName(displayName) || normalizeRegionName(row.team || '') || normalizeRegionName(row.region || '');
  }

  return {
    ...row,
    participant_type: participantType,
    display_name: displayName,
    region_id: regionId,
    team_id: teamId,
    athlete_id: athleteId
  };
}

const RECORD_RUN_RE = /иду на рекорд/i;
const isRecordRunRow = (row) => RECORD_RUN_RE.test(String(row?.category || row?.pageTitle || ''));
const isTeamCategoryName = (name) => /команд|эстафет|сборн/i.test(String(name || ''));
// «138.0 баллов (25:59 / 14:17 | 240 кг)» → { main:'138', unit:'баллов', parts:['25:59 / 14:17','240 кг'] }
function splitResultText(result) {
  const raw = String(result || '').trim();
  if (!raw) return { main: '', unit: '', parts: [] };
  const m = raw.match(/^(.*?)\s*\((.*)\)\s*$/);   // внешние скобки — раскладка по станциям (внутри могут быть свои скобки)
  let head = m ? m[1].trim() : raw;
  const parts = m ? m[2].split('|').map(x => x.trim()).filter(Boolean) : [];
  // итог внутри скобок: «(Баллы: 20 | Задание А: 96 (10) | Задание Б: 2:22 (10))» («Первая попытка», Народные Игры 2024) — это итог,
  // а не задание: раньше «Баллы» показывались третьим заданием во вкладке «Упражнения» (10.10.2026)
  const inner = !head && parts.length > 1 && parts[0].match(/^(?:баллы|очки|итог|сумма|всего)\s*:\s*(\d[\d.,]*|[-—–])\s*$/i);
  if (inner) { parts.shift(); head = /\d/.test(inner[1]) ? `${inner[1]} балл.` : ''; }   // «Баллы: -» — итога нет
  const n = head.match(/^(\d+(?::\d{2})*(?:[.,]\d+)?)\s*(.*)$/);   // «7:34,22», «1:02:03», «112.5 кг», «20»
  let main = n ? n[1] : head, unit = n ? n[2] : '';
  if (/^\d+\.0$/.test(main)) main = main.slice(0, -2);
  unit = unitFor(main, unit);   // «41 баллов» → «41 балл», «252 баллов» → «252 балла» (табло и сканы писали без склонения)
  return { main, unit, parts };
}
// «224 повт. (1) / 62 повт. (5) — 6 очк. (1)» → { rest:'224 повт. (1) / 62 повт. (5)', pts:'6', rank:'1' }
function cellSummary(v) {
  const m = String(v || '').match(/^(.*?)\s—\s([\d.,]+)\sочк\.(?:\s\((\d{1,3})\))?$/);
  return m ? { rest: m[1], pts: m[2], rank: m[3] || '' } : { rest: String(v || ''), pts: '', rank: '' };
}
function resultTilesHtml(parts, names = []) {
  if (!parts.length) return '';
  return `<div class="lb-tiles res-tiles">${parts.map((raw, i) => {
    const p = parsePart(raw);
    const label = p.label || names[i] || `Этап ${i + 1}`; const v = p.label ? p.value : raw;
    return `<button type="button" class="lb-tile" data-station="${esc(label)}" title="Подробнее о станции «${esc(label)}»"><small>${p.day ? `<em>Д${p.day}</em> ` : ''}${esc(label)}</small><b>${esc(v)}</b></button>`; }).join('')}</div>`;
}
function regionLinkHtml(region) {
  if (!region) return '';
  const id = normalizeRegionName(region);
  return id ? `<button type="button" class="res-region-btn" data-open-region="${esc(id)}">${esc(region)}</button>` : esc(region);
}
// отметка протокола вместо места (замечание редакции 12.10.2026: у «Героя ГТО» в Сириусе стояли прочерки у «в/к» и сошедших)
const RANK_MARKS = [[/^в\s*\/?\s*к\.?$/i, 'в/к', 'Вне конкурса'], [/^(сош[её]л|сошла|dnf$)/i, 'сошёл', 'Сошёл с дистанции'],
  [/^(н\s*\/\s*я|dns)$/i, 'н/я', 'Не явился'], [/^(дискв|dq|dsq)/i, 'дискв.', 'Дисквалификация']];
const rankMark = (rank) => RANK_MARKS.find(([re]) => re.test(String(rank || '').trim())) || null;
// место в таблице протокола (lg-place): номер, отметка протокола («в/к», «сошёл») или «—»
function lgPlaceHtml(rank, medal) {
  const n = parseRank(rank);
  if (n < 999999) return `<span class="lg-place ${medal}">${n}</span>`;
  const mark = rankMark(rank);
  return mark ? `<span class="lg-place is-mark" title="${mark[2]}">${mark[1]}</span>` : `<span class="lg-place ${medal}">—</span>`;
}
function rankBadgeHtml(rank) {
  const n = parseRank(rank);
  const has = n > 0 && n < 999999;
  const medal = { 1: 'Золото', 2: 'Серебро', 3: 'Бронза' }[n];
  const mark = has ? null : rankMark(rank);
  if (mark) return `<div class="lb-rank is-mark" title="${mark[2]}"><span>${mark[1]}</span></div>`;
  return `<div class="lb-rank">${has ? n : '—'}${medal ? `<small>${medal}</small>` : ''}</div>`;
}
// тёзки (полное совпадение ФИО у публичных атлетов) — «#2»: номер по порядку появления в базе (export_site_data.namesakes)
function nsTagHtml(n) { return n ? `<span class="ns-tag" title="Полный тёзка №${n} — у этого ФИО в базе несколько атлетов">#${n}</span>` : ''; }
// видео выступления участника (онлайн-этапы: ссылка из протокола старого сайта — event_content/<номер>.videos.json, 10.10.2026):
// только https и только видеосервисы — ссылкой «▶ Видео» рядом с именем
const VIDEO_HOST = /^(?:www\.|m\.)?(youtube\.com|youtu\.be|rutube\.ru|vk\.com|vkvideo\.ru|vk\.ru|disk\.yandex\.ru|disk\.yandex\.com|cloud\.mail\.ru|drive\.google\.com)$/i;
function resultVideoHtml(row, name = '') {
  const url = String(row?.video || '');
  try { if (!url.startsWith('https://') || !VIDEO_HOST.test(new URL(url).hostname)) return ''; } catch (_) { return ''; }
  return `<a class="res-video" href="${esc(url)}" target="_blank" rel="noopener" title="${esc(linkName(url))}" data-video-title="${esc(name ? `${name} — видео выступления` : 'Видео выступления')}" aria-label="Видео выступления${name ? `: ${esc(name)}` : ''} (${esc(linkName(url))})"><span aria-hidden="true">▶</span>Видео</a>`;
}
function resultRowHtml(row, i = 0, opts = {}) {
  const n = parseRank(row.rank);
  const top = n >= 1 && n <= 3 ? `top top${n}` : '';
  const name = row.display_name || row.participant || row.team || 'Не указано';
  const isTeamEntity = row.participant_type === 'team' || row.participant_type === 'regional_team';
  const r = splitResultText(row.result);
  const metrics = Object.entries(row.details || {}).filter(([k, v]) => v && k && !/^(фамилия|имя|регион|место|категория|возраст на старте|пол|возрастная группа)$/i.test(k)).slice(0, 6);
  const age = resultAge(row);
  const sub = [row.national_group ? nationalGroupHtml(row.national_group) : row.gto_stage ? gtoStageHtml(row.gto_stage) : '', regionLinkHtml(row.region), opts.showCategory ? esc(row.category) : '', age && !opts.hideAge ? esc(age) : '', row.subgroup && row.subgroup !== age ? esc(row.subgroup) : ''].filter(Boolean);
  const title = isTeamEntity
    ? `<button type="button" class="res-name-btn" data-open-team="${esc(name)}">${esc(name)}</button>`
    : `<button type="button" class="res-name-btn" data-athlete-query="${esc(name)}">${esc(name)}</button>`;
  return `<article class="lb-row res-row ${top}" style="--i:${Math.min(i, 14)}">
    ${rankBadgeHtml(row.rank)}
    <div class="lb-body">
      <div class="lb-name">${title}${isTeamEntity ? '<span class="lb-stage">Команда</span>' : nsTagHtml(row.namesake)}${resultVideoHtml(row, name)}${row.place_computed ? '<span class="res-calc" title="Место рассчитано по результатам: в исходном протоколе места не проставлены">расч.</span>' : ''}</div>
      ${sub.length ? `<div class="lb-sub">${sub.join(' · ')}</div>` : ''}
      ${r.parts.length ? resultTilesHtml(r.parts) : (metrics.length ? `<div class="lb-tiles res-tiles">${metrics.map(([k, v]) => `<span class="lb-tile"><small>${esc(k)}</small><b>${esc(v)}</b></span>`).join('')}</div>` : '')}
    </div>
    ${r.main ? `<div class="lb-total"><b>${esc(r.main)}</b>${r.unit ? `<small>${esc(r.unit)}</small>` : ''}</div>` : '<div class="lb-total"><b>—</b></div>'}
  </article>`;
}
// командная категория: одна карточка на команду — место, баллы, регион и состав (участники кликабельны)
function teamRowHtml(teamName, rows, i = 0) {
  // в старых протоколах participant = название команды, а человек — в display_name; в новых participant = человек
  const personOf = (x) => { const n = (x.display_name || x.participant || '').trim(); return n && n !== teamName ? n : ''; };
  const entry = rows.find(x => !personOf(x)) || rows[0];
  const members = rows.filter(x => personOf(x));
  const rank = [entry, ...rows].map(x => x.rank).find(x => parseRank(x) < 999999) || '';
  const n = parseRank(rank);
  const top = n >= 1 && n <= 3 ? `top top${n}` : '';
  const detailed = rows.map(x => x.result).find(x => /\(/.test(x || ''));   // строка с раскладкой по станциям (с табло) — приоритет
  const r = splitResultText(detailed || entry.result || rows.find(x => x.result)?.result);
  const region = entry.region || rows.find(x => x.region)?.region || '';
  const isReg = entry.participant_type === 'regional_team';
  const computed = rows.some(x => x.place_computed);
  return `<article class="lb-row res-row res-team ${top}" style="--i:${Math.min(i, 14)}">
    ${rankBadgeHtml(rank)}
    <div class="lb-body">
      <div class="lb-name"><button type="button" class="res-name-btn" data-open-team="${esc(teamName)}">${esc(teamName)}</button><span class="lb-stage">${isReg ? 'Сборная региона' : 'Команда'}</span>${computed ? '<span class="res-calc" title="Место рассчитано по результатам">расч.</span>' : ''}</div>
      <div class="lb-sub">${[regionLinkHtml(region), members.length ? `${members.length} ${ruPlural(members.length, 'участник', 'участника', 'участников')}` : ''].filter(Boolean).join(' · ')}</div>
      ${resultTilesHtml(r.parts)}
      ${members.length ? `<div class="lb-members res-members">${members.map(m => `<button type="button" class="res-member" data-athlete-query="${esc(personOf(m))}">${esc(personOf(m))}</button>`).join('')}</div>` : ''}
    </div>
    ${r.main ? `<div class="lb-total"><b>${esc(r.main)}</b>${r.unit ? `<small>${esc(r.unit)}</small>` : ''}</div>` : '<div class="lb-total"><b>—</b></div>'}
  </article>`;
}
function resultsPodiumHtml(top, unitLabel = '') {
  const card = (x) => {
    if (!x) return '<div></div>';
    const r0 = splitResultText(x.result); const r = r0.main ? r0 : (x.calc || r0);
    const attr = x.isTeam ? `data-open-team="${esc(x.name)}"` : `data-athlete-query="${esc(x.name)}"`;
    return `<div class="lb-pod lb-pod-${x.rank}"><div class="lb-pod-medal">${x.rank}</div><button type="button" class="lb-pod-name" ${attr}>${esc(x.name)}</button><span>${esc(x.region || '')}</span><em>${esc(r.main || '—')}<small>${esc(r.unit || unitLabel)}</small></em><div class="lb-pod-step"></div></div>`;
  };
  return `<section class="lb-podium res-podium" aria-label="Призёры категории">${card(top[1])}${card(top[0])}${card(top[2])}</section>`;
}
function groupHeaderHtml(tag, title, count, word) {
  const clickable = tag === 'Категория';
  return `<div class="res-group"><span class="res-group-tag">${esc(tag)}</span>${clickable ? `<button type="button" class="res-group-btn" data-result-category="${esc(title)}" title="Показать только эту категорию"><h3>${esc(title)}</h3></button>` : `<h3>${esc(title)}</h3>`}<span class="res-group-count">${count} ${word}</span></div>`;
}

// карточка станции/комплекса: описание с leaderboards.ru (если есть) + все результаты на этой станции по категориям
function openStationModal(label) {
  document.getElementById('station-modal')?.remove();
  const meta = (state.lbMeta?.complexes || []).find(c => c.short === label || c.name === label) || null;
  const rows = (state.currentEventResults?.results || []).map(normalizeProtocolRow).filter(Boolean);
  const lists = stationResultsHtml(label, rows, { openAll: true });
  const modal = document.createElement('div');
  modal.className = 'share-modal'; modal.id = 'station-modal'; modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true');
  modal.innerHTML = `<div class="share-modal-card rating-explain-card st-card">
      <button type="button" class="share-modal-close" data-st-close aria-label="Закрыть">✕</button>
      <span class="eyebrow">Станция · комплекс</span>
      <h3 class="rx-title">${esc(meta?.name || label)}</h3>
      ${meta?.description ? `<p class="st-desc">${esc(meta.description)}</p>` : '<p class="st-desc st-muted">Описание станции появится, когда организатор загрузит регламент.</p>'}
      ${meta ? `<div class="lbo-station-meta">${[(meta.scores || []).join(' · '), meta.time_cap ? `лимит ${meta.time_cap >= 120 ? Math.round(meta.time_cap / 60) + ' мин' : meta.time_cap + ' с'}` : '', meta.venue].filter(Boolean).map(m => `<span>${esc(m)}</span>`).join('')}</div>` : ''}
      ${meta?.standards ? `<details class="lbo-standards"><summary>Нормативы</summary><p>${esc(meta.standards)}</p></details>` : ''}
      ${lists ? `<div class="st-head"><b>Все результаты на станции</b><small>по категориям · имя ведёт в профиль</small></div>${lists}` : ''}
    </div>`;
  document.body.appendChild(modal);
  const close = () => modal.remove();
  modal.querySelector('[data-st-close]').onclick = close;
  modal.addEventListener('click', (e) => { if (e.target === modal) close(); else if (e.target.closest('[data-athlete-query],[data-open-team]')) setTimeout(close, 0); });
}

// сквозные результаты по станции: все участники, по категориям (модалка станции и вкладка «Комплексы»)
function stationEntries(label, rows) {
  const found = [];
  rows.forEach(r => {
    const parts = splitResultText(r.result).parts;
    const part = parts.map(parsePart).find(p => p.label === label);
    if (!part) return;
    // значение этапа целиком: «00:13:23.012» — 803 с, «13:21.909» — 801,909 с (раньше часы и доли терялись, и рейтинг этапа ломался)
    const val = part.value; const cn = cellNumber(val); const num = cn.num;
    const isTeam = r.participant_type === 'team' || r.participant_type === 'regional_team';
    // официальное место на станции из протокола («179 повт. (3)», «… — 6 очк. (2)») важнее пересчёта по значению:
    // закончивший комплекс за 10:22 выше тех, кто не уложился в лимит и записан повторами
    const rank = stageRankOf(val);
    const sum = cellSummary(val);
    const shown = sum.rest.replace(/\s*\(\d{1,3}\)/g, '').trim() + (sum.pts ? ` · ${sum.pts} очк.` : '');
    found.push({ name: r.display_name || r.participant || r.team, team: r.team, region: r.region, category: r.category || 'Основной зачёт', val: shown, num, rank, isTime: cn.isTime, isTeam });
  });
  const seen = new Set();
  return found.filter(x => { const k = (x.team && x.isTeam ? x.team : x.name) + '|' + x.category; if (seen.has(k)) return false; seen.add(k); return true; });
}
function stationResultsHtml(label, rows, opts = {}) {
  const uniq = stationEntries(label, rows);
  const byCat = new Map();
  uniq.forEach(x => { if (!byCat.has(x.category)) byCat.set(x.category, []); byCat.get(x.category).push(x); });
  const groups = [...byCat.entries()].map(([cat, list]) => {
    // формат большинства задаёт порядок: время — меньше лучше; повторы/кг — больше лучше; «чужой» формат (не уложился, DNF) — в конец
    const timeN = list.filter(x => x.isTime).length; const asc = timeN * 2 >= list.length;
    const ranked = list.filter(x => x.rank).length * 2 >= list.length;   // места есть в протоколе — по ним
    const off = (x) => (x.isTime !== asc) || isNaN(x.num);
    if (ranked) list.sort((a, b) => (a.rank || 999) - (b.rank || 999));
    else list.sort((a, b) => (off(a) !== off(b)) ? (off(a) ? 1 : -1) : (asc ? a.num - b.num : b.num - a.num));
    return { cat, asc, ranked, list };
  }).sort((a, b) => b.list.length - a.list.length);
  if (!groups.length) return '';
  return groups.map((g, gi) => `<details class="st-group" ${gi === 0 || opts.openAll ? 'open' : ''}>
      <summary><b>${esc(g.cat)}</b><small>${g.list.length} ${ruPlural(g.list.length, 'результат', 'результата', 'результатов')} · ${g.ranked ? 'места по протоколу' : g.asc ? 'меньше — лучше' : 'больше — лучше'}</small></summary>
      <ol class="st-list">${g.list.map((x, i) => { const n = g.ranked ? x.rank : i + 1; return `<li><span class="st-rank ${n && n <= 3 ? 'top' + n : ''}">${n || '—'}</span><button type="button" class="st-name" ${x.isTeam && x.team ? `data-open-team="${esc(x.team)}"` : `data-athlete-query="${esc(x.name)}"`}>${esc(x.isTeam && x.team ? x.team : x.name)}</button><small>${esc(x.region || '')}</small><b>${esc(x.val)}</b></li>`; }).join('')}</ol>
    </details>`).join('');
}
// вкладка «Комплексы» для турниров с протоколом: каждая станция — раскрывающийся блок со всеми результатами
function protocolStationLabels(protocol) {
  const labels = [];
  (protocol?.results || []).forEach(r => {
    splitResultText(r.result).parts.forEach(p => { const x = parsePart(p); if (x.label && !labels.some(l => l.label === x.label)) labels.push(x); });
  });
  return labels;
}
// «1/4 финала · ч.2» → этап «1/4 финала» (части тура — время/вес/повторы — это одно задание, а не отдельные комплексы)
const stageOf = (label) => String(label || '')
  .replace(/\s·\sч\.\d+$/, '')                         // «1/4 финала · ч.2»
  .replace(/[\s.]*(?:часть|ч\.)\s*\d+\.?$/i, '')        // «1 комплекс. Часть 2», «3 комплекс ч.2»
  .replace(/\s+\/\s+.*$/, '')                             // «6 комплекс / Задержка дыхания» (дробь «1/4» не трогаем)
  .replace(/^(\d+\s*комп?лекс)\s*\([^)]*\)$/i, '$1')        // «1 комплекс (время)», «1 комплекс (вес)» → «1 комплекс»
  .replace(/\bкомлекс\b/i, 'комплекс').trim();
function protocolStages(protocol) {
  const rows = (protocol?.results || []).map(normalizeProtocolRow).filter(r => r && !isRecordRunRow(r));
  const byCat = new Map();
  rows.forEach(r => {
    const cat = r.category || 'Основной зачёт';
    if (!byCat.has(cat)) byCat.set(cat, []);
    const list = byCat.get(cat);
    splitResultText(r.result).parts.map(parsePart).forEach((p, i) => {
      if (!p.label) return;
      const st = stageOf(p.label);
      let stage = list.find(x => x.stage === st);
      if (!stage) { stage = { stage: st, day: p.day, i, parts: [] }; list.push(stage); }
      if (p.day && (!stage.day || p.day < stage.day)) stage.day = p.day;
      if (!stage.parts.some(x => x.label === p.label)) stage.parts.push({ label: p.label, day: p.day, i });
    });
  });
  const groups = new Map();
  for (const [cat, list] of byCat) {
    if (!list.length) continue;
    list.sort((a, b) => (a.day - b.day) || (a.i - b.i));
    list.forEach(st => st.parts.sort((a, b) => (a.day - b.day) || (a.i - b.i)));
    const sig = list.map(x => x.stage + ':' + x.parts.map(p => p.label).join(',')).join('~');
    if (!groups.has(sig)) groups.set(sig, { cats: [], list });
    groups.get(sig).cats.push(cat);
  }
  return { rows, groups: [...groups.values()] };
}
function protocolStagesCount(protocol) {
  const { groups } = protocolStages(protocol);
  return new Set(groups.flatMap(g => g.list.map(x => x.stage.toLowerCase()))).size;
}
// видеоинструкции категорий из описания турнира: строки «• «Любители»: https://youtu.be/…» (видео — только встраиваемые сервисы)
const GUIDE_LINE = /^\s*[•\-–]?\s*«([^»]{2,60})»\s*[:—–-]\s*(https:\/\/\S+)\s*$/;
function categoryGuides(paragraphs) {
  return paragraphs.flatMap((p) => String(p).split('\n')).map((l) => l.match(GUIDE_LINE)).filter((m) => m && videoEmbedUrl(m[2])).map((m) => ({ label: m[1].trim(), url: m[2] }));
}
// видео к группе категорий: «Юниоры продвинутые» берёт видео «Юниоры», если своего нет
function guidesFor(cats, guides) {
  const key = (t) => normRu(String(t)).trim();
  const seen = new Set();
  return cats.map((c) => guides.find((g) => key(c) === key(g.label)) || guides.find((g) => key(c).startsWith(key(g.label) + ' ')))
    .filter((g) => g && !seen.has(g.url) && seen.add(g.url));
}
// как сложился итог группы: сумма мест в заданиях («7 (Задание А: 91 (2) | Задание Б: 2:22 (5))») или сумма очков
// («17 очк. (Задание А: 96 / 2 очк. | Задание В: 2:16 / 15 очк.)») — если сходится у 80% строк; иначе ничего не утверждаем
function totalRule(rows) {
  const ptsOf = (v) => { const m = String(v).match(/\/\s*([\d.,]+)\s*очк\.?\s*$/); return m ? parseFloat(m[1].replace(',', '.')) : NaN; };
  let n = 0, places = 0, points = 0;
  rows.forEach((r) => {
    const sp = splitResultText(r.result); const tot = parseFloat(String(sp.main).replace(',', '.'));
    const ps = sp.parts.map(parsePart).filter((x) => x.label);
    if (!Number.isFinite(tot) || ps.length < 2) return;
    n += 1;
    if (Math.abs(ps.reduce((a, p) => a + (stageRankOf(p.value) || NaN), 0) - tot) < 0.01) places += 1;
    else if (Math.abs(ps.reduce((a, p) => a + ptsOf(p.value), 0) - tot) < 0.01) points += 1;
  });
  if (!n) return '';
  return places >= n * 0.8 ? 'сумма мест в заданиях (меньше — лучше)' : points >= n * 0.8 ? 'сумма очков за задания' : '';
}
function protocolStationsHtml(protocol, { guides = [] } = {}) {
  const { rows, groups } = protocolStages(protocol);
  if (!groups.length) return '';
  // описаний упражнений у таких турниров нет (онлайн-этапы: задания объясняли видео) — вкладка собрана из столбцов протокола;
  // что это и чем отличается от «Результатов» (10.10.2026, владелец: «что за кнопка упражнения?», «Задание А — может, это задвоение результатов?»)
  const lead = `<p class="cx-lead"><b>Это не второй протокол.</b> В «Результатах» — итог участника, здесь — те же выступления по заданиям: кто лучший в каждом. У каждой категории свои упражнения${guides.length ? ' — смотрите видео «Как выполнять»' : ' — как их выполнять, во вкладке «О турнире»'}. Нажмите на задание — откроется его рейтинг.</p>`;
  return `<div class="cx-list">${lead}${groups.map(g => {
    const gRows = rows.filter(r => g.cats.includes(r.category || 'Основной зачёт'));
    let day = -1;
    const items = g.list.map((st, k) => {
      const head = st.day && st.day !== day ? `<div class="lbo-day">День ${st.day}</div>` : ''; day = st.day;
      const cnt = new Set(gRows.filter(r => splitResultText(r.result).parts.map(parsePart).some(p => stageOf(p.label) === st.stage)).map(r => r.display_name || r.participant || r.team)).size;
      const multi = st.parts.length > 1;
      const partNote = multi ? st.parts.map(p => `${p.label.match(/ч\.\d+$/)?.[0] || ''}${p.day && p.day !== st.day ? ` (день ${p.day})` : ''}`).join(' · ') : '';
      const body = multi
        ? st.parts.map(p => `<div class="cx-part"><div class="cx-part-head"><b>${esc(p.label.match(/ч\.\d+$/)?.[0] || p.label)}</b>${p.day ? `<small>день ${p.day}</small>` : ''}<button type="button" class="lbo-step-btn" data-station="${esc(p.label)}">все результаты ›</button></div>${stationResultsHtml(p.label, gRows)}</div>`).join('')
        : stationResultsHtml(st.parts[0].label, gRows);
      return `${head}<details class="cx-station"><summary><span class="lbo-station-num">${k + 1}</span><b>${esc(st.stage)}${multi ? `<small class="cx-parts">${st.parts.length} ${ruPlural(st.parts.length, 'часть', 'части', 'частей')}: ${esc(partNote)}</small>` : ''}</b><small>${cnt} ${ruPlural(cnt, 'участник', 'участника', 'участников')}</small><span class="cx-open" aria-hidden="true">Рейтинг</span></summary><div class="cx-body">${body}</div></details>`;
    }).join('');
    const gv = guidesFor(g.cats, guides);
    const how = totalRule(gRows);
    const guideHtml = gv.length ? `<div class="cx-guides"><span>Как выполнять:</span>${gv.map((v) => `<a class="about-card-link is-video" href="${esc(v.url)}" target="_blank" rel="noopener" data-video-title="${esc(`Как выполнять: «${v.label}»`)}"><span aria-hidden="true">▶</span>«${esc(v.label)}»</a>`).join('')}</div>` : '';
    return `<section class="cx-group"><div class="res-group"><span class="res-group-tag">${g.cats.some(c => isTeamCategoryName(c)) ? 'Команды' : 'Зачёт'}</span><h3>${esc(g.cats.join(' · '))}</h3><span class="res-group-count">${g.list.length} ${g.list.every((x) => /^задани/i.test(x.stage)) ? ruPlural(g.list.length, 'задание', 'задания', 'заданий') : ruPlural(g.list.length, 'этап', 'этапа', 'этапов')}</span></div>${how ? `<p class="cx-how">Итог в «Результатах» — ${how}.</p>` : ''}${guideHtml}${items}</section>`;
  }).join('')}</div>`;
}

// Подробные таблицы первоисточника (старый сайт: список участников, дни/туры) — в стиле табло, все имена кликабельны
function legacyTablesHtml(sections, opts = {}) {
  const list = (sections || []).filter(s => s && (s.tables || []).some(t => Array.isArray(t) && t.length));
  if (!list.length) return '';
  const isNum = v => /^\d{1,3}$/.test(String(v || '').trim());
  const looksPerson = n => /^[А-ЯЁ][а-яё\-]+\s+[А-ЯЁ][а-яё\-]+(\s+[А-ЯЁ][а-яё\-]+)?$/.test(String(n || '').trim());
  const val = v => esc(String(v ?? '')).replace(/\((\d{1,3})\)/g, '<i class="lg-r">$1</i>').replace(/\n/g, '<br>');
  const tableHtmlNew = (rows, sectionTitle) => {
    const cols = Math.max(1, ...rows.map(r => r.length));
    let head = null, group = '', out = [], last = null;
    const flush = () => { if (last) { out.push(last); last = null; } };
    rows.forEach(row => {
      const cells = row.map(c => String(c == null ? '' : c).trim());
      const ne = cells.filter(Boolean);
      if (ne.length === 1 && !isNum(ne[0]) && !/\d{2}:\d{2}|\d+\s*(кг|повт|м)\b/i.test(ne[0])) { flush(); group = ne[0]; out.push({ kind: 'group', title: ne[0] }); return; }
      const hits = cells.filter(c => HEADER_TOKENS.test(c)).length;
      if (!isNum(cells[0]) && hits >= 2 && cells.length > 1) { flush(); head = cells; out.push({ kind: 'head', head: cells }); return; }
      if (isNum(cells[0]) && cells.length >= 2 && cells[1]) { flush(); last = { kind: 'row', place: cells[0], name: cells[1], cells: cells.slice(2), grp: group }; return; }
      if (last && ne.length) { ne.forEach((v, k) => { if (k < last.cells.length) last.cells[k] += '\n' + v; else last.cells.push(v); }); return; }
      if (ne.length) { flush(); out.push({ kind: 'raw', raw: cells }); }
    });
    flush();
    const isTeamGroup = g => /команд|сборн|эстафет|дфо|про\b/i.test(g);
    let html = `<div class="lg-scroll"><table class="lg-table"><tbody>`;
    out.forEach(item => {
      if (item.kind === 'group') html += `<tr class="lg-group"><td colspan="${cols}">${esc(item.title)}</td></tr>`;
      else if (item.kind === 'head') html += `<tr class="lg-head">${item.head.map((h, i) => `<th class="${i === 0 ? 'lg-c-place' : i === 1 ? 'lg-c-name' : ''}">${esc(h)}</th>`).join('')}</tr>`;
      else if (item.kind === 'raw') html += `<tr>${item.raw.map(c => `<td>${val(c)}</td>`).join('')}</tr>`;
      else {
        const n = Number(item.place); const medal = n >= 1 && n <= 3 ? `top${n}` : '';
        const team = isTeamGroup(item.grp) || !looksPerson(item.name);
        const nameBtn = team ? `<button type="button" class="res-name-btn" data-open-team="${esc(item.name)}">${esc(item.name)}</button>` : `<button type="button" class="res-name-btn" data-athlete-query="${esc(item.name)}">${esc(item.name)}</button>`;
        html += `<tr class="${medal}"><td class="lg-c-place"><span class="lg-place ${medal}">${esc(item.place)}</span></td><td class="lg-c-name">${nameBtn}</td>${item.cells.map(c => `<td>${val(c)}</td>`).join('')}</tr>`;
      }
    });
    return html + '</tbody></table></div>';
  };
  return `<section class="lg-wrap">
    <div class="res-group"><span class="res-group-tag">Первоисточник</span><h3>${esc(opts.title || 'Подробные таблицы соревнований')}</h3><span class="res-group-count">${list.length} ${ruPlural(list.length, 'раздел', 'раздела', 'разделов')}</span></div>
    ${opts.note ? `<p class="lg-p">${esc(opts.note)}</p>` : ''}
    ${list.map((s, i) => `<details class="lg-section" ${opts.openFirst && i === 0 ? 'open' : ''}><summary><b>${esc(s.title || 'Раздел')}</b><small>${(s.tables || []).filter(Array.isArray).length} ${ruPlural((s.tables || []).filter(Array.isArray).length, 'таблица', 'таблицы', 'таблиц')}</small></summary>
      <div class="lg-body">${(s.paragraphs || []).filter(p => String(p).length <= 200).slice(0, 3).map(p => `<p class="lg-p">${esc(String(p))}</p>`).join('')}${(s.tables || []).filter(Array.isArray).map(t => tableHtmlNew(t, s.title)).join('')}</div>
    </details>`).join('')}
  </section>`;
}

// «Д2 · 1/4 финала · ч.2: 09:59,84 (5)» → { day: 2, label: '1/4 финала · ч.2', value: '09:59,84 (5)' }
// название этапа может само содержать «: » («К1: Любители - Бег + …: 12:39 (3)») — делим по ПОСЛЕДНЕМУ «: », в значениях его нет
const PART_RE = /^(?:Д(\d+)\s·\s)?(.{1,80}):\s+(.+)$/;
function parsePart(raw) {
  const m = String(raw || '').match(PART_RE);
  if (!m || !/[A-Za-zА-Яа-яЁё]/.test(m[2])) return { day: 0, label: '', value: String(raw || '') };
  return { day: m[1] ? Number(m[1]) : 0, label: m[2].replace(/[\s+\-–,]+$/, '').trim(), value: m[3] };
}
// состав команды свёрнут: «Состав · 7» раскрывает участников; раскрыт сразу, если поиск по протоколу нашёл кого-то из них
function rosterHtml(members, cls) {
  if (!members || !members.length) return '';
  const q = normRu(state.eventResultQuery || '').trim();
  const hit = q.length >= 3 && members.some((m) => normRu(m).includes(q));
  const ini = (m) => String(m).split(/\s+/).slice(0, 2).map((w) => w[0] || '').join('').toUpperCase();
  const avatars = members.slice(0, 4).map((m, i) => `<span class="rt-ava c${i % 5}" aria-hidden="true">${esc(ini(m))}</span>`).join('') + (members.length > 4 ? `<span class="rt-ava more" aria-hidden="true">+${members.length - 4}</span>` : '');
  return `<details class="rt-roster" ${hit ? 'open' : ''}><summary aria-label="Состав команды: ${members.length} ${ruPlural(members.length, 'участник', 'участника', 'участников')}"><span class="rt-avas">${avatars}</span><span class="rt-roster-txt">${members.length} ${ruPlural(members.length, 'участник', 'участника', 'участников')}</span></summary>
    <div class="${cls}">${members.map((m) => `<button type="button" class="rt-member" data-athlete-query="${esc(m)}">${esc(m)}</button>`).join('')}</div></details>`;
}

// табличный вид категории (как на leaderboards.ru): участники в столбик, сверху комплексы по дням, справа итог, слева место
// итог, если в протоколе его нет (турнир на выбывание): сумма мест в самом дальнем этапе, куда дошёл участник;
// если все прошли одни и те же этапы — сумма мест за все этапы (сверено с официальными местами Кубка ДВ 2022)
const STAGE_NAME = { 1: '1/8', 2: '1/4', 3: '1/2', 4: 'финал' };
function stageLevel(label) {
  const l = String(label).toLowerCase();
  return /1\/8/.test(l) ? 1 : /1\/4|четверт/.test(l) ? 2 : /1\/2|полуфин|^пф\b/.test(l) ? 3 : /финал|фин\b/.test(l) ? 4 : 0;
}
function stageTotals(results) {
  const all = results.map((res) => splitResultText(res).parts.map(parsePart).filter((p) => p.label)
    .map((p) => ({ lvl: stageLevel(p.label), rank: Number(cellSummary(p.value).rank || (String(p.value).match(/\((\d{1,3})\)\s*$/) || [])[1] || 0) })));
  const sameStages = new Set(all.map((a) => [...new Set(a.map((x) => x.lvl))].sort().join())).size === 1;
  return all.map((a) => {
    if (!a.some((x) => x.rank)) return null;
    const top = sameStages ? -1 : Math.max(...a.map((x) => x.lvl));
    const total = a.filter((x) => top < 0 || x.lvl === top).reduce((m, x) => m + x.rank, 0);
    return total ? { main: String(total), unit: top > 0 && STAGE_NAME[top] ? `сумма мест · ${STAGE_NAME[top]}` : 'сумма мест' } : null;
  });
}
// место в комплексе из значения ячейки: «9:29 (4) / 5:42 (1) — 5 очк. (2)» → 2, «25:15 (3)» → 3, нет места → 0
function stageRankOf(v) {
  const sum = cellSummary(v);
  const r = sum.rank || (String(sum.rest).match(/\((\d{1,3})\)\s*$/) || [])[1];
  return r ? Number(r) : 0;
}
// очки участника в комплексе: у комплекса из частей — сумма мест частей (очки), иначе — место
const complexScore = (v) => { const cs = cellSummary(v); return cs.pts ? parseFloat(String(cs.pts).replace(',', '.')) : stageRankOf(v); };
// итог протокола — сумма очков за комплексы (сверяем у 80% строк); только тогда осмыслен «ход турнира»
function isSumOfPlaces(entries, partsOf) {
  let n = 0; let same = 0;
  entries.forEach((e) => {
    const tot = parseFloat(String(splitResultText(e.result).main).replace(',', '.')); const ps = partsOf(e);
    if (!Number.isFinite(tot) || !ps.length) return;
    n += 1;
    if (Math.abs(ps.reduce((a, p) => a + (complexScore(p.value) || 0), 0) - tot) < 0.01) same += 1;
  });
  return n > 0 && same >= n * 0.8;
}
// место в общем зачёте после каждого комплекса (по порядку колонок): Map(entry → [места]); кто пропустил комплекс — дальше без места
function standingsProgress(entries, cols, valuesOf, desc = false) {
  const out = new Map(entries.map((e) => [e, []]));
  const run = new Map(entries.map((e) => [e, 0]));
  cols.forEach((c) => {
    const alive = [];
    entries.forEach((e) => {
      if (run.get(e) == null) return;
      const sc = complexScore(valuesOf(e).get(c.key));
      if (!sc) { run.set(e, null); return; }
      run.set(e, run.get(e) + sc); alive.push(e);
    });
    alive.sort((a, b) => (desc ? run.get(b) - run.get(a) : run.get(a) - run.get(b)));   // очки «больше — лучше» (отбор на Кубок ДВ) — по убыванию
    alive.forEach((e, i) => { const prev = alive[i - 1]; out.get(e).push(prev && run.get(prev) === run.get(e) ? out.get(prev).at(-1) : i + 1); });
  });
  return out;
}
function progressHtml(list, finalPlace) {
  if (!list || list.length < 2) return '';
  const shown = list.length > 6 ? [list[0], '…', ...list.slice(-4)] : list;
  const delta = list[0] - list.at(-1);
  return `<div class="rt-prog" title="Место в общем зачёте после каждого комплекса"><span>${shown.map((x) => (x === '…' ? '…' : `<i>${x}</i>`)).join('<em>→</em>')}</span>${delta ? `<b class="${delta > 0 ? 'up' : 'down'}">${delta > 0 ? '▲' : '▼'}${Math.abs(delta)}</b>` : ''}</div>`;
}
// «Как считаются очки?» — правило выводится из самого протокола (сверяем итог с суммой мест), а не пишется руками
function scoringRuleText(entries, partsOf, desc = false) {
  const hasParts = entries.some((e) => /\sочк\./.test(e.result || ''));
  const partsNote = !hasParts ? '' : desc ? ' Комплекс из нескольких частей: очки за комплекс — сумма очков частей, по ним определяется место за комплекс.'
    : ' Комплекс из нескольких частей: у каждой части своё место, очки за комплекс — сумма мест в частях («5 + 5 = 10 очк.»), по ним определяется место за комплекс.';
  if (desc && isSumOfPlaces(entries, partsOf)) return `Итог — сумма очков за все комплексы: больше — лучше.${partsNote}`;
  if (entries.some((e) => e.calcTotal)) return 'В протоколе нет общего итога — сайт считает его сам: сумма мест в самом дальнем этапе, куда вышел участник (финал → 1/2 → 1/4). Если все прошли одни и те же этапы — сумма мест за все этапы. Меньше — лучше. Места в таблице — официальные, из протокола.';
  const num = (x) => parseFloat(String(x || '').replace(',', '.'));
  if (isSumOfPlaces(entries, partsOf)) return `Место в комплексе даёт столько же очков: 1-е место — 1 очко, 7-е — 7 очков.${partsNote} Итог — сумма очков за все комплексы: меньше — лучше.`;
  const tots = entries.map((e) => num(splitResultText(e.result).main)).filter(Number.isFinite);
  let up = 0; let down = 0;
  for (let i = 1; i < tots.length; i += 1) { if (tots[i] > tots[i - 1]) up += 1; else if (tots[i] < tots[i - 1]) down += 1; }
  if (up > down) return `Итог — сумма очков: меньше — лучше.${partsNote}`;
  if (down > up) return `Итог — баллы: больше — лучше. Места в комплексах показаны для сравнения.${partsNote}`;
  return partsNote.trim();
}
function resultRegionSelectHtml(rows) {
  const counts = new Map();
  rows.forEach((r) => { if (r.region) counts.set(r.region, (counts.get(r.region) || 0) + 1); });
  if (counts.size < 2) return '';
  const opts = [...counts].sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0], 'ru'));
  return `<label class="res-region"><select id="event-result-region" aria-label="Регион"><option value="all">Все регионы</option>${opts.map(([r, n]) => `<option value="${esc(r)}" ${state.eventResultRegion === r ? 'selected' : ''}>${esc(r)} · ${n}</option>`).join('')}</select></label>`;
}
// «★ Мои»: отмеченные звёздочкой и вошедший в кабинет — плашками над протоколом, нажал — перешёл к строке
function mineStripHtml(rows) {
  const teamCats = new Set([...new Set(rows.map((r) => r.category))].filter((c) => isTeamCategoryName(c) || rows.filter((r) => r.category === c).every((r) => r.team)));
  const seen = new Set(); const items = [];
  rows.forEach((r) => {
    const person = r.display_name || r.participant || '';
    const name = teamCats.has(r.category) && r.team ? r.team : person;
    const me = isMe(person);
    if (!me && !isFav(name) && !isFav(person)) return;
    const key = `${r.category}|${nameKey(name)}`;
    if (seen.has(key)) return;
    seen.add(key);
    const n = parseRank(r.rank); const tot = splitResultText(r.result);
    items.push(`<button type="button" class="rt-mine-chip${me ? ' is-me' : ''}" data-rt-jump="${esc(nameKey(name))}" data-rt-cat="${esc(r.category || '')}"><i class="rt-rk r${n < 999999 ? Math.min(n, 4) : 0}">${n < 999999 ? n : '—'}</i><span><b>${esc(name)}</b><small>${me ? 'это вы · ' : ''}${esc(r.category || '')}${tot.main ? ` · ${esc(tot.main)} ${esc(tot.unit)}` : ''}</small></span></button>`);
  });
  return items.length ? `<section class="rt-mine" aria-label="Мои в протоколе"><span class="rt-mine-title">★ Мои</span>${items.join('')}</section>` : '';
}
function renderMineStrip() {
  const box = $('#event-result-mine');
  if (box) box.innerHTML = mineStripHtml(filteredEventResults());
}
// ступень ГТО участника (турниры с табло в режиме ГТО): определяется по дате рождения на день старта, от категории не зависит
const nationalGroupHtml = (group) => {const label=nationalGroupLabel(group);return label?`<span class="gto-st" data-national-group="${esc(group.system)}">${esc(label)}</span>`:'';};
const gtoStageHtml = (st) => `<span class="gto-st" title="Ступень ГТО — по возрасту на день старта; по ней считается норматив на знак">${esc(st)} ступень ГТО</span>`;
function resultsTableHtml(rows, catName, { teamCat = false, noPodium = false, fullRows = null } = {}) {
  // части без подписи («280 баллов (108 кг / 7:14 / 100 повт.)», отбор на Кубок ДВ 2026) — колонка «Результат» / «Этап N»:
  // раньше такие части отбрасывались, и в таблице протокола не было колонки результата, которая есть в официальном PDF
  // (пояснение без чисел — «53 балла (сумма мест)» — не колонка)
  const partsOf = (r) => { const ps = splitResultText(r.result).parts.map(parsePart); if (!(ps.length && ps.every((p) => !p.label))) return ps.filter((p) => p.label);
    const vals = ps.filter((p) => /\d/.test(p.value)); return vals.map((p, i) => ({ ...p, label: vals.length === 1 ? 'Результат' : `Этап ${i + 1}` })); };
  const buildEntries = (rows) => teamCat ? (() => {
    // одноимённые команды с разными местами — разные команды (protocol_rules.teamGroups): раньше сливались в одну строку
    const best = (trs) => trs.map((x) => parseRank(x.rank)).reduce((m, v) => Math.min(m, v), 999999);
    return teamGroups(rows).map((g) => [g.name, g.rows]).sort((a, b) => best(a[1]) - best(b[1]) || a[0].localeCompare(b[0], 'ru')).map(([name, trs]) => {
      const personOf = (x) => { const n = (x.display_name || x.participant || '').trim(); return n && n !== name ? n : ''; };
      const detailed = trs.map((x) => x.result).find((x) => /\(/.test(x || '')) || (trs.find((x) => x.result) || {}).result || '';
      return { name, isTeam: true, rank: trs.map((x) => x.rank).find((x) => parseRank(x) < 999999) || '', region: trs.find((x) => x.region)?.region || '', members: [...new Set(trs.map(personOf).filter(Boolean))], result: detailed, computed: trs.some((x) => x.place_computed) };
    });
  })() : rows.map((r) => ({ name: r.display_name || r.participant || r.team, ns: r.namesake || 0, video: r.video || '', isTeam: r.participant_type === 'team' || r.participant_type === 'regional_team', rank: r.rank, region: r.region, members: [], result: r.result, computed: r.place_computed, national_group: r.national_group || null, stage: r.gto_stage || '', sub: (r.national_group || r.gto_stage) ? '' : (resultAge(r) || r.subgroup || '') }));
  const entries = buildEntries(rows);
  // колонки: по дням, внутри дня — в порядке, как они идут у участников (порядок комплексов)
  const cols = []; const seen = new Map();
  entries.forEach((e) => partsOf(e).forEach((p, i) => { const k = `${p.day}|${p.label}`; if (!seen.has(k)) { seen.set(k, cols.length); cols.push({ key: k, day: p.day, label: p.label, order: i }); } }));
  const lbOrder = new Map((state.lbMeta?.complexes || []).map((c, i) => [c.short, (c.day || 0) * 1000 + (c.order ?? i)]));
  cols.forEach((c, i) => { c.pos = i; });
  cols.sort((a, b) => (a.day - b.day) || ((lbOrder.get(a.label) ?? a.pos) - (lbOrder.get(b.label) ?? b.pos)) || (a.pos - b.pos));
  const hasDays = cols.some((c) => c.day > 0);
  const hasTotal = entries.some((e) => splitResultText(e.result).main);
  const labelHtml = (c) => { const m = c.label.match(/^(.*?)\s·\s(ч\.\d+)$/); return m ? `${esc(m[1])}<small>${esc(m[2])}</small>` : esc(c.label); };
  const dayGroups = []; cols.forEach((c) => { const g = dayGroups[dayGroups.length - 1]; if (g && g.day === c.day) g.n++; else dayGroups.push({ day: c.day, n: 1 }); });
  // значения этапа столбиком, место на этапе — отдельным значком в цвете медали (1–3);
  // комплекс из частей («224 повт. (1) / 62 повт. (5) — 6 очк. (1)»): у каждой части своё место, внизу очки и место за комплекс
  const cell = (v) => {
    if (!v) return '—';
    const sum = cellSummary(v);
    const multi = !!sum.pts;
    let rank = sum.rank; const partRanks = [];
    const raw = sum.rest.split(/\s\/\s/);
    const vals = raw.map((x, k) => {
      const m = x.match(/^(.*?)\s*\((\d{1,3})\)$/); if (m && !rank) rank = m[2]; if (m) partRanks.push(Number(m[2]));
      const t = (m ? m[1] : x).trim();
      return `<span class="rt-v${/^(н\/я|dns|dnf|—|-)$/i.test(t) ? ' is-dnf' : ''}">${multi ? `<small class="rt-pn">ч.${k + 1}</small>` : ''}<b>${esc(t)}</b>${multi && m ? `<em class="rt-pr r${Math.min(Number(m[2]), 4)}" title="Место в части ${k + 1}">${m[2]}</em>` : ''}</span>`;
    }).join('');
    // очки комплекса = сумма мест в частях — показываем, как сложились: «5 + 5 = 10 очк.»
    const sumTxt = multi ? (partRanks.length > 1 && partRanks.reduce((a, b) => a + b, 0) === Number(String(sum.pts).replace(',', '.')) ? `${partRanks.join(' + ')} = ${sum.pts} очк.` : `${sum.pts} очк.`) : '';
    return `<div class="rt-cellbox">${rank ? `<i class="rt-rk r${Math.min(Number(rank), 4)}" title="${multi ? 'Место за комплекс' : 'Место на этапе'}">${rank}</i>` : ''}<div class="rt-vals">${vals}${multi ? `<span class="rt-pts">${esc(sumTxt)}</span>` : ''}</div></div>`;
  };
  if (!hasTotal) stageTotals(entries.map((e) => e.result)).forEach((t, k) => { if (t) entries[k].calcTotal = t; });
  const showTotal = hasTotal || entries.some((e) => e.calcTotal);
  const totalOf = (e) => { const m = splitResultText(e.result); return m.main ? m : (e.calcTotal || { main: '', unit: '' }); };
  // порядок по месту в выбранном комплексе (нажали на заголовок или выбрали в списке); итоговое место в строке не меняется
  const sortCol = cols.find((c) => c.key === state.eventResultSort);
  const valuesOf = (e) => new Map(partsOf(e).map((p) => [`${p.day}|${p.label}`, p.value]));
  const rankIn = (e) => stageRankOf(valuesOf(e).get(sortCol.key)) || 999999;
  const ordered = sortCol ? [...entries].sort((a, b) => rankIn(a) - rankIn(b) || parseRank(a.rank) - parseRank(b.rank)) : entries;
  // ход турнира — по всей категории (фильтр по региону или поиск показывает часть строк, но места — среди всех)
  const fieldEntries = fullRows && fullRows.length > rows.length ? buildEntries(fullRows) : entries;
  // направление итога — по самому протоколу: очки отбора (300 > 285 > 180) — больше лучше, сумма мест — меньше лучше
  const desc = totalsDirection(fieldEntries.map((e) => ({ rank: e.rank, total: splitResultText(e.result).main }))) === 'desc';
  const progress = cols.length >= 2 && isSumOfPlaces(fieldEntries, partsOf) ? standingsProgress(fieldEntries, cols, valuesOf, desc) : null;
  const progByName = progress ? new Map(fieldEntries.map((e) => [e.name, progress.get(e)])) : null;
  const progOf = (e) => (progByName ? progressHtml(progByName.get(e.name), parseRank(e.rank) < 999999 ? parseRank(e.rank) : 0) : '');
  const mark = (e) => {
    const fav = isFav(e.name);
    return { cls: `${fav ? ' is-fav' : ''}${isMe(e.name, e.members) ? ' is-me' : ''}${state.rtHighlightKey && state.rtHighlightKey === nameKey(e.name) ? ' rt-hl' : ''}`, attrs: `data-rt-name="${esc(nameKey(e.name))}"`,
      star: `<button type="button" class="rt-fav" data-rt-fav="${esc(e.name)}" aria-pressed="${fav}" aria-label="${fav ? 'Убрать из «Моих»' : 'Добавить в «Мои»'}: ${esc(e.name)}">${fav ? '★' : '☆'}</button><button type="button" class="rt-share" data-rt-share="${esc(nameKey(e.name))}" data-rt-cat="${esc(catName || '')}" data-rt-label="${esc(e.name)}" aria-label="Поделиться результатом: ${esc(e.name)}" title="Ссылка на эту строку">↗</button>` };
  };
  // заголовок комплекса — просто название (нажатие — описание комплекса); порядок по комплексу выбирается списком «Порядок» над таблицей
  const thHtml = (c, cls = '') => `<th class="rt-c-st ${cls}${sortCol === c ? ' is-sorted' : ''}" ${sortCol === c ? 'aria-sort="ascending"' : ''}><button type="button" class="rt-th-btn" data-station="${esc(c.label)}" title="О комплексе «${esc(c.label)}»">${labelHtml(c)}</button></th>`;
  const totalTh = (rs) => `<th class="rt-c-total" ${rs}>Итог</th>`;
  const head = hasDays
    ? `<tr class="rt-days"><th class="rt-c-place" rowspan="2">Место</th><th class="rt-c-name" rowspan="2">${teamCat ? 'Команда' : 'Участник'}</th>${dayGroups.map((g) => `<th class="rt-day" colspan="${g.n}">${g.day ? `День ${g.day}` : ''}</th>`).join('')}${showTotal ? totalTh('rowspan="2"') : ''}</tr>
       <tr>${cols.map((c, i) => thHtml(c, c.day !== cols[i - 1]?.day ? 'rt-day-start' : '')).join('')}</tr>`
    : `<tr><th class="rt-c-place">Место</th><th class="rt-c-name">${teamCat ? 'Команда' : 'Участник'}</th>${cols.map((c) => thHtml(c)).join('')}${showTotal ? totalTh('') : ''}</tr>`;
  // длинные протоколы (онлайн-этапы — тысячи строк; таблица и карточки — это двойной DOM): первые RT_LIMIT строк,
  // остальное — кнопкой «Показать всех»; «мои» и отмеченные звёздочкой строки видны всегда
  const rtKey = `${state.currentEventId}|${catName || ''}`;
  const visible = state.rtExpanded?.has(rtKey) ? ordered : ordered.filter((e, i) => i < (state.rtLimit || RT_LIMIT) || /is-(me|fav)|rt-hl/.test(mark(e).cls));
  const hiddenN = ordered.length - visible.length;
  const moreBtn = hiddenN > 0 ? `<button type="button" class="load-more-results rt-more" data-rt-more="${esc(rtKey)}">Показать всех: ещё ${hiddenN} ↓</button>` : '';
  const body = visible.map((e) => {
    const n = parseRank(e.rank); const medal = n >= 1 && n <= 3 ? `top${n}` : ''; const mk = mark(e);
    const pv = new Map(partsOf(e).map((p) => [`${p.day}|${p.label}`, p.value]));
    const main = totalOf(e);
    const nameBtn = e.isTeam ? `<button type="button" class="res-name-btn" data-open-team="${esc(e.name)}">${esc(e.name)}</button>` : `<button type="button" class="res-name-btn" data-athlete-query="${esc(e.name)}">${esc(e.name)}</button>${nsTagHtml(e.ns)}`;
    const sub = [e.national_group ? nationalGroupHtml(e.national_group) : e.stage ? gtoStageHtml(e.stage) : '', e.region ? regionLinkHtml(e.region) : '', e.sub ? esc(e.sub) : ''].filter(Boolean).join(' · ');
    const members = rosterHtml(e.members, 'rt-members');
    return `<tr class="${medal}${mk.cls}" ${mk.attrs}>
      <td class="rt-c-place">${lgPlaceHtml(e.rank, medal)}${e.computed ? '<span class="res-calc" title="Место рассчитано по результатам">расч.</span>' : ''}</td>
      <td class="rt-c-name"><div class="rt-name-row">${nameBtn}${e.isTeam ? '' : resultVideoHtml(e, e.name)}${mk.star}</div>${sub ? `<small>${sub}</small>` : ''}${progOf(e)}${members}</td>
      ${cols.map((c, i) => `<td class="rt-c-st ${pv.get(c.key) ? '' : 'rt-empty'} ${hasDays && c.day !== cols[i - 1]?.day ? 'rt-day-start' : ''}${sortCol === c ? ' rt-sorted' : ''}">${cell(pv.get(c.key))}</td>`).join('')}
      ${showTotal ? `<td class="rt-c-total ${e.calcTotal ? 'is-calc' : ''}"><b>${esc(main.main || '—')}</b>${main.unit ? `<small>${esc(main.unit)}</small>` : ''}</td>` : ''}
    </tr>`;
  }).join('');
  // телефон: вместо широкой таблицы — карточки (место, имя, итог, состав строкой, этапы по дням сеткой)
  // свёрнутые этапы: вместо «Этапы · 10» — полоска мест по этапам (видно, как шёл турнир), день отделён зазором
  const stripHtml = (filled, pv) => `<span class="rtm-strip">${filled.map((c, i) => {
    const r = stageRankOf(pv.get(c.key)) || '';
    return `<i class="rt-rk r${r ? Math.min(Number(r), 4) : 0}${hasDays && i && c.day !== filled[i - 1].day ? ' gap' : ''}" title="${esc(c.label)}">${r || '·'}</i>`; }).join('')}</span><span class="rtm-strip-n">${filled.length}${filled.length < cols.length ? ` из ${cols.length}` : ''}</span>`;
  // сворачиваем одинаково для всей категории (по числу этапов в протоколе), а не по карточке:
  // иначе у финалистов свёрнуто, а у выбывших раньше — развёрнуто
  const collapseStages = cols.length > 4;
  const cards = visible.map((e) => {
    const n = parseRank(e.rank); const medal = n >= 1 && n <= 3 ? `top${n}` : ''; const mk = mark(e);
    const pv = new Map(partsOf(e).map((p) => [`${p.day}|${p.label}`, p.value]));
    const main = totalOf(e);
    const nameBtn = e.isTeam ? `<button type="button" class="res-name-btn" data-open-team="${esc(e.name)}">${esc(e.name)}</button>` : `<button type="button" class="res-name-btn" data-athlete-query="${esc(e.name)}">${esc(e.name)}</button>${nsTagHtml(e.ns)}`;
    const sub = [e.national_group ? nationalGroupHtml(e.national_group) : e.stage ? gtoStageHtml(e.stage) : '', e.region ? regionLinkHtml(e.region) : '', e.sub ? esc(e.sub) : ''].filter(Boolean).join(' · ');
    const members = rosterHtml(e.members, 'rtm-members');
    const filled = cols.filter((c) => pv.get(c.key));
    // одна сплошная сетка: день — меткой внутри плитки, чтобы строки не оставались полупустыми
    const stages = filled.length ? `<dl class="rtm-grid">${filled.map((c) => `<div class="rtm-st ${String(pv.get(c.key)).split(/\s\/\s/).length > 2 ? 'wide' : ''}"><dt>${hasDays && c.day ? `<span class="rtm-d d${c.day % 6}">Д${c.day}</span>` : ''}${labelHtml(c)}</dt><dd>${cell(pv.get(c.key))}</dd></div>`).join('')}</dl>` : '';
    const sortedLine = sortCol && pv.get(sortCol.key) ? `<div class="rtm-sorted"><span>${labelHtml(sortCol)}</span>${cell(pv.get(sortCol.key))}</div>` : '';
    return `<li class="rtm-card ${medal}${mk.cls}" ${mk.attrs}>
      <div class="rtm-head">${lgPlaceHtml(e.rank, medal)}
        <div class="rtm-who"><div class="rt-name-row">${nameBtn}${e.isTeam ? '' : resultVideoHtml(e, e.name)}${mk.star}</div>${sub ? `<small>${sub}</small>` : ''}${progOf(e)}${e.computed ? '<span class="res-calc" title="Место рассчитано по результатам">расч.</span>' : ''}</div>
        ${main.main ? `<div class="rtm-total ${e.calcTotal ? 'is-calc' : ''}"><b>${esc(main.main)}</b>${main.unit ? `<small>${esc(main.unit)}</small>` : ''}</div>` : ''}</div>
      ${members}${sortedLine}
      ${stages ? (collapseStages ? `<details class="rtm-more"><summary aria-label="Этапы: ${filled.length}. Показать результаты">${stripHtml(filled, pv)}</summary>${stages}</details>` : `<div class="rtm-stages">${stages}</div>`) : ''}
    </li>`;
  }).join('');
  const podium = entries.filter((e) => [1, 2, 3].includes(parseRank(e.rank))).sort((x, y) => parseRank(x.rank) - parseRank(y.rank)).slice(0, 3);
  const podiumHtml = !noPodium && podium.length === 3 ? `<div class="rt-podium" aria-label="Призёры">${[podium[1], podium[0], podium[2]].map((e) => { const n = parseRank(e.rank); const mm = totalOf(e); return `<div class="rt-pod p${n}">
      <span class="rt-pod-rank">${n}</span><b>${esc(e.name)}</b><small>${esc(e.region || e.sub || '')}</small>${mm.main ? `<span class="rt-pod-pts">${esc(mm.main)}<i>${esc(mm.unit || '')}</i></span>` : ''}</div>`; }).join('')}</div>` : '';
  const hasParts = entries.some((e) => /\sочк\./.test(e.result || ''));
  const legend = hasParts ? `<p class="rt-legend"><i class="rt-rk r0">4</i> место за комплекс · <small class="rt-pn">ч.1</small> <em class="rt-pr">5</em> место в части комплекса · ${desc ? 'очки комплекса = сумма очков частей (больше — лучше)' : 'очки комплекса = сумма мест в частях (меньше — лучше)'}</p>` : '';
  const rule = scoringRuleText(entries, partsOf, desc);
  const sortSel = cols.length > 1 ? `<label class="rt-sort"><span>Порядок</span><select data-rt-sort-select aria-label="Порядок участников"><option value="">по итоговому месту</option>${cols.map((c) => `<option value="${esc(c.key)}" ${sortCol === c ? 'selected' : ''}>по месту: ${hasDays && c.day ? `Д${c.day} · ` : ''}${esc(c.label)}</option>`).join('')}</select></label>` : '';
  const how = rule ? `<details class="rt-how"><summary>Как считаются очки?</summary><p>${esc(rule)}</p></details>` : '';
  const tools = sortSel || how ? `<div class="rt-tools">${sortSel}${how}</div>` : '';
  const sortedNote = sortCol ? `<p class="rt-sorted-note">Порядок — по месту в комплексе «${esc(sortCol.label)}», слева — итоговое место. <button type="button" data-rt-sort="">Вернуть итоговый порядок</button></p>` : '';
  // до старта (в табло только заявки: ни мест, ни результатов) — компактный список заявленных
  const roster = entries.length > 0 && entries.every((e) => !(parseRank(e.rank) < 999999) && !totalOf(e).main && !partsOf(e).length);
  return `<div class="rt-block${roster ? ' is-roster' : ''}" data-rt-cat="${esc(catName || '')}">${podiumHtml}${tools}${legend}${sortedNote}<div class="rt-scroll"><table class="rt-table rt-lb ${cols.length <= 3 ? 'rt-few ' : ''}${cols.length > 8 ? 'rt-dense' : ''}"><thead>${head}</thead><tbody>${body}</tbody></table></div><ol class="rtm" aria-label="${esc(catName || 'Результаты')}">${cards}</ol>${moreBtn}</div>`;
}
const RT_LIMIT = 60;
bindReportButtons();

function resultsViewMode() { return 'table'; }   // единый вид результатов — таблица (карточки и прочие варианты убраны)

// компактный результат для профиля, «Моего результата» и страницы команды: итог крупно, туры/станции — плашками по дням
function resultCompactHtml(result, { label = 'Результат' } = {}) {
  const raw = String(result || '').trim(); if (!raw) return '';
  const r = splitResultText(raw); const parts = r.parts.map(parsePart);
  if (!r.parts.length) return `<div class="rc"><div class="rc-head"><span class="rc-label">${esc(label)}</span><b class="rc-main">${esc(raw)}</b></div></div>`;
  const byDay = new Map();
  parts.forEach((p, i) => { const k = p.day || 0; if (!byDay.has(k)) byDay.set(k, []); byDay.get(k).push({ ...p, i }); });
  const chip = (p) => { const bits = String(p.value).split(/\s\/\s/).map((x) => { const m = x.match(/^(.*?)\s*\((\d{1,3})\)$/); return `<b>${esc(m ? m[1] : x)}</b>${m ? `<i class="lg-r">${m[2]}</i>` : ''}`; }).join('<span class="rc-sep">/</span>'); return `<span class="rc-chip"><small>${esc(p.label || `Этап ${p.i + 1}`)}</small><span>${bits}</span></span>`; };
  const days = [...byDay.keys()].sort((a, b) => a - b);
  return `<div class="rc">
    ${r.main ? `<div class="rc-head"><span class="rc-label">${esc(label)}</span><b class="rc-main">${esc(r.main)}</b>${r.unit ? `<small class="rc-unit">${esc(r.unit)}</small>` : ''}</div>` : ''}
    ${days.map((d) => `${d ? `<div class="rc-day">День ${d}</div>` : ''}<div class="rc-grid">${byDay.get(d).map(chip).join('')}</div>`).join('')}
  </div>`;
}
// этапы результата сеткой на всю ширину: метка дня, полное название, значения и место на этапе («н/я» — приглушённо)
function resultStagesHtml(result) {
  const raw = String(result || '').trim(); if (!raw) return '';
  const r = splitResultText(raw);
  const head = r.main ? `<div class="tl-total"><span>Итог</span><b>${esc(r.main)}</b>${r.unit ? `<small>${esc(r.unit)}</small>` : ''}</div>` : '';
  if (!r.parts.length) return `<div class="tl-result">${head || `<div class="tl-total"><span>Результат</span><b>${esc(raw)}</b></div>`}</div>`;
  const parts = r.parts.map(parsePart);
  const multiDay = new Set(parts.map(p => p.day).filter(Boolean)).size > 1;
  const cell = (p, i) => {
    let value = String(p.value), sub = '';
    const inner = value.match(/^([^:]{3,60}?):\s+(.+)$/);   // «Часть А и Б (Синхронная): н/я» — подпись части уходит к названию
    if (inner && /[А-Яа-яЁё]/.test(inner[1]) && !/^\d/.test(inner[1])) { sub = inner[1]; value = inner[2]; }
    // комплекс из частей: «115 кг (2) / 34 повт. (5) — 75 очк. (3)» — места частей у значений, очки и место за комплекс строкой ниже
    const sum = cellSummary(value); value = sum.rest;
    const vals = value.split(/\s\/\s/).map(x => {
      const m = x.match(/^(.*?)\s*\((\d{1,3})\)$/); const v = (m ? m[1] : x).trim();
      const dnf = /^(н\/я|dns|dnf|-|—)$/i.test(v);
      return `<span class="tl-val ${dnf ? 'is-dnf' : ''}">${dnf ? 'не явились' : esc(v)}${m ? `<i class="tl-rank r${Math.min(Number(m[2]), 4)}">${m[2]}</i>` : ''}</span>`;
    }).join('');
    const label = [(p.label || `Этап ${i + 1}`).replace(/:\s*$/, ''), sub].filter(Boolean).join(' · ');
    const pts = sum.pts ? `<span class="tl-pts">${esc(sum.pts)} очк.${sum.rank ? ` · место <i class="tl-rank r${Math.min(Number(sum.rank), 4)}">${esc(sum.rank)}</i>` : ''}</span>` : '';
    return `<div class="tl-stage d${(p.day || 0) % 6}">${multiDay && p.day ? `<span class="tl-day">Д${p.day}</span>` : ''}<span class="tl-stage-name" title="${esc(label)}">${esc(label)}</span><div class="tl-vals">${vals}</div>${pts}</div>`;
  };
  return `<div class="tl-result">${head}<div class="tl-stages">${parts.map(cell).join('')}</div></div>`;
}

// кабинет «Герой ГТО» (отдельный модуль) берёт те же компоненты карточек, что публичный профиль
if (typeof window !== 'undefined') window.__fmgtoUi = { resultStagesHtml: (r) => resultStagesHtml(r), parseRank: (r) => parseRank(r) };

const resultMainText = (result) => { const r = splitResultText(result); return r.parts.length ? [r.main, r.unit].filter(Boolean).join(' ') : String(result || ''); };

function resultsHeroMetaFor(d, base, protocol, past) {
  const rows = (protocol?.results || []).filter(x => !isRecordRunRow(x));
  const cats = new Set(rows.map(x => x.category).filter(Boolean));
  const teamsN = teamsCount(rows);   // одноимённые команды одной категории (сборная и вузы одного региона) — каждая своя
  const live = liveOf(d, base); const lbId = live.id;
  const board = live.own ? 'табло турнира' : 'табло leaderboards.ru';   // у своего движка — без бренда
  const stats = rows.length ? [{ v: rows.length, l: ruPlural(rows.length, 'строка', 'строки', 'строк') }, { v: cats.size, l: ruPlural(cats.size, 'категория', 'категории', 'категорий') }]
    .concat(teamsN ? [{ v: teamsN, l: ruPlural(teamsN, 'команда', 'команды', 'команд') }] : []) : [];
  const pill = rows.length ? `<span class="lb-pill done">Официальный протокол</span>${lbId ? `<span class="lb-updated">места и станции сверены с ${board}</span>` : ''}` : (lbId ? '<span class="lb-pill soon">Загружаем табло…</span>' : (past ? '<span class="lb-pill done">Завершён</span>' : (isOngoing(base || d) ? '<span class="lb-pill live">Идёт сейчас</span>' : '<span class="lb-pill soon">Предстоит</span>')));
  const actions = rows.length ? `<button type="button" class="res-hero-btn" data-results-export="csv"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-file-text"/></svg>CSV</button>
      <a class="res-hero-btn results-pdf-link" href="/protocol/${encodeURIComponent(state.currentEventId)}.pdf" target="_blank" rel="noopener"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-file-text"/></svg>PDF</a>
      <button type="button" class="res-hero-btn" data-report-error data-event-id="${esc(String(state.currentEventId || ''))}" data-context="Протокол: ${esc(d?.title || base?.title || '')}">Сообщить об ошибке</button>` : '';
  // табло ещё грузится: заглушки статуса и цифр той же высоты — иначе шапка дорастала и сдвигала протокол (CLS 0,11)
  const lbPending = !rows.length && lbId;
  // та же разметка, что присылает табло: статус + «обновлено» + кнопка; четыре цифры, последняя подпись в две строки
  const pillOut = lbPending ? '<span class="lb-pill lb-sk" aria-hidden="true">загрузка табло</span><span class="lb-updated lb-sk" aria-hidden="true">обновлено 00:00:00</span><span class="lb-refresh lb-sk" aria-hidden="true"></span>' : pill;
  const statsOut = lbPending ? ['участники', 'категории', 'станции', 'ступени по возрасту'].map((l) => ({ v: '00', l, cls: 'lb-sk' })) : stats;
  return { cover: d?.cover || base?.localPoster || base?.img || '', pill: pillOut, kicker: lbId ? (rows.length ? `Протокол · ${board}` : (live.own ? 'Живое табло' : 'Живое табло · leaderboards.ru')) : 'Официальный протокол',
    title: d?.title || base?.title || '', meta: [d?.location || base?.location || base?.city || '', d?.period || base?.period || ''].filter(Boolean).join(' · '), stats: statsOut, actions };
}

// служебные категории протокола (отбор, участники без итогового места) — в конце списка
const isAuxCategory = (name) => /отборочн|без итогов/i.test(String(name || ''));

// «Участники» турнира на движке по программам (09.10.2026, владелец: «три вкладки — Иду на рекорд / Гран-при / Гонка ГТО,
// и в ней уже подвкладки возраста»): программа — по названию категории; только у живого протокола и если программ ≥ 2
const RESULT_PROGRAMS = [['records', 'Знак ГТО / Рекорд дня'], ['ko', 'Заруба ГТО (Гран-при на вылет)'], ['race', 'Гонка ГТО']];   // подпись — владелец, 09.10.2026
const resultProgramOf = (cat) => (/рекорд|знак\s+гто/i.test(cat || '') ? 'records' : /заруба|гран-?при/i.test(cat || '') ? 'ko' : 'race');
function resultPrograms(protocol, categories) {
  if (!protocol?.live) return null;
  const have = new Set(categories.map(resultProgramOf));
  return have.size >= 2 ? RESULT_PROGRAMS.filter(([k]) => have.has(k)) : null;
}
// выбранная программа: категория из ссылки (?cat=) задаёт её сама; иначе выбор человека или программа с большим числом строк
function currentResultProgram(programs, rowsAll) {
  if (!programs) return '';
  if (state.eventResultCategory !== 'all') return resultProgramOf(state.eventResultCategory);
  if (programs.some(([k]) => k === state.eventResultProgram)) return state.eventResultProgram;
  const n = (k) => rowsAll.filter((r) => resultProgramOf(r.category) === k).length;
  return programs.reduce((best, [k]) => (n(k) > n(best) ? k : best), programs[0][0]);
}
// живой протокол — в порядке движка (там категории заведены по возрасту: «Дети 6–9» … «Ветераны 45+»), остальные — по алфавиту
const resultCategories = (rowsAll, live = false) => [...new Set(rowsAll.map(x => x.category).filter(Boolean))].sort((a, b) => isAuxCategory(a) - isAuxCategory(b) || (live ? 0 : a.localeCompare(b, 'ru')));
function refreshResultCats() {
  const box = document.querySelector('#event-detail [data-res-cats-box]'); const protocol = state.currentEventResults;
  if (!box || !protocol) return;
  const rowsAll = protocol.results.filter(x => !isRecordRunRow(x));
  box.innerHTML = resultCatsHtml(protocol, rowsAll, resultCategories(rowsAll, protocol.live));
}
function resultCatsHtml(protocol, rowsAll, categories) {
  const chip = (v, l, n) => `<button type="button" class="res-cat-chip ${state.eventResultCategory === v ? 'active' : ''}" data-result-cat="${esc(v)}" aria-pressed="${state.eventResultCategory === v}">${esc(l)}${n != null ? `<small>${n}</small>` : ''}</button>`;
  const count = (c) => rowsAll.filter((r) => r.category === c).length;
  const programs = resultPrograms(protocol, categories);
  if (!programs) return `<div class="res-cats" role="group" aria-label="Категории">${chip('all', 'Все')}${categories.map((c) => chip(c, c, count(c))).join('')}</div>`;
  const prog = currentResultProgram(programs, rowsAll);
  const cats = categories.filter((c) => resultProgramOf(c) === prog);
  return `<div class="res-programs" data-res-programs>
    <div class="lb-seg res-seg res-prog-tabs" role="tablist" aria-label="Программы турнира">${programs.map(([k, l]) => `<button type="button" role="tab" class="lb-seg-btn ${k === prog ? 'active' : ''}" aria-selected="${k === prog}" data-result-program="${k}">${esc(l)}<small>${rowsAll.filter((r) => resultProgramOf(r.category) === k).length}</small></button>`).join('')}</div>
    ${cats.length > 1 ? `<div class="res-cats" role="group" aria-label="Возрастные категории">${chip('all', 'Все')}${cats.map((c) => chip(c, c, count(c))).join('')}</div>` : ''}
  </div>`;
}

function tournamentResultsShell(protocol, opts = {}) {
  const rowsAll = protocol.results.filter(x => !isRecordRunRow(x));
  const categories = resultCategories(rowsAll, protocol.live);
  const ages = [...new Set(rowsAll.map(resultAge).filter(Boolean))].sort((a, b) => a.localeCompare(b, 'ru', { numeric: true }));
  const complexes = [...new Set(rowsAll.flatMap(resultComplexes).filter(Boolean))].sort((a, b) => a.localeCompare(b, 'ru', { numeric: true }));
  const groupBy = state.eventResultGroupBy || 'category';
  const isTeamView = ['team', 'regional'].includes(state.eventResultStanding) || isTeamCategoryName(state.eventResultCategory);
  const teamsN = teamsCount(rowsAll);   // одноимённые команды одной категории — каждая своя
  const seg = (attr, items, cur) => `<div class="lb-seg res-seg" role="group">${items.map(([v, label]) => `<button type="button" class="lb-seg-btn ${cur === v ? 'active' : ''}" ${attr}="${v}">${label}</button>`).join('')}</div>`;
  return `<div class="tournament-results res-wrap">
    ${opts.noHead ? '' : `<div class="res-head">
      <div class="res-head-copy">
        <span class="lb-kicker">Официальный протокол</span>
        <b>${rowsAll.length.toLocaleString('ru-RU')} ${ruPlural(rowsAll.length, 'строка', 'строки', 'строк')} · ${categories.length} ${ruPlural(categories.length, 'категория', 'категории', 'категорий')}${teamsN ? ` · ${teamsN} ${ruPlural(teamsN, 'команда', 'команды', 'команд')}` : ''}</b>
      </div>
      <div class="res-export">
        <button type="button" data-results-export="csv" aria-label="Скачать результаты в CSV"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-file-text"/></svg>CSV</button>
        <button type="button" data-results-share aria-label="Поделиться ссылкой на протокол с выбранной категорией и регионом"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-link"/></svg>Ссылка</button>
        <a class="results-pdf-link" href="/protocol/${encodeURIComponent(state.currentEventId)}.pdf" target="_blank" rel="noopener" aria-label="Протокол в PDF"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-file-text"/></svg>PDF</a>
      </div>
    </div>`}
    <div data-res-cats-box>${resultCatsHtml(protocol, rowsAll, categories)}</div>
    <div class="res-find">
      <label class="lb-search res-search"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-search"/></svg><input id="event-result-search" type="search" value="${esc(state.eventResultQuery)}" placeholder="Фамилия, команда или регион" aria-label="Поиск по протоколу"></label>
      ${resultRegionSelectHtml(rowsAll)}
    </div>
    <div id="event-result-summary" class="result-line res-line"></div>
    <div id="event-result-mine"></div>
    <div id="event-online-lb"></div>
    <div id="event-badge-live" class="event-badge-live" hidden></div>
    <div id="event-ko-live" class="event-ko-live" hidden></div>
    <div id="event-race-live" class="event-race-live" hidden></div>
    <div id="event-result-list" class="event-result-list res-list"></div>
  </div>`;
}

// «Иду на рекорд»: отдельная вкладка турнира — попытки по дисциплинам, лучший результат турнира, места по результату
const REC_LIMIT = 30; const recMoreStore = new Map(); let recMoreSeq = 0; let recProtocol = null;
// «% ГТО»: результат относительно золотого знака своей ступени (считается при публикации: scripts/db/gto_norms.py)
function normChipHtml(n) {
  if (!n || !n.pct) return '';
  const tip = `${n.pct}% от золотого знака ГТО · ${n.stage} ступень${n.approx ? ' · ориентир: в ГТО это упражнение выполняется в других условиях' : ''}`;
  return `<small class="norm-chip ${n.pct >= 100 ? 'is-gold' : ''}${n.approx ? ' is-approx' : ''}" title="${esc(tip)}" aria-label="${esc(tip)}">${n.pct}% ГТО${n.approx ? '*' : ''}</small>`;
}
// порядок групп протокола: сначала женские (девочки → девушки → женщины), потом мужские (мальчики → юноши → мужчины), внутри — по возрасту; без пола — в конце
const SUBGROUP_SEX = ['девочки', 'девушки', 'женщины', 'мальчики', 'юноши', 'мужчины'];
function subgroupOrder(a, b) {
  const key = (sg) => { const w = String(sg).trim().split(/\s+/)[0].toLowerCase(); const i = SUBGROUP_SEX.indexOf(w); const n = String(sg).match(/\d+/); return [i < 0 ? SUBGROUP_SEX.length : i, n ? Number(n[0]) : 0]; };
  const [sa, na] = key(a), [sb, nb] = key(b);
  return sa - sb || na - nb || String(a).localeCompare(String(b), 'ru');
}
function tournamentRecordsHtml(protocol, { past = true } = {}) {
  recProtocol = protocol;
  // книга рекордов ведётся раздельно у мужчин и женщин: группа без пола, где есть и те и другие, подписывается полом
  const rows = splitSubgroupsBySex((protocol?.results || []).map(normalizeProtocolRow).filter(r => r && isRecordRunRow(r)), { isRecord: () => true });
  // турнир ещё не завершён — попытки идут, результаты появятся после проверки; «не проводился» — только про прошедший турнир
  if (!rows.length && !past) return `<div class="lb-empty rec-empty"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-award"/></svg><b>«Иду на рекорд» проводится на этом турнире</b><span>Одно испытание, три попытки, лучший результат идёт в реестр рекордов ФМГТО. Результаты появятся здесь после проверки судьями.</span><button type="button" class="secondary-action" data-go="records" style="margin-top:12px">Действующие рекорды и заявка на рекорд →</button></div>`;
  if (!rows.length) return `<div class="lb-empty rec-empty"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-award"/></svg><b>«Иду на рекорд» на этом турнире не проводился</b><span>Программа рекордных попыток: одно испытание, три попытки, лучший результат идёт в реестр рекордов ФМГТО</span></div>`;
  const groups = new Map();
  const discOf = (r) => String(r.category).replace(RECORD_RUN_RE, '').replace(/^\s*\[|\]\s*$/g, '').trim() || 'Дисциплина';
  rows.forEach(r => { const d = discOf(r); if (!groups.has(d)) groups.set(d, []); groups.get(d).push(r); });
  // попытка без результата («NULL», пусто, «00» судей) — заявка-неявка: без места, не «лучший результат турнира», в конце списка
  const scored = (r) => hasResult(r, discOf(r));
  const done = rows.filter(scored);
  const noRes = rows.length - done.length;
  const uniq = new Set(done.map(r => r.display_name || r.participant)).size;
  let html = `<div class="rec-wrap">
    <section class="rec-hero"><div class="rec-hero-shade"></div><div class="lb-hero-body">
      <span class="lb-kicker">Программа рекордных попыток</span>
      <h2 class="lb-title">Иду на рекорд</h2>
      <div class="lb-meta">${groups.size} ${ruPlural(groups.size, 'дисциплина', 'дисциплины', 'дисциплин')} · ${done.length} ${ruPlural(done.length, 'попытка', 'попытки', 'попыток')} · ${uniq} ${ruPlural(uniq, 'атлет', 'атлета', 'атлетов')}${noRes ? ` · ${noRes} ${ruPlural(noRes, 'заявка', 'заявки', 'заявок')} без результата` : ''}</div>
    </div></section>`;
  const byNorm = state.recSort === 'norm';
  const anyNorm = rows.some((r) => r.norm);
  // сверху — все дисциплины кнопками; выбрана одна — рекорды по группам (пол и возраст) и попытки выбранной группы
  // (10.10.2026, владелец: «нужно, чтобы сверху было видно все рекорды, какие есть, — а то я всех вниз листаю»)
  const discs = [...groups.entries()].sort((a, b) => b[1].length - a[1].length);
  const pick = discs.some(([dn]) => dn === state.recDisc) ? state.recDisc : '';
  if (discs.length > 1) html += `<nav class="rec-nav" aria-label="Дисциплины «Иду на рекорд»"><button type="button" data-rec-disc="" aria-pressed="${!pick}">Все дисциплины<small>${rows.length}</small></button>${discs.map(([dn, l]) => `<button type="button" data-rec-disc="${esc(dn)}" aria-pressed="${pick === dn}">${esc(dn)}<small>${l.length}</small></button>`).join('')}</nav>`;
  if (anyNorm) html += `<div class="rec-sort" role="group" aria-label="Порядок попыток"><span>Порядок:</span>
      <button type="button" data-rec-sort="result" aria-pressed="${!byNorm}">по результату</button>
      <button type="button" data-rec-sort="norm" aria-pressed="${byNorm}" title="Процент от золотого знака ГТО своей ступени — честное сравнение разных возрастов">по % от норматива ГТО</button></div>`;
  const subOf = (r) => String(r.subgroup || resultAge(r) || '').trim();
  let noPlaces = false;
  (pick ? discs.filter(([dn]) => dn === pick) : discs).forEach(([disc, list0]) => {
    // порядок по результату — с направлением дисциплины: бег — меньше лучше, вис и повторы — больше (раньше всё по убыванию:
    // в беге 30 м «лучшим» был 9,29 вместо 3,85); по % норматива — как раньше, но без результата — в конце
    const all = byNorm ? [...list0].sort((a, b) => (scored(b) - scored(a)) || ((b.norm?.pct ?? -1) - (a.norm?.pct ?? -1))) : sortRecordAttempts(list0, disc);
    // места — только если они есть в источнике (по группам); иначе попытки разных возрастов не получают мест и медалей
    const official = hasOfficialPlaces(all);
    const doneN = all.filter(scored).length;
    let list = all;
    if (pick) {   // рекорды выбранной дисциплины по группам: лучший в каждой группе — строкой таблицы, нажатие — попытки группы
      // группы — только по засчитанным попыткам (без результата — неявка, своей строки в таблице рекордов не даёт)
      const subs = [...new Set(all.filter(scored).map(subOf))].filter(Boolean).sort(subgroupOrder);
      const sub = subs.includes(state.recSub) ? state.recSub : '';
      if (subs.length > 1) {
        html += `<section class="rec-table-wrap" aria-label="Рекорды по группам"><h3 class="rec-table-title">Рекорды по группам · ${esc(disc)}</h3><div class="rec-table" role="list">
          <button type="button" class="rec-trow${sub ? '' : ' is-on'}" data-rec-sub="" aria-pressed="${!sub}"><span>Все группы</span><b>${doneN} ${ruPlural(doneN, 'попытка', 'попытки', 'попыток')}</b><i></i></button>${subs.map((sg) => {
          const best = all.find((r) => subOf(r) === sg && scored(r));
          return `<button type="button" class="rec-trow${sub === sg ? ' is-on' : ''}" data-rec-sub="${esc(sg)}" aria-pressed="${sub === sg}"><span>${esc(sg)}</span><b>${esc(best.display_name || best.participant || '—')}</b><i>${esc(best.result || '—')}</i></button>`;
        }).join('')}</div></section>`;
        if (sub) list = all.filter((r) => subOf(r) === sub);
      }
    }
    const best = list.find(scored);
    const listDone = list.filter(scored).length; const listNo = list.length - listDone;
    html += `<section class="rec-group">
      <header class="rec-group-head"><div><span class="lb-kicker">${esc(disc)}</span><b>${listDone} ${ruPlural(listDone, 'попытка', 'попытки', 'попыток')}${listNo ? ` · ${listNo} без результата` : ''}</b></div></header>
      ${best ? `<div class="rec-best"><div class="rec-best-val"><b>${esc(byNorm && best.norm ? `${best.norm.pct}%` : best.result || '—')}</b><small>${byNorm && best.norm ? `от норматива ГТО · результат ${esc(best.result || '—')}` : 'лучший результат турнира'}</small></div>
        <div class="rec-best-who"><button type="button" class="res-name-btn" data-athlete-query="${esc(best.display_name || best.participant)}">${esc(best.display_name || best.participant)}</button><span>${[best.region, resultAge(best) || best.subgroup].filter(Boolean).map(esc).join(' · ')}</span></div></div>` : ''}
      <div class="lb-list rec-list">${(() => {
        const rowHtml = (r, i) => { const name = r.display_name || r.participant || '—'; const ok = scored(r);
          const n = official ? parseRank(r.rank) : 0; const top = n >= 1 && n <= 3 ? `top top${n}` : '';
          return `<article class="lb-row res-row ${top}${ok ? '' : ' is-noresult'}" style="--i:${Math.min(i, 14)}">${rankBadgeHtml(official && ok ? r.rank : '')}
          <div class="lb-body"><div class="lb-name"><button type="button" class="res-name-btn" data-athlete-query="${esc(name)}">${esc(name)}</button>${nsTagHtml(r.namesake)}${/^рекорд/i.test(String(r.rank || '')) ? '<span class="lb-stage" title="Отмечено в протоколе как рекорд">Рекорд</span>' : ''}${resultVideoHtml(r, name)}</div>
          <div class="lb-sub">${[r.region, resultAge(r) || r.subgroup].filter(Boolean).map(esc).join(' · ')}</div></div>
          <div class="lb-total"><b>${esc(ok ? r.result : '—')}</b>${ok ? (normChipHtml(r.norm) || '<small>результат</small>') : '<small>нет результата</small>'}</div></article>`; };
        // онлайн-этапы — сотни попыток на дисциплину: сначала REC_LIMIT, остальные вставляются по кнопке (не держим тысячи строк в DOM)
        if (list.length <= REC_LIMIT) return list.map(rowHtml).join('');
        const id = `rec${++recMoreSeq}`; const rest = list.slice(REC_LIMIT);
        recMoreStore.set(id, () => rest.map((r, k) => rowHtml(r, REC_LIMIT + k)).join(''));
        return list.slice(0, REC_LIMIT).map(rowHtml).join('') + `<button type="button" class="load-more-results" data-rec-more="${id}">Показать всех: ещё ${rest.length} ↓</button>`;
      })()}</div>
    </section>`;
    if (!official) noPlaces = true;
  });
  if (noPlaces) html += '<p class="rec-note">Мест в протоколе нет: попытки идут по результату, рекорды — по группам (пол и возраст).</p>';
  if (anyNorm) html += '<p class="rec-note">% ГТО — результат относительно золотого знака ГТО своей ступени (по возрасту на старте и полу). * — ориентир: в ГТО это упражнение выполняется без ограничения по времени или с другим весом.</p>';
  return html + '</div>';
}

function resultText(row) {
  return `${row.category || ''} ${row.subgroup || ''} ${row.pageTitle || ''} ${Object.entries(row.details || {}).map(([k, v]) => `${k} ${v}`).join(' ')}`.toLowerCase();
}

// пол строки: поле gender выгрузки, иначе название категории/группы; «Юниоры» — общая категория, не «мужская» (protocol_rules.rowSex)
function resultSex(row) { return rowSex(row); }

function resultAge(row) {
  const text = `${row.subgroup || ''} ${row.category || ''} ${row.pageTitle || ''}`;
  const range = text.match(/(?:от\s*)?(\d{1,2})\s*(?:[-–—]\s*(\d{1,2})|\+|лет|года?)/i);
  if (!range) return '';
  if (/\+/.test(range[0])) return `${range[1]}+ лет`;
  return range[2] ? `${range[1]}–${range[2]} лет` : `${range[1]} лет`;
}

function resultStanding(row) {
  const cat = `${row.category || ''} ${row.pageTitle || ''}`;
  if (row.participant_type === 'regional_team' || /сборн|регион|субъект/i.test(cat)) return 'regional';   // сборные регионов — отдельный зачёт
  if (row.participant_type === 'team') return 'team';
  return row.team || /команд|эстафет/.test(resultText(row)) ? 'team' : 'individual';
}

function resultComplexes(row) {
  const named = Object.keys(row.details || {}).filter(key => /^комплекс(?:\s|$)/i.test(key));
  if (named.length) return named;
  const source = `${row.category || ''} ${row.pageTitle || ''}`;
  const patterns = [['Пресс', /пресс/i], ['Подтягивания', /подтяг/i], ['Рывок гири', /рывок гир/i], ['Гонка', /гонк/i], ['День 1', /день\s*1/i], ['День 2', /день\s*2/i], ['День 3', /день\s*3/i], ['День 4', /день\s*4/i]];
  return patterns.filter(([, re]) => re.test(source)).map(([name]) => name);
}

function filteredEventResults() {
  const protocol = state.currentEventResults;
  if (!protocol || !Array.isArray(protocol.results)) return [];
  const q = (state.eventResultQuery || '').trim().toLowerCase();
  const isTeamStanding = state.eventResultStanding === 'team';
  const isIndividualStanding = state.eventResultStanding === 'individual';
  const isTeamCategory = /команд|эстафет|сборн/i.test(state.eventResultCategory || '');
  const progRows = protocol.results.filter((r) => r && !isRecordRunRow(r));
  const program = currentResultProgram(resultPrograms(protocol, resultCategories(progRows)), progRows);

  const validRows = [];
  for (const rawRow of protocol.results) {
    const row = normalizeProtocolRow(rawRow);
    if (!row || isRecordRunRow(row)) continue;

    const standing = resultStanding(row);
    const isTeamItem = standing !== 'individual';
    if (isIndividualStanding && isTeamItem) continue;
    if (isTeamStanding && standing !== 'team') continue;
    if (state.eventResultStanding === 'regional' && standing !== 'regional') continue;

    if (state.eventResultCategory !== 'all' && row.category !== state.eventResultCategory) {
      continue;
    }
    if (program && resultProgramOf(row.category) !== program) continue;   // вкладка программы («Гонка ГТО» и т. д.)
    if (state.eventResultRegion !== 'all' && (row.region || '') !== state.eventResultRegion) continue;

    // Gender filter: only apply to individual participants
    if (!isTeamItem && !isTeamCategory && state.eventResultSex !== 'all') {
      const sex = resultSex(row);
      if (sex && sex !== state.eventResultSex) continue;
    }

    // Age filter: only apply to individual participants
    if (!isTeamItem && !isTeamCategory && state.eventResultAge !== 'all') {
      const age = resultAge(row);
      if (age && age !== state.eventResultAge) continue;
    }


    if (state.eventResultComplex !== 'all') {
      if (!resultComplexes(row).includes(state.eventResultComplex)) continue;
    }

    if (q) {
      const dName = (row.display_name || '').toLowerCase();
      const pName = (row.participant || '').toLowerCase();
      const tName = (row.team || '').toLowerCase();
      const rName = (row.region || '').toLowerCase();
      const cName = (row.category || '').toLowerCase();
      const sName = (row.subgroup || '').toLowerCase();
      const detailsStr = Object.values(row.details || {}).join(' ').toLowerCase();
      const haystack = `${dName} ${pName} ${tName} ${rName} ${cName} ${sName} ${detailsStr}`;
      if (!haystack.includes(q)) continue;
    }

    validRows.push(row);
  }

  return validRows;
}

export function sortProtocolRows(a, b) {
  const rankA = parseRank(a.rank);
  const rankB = parseRank(b.rank);
  if (rankA !== rankB) {
    return rankA - rankB;
  }
  const numA = parseFloat(String(a.result || '').replace(',', '.').replace(/[^\d.]/g, ''));
  const numB = parseFloat(String(b.result || '').replace(',', '.').replace(/[^\d.]/g, ''));
  if (!isNaN(numA) && !isNaN(numB) && numA !== numB) {
    if (String(a.result || '').includes(':')) {
      return numA - numB;
    }
    return numB - numA;
  }
  const nameA = a.display_name || a.participant || a.team || '';
  const nameB = b.display_name || b.participant || b.team || '';
  return nameA.localeCompare(nameB, 'ru');
}

function updateResultFiltersState() {
  const isTeamView = state.eventResultStanding === 'team' || /команд|эстафет|сборн/i.test(state.eventResultCategory || '');
  const sexGroup = document.querySelector('[data-result-sex]')?.closest('.result-filter-group');
  if (sexGroup) {
    sexGroup.classList.toggle('filter-disabled-team', isTeamView);
    $$('[data-result-sex]').forEach(btn => {
      btn.disabled = isTeamView;
    });
  }
  const ageWrap = $('#event-result-age')?.closest('.filter-pill-wrap');
  const ageSelect = $('#event-result-age');
  if (ageWrap && ageSelect) {
    ageWrap.classList.toggle('filter-disabled-team', isTeamView);
    ageSelect.disabled = isTeamView;
  }
}


// онлайн-этап: засчитанные судьями видео (judging.py) — таблица по мере проверки, над протоколом
const onlineLbCache = new Map();
function renderOnlineLeaderboard() {
  const box = $('#event-online-lb'); const id = String(state.currentEventId || '');
  if (!box || !id) return;
  const draw = (d) => {
    const cats = (d && d.categories) || [];
    box.innerHTML = cats.length ? `<section class="online-lb" aria-label="Онлайн-этап: проверенные видео"><h3>Онлайн-этап · проверенные видео</h3>
      ${cats.map((c) => `<details class="online-lb-cat" ${cats.length === 1 ? 'open' : ''}><summary><b>${esc(c.category)}</b><span>${c.rows.length}</span></summary>
        <ol>${c.rows.map((r) => `<li><span class="lg-place ${r.place <= 3 ? 'top' + r.place : ''}">${r.place}</span><span class="olb-who"><button type="button" class="res-name-btn" data-athlete-query="${esc(r.name)}">${esc(r.name)}</button><small>${esc(r.region)}</small></span><b>${esc(r.result)}</b>${normChipHtml(r.norm)}</li>`).join('')}</ol></details>`).join('')}</section>` : '';
  };
  if (onlineLbCache.has(id)) { draw(onlineLbCache.get(id)); return; }
  fetch(`/api/judging/leaderboard?tournament=${encodeURIComponent(id)}`).then((r) => r.ok ? r.json() : null).then((d) => { onlineLbCache.set(id, d); if (String(state.currentEventId) === id) draw(d); }).catch(() => {});
}

function renderEventResults() {
  renderOnlineLeaderboard();
  const protocol = state.currentEventResults;
  const list = $('#event-result-list');
  if (!protocol || !list) return;
  updateResultFiltersState();
  // турнир на своём движке: «Знак ГТО / Рекорд дня» — табло зоны знака (badge_panel.js?v=29548950), «Заруба ГТО» — общая таблица
  // на вылет по кругам (ko_panel.js?v=feeb6463), «Гонка ГТО» — подробная таблица по категориям (race_panel.js?v=6d81cc45) вместо списка протокола (25.10.2026, владелец: «чтобы были результаты онлайн»,
  // «как общая таблица, где результаты всех и на уменьшение с каждым вылетом»)
  const progAll = protocol.results.filter((r) => r && !isRecordRunRow(r));
  const liveProg = protocol.liveT > 0 ? currentResultProgram(resultPrograms(protocol, resultCategories(progAll)), progAll) : '';
  const badgeBox = $('#event-badge-live'); const koBox = $('#event-ko-live'); const raceBox = $('#event-race-live');
  const panelProg = (liveProg === 'records' && badgeBox) || (liveProg === 'ko' && koBox) || (liveProg === 'race' && raceBox) ? liveProg : '';
  if (badgeBox) badgeBox.hidden = panelProg !== 'records';
  if (koBox) koBox.hidden = panelProg !== 'ko';
  if (raceBox) raceBox.hidden = panelProg !== 'race';
  list.hidden = Boolean(panelProg);
  list.closest('.tournament-results')?.querySelectorAll('.res-find, #event-result-summary, #event-result-mine, .res-programs .res-cats').forEach((x) => { x.hidden = Boolean(panelProg); });
  if (panelProg === 'records') { import('./badge_panel.js?v=29548950').then((m) => m.mountBadgePanel(badgeBox, protocol.liveT)).catch(() => {}); return; }
  if (panelProg === 'ko') { import('./ko_panel.js?v=feeb6463').then((m) => m.mountKoPanel(koBox, state.currentEventId)).catch(() => {}); return; }
  if (panelProg === 'race') { import('./race_panel.js?v=6d81cc45').then((m) => m.mountRacePanel(raceBox, state.currentEventId)).catch(() => {}); return; }
  const filtered = filteredEventResults();
  // таблица по категориям — показываем всех; группа без пола, где места разыграны отдельно у мужчин и женщин
  // (онлайн-этапы: два первых места в «45-49»), подписывается полом — «Женщины 45-49» / «Мужчины 45-49»
  const shown = splitSubgroupsBySex(filtered);
  const isTeamView = state.eventResultStanding === 'team' || isTeamCategoryName(state.eventResultCategory);
  const foundN = isTeamView ? teamGroups(filtered).length : filtered.length;
  const countWord = isTeamView ? ruPlural(foundN, 'команда', 'команды', 'команд') : ruPlural(foundN, 'строка', 'строки', 'строк');
  $('#event-result-summary').innerHTML = state.eventResultQuery ? `<span>Найдено: <b>${foundN.toLocaleString('ru-RU')}</b> ${countWord}</span>` : '';
  if (!filtered.length) {
    const mineBox = $('#event-result-mine'); if (mineBox) mineBox.innerHTML = '';
    const onlyRecords = (protocol.results || []).length && (protocol.results || []).every(isRecordRunRow);
    list.innerHTML = onlyRecords
      ? tournamentRecordsHtml(protocol)   // турнир только из рекордных попыток — показываем их прямо в «Результатах»
      : '<div class="lb-empty"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-search"/></svg><b>Совпадений нет</b><span>Измените запрос или сбросьте фильтр</span></div>';
    if (onlyRecords) { const f = list.closest('.tournament-results'); f?.querySelectorAll('.res-filters, .res-controls, #event-result-summary').forEach(x => { x.hidden = true; }); }
    return;
  }
  const groupBy = 'category';
  const singleCategory = state.eventResultCategory !== 'all';
  // большой протокол целиком (онлайн-этапы — тысячи строк): в каждой группе сначала 10 строк; одна категория — до RT_LIMIT
  state.rtLimit = filtered.length > 400 && !singleCategory ? 10 : RT_LIMIT;
  let idx = 0;
  // список строк категории: команды сворачиваются в одну карточку с составом
  const renderRows = (rows, catName, showCategory = false, noPodium = false) => {
    rows.sort(sortProtocolRows);
    const teamCat = isTeamCategoryName(catName) || rows.every(r => r.team);
    if (resultsViewMode() === 'table') {
      let podium = '';
      if (singleCategory && !noPodium && rows.length >= 3 && !teamCat && rows.slice(0, 3).every((r, i) => parseRank(r.rank) === i + 1)) { const calc = stageTotals(rows.map((r) => r.result)); podium = resultsPodiumHtml(rows.slice(0, 3).map((r, k) => ({ rank: parseRank(r.rank), name: r.display_name || r.participant, region: r.region, result: r.result, calc: calc[k] }))); }
      // все строки категории (без фильтра по региону и поиска) — для «хода турнира»
      const filteredOut = state.eventResultRegion !== 'all' || state.eventResultQuery;
      const fullRows = filteredOut ? splitSubgroupsBySex((protocol.results || []).map(normalizeProtocolRow).filter((r) => r && !isRecordRunRow(r) && (r.category || r.pageTitle || 'Основной зачёт') === catName)).filter((r) => !rows[0]?.subgroup || (r.subgroup || '') === rows[0].subgroup) : null;
      return podium + resultsTableHtml(rows, catName, { teamCat: teamCat && rows.some(r => r.team), noPodium: !!podium, fullRows });
    }
    if (teamCat && rows.some(r => r.team)) {
      const best = (trs) => trs.map(r => parseRank(r.rank)).reduce((m, v) => Math.min(m, v), 999999);
      const teams = teamGroups(rows).map((g) => [g.name, g.rows]).sort((x, y) => best(x[1]) - best(y[1]) || x[0].localeCompare(y[0], 'ru'));
      const podium = singleCategory && teams.length >= 3 && teams.slice(0, 3).every((t, i) => best(t[1]) === i + 1)
        ? resultsPodiumHtml(teams.slice(0, 3).map(([name, trs], i) => ({ rank: i + 1, name, region: trs[0].region, result: (trs.find(r => /\(/.test(r.result || '')) || trs.find(r => r.result) || {}).result, isTeam: true })), 'баллов') : '';
      return podium + teams.map(([name, trs]) => teamRowHtml(name, trs, idx++)).join('');
    }
    const podium = singleCategory && rows.length >= 3 && rows.slice(0, 3).every((r, i) => parseRank(r.rank) === i + 1)
      ? resultsPodiumHtml(rows.slice(0, 3).map(r => ({ rank: parseRank(r.rank), name: r.display_name || r.participant, region: r.region, result: r.result }))) : '';
    return podium + rows.map(r => resultRowHtml(r, idx++, { showCategory })).join('');
  };
  let html = '';
  if (groupBy === 'category') {
    const groups = new Map();
    shown.forEach(row => { const cat = row.category || row.pageTitle || 'Основной зачёт'; if (!groups.has(cat)) groups.set(cat, []); groups.get(cat).push(row); });
    for (const [catName, rows] of [...groups].sort((a, b) => isAuxCategory(a[0]) - isAuxCategory(b[0]) || a[0].localeCompare(b[0], 'ru'))) {
      const teamCat = isTeamCategoryName(catName) || rows.every(r => r.team);
      const n = teamCat ? teamGroups(rows).length : rows.length;
      html += groupHeaderHtml('Категория', catName, n, teamCat ? ruPlural(n, 'команда', 'команды', 'команд') : ruPlural(n, 'участник', 'участника', 'участников'));
      // подгруппы внутри категории (возраст/пол: «Мужчины 18-34», «Девочки 12-13») — у каждой свои места
      const subs = [...new Set(rows.map(r => r.subgroup || ''))].sort(subgroupOrder);
      if (subs.length > 1 && subs.filter(Boolean).length > 1) {
        // одна категория — группы вкладками сверху: выбранная показывается одна, без пролистывания всех (10.10.2026, владелец)
        let showSubs = subs;
        if (singleCategory) {
          const sub = subs.includes(state.eventResultSub) ? state.eventResultSub : '';
          html += `<div class="res-sub-tabs" role="group" aria-label="Группы: ${esc(catName)}"><button type="button" data-result-sub="" aria-pressed="${!sub}">Все группы<small>${rows.length}</small></button>${subs.map(sg => `<button type="button" data-result-sub="${esc(sg)}" aria-pressed="${sub === sg}">${esc(sg || 'Без подгруппы')}<small>${rows.filter(r => (r.subgroup || '') === sg).length}</small></button>`).join('')}</div>`;
          if (sub) showSubs = [sub];
        }
        html += showSubs.map(sg => {
          const part = rows.filter(r => (r.subgroup || '') === sg);
          return `<div class="res-subgroup"><h4 class="res-sub-title">${esc(sg || 'Без подгруппы')}<small>${part.length}</small></h4><div class="lb-list res-cat-list">${renderRows(part, catName, false, true)}</div></div>`;
        }).join('');
      } else {
        html += `<div class="lb-list res-cat-list">${renderRows(rows, catName)}</div>`;
      }
    }
  } else if (groupBy === 'rank') {
    const sorted = [...shown].sort(sortProtocolRows);
    const tiers = [
      { title: 'Победители', tag: '1 место', filter: r => parseRank(r.rank) === 1 },
      { title: 'Серебряные призёры', tag: '2 место', filter: r => parseRank(r.rank) === 2 },
      { title: 'Бронзовые призёры', tag: '3 место', filter: r => parseRank(r.rank) === 3 },
      { title: 'Топ-10', tag: '4–10 места', filter: r => { const n = parseRank(r.rank); return n >= 4 && n <= 10; } },
      { title: 'Участники турнира', tag: '11+ места', filter: r => { const n = parseRank(r.rank); return n > 10 && n < 999999; } },
      { title: 'Без места в протоколе', tag: 'Протокол', filter: r => parseRank(r.rank) >= 999999 }
    ];
    for (const tier of tiers) {
      const tierRows = sorted.filter(tier.filter);
      if (!tierRows.length) continue;
      html += groupHeaderHtml(tier.tag, tier.title, tierRows.length, ruPlural(tierRows.length, 'строка', 'строки', 'строк'));
      html += `<div class="lb-list">${tierRows.map(r => resultRowHtml(r, idx++, { showCategory: true })).join('')}</div>`;
    }
  } else if (groupBy === 'complex') {
    const complexes = [...new Set(filtered.flatMap(resultComplexes).filter(Boolean))].sort((a, b) => a.localeCompare(b, 'ru', { numeric: true }));
    const pool = complexes.length ? complexes : ['Итоговые результаты турнира'];
    for (const comp of pool) {
      const compRows = complexes.length ? shown.filter(r => resultComplexes(r).includes(comp)) : [...shown];
      if (!compRows.length) continue;
      compRows.sort(sortProtocolRows);
      html += groupHeaderHtml(complexes.length ? 'Комплекс' : 'Общий зачёт', comp, compRows.length, ruPlural(compRows.length, 'строка', 'строки', 'строк'));
      html += `<div class="lb-list">${compRows.map(r => resultRowHtml(r, idx++, { showCategory: true })).join('')}</div>`;
    }
  } else {
    const sorted = [...shown].sort(sortProtocolRows);
    html = `<div class="lb-list">${sorted.map(r => resultRowHtml(r, idx++, { showCategory: true })).join('')}</div>`;
  }
  if (filtered.length > shown.length && !state.eventResultPrintAll) {
    const remain = filtered.length - shown.length;
    html += `<button class="load-more-results" data-results-more="true">Показать ещё ${Math.min(remain, 120)} из ${remain} оставшихся ↓</button>`;
  }
  list.innerHTML = html;
  const box = $('#event-result-mine'); if (box) box.innerHTML = mineStripHtml(filtered);
  // открыли по ссылке «поделиться результатом» (?hl=…) — один раз прокрутить к строке и выделить её
  if (state.eventResultHighlight) {
    const hl = state.eventResultHighlight; state.eventResultHighlight = null;
    state.rtHighlightKey = hl; state.rtHighlightEvent = state.currentEventId;   // выделение переживает перерисовки (догрузка альбомов и т.п.)
    requestAnimationFrame(() => jumpToResultRow(hl, state.eventResultCategory && state.eventResultCategory !== 'all' ? state.eventResultCategory : '', true));
  }
  syncResultsHash();   // после выделения: hl остаётся в адресе
}

function exportEventResultsCsv() {
  const protocol = state.currentEventResults;
  const rows = filteredEventResults();
  if (!protocol || !rows.length) return;
  const detailKeys = [...new Set(rows.flatMap(row => Object.keys(row.details || {})))];
  const columns = ['Место', 'Участник', 'Команда', 'Регион', 'Пол', 'Возраст', 'Зачёт', 'Категория', 'Подгруппа', 'Результат', ...detailKeys];
  const quote = value => `"${String(value ?? '').replace(/"/g, '""')}"`;
  const data = [columns, ...rows.map(row => [row.rank, row.participant, row.team, row.region, resultSex(row) === 'female' ? 'Женщины' : resultSex(row) === 'male' ? 'Мужчины' : '', resultAge(row), resultStanding(row) === 'team' ? 'Командный' : 'Личный', row.category, row.subgroup, row.result, ...detailKeys.map(key => row.details?.[key] || '')])];
  const blob = new Blob(['\ufeff' + data.map(line => line.map(quote).join(';')).join('\r\n')], { type: 'text/csv;charset=utf-8' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `gto-results-${protocol.eventId || 'tournament'}.csv`;
  link.click();
  setTimeout(() => URL.revokeObjectURL(link.href), 1000);
}

function printEventResults() {
  state.eventResultPrintAll = true;
  renderEventResults();
  document.body.classList.add('printing-results');
  window.print();
  setTimeout(() => {
    document.body.classList.remove('printing-results');
    state.eventResultPrintAll = false;
    renderEventResults();
  }, 800);
}

// текст новости без разметки (модератор набрал абзацами в окне «Создать публикацию»): абзац — по пустой строке, перенос — <br>;
// раньше такой текст выводился как HTML и сливался в одну строку (07.10.2026)
const BLOCK_MARKUP = /<(p|br|div|ul|ol|li|h[1-6]|img|blockquote|table|figure)\b/i;
export function plainTextParagraphs(t) {
  return String(t || '').replace(/\r\n?/g, '\n').split(/\n[ \t]*\n+/).map((p) => p.trim()).filter(Boolean)
    .map((p) => `<p>${p.replace(/\n/g, '<br>')}</p>`).join('');
}

// полный текст новости с форматированием (со старого сайта — data/news_full/<id>.json, 12.10.2026, владелец: «нужно полностью текст
// и форматирование перенести»): разбор в DOM, на выход — только разрешённые теги, текст экранируется заново, ссылки — https/mailto/tel
// (через extLink: внешние — в новой вкладке, видео — плеером сайта), картинки — наши /files/… или https; таблица — с прокруткой
const ART_TAGS = new Set(['P', 'H2', 'H3', 'H4', 'UL', 'OL', 'LI', 'BLOCKQUOTE', 'TABLE', 'THEAD', 'TBODY', 'TR', 'TH', 'TD', 'FIGURE', 'FIGCAPTION',
  'STRONG', 'EM', 'A', 'BR', 'IMG', 'SUB', 'SUP']);
function richArticleHtml(html) {
  const doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
  // текст между тегами — без обрезки краёв (esc → clean обрезает: «более <strong>350» превращалось в «более350»)
  const escText = (v) => String(v).replace(/\s+/g, ' ').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const walk = (node) => [...node.childNodes].map((n) => {
    if (n.nodeType === 3) return escText(n.textContent);
    if (n.nodeType !== 1) return '';
    const inner = walk(n);
    if (!ART_TAGS.has(n.tagName)) return inner;
    const t = n.tagName.toLowerCase();
    if (t === 'br') return '<br>';
    if (t === 'img') {
      const src = n.getAttribute('src') || '';
      if (!/^(\/files\/|https:\/\/)/.test(src)) return '';
      const w = Number(n.getAttribute('width')) || 0, h = Number(n.getAttribute('height')) || 0;
      return `<img loading="lazy" decoding="async" src="${safeImage(src)}" alt="${esc(n.getAttribute('alt') || '')}"${w && h ? ` width="${w}" height="${h}"` : ''}>`;
    }
    if (t === 'a') {
      const href = (n.getAttribute('href') || '').trim();
      if (/^(mailto|tel):/i.test(href)) return `<a href="${esc(href)}">${inner}</a>`;
      if (!/^https?:\/\//i.test(href)) return inner;
      return extLink(esc(href), inner || esc(linkName(href)));
    }
    if (t === 'table') return `<div class="art2-table" tabindex="0" role="region" aria-label="Таблица — прокручивается"><table>${inner}</table></div>`;
    if (t === 'td' || t === 'th') {
      const span = ['colspan', 'rowspan'].map((k) => (/^\d{1,2}$/.test(n.getAttribute(k) || '') ? ` ${k}="${n.getAttribute(k)}"` : '')).join('');
      return `<${t}${span}>${inner}</${t}>`;
    }
    if (t === 'ul' || t === 'ol') return `<${t} class="art2-list">${inner}</${t}>`;
    return `<${t}>${inner}</${t}>`;
  }).join('');
  return walk(doc.body).trim();
}

function articleBody(item) {
  if (item.body_html) {
    return BLOCK_MARKUP.test(item.body_html) ? item.body_html : plainTextParagraphs(item.body_html);
  }
  if (item.fullContentHtml) {
    const rich = richArticleHtml(item.fullContentHtml);
    if (rich) return rich;
  }
  const sourceText = item.text || '';
  if (!item.fullContentHtml && sourceText) {
    return sourceText.split(/\n\n+/).filter(Boolean).map(p => `<p>${esc(p)}</p>`).join('');
  }
  const doc = new DOMParser().parseFromString(item.fullContentHtml || `<p>${esc(sourceText)}</p>`, 'text/html');
  const blocks = [];
  doc.body.querySelectorAll('p,li,img').forEach(node => {
    if (node.tagName === 'IMG') {
      const src = node.getAttribute('src') || '';
      if (/^https?:\/\//.test(src) || /^\/api\/news\//.test(src) || /^\.\/assets\//.test(src)) {
        blocks.push(`<img loading="lazy" src="${safeImage(src)}" alt="">`);
      }
    } else {
      const value = clean(node.textContent);
      if (value) blocks.push(node.tagName === 'LI' ? `<li>${esc(value)}</li>` : `<p>${esc(value)}</p>`);
    }
  });
  // подряд идущие пункты — одним списком (раньше <li> стояли без <ul>)
  return blocks.join('').replace(/(?:<li>[\s\S]*?<\/li>)+/g, (m) => `<ul class="art2-list">${m}</ul>`) || sourceText.split(/\n\n+/).filter(Boolean).map(p => `<p>${esc(p)}</p>`).join('');
}

async function openArticle(id, push = true, restoreScrollY = null) {
  let newsList = getUnifiedNews();
  const idStr = String(id);
  let item = newsList.find(x => String(x.id) === idStr);
  if (!item) {
    await ensureScreenData('news');
    newsList = getUnifiedNews();
    item = newsList.find(x => String(x.id) === idStr);
  }
  if (!item && HOME_SUMMARY?.latestNews) {
    item = HOME_SUMMARY.latestNews.find(x => String(x.id) === idStr);
  }
  if (!item) return;
  // полный текст новости — отдельным файлом (лента data/news.json лёгкая): full — версия текста, она же ?v= (кэш обновится сам);
  // не загрузился — остаётся короткий текст ленты
  if (item.full && !item.fullContentHtml) {
    try {
      const r = await fetch(`./data/news_full/${encodeURIComponent(idStr)}.json?v=${encodeURIComponent(item.full)}`);
      const j = r.ok ? await r.json() : null;
      if (j && typeof j.html === 'string') item.fullContentHtml = j.html;
    } catch (_) { /* сеть: показываем короткий текст */ }
  }
  if (push) {
    pushRoute({ screen: 'article', params: { id: idStr } });
  }
  go('article', false, restoreScrollY);
  const hashTarget = `#article/${idStr}`;
  if (push && location.hash !== hashTarget) {
    history.pushState({ screen: 'article', id: idStr }, '', hashTarget);
  } else if (location.hash !== hashTarget) {
    history.replaceState({ screen: 'article', id: idStr }, '', hashTarget);
  }
  // источник — карточкой в конце статьи; регион дописывается, только если его нет в названии канала
  const srcTitle = item.isHub ? (item.sourceTitle || 'Канал региона') : 'Федерация многоборья ГТО';
  const srcRegion = item.isHub && item.region_name && !normRu(srcTitle).includes(normRu(item.region_name).split(' ')[0]) ? item.region_name : '';
  const srcHref = item.isHub ? (item.sourceUrl || item.url) : item.url;   // ссылки нет — кнопку «Оригинал» не показываем (раньше вела на «#»)
  const attributionHtml = `<aside class="art2-src" aria-label="Источник">
      <span class="art2-src-ico" aria-hidden="true"><svg class="ic"><use href="./assets/icons.svg?v=1#${item.isHub ? 'i-megaphone' : 'i-newspaper'}"/></svg></span>
      <div><small>${item.isHub ? 'Новость региона' : 'Источник'}</small><b>${esc(srcTitle)}</b>${srcRegion ? `<span>${esc(srcRegion)}</span>` : ''}</div>
      ${/^https?:\/\//.test(srcHref) ? `<a class="art2-src-btn" href="${safeUrl(srcHref)}" target="_blank" rel="noopener nofollow">${item.isHub ? 'Оригинал в канале' : 'Оригинал публикации'} <span aria-hidden="true">↗</span></a>` : ''}
    </aside>`;
  // новость о мероприятии — кнопка на его страницу (итоги, документы, результаты)
  const eventLinkHtml = /^\d{1,6}$/.test(String(item.eventId || '')) ? `<a class="art2-event-btn" href="#event/${esc(item.eventId)}"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-trophy"/></svg><span>${esc(item.eventLinkText || 'Страница мероприятия')}</span><span aria-hidden="true">→</span></a>` : '';

  const isModerator = Boolean(localStorage.getItem('fmgto_hub_token'));
  const moderatorToolbarHtml = isModerator ? `
    <div class="moderator-toolbar" id="mod-toolbar">
      <div class="mod-info">
        <span class="mod-tag"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-shield"/></svg> Модератор</span>
        <span class="mod-meta">${esc(item.region_name || 'Новость сайта')} ${item.inbox_id ? `· Заявка #${item.inbox_id}` : ''}</span>
      </div>
      <div class="mod-actions">
        <button type="button" class="mod-btn" id="btn-mod-pin-article">📌 ${(() => { const pn = contentOverride('home', 'pinned'); return pn && !pn.deleted && String(pn.newsId) === String(item.id) ? 'Открепить с главной' : 'Закрепить на главной'; })()}</button>
        <button type="button" class="mod-btn" id="btn-mod-edit-article"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-pencil"/></svg> Редактировать</button>
        <button type="button" class="mod-btn danger" id="btn-mod-withdraw-article"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-triangle-alert"/></svg> Снять с сайта</button>
        <button type="button" class="mod-btn danger" id="btn-mod-delete-article"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-trash-2"/></svg> Удалить</button>
      </div>
    </div>
  ` : '';

  $('#article-detail').innerHTML = `${moderatorToolbarHtml}<header class="art2">${item.img ? `<figure class="art2-media"><img class="art2-bg" ${rsImgAttrs(item.img, 320)} alt="" aria-hidden="true" decoding="async"><img class="art2-img" ${rsImgAttrs(item.img, 1280)} alt="" fetchpriority="high" decoding="async" data-fb="logo"></figure>` : ''}<div class="art2-head"><time>${esc(item.date)}</time><h1>${esc(item.title)}</h1></div></header><div class="article-body art2-body">${articleBody(item)}</div>${eventLinkHtml}${attributionHtml}`;
  if (restoreScrollY == null) { resetScrollToTop(); requestAnimationFrame(resetScrollToTop); }   // новость открывается с фото, а не с середины текста
  if (isModerator) {
    bindModeratorToolbar(item);
  }
  if (typeof restoreScrollY === 'number') {
    restoreScrollPosition(restoreScrollY);
  }
}

// адрес новости для действий модератора: новости каналов — по slug, новости старого сайта — /api/news/legacy/<id>
// (их номера 1, 2, 3… совпадают с номерами новостей каналов — раньше «Удалить» у старой новости било по новости канала)
function newsApiId(item) {
  if (item.isHub || String(item.id).startsWith('hub_')) return item.slug || ('hub_' + String(item.dbId || String(item.id).replace('hub_', '')));
  return 'legacy/' + encodeURIComponent(String(item.id));
}

function bindModeratorToolbar(item) {
  const token = localStorage.getItem('fmgto_hub_token');
  if (!token) return;
  $('#btn-mod-pin-article')?.addEventListener('click', (e) => {
    const btn = e.currentTarget; btn.disabled = true;
    import('./mod_content.js?v=297d9599').then((m) => m.togglePinNews(item)).then((pinned) => { btn.textContent = pinned ? '📌 Открепить с главной' : '📌 Закрепить на главной'; })
      .finally(() => { btn.disabled = false; });
  });

  const editBtn = $('#btn-mod-edit-article');
  const withdrawBtn = $('#btn-mod-withdraw-article');
  const deleteBtn = $('#btn-mod-delete-article');

  if (withdrawBtn) {
    withdrawBtn.addEventListener('click', async () => {
      if (!confirm('Снять эту новость с публикации на сайте? Новость будет скрыта от посетителей.')) return;
      withdrawBtn.disabled = true;
      withdrawBtn.textContent = 'Снятие...';
      try {
        const targetId = newsApiId(item);
        const res = await fetch(`/api/news/${targetId}/withdraw`, {
          method: 'POST',
          headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
          }
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.error || 'Ошибка при снятии с публикации');
        }
        deleteUnifiedNews(item.id);
        invalidateHubNewsCache(); invalidateLegacyOverrides();
        window.location.hash = '#news';
        offerUndo('Новость снята с сайта', async () => {
          const back = await fetch(`/api/news/${targetId}/${String(targetId).startsWith('legacy/') ? 'restore' : 'republish'}`, { method: 'POST', headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json' } });
          const d = await back.json().catch(() => ({}));
          if (!back.ok) return { ok: false, error: d.error || `ошибка ${back.status}` };
          restoreUnifiedNewsLocal(item.id); invalidateHubNewsCache(); invalidateLegacyOverrides();
          if (state.screen === 'news') renderNews?.();
          return { ok: true };
        });
      } catch (err) {
        alert('Ошибка: ' + err.message);
        withdrawBtn.disabled = false;
        withdrawBtn.textContent = 'Снять с сайта';
      }
    });
  }

  if (deleteBtn) {
    deleteBtn.addEventListener('click', async () => {
      if (!confirm('Вы действительно хотите навсегда удалить эту новость с сайта? Это действие необратимо.')) return;
      deleteBtn.disabled = true;
      deleteBtn.textContent = 'Удаление...';
      try {
        const targetId = newsApiId(item);
        const res = await fetch(`/api/news/${targetId}/delete`, {
          method: 'POST',
          headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
          }
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.error || 'Ошибка при удалении');
        }
        deleteUnifiedNews(item.id);
        invalidateHubNewsCache(); invalidateLegacyOverrides();
        showToast('✓ Новость удалена с сайта');
        window.location.hash = '#news';
      } catch (err) {
        alert('Ошибка: ' + err.message);
        deleteBtn.disabled = false;
        deleteBtn.textContent = 'Удалить';
      }
    });
  }

  if (editBtn) {
    editBtn.addEventListener('click', () => {
      openModEditDialog(item);
    });
  }
}

export function openModEditDialog(item) {
  const existing = document.getElementById('mod-article-edit-modal');
  if (existing) existing.remove();

  const token = localStorage.getItem('fmgto_hub_token');
  const dialog = document.createElement('div');
  dialog.className = 'mod-edit-dialog';
  dialog.id = 'mod-article-edit-modal';

  const regionsOptions = (typeof GTO_REGIONS !== 'undefined' ? GTO_REGIONS : []).map(r => `
    <option value="${r.id}" ${String(r.id) === String(item.region_id) ? 'selected' : ''}>${esc(r.name)}</option>
  `).join('');

  dialog.innerHTML = `
    <div class="mod-edit-card" role="dialog" aria-modal="true">
      <div class="mod-edit-head">
        <h3><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-pencil"/></svg> Редактирование новости</h3>
        <button type="button" class="mod-edit-close" id="btn-close-mod-edit">✕</button>
      </div>
      <form id="form-mod-edit-article">
        <div class="mod-edit-field">
          <label>Заголовок новости *</label>
          <input type="text" id="mod-edit-title" value="${esc(item.title || '')}" required>
        </div>
        <div class="mod-edit-field">
          <label>Краткое описание / Лид</label>
          <textarea id="mod-edit-lead" rows="3">${esc(item.lead || '')}</textarea>
        </div>
        <div class="mod-edit-field">
          <label>Основной текст новости (HTML или текст)</label>
          <textarea id="mod-edit-body" rows="8">${esc(item.body_html || item.text || '')}</textarea>
        </div>
        <div class="mod-edit-field">
          <label>Ссылка на фото / обложку</label>
          <input type="text" id="mod-edit-cover" value="${esc(item.img || '')}">
        </div>
        <div class="mod-edit-field">
          <label>Регион</label>
          <select id="mod-edit-region" style="width:100%;padding:10px 12px;background:#112236;border:1px solid rgba(255,255,255,0.12);border-radius:10px;color:#fff;">
            <option value="0">Без региона (Федеральная)</option>
            ${regionsOptions}
          </select>
        </div>
        <div class="mod-edit-actions">
          <button type="button" class="mod-btn" id="btn-cancel-mod-edit">Отмена</button>
          <div style="display:flex;gap:8px;">
            ${item.inbox_id ? `<button type="button" class="mod-btn" id="btn-mod-open-inbox">Открыть в инбоксе ↗</button>` : ''}
            <button type="submit" class="mod-btn" id="btn-save-mod-edit" style="background:#0284c7;color:#fff;border-color:#38bdf8;"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-save"/></svg> Сохранить изменения</button>
          </div>
        </div>
      </form>
    </div>
  `;

  document.body.appendChild(dialog);
  import('./mod_ui.js?v=9a7f86f1').then((m) => { m.enhanceModDialog(dialog); m.attachPhotoUpload(dialog.querySelector('#mod-edit-cover')); m.attachPreview(dialog, 'news', 'mod-edit'); }).catch(() => {});

  const closeDialog = () => dialog.remove();
  dialog.querySelector('#btn-close-mod-edit')?.addEventListener('click', closeDialog);
  dialog.querySelector('#btn-cancel-mod-edit')?.addEventListener('click', closeDialog);
  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) closeDialog();
  });

  const inboxBtn = dialog.querySelector('#btn-mod-open-inbox');
  if (inboxBtn && item.inbox_id) {
    inboxBtn.addEventListener('click', () => {
      closeDialog();
      window.location.hash = `#inbox?item=${item.inbox_id}`;
    });
  }

  const form = dialog.querySelector('#form-mod-edit-article');
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const saveBtn = dialog.querySelector('#btn-save-mod-edit');
    if (saveBtn) {
      saveBtn.disabled = true;
      saveBtn.textContent = 'Сохранение...';
    }

    const title = dialog.querySelector('#mod-edit-title').value.trim();
    const lead = dialog.querySelector('#mod-edit-lead').value.trim();
    const body = dialog.querySelector('#mod-edit-body').value.trim();
    const cover_url = dialog.querySelector('#mod-edit-cover').value.trim();
    const region_id = Number(dialog.querySelector('#mod-edit-region').value || 0);
    const regObj = typeof GTO_REGIONS !== 'undefined' ? GTO_REGIONS.find(r => r.id === region_id) : null;
    const region_name = regObj ? regObj.name : '';

    try {
      const targetId = newsApiId(item);
      if (token) {
        const res = await fetch(`/api/news/${targetId}/edit`, {
          method: 'POST',
          headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            title,
            lead,
            body,
            cover_url,
            region_id,
            region_name
          })
        });

        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.error || 'Ошибка при сохранении изменений на сервере');
        }
      }

      // Обновляем данные локально
      item.title = title;
      item.lead = lead;
      item.body_html = body;
      item.text = lead ? `${lead}\n\n${body}` : body;
      if (cover_url) item.img = cover_url;
      item.region_id = region_id;
      item.region_name = region_name;

      updateUnifiedNews(item.id, item);
      invalidateHubNewsCache(); invalidateLegacyOverrides();
      closeDialog();

      // Если сейчас открыта именно эта статья, перерисовываем её
      const currentHash = location.hash;
      if (currentHash.includes(String(item.id)) || (item.slug && currentHash.includes(item.slug))) {
        openArticle(item.id, false);
      } else {
        renderNews();
      }
      showToast('✓ Изменения сохранены — уже на сайте');
    } catch (err) {
      alert('Ошибка сохранения: ' + err.message);
      if (saveBtn) {
        saveBtn.disabled = false;
        saveBtn.textContent = 'Сохранить изменения';
      }
    }
  });
}

async function handleModDeleteArticle(item) {
  const token = localStorage.getItem('fmgto_hub_token');
  if (!confirm(`Снять новость «${item.title || 'Новость'}» с публикации на сайте?`)) return;
  try {
    const targetId = newsApiId(item);
    if (token && (item.isHub || String(item.id).startsWith('hub_'))) {
      const res = await fetch(`/api/news/${targetId}/withdraw`, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        }
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.error || 'Ошибка при снятии с публикации на сервере');
      }
    }
    deleteUnifiedNews(item.id);
    invalidateHubNewsCache();
    renderNews();
    alert('Новость успешно снята с публикации на сайте!');
  } catch (err) {
    alert('Ошибка: ' + err.message);
  }
}

export function formatNewsType(t) {
  if (t === 'announcement') return 'Анонс';
  if (t === 'event_report') return 'Итоги соревнований';
  if (t === 'official') return 'Официально';
  return 'Новость';
}

export function renderModeratorBar() {
  const isMod = Boolean(localStorage.getItem('fmgto_hub_token'));
  let bar = document.getElementById('moderator-top-bar');

  if (!isMod) {
    if (bar) bar.remove();
    return;
  }

  if (!bar) {
    bar = document.createElement('div');
    bar.id = 'moderator-top-bar';
    bar.className = 'mod-top-bar';
    bar.innerHTML = `
      <div class="mod-top-bar-inner">
        <span class="mod-top-bar-badge"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-shield"/></svg> Режим модератора</span>
        <div class="mod-top-bar-actions">
          <button type="button" class="mod-top-btn" id="mod-bar-add-news"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-plus"/></svg> Новость</button>
          <button type="button" class="mod-top-btn" id="mod-bar-add-event"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-plus"/></svg> Соревнование</button>
          <button type="button" class="mod-top-btn" id="mod-bar-add-record"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-plus"/></svg> Рекорд</button>
          <button type="button" class="mod-top-btn attention" data-mod-menu="attention"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-bell"/></svg> Требует внимания <b class="mod-attn-badge" hidden></b></button>
          <button type="button" class="mod-top-btn secondary" data-mod-menu="protocol"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-clipboard-list"/></svg> Загрузить протокол</button>
          <button type="button" class="mod-top-btn secondary" data-mod-menu="banner"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-megaphone"/></svg> Объявление на главной</button>
          <button type="button" class="mod-top-btn secondary" data-mod-menu="hidden"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-eye"/></svg> Скрытое на сайте</button>
          <button type="button" class="mod-top-btn secondary" data-mod-menu="audit"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-scroll-text"/></svg> Журнал изменений</button>
          <button type="button" class="mod-top-btn secondary" id="mod-bar-open-cms"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-settings"/></svg> CMS / Все разделы</button>
          <button type="button" class="mod-top-btn logout" id="mod-bar-logout">Выйти</button>
        </div>
      </div>
      <button type="button" class="mod-fab" id="mod-fab" aria-expanded="false" aria-controls="mod-top-bar-actions" aria-label="Добавить на сайт"><svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg></button>
    `;
    document.body.prepend(bar);
    import('./mod_ui.js?v=9a7f86f1').catch(() => {});   // удобства окон модератора — заранее, чтобы были готовы к первому окну
    // «Требует внимания · N» — число дел на кнопке меню и точка на «＋»; считаем в фоне, не задерживая страницу
    setTimeout(() => import('./mod_attention.js?v=0076cf7f').then((m) => m.attentionCount()).then((n) => {
      const badge = document.querySelector('.mod-attn-badge'); if (!badge) return;
      badge.hidden = !n; badge.textContent = n > 99 ? '99+' : String(n);
      document.getElementById('mod-fab')?.classList.toggle('has-attn', n > 0);
    }).catch(() => {}), 2500);
    // телефон: вместо трёх строк кнопок над шапкой — одна кнопка «＋» внизу, меню открывается по нажатию
    const actions = bar.querySelector('.mod-top-bar-actions'); actions.id = 'mod-top-bar-actions';
    const fab = bar.querySelector('#mod-fab');
    const setMenu = (open) => { bar.classList.toggle('menu-open', open); fab.setAttribute('aria-expanded', String(open)); fab.setAttribute('aria-label', open ? 'Закрыть меню' : 'Добавить на сайт'); };
    fab.addEventListener('click', () => setMenu(!bar.classList.contains('menu-open')));
    actions.addEventListener('click', (e) => { if (e.target.closest('button')) setMenu(false); });
    document.addEventListener('click', (e) => { if (bar.classList.contains('menu-open') && !bar.contains(e.target)) setMenu(false); });
    // переход на другую страницу и Esc закрывают меню (раньше оно оставалось открытым поверх новой страницы)
    window.addEventListener('hashchange', () => setMenu(false));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && bar.classList.contains('menu-open')) { setMenu(false); fab.focus(); } });

    bar.querySelector('#mod-bar-add-news')?.addEventListener('click', () => {
      openModCreateNewsDialog();
    });
    bar.querySelector('#mod-bar-add-event')?.addEventListener('click', () => {
      openModEventDialog(null);
    });
    bar.querySelector('#mod-bar-add-record')?.addEventListener('click', () => {
      openModRecordDialog(null);
    });
    bar.querySelector('#mod-bar-open-cms')?.addEventListener('click', () => {
      go('admin');
    });
    bar.querySelector('#mod-bar-logout')?.addEventListener('click', () => {
      localStorage.removeItem('fmgto_hub_token');
      renderModeratorBar();
      alert('Вы вышли из режима модератора');
      location.reload();
    });
  }
}

export function openModCreateNewsDialog() {
  const existing = document.getElementById('mod-create-news-modal');
  if (existing) existing.remove();

  const dialog = document.createElement('div');
  dialog.className = 'mod-edit-dialog';
  dialog.id = 'mod-create-news-modal';

  const regionsOptions = (typeof GTO_REGIONS !== 'undefined' ? GTO_REGIONS : []).map(r => `
    <option value="${r.id}">${esc(r.name)}</option>
  `).join('');

  dialog.innerHTML = `
    <div class="mod-edit-card" role="dialog" aria-modal="true">
      <div class="mod-edit-head">
        <h3><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-plus"/></svg> Создать публикацию на сайте</h3>
        <button type="button" class="mod-edit-close" id="btn-close-mod-create-news">✕</button>
      </div>
      <form id="form-mod-create-news">
        <div class="mod-edit-field">
          <label>Заголовок новости *</label>
          <input type="text" id="mod-new-title" required placeholder="Например: Итоги открытого Кубка России...">
        </div>
        <div class="mod-edit-field">
          <label>Краткий анонс / Лид</label>
          <textarea id="mod-new-lead" rows="2" placeholder="Краткое содержание новости для превью в ленте..."></textarea>
        </div>
        <div class="mod-edit-field">
          <label>Полный текст статьи (HTML или текст) *</label>
          <textarea id="mod-new-body" rows="8" required placeholder="Подробный текст статьи..."></textarea>
        </div>
        <div class="mod-edit-field">
          <label>Ссылка на обложку / постер</label>
          <input type="text" id="mod-new-cover" placeholder="https://... или assets/...">
        </div>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
          <div class="mod-edit-field">
            <label>Категория</label>
            <select id="mod-new-cat" style="width:100%;padding:10px 12px;background:#112236;border:1px solid rgba(255,255,255,0.12);border-radius:10px;color:#fff;">
              <option value="Новости">Новости</option>
              <option value="Анонсы">Анонсы</option>
              <option value="Итоги соревнований">Итоги соревнований</option>
              <option value="Официально">Официально</option>
            </select>
          </div>
          <div class="mod-edit-field">
            <label>Регион РФ</label>
            <select id="mod-new-region" style="width:100%;padding:10px 12px;background:#112236;border:1px solid rgba(255,255,255,0.12);border-radius:10px;color:#fff;">
              <option value="0">Вся Россия (Федеральная)</option>
              ${regionsOptions}
            </select>
          </div>
        </div>
        <div class="mod-edit-actions">
          <button type="button" class="mod-btn" id="btn-cancel-mod-create-news">Отмена</button>
          <button type="submit" class="mod-btn" id="btn-submit-mod-create-news" style="background:#0284c7;color:#fff;border-color:#38bdf8;"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-rocket"/></svg> Опубликовать на сайте</button>
        </div>
      </form>
    </div>
  `;

  document.body.appendChild(dialog);
  import('./mod_ui.js?v=9a7f86f1').then((m) => { m.enhanceModDialog(dialog); m.attachPhotoUpload(dialog.querySelector('#mod-new-cover')); m.attachPreview(dialog, 'news', 'mod-new'); }).catch(() => {});
  const closeDialog = () => dialog.remove();
  dialog.querySelector('#btn-close-mod-create-news')?.addEventListener('click', closeDialog);
  dialog.querySelector('#btn-cancel-mod-create-news')?.addEventListener('click', closeDialog);
  dialog.addEventListener('click', (e) => { if (e.target === dialog) closeDialog(); });

  dialog.querySelector('#form-mod-create-news')?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = dialog.querySelector('#btn-submit-mod-create-news');
    if (btn) { btn.disabled = true; btn.textContent = 'Публикация...'; }

    const title = dialog.querySelector('#mod-new-title').value.trim();
    const lead = dialog.querySelector('#mod-new-lead').value.trim();
    const body = dialog.querySelector('#mod-new-body').value.trim();
    const cover_url = dialog.querySelector('#mod-new-cover').value.trim();
    const category = dialog.querySelector('#mod-new-cat').value;
    const region_id = Number(dialog.querySelector('#mod-new-region').value || 0);
    const regObj = typeof GTO_REGIONS !== 'undefined' ? GTO_REGIONS.find(r => r.id === region_id) : null;
    const region_name = regObj ? regObj.name : '';

    try {
      await createHubNews({
        title,
        lead,
        body,
        cover_url,
        category,
        region_id,
        region_name
      });
      closeDialog();
      renderNews();
      showToast('✓ Новость успешно создана и опубликована!');
    } catch (err) {
      alert(err.message || 'Ошибка создания новости');
      if (btn) { btn.disabled = false; btn.textContent = 'Опубликовать на сайте'; }
    }
  });
}

// текст «О соревновании» со страницы турнира одной строкой для правки: абзацы через пустую строку, разделы — с заголовком
// правка модератора поверх файла турнира (разделы описания, весь список документов, фото) — event_mod_edits.js

export function openModEventDialog(item = null) {
  const isEdit = Boolean(item && item.id);
  if (isEdit && isEngineEvent(item)) { openLiveEditNotice(item); return; }   // данные турнира — в админке движка
  const existing = document.getElementById('mod-event-edit-modal');
  if (existing) existing.remove();

  const dialog = document.createElement('div');
  dialog.className = 'mod-edit-dialog';
  dialog.id = 'mod-event-edit-modal';

  const curReg = item?.region_id || item?.region || '';
  const regionsOptions = (typeof GTO_REGIONS !== 'undefined' ? GTO_REGIONS : []).map(r => `
    <option value="${r.name}" ${r.name === curReg || String(r.id) === String(curReg) ? 'selected' : ''}>${esc(r.name)}</option>
  `).join('');

  dialog.innerHTML = `
    <div class="mod-edit-card" role="dialog" aria-modal="true">
      <div class="mod-edit-head">
        <h3>${isEdit ? 'Редактирование соревнования' : 'Добавить соревнование в календарь'}</h3>
        <button type="button" class="mod-edit-close" id="btn-close-mod-event">✕</button>
      </div>
      <form id="form-mod-event" novalidate>
        <div class="mod-edit-field">
          <label>Название соревнования *</label>
          <input type="text" id="mod-event-title" value="${esc(item?.title || '')}" required placeholder="Например: Чемпионат России по многоборью ГТО">
        </div>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
          <div class="mod-edit-field">
            <label>Период / Даты *</label>
            <input type="text" id="mod-event-period" value="${esc(item?.period || '')}" required placeholder="Например: 12-15 мая">
          </div>
          <div class="mod-edit-field">
            <label>Год проведения *</label>
            <input type="number" id="mod-event-year" value="${item?.year || new Date().getFullYear()}" required>
          </div>
        </div>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
          <div class="mod-edit-field">
            <label>Город проведения *</label>
            <input type="text" id="mod-event-city" value="${esc(item?.city || '')}" required placeholder="Москва, Кисловодск...">
          </div>
          <div class="mod-edit-field">
            <label>Регион РФ</label>
            <select id="mod-event-region" style="width:100%;padding:10px 12px;background:#112236;border:1px solid rgba(255,255,255,0.12);border-radius:10px;color:#fff;">
              <option value="">Всероссийское / Федеральное</option>
              ${regionsOptions}
            </select>
          </div>
        </div>
        <div class="mod-edit-field">
          <label>Место / Арена проведения</label>
          <input type="text" id="mod-event-location" value="${esc(item?.location || '')}" placeholder="г. Москва, СК «Лужники»">
        </div>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
          <div class="mod-edit-field">
            <label>Категория старта</label>
            <select id="mod-event-category" style="width:100%;padding:10px 12px;background:#112236;border:1px solid rgba(255,255,255,0.12);border-radius:10px;color:#fff;">
              <option value="Федеральные" ${item?.category === 'Федеральные' ? 'selected' : ''}>Федеральные (ЧР, КР, Игры)</option>
              <option value="Региональные" ${item?.category === 'Региональные' ? 'selected' : ''}>Региональные первенства</option>
              <option value="Муниципальные" ${item?.category === 'Муниципальные' ? 'selected' : ''}>Муниципальные старты</option>
            </select>
          </div>
          <div class="mod-edit-field">
            <label>Формат участия</label>
            <select id="mod-event-format" style="width:100%;padding:10px 12px;background:#112236;border:1px solid rgba(255,255,255,0.12);border-radius:10px;color:#fff;">
              <option value="OFFLINE" ${item?.format === 'OFFLINE' ? 'selected' : ''}>Очный старт (арена)</option>
              <option value="HYBRID" ${item?.format === 'HYBRID' ? 'selected' : ''}>Гибрид (очно + онлайн)</option>
              <option value="ONLINE" ${item?.format === 'ONLINE' ? 'selected' : ''}>Онлайн-турнир (видеоотбор)</option>
            </select>
          </div>
        </div>
        <div class="mod-edit-field">
          <label>Ссылка на афишу / постер старта</label>
          <input type="text" id="mod-event-poster" value="${esc(item?.poster || item?.img || '')}" placeholder="https://... или assets/events/...">
        </div>
        <div class="mod-edit-field">
          <label>Ссылка на регистрацию участников</label>
          <input type="text" id="mod-event-reg-url" value="${esc(item?.regUrl || '')}" placeholder="https://forms.yandex.ru/...">
          <label class="mod-edit-check"><input type="checkbox" id="mod-event-reg-closed" ${item?.regClosed ? 'checked' : ''}> Приём заявок завершён (ссылку и «Идёт регистрация» не показывать)</label>
        </div>
        <div class="mod-edit-field">
          <label>Описание и регламент турнира</label>
          <textarea id="mod-event-desc" rows="14" placeholder="Информация о комплексе упражнений, призах и правилах...">${esc(item?.description || '')}</textarea>
          <small class="mod-edit-hint">Абзацы — через пустую строку. Отдельная строка «## Заголовок» начинает новый раздел (например, «## Расписание»). Строки «• …» или «1) …» подряд — список. «Метка: текст» — блок с заголовком. «„Название“ — текст» — плитка.</small>
        </div>
        <div class="mod-edit-field">
          <label>Документы турнира (Положение, регламент)</label>
          <div class="mod-ev-docs" id="mod-event-docs"></div>
          <button type="button" class="mod-btn" id="btn-mod-event-doc-add">+ Добавить документ</button>
          <small class="mod-edit-hint">Это весь список вкладки «Документы»: можно переименовать, поменять вид, убрать лишнее или добавить новое. PDF, Word или Excel до 25 МБ. «Инструкция» — отдельная группа, «Протокол» со ссылкой — кнопка во вкладке «Результаты».</small>
        </div>
        <div class="mod-edit-field">
          <label>Фотографии турнира</label>
          <div class="mod-ev-photos" id="mod-event-photos"><p class="mod-hint">Загружаем фото страницы…</p></div>
          <small class="mod-edit-hint">«Скрыть» убирает фото со страницы (его можно вернуть), «Добавить фото» — свои фото во вкладку «Фото».</small>
        </div>
        <div class="mod-edit-actions">
          <button type="button" class="mod-btn" id="btn-cancel-mod-event">Отмена</button>
          <button type="submit" class="mod-btn" id="btn-save-mod-event" style="background:#0284c7;color:#fff;border-color:#38bdf8;"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-save"/></svg> ${isEdit ? 'Сохранить изменения' : 'Создать соревнование'}</button>
        </div>
      </form>
    </div>
  `;

  document.body.appendChild(dialog);
  import('./mod_ui.js?v=9a7f86f1').then((m) => { m.enhanceModDialog(dialog); m.attachPhotoUpload(dialog.querySelector('#mod-event-poster'), { label: 'Загрузить афишу' }); m.attachDateRange(dialog.querySelector('#mod-event-period'), dialog.querySelector('#mod-event-year')); m.attachPreview(dialog, 'event', 'mod-event'); }).catch(() => {});

  // документы турнира: строка — название и файл (загрузить или вставить ссылку)
  const docsBox = dialog.querySelector('#mod-event-docs');
  const addDocRow = (doc = {}) => {
    const row = document.createElement('div'); row.className = 'mod-ev-doc';
    row.innerHTML = docRowHtml(doc);
    docsBox.appendChild(row);
    row.querySelector('.mod-ev-doc-del').addEventListener('click', () => row.remove());
    import('./mod_content.js?v=297d9599').then((m) => m.attachDocUpload(row.querySelector('.mod-ev-doc-url'), row.querySelector('.mod-ev-doc-title'))).catch(() => {});
  };
  modEventDocs(item).forEach(addDocRow);
  let docsFull = Boolean(item?.documentsFull), docsTouched = false, photosState = null;
  docsBox.addEventListener('input', () => { docsTouched = true; });
  docsBox.addEventListener('click', (e) => { if (e.target.closest('.mod-ev-doc-del')) docsTouched = true; });
  dialog.querySelector('#btn-mod-event-doc-add')?.addEventListener('click', () => { docsTouched = true; addDocRow(); });
  const photosBox = dialog.querySelector('#mod-event-photos');
  // фото как у афиши: сжатие на телефоне и загрузка в хаб (/api/news/upload)
  const uploadPhoto = async (f) => {
    const { compressImage } = await import('./mod_ui.js?v=9a7f86f1');
    if (f.size > 20 * 1024 * 1024) throw new Error('Фото больше 20 МБ — выберите поменьше');
    const fd = new FormData(); fd.append('photo', await compressImage(f));
    const r = await fetch('/api/news/upload', { method: 'POST', headers: { Authorization: 'Bearer ' + (localStorage.getItem('fmgto_hub_token') || '') }, body: fd });
    const d = await r.json().catch(() => ({}));
    if (r.status === 401) throw new Error('Вход модератора истёк — войдите заново');
    if (!r.ok || !d.url) throw new Error(d.error || 'Не удалось загрузить фото');
    return d.url;
  };
  const mountPhotos = (media) => { photosState = mountEventPhotos(photosBox, { media, hidden: item?.photosHidden || [], added: item?.photosAdded || [], upload: uploadPhoto }); };
  if (!(isEdit && /^\d+$/.test(String(item.id)))) mountPhotos([]);

  // правка существующего турнира: поля — как на его странице (файл турнира с правками модератора), а не из строки
  // календаря; иначе «Сохранить» без изменений подменило бы на странице описание и афишу календарными
  if (isEdit && /^\d+$/.test(String(item.id))) {
    const touched = new Set();
    dialog.addEventListener('input', (e) => { if (e.target.id) touched.add(e.target.id); });
    fetch(`./data/events/${encodeURIComponent(item.id)}.json?v=18`).then((r) => (r.ok ? r.json() : null)).then((file) => {
      if (!file || !dialog.isConnected) return;
      const f = withModEdits(file, item);
      const put = (id, v) => { const el = dialog.querySelector('#' + id); if (el && v && !touched.has(id)) el.value = v; };
      put('mod-event-title', f.title); put('mod-event-period', f.period); put('mod-event-location', f.location);
      put('mod-event-poster', f.cover); put('mod-event-reg-url', f.regUrl); put('mod-event-desc', aboutPlainText(f.about));
      // документы — весь список страницы (файл + прежние правки), чтобы их можно было переименовать и убрать
      if (!docsTouched) { docsBox.innerHTML = ''; (f.documents || []).forEach(addDocRow); docsFull = true; }
      mountPhotos(file.media || []);
    }).catch(() => { photosBox.innerHTML = '<p class="mod-hint">Фото страницы не загрузились — добавить свои можно после повторного открытия.</p>'; });
  }
  const closeDialog = () => dialog.remove();
  dialog.querySelector('#btn-close-mod-event')?.addEventListener('click', closeDialog);
  dialog.querySelector('#btn-cancel-mod-event')?.addEventListener('click', closeDialog);
  dialog.addEventListener('click', (e) => { if (e.target === dialog) closeDialog(); });

  dialog.querySelector('#form-mod-event')?.addEventListener('input', () => dialog.querySelector('.mod-validation-summary')?.remove());
  dialog.querySelector('#form-mod-event')?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const invalid = [...form.querySelectorAll('input, textarea, select')].filter((field) => !field.checkValidity());
    if (invalid.length) {
      form.reportValidity();
      const names = invalid.map((field) => {
        const own = field.closest('label')?.querySelector('span, b')?.textContent;
        const before = field.previousElementSibling?.textContent;
        return (own || before || 'обязательное поле').replace(/\*|:/g, '').trim().toLowerCase();
      });
      let summary = dialog.querySelector('.mod-validation-summary');
      if (!summary) {
        summary = document.createElement('div');
        summary.className = 'mod-validation-summary';
        summary.setAttribute('role', 'alert');
        form.prepend(summary);
      }
      summary.textContent = `Не удалось сохранить. Заполните: ${[...new Set(names)].join(', ')}.`;
      invalid[0].focus({ preventScroll: true });
      invalid[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      showToast('Не сохранено: заполните выделенные поля');
      return;
    }
    const btn = dialog.querySelector('#btn-save-mod-event');
    if (btn) { btn.disabled = true; btn.textContent = 'Сохранение...'; }

    const title = dialog.querySelector('#mod-event-title').value.trim();
    const period = dialog.querySelector('#mod-event-period').value.trim();
    const year = Number(dialog.querySelector('#mod-event-year').value || new Date().getFullYear());
    const city = dialog.querySelector('#mod-event-city').value.trim();
    const region = dialog.querySelector('#mod-event-region').value;
    const location = dialog.querySelector('#mod-event-location').value.trim() || `${city}, спортивный комплекс`;
    const category = dialog.querySelector('#mod-event-category').value;
    const format = dialog.querySelector('#mod-event-format').value;
    const poster = dialog.querySelector('#mod-event-poster').value.trim();
    const regUrl = dialog.querySelector('#mod-event-reg-url').value.trim();
    const regClosed = dialog.querySelector('#mod-event-reg-closed').checked;
    const description = dialog.querySelector('#mod-event-desc').value.trim();
    const documents = docsFromRows(dialog.querySelectorAll('.mod-ev-doc'));

    const evData = {
      ...(item || {}),
      id: isEdit ? item.id : ('evt_' + Date.now()),
      title,
      period,
      year,
      city,
      region,
      location,
      category,
      format,
      poster,
      localPoster: poster || item?.localPoster || '',
      img: poster,
      regUrl,
      regClosed,
      description,
      documents,
      documentsFull: docsFull,                 // список документов — весь (а не добавка к документам турнира)
      ...(photosState ? photosState() : {}),   // photosHidden, photosAdded
      isMajor: item?.isMajor ?? category === 'Федеральные',   // при правке — как было; новый федеральный — крупный
      programs: item?.programs || ['allround']            // при правке программы турнира не трогаем
    };

    const res = await saveUnifiedEvent(evData).saved;
    if (res.ok) {
      closeDialog();
      renderEvents();
      // правили со страницы турнира — перерисовать её с правкой
      if (state.screen === 'event' && String(state.currentEventId) === String(evData.id)) { const y = window.scrollY; state.currentEventId = null; openEvent(evData.id, 'about', false, y); }
      showToast(`✓ «${title}» сохранено — уже на сайте`);
    } else {
      showToast(`Не сохранено: ${res.error}`);
      if (btn) { btn.disabled = false; btn.textContent = isEdit ? 'Сохранить изменения' : 'Создать соревнование'; }
    }
  });
}

export function openModRecordDialog(item = null) {
  const isEdit = Boolean(item && item.id);
  const existing = document.getElementById('mod-record-edit-modal');
  if (existing) existing.remove();

  const dialog = document.createElement('div');
  dialog.className = 'mod-edit-dialog';
  dialog.id = 'mod-record-edit-modal';

  dialog.innerHTML = `
    <div class="mod-edit-card" role="dialog" aria-modal="true">
      <div class="mod-edit-head">
        <h3>${isEdit ? 'Редактирование рекорда' : 'Добавить рекорд России'}</h3>
        <button type="button" class="mod-edit-close" id="btn-close-mod-rec">✕</button>
      </div>
      <form id="form-mod-record">
        <div class="mod-edit-field">
          <label>Дисциплина / Упражнение *</label>
          <input type="text" id="mod-rec-disc" value="${esc(item?.discipline || item?.ex || '')}" required placeholder="Например: Прыжок в длину с места">
        </div>
        <div class="mod-edit-field">
          <label>ФИО Атлета / Рекордсмена *</label>
          <input type="text" id="mod-rec-holder" value="${esc(item?.holder || item?.athlete || '')}" required placeholder="Например: Иванов Иван Иванович">
        </div>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
          <div class="mod-edit-field">
            <label>Результат (время или повторения) *</label>
            <input type="text" id="mod-rec-result" value="${esc(item?.result || item?.record || '')}" required placeholder="Например: 320 см / 01:12">
          </div>
          <div class="mod-edit-field">
            <label>Пол атлета</label>
            <select id="mod-rec-sex" style="width:100%;padding:10px 12px;background:#112236;border:1px solid rgba(255,255,255,0.12);border-radius:10px;color:#fff;">
              <option value="M" ${item?.sex === 'M' ? 'selected' : ''}>Мужчины</option>
              <option value="W" ${item?.sex === 'W' ? 'selected' : ''}>Женщины</option>
            </select>
          </div>
        </div>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
          <div class="mod-edit-field">
            <label>Возрастная категория</label>
            <input type="text" id="mod-rec-age" value="${esc(item?.ageGroup || item?.age || '18-29')}" placeholder="18-29, 30-39...">
          </div>
          <div class="mod-edit-field">
            <label>Город / Регион</label>
            <input type="text" id="mod-rec-city" value="${esc(item?.city || '')}" placeholder="Москва, Санкт-Петербург...">
          </div>
        </div>
        <div class="mod-edit-field">
          <label>Название турнира / Мероприятия</label>
          <input type="text" id="mod-rec-event" value="${esc(item?.event || item?.tournament || '')}" placeholder="Игры ГТО 2026...">
        </div>
        <div class="mod-edit-field">
          <label>Дата установления рекорда</label>
          <input type="text" id="mod-rec-date" value="${esc(item?.date || new Date().toISOString().slice(0, 10))}">
        </div>
        <div class="mod-edit-actions">
          <button type="button" class="mod-btn" id="btn-cancel-mod-rec">Отмена</button>
          <button type="submit" class="mod-btn" id="btn-save-mod-rec" style="background:#0284c7;color:#fff;border-color:#38bdf8;"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-save"/></svg> ${isEdit ? 'Сохранить изменения' : 'Внести рекорд'}</button>
        </div>
      </form>
    </div>
  `;

  document.body.appendChild(dialog);
  import('./mod_ui.js?v=9a7f86f1').then((m) => { m.enhanceModDialog(dialog);  }).catch(() => {});
  const closeDialog = () => dialog.remove();
  dialog.querySelector('#btn-close-mod-rec')?.addEventListener('click', closeDialog);
  dialog.querySelector('#btn-cancel-mod-rec')?.addEventListener('click', closeDialog);
  dialog.addEventListener('click', (e) => { if (e.target === dialog) closeDialog(); });

  dialog.querySelector('#form-mod-record')?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = dialog.querySelector('#btn-save-mod-rec');
    if (btn) { btn.disabled = true; btn.textContent = 'Сохранение...'; }

    const discipline = dialog.querySelector('#mod-rec-disc').value.trim();
    const holder = dialog.querySelector('#mod-rec-holder').value.trim();
    const result = dialog.querySelector('#mod-rec-result').value.trim();
    const sex = dialog.querySelector('#mod-rec-sex').value;
    const ageGroup = dialog.querySelector('#mod-rec-age').value.trim();
    const city = dialog.querySelector('#mod-rec-city').value.trim();
    const event = dialog.querySelector('#mod-rec-event').value.trim();
    const date = dialog.querySelector('#mod-rec-date').value.trim();

    const recData = {
      ...(item || {}),
      id: isEdit ? item.id : ('REC-RU-' + Date.now().toString().slice(-6)),
      discipline,
      ex: discipline,
      holder,
      athlete: holder,
      result,
      record: result,
      sex,
      gender: sex,
      ageGroup,
      age: ageGroup,
      city,
      event,
      tournament: event,
      date
    };

    const res = await addUnifiedRecord(recData).saved;
    if (res.ok) {
      closeDialog();
      renderRecords();
      showToast(`✓ Рекорд «${discipline}» (${holder}) сохранён — уже на сайте`);
    } else {
      showToast(`Не сохранено: ${res.error}`);
      if (btn) { btn.disabled = false; btn.textContent = 'Сохранить'; }
    }
  });
}

let newsFiltersInitialized = false;
export function setupNewsFilters() {
  const newsList = getUnifiedNews();
  const yearSelect = $('#news-year-filter');
  const regionSelect = $('#news-region-filter');
  const eventSelect = $('#news-event-filter');
  const typeSelect = $('#news-type-filter');

  if (yearSelect && (yearSelect.options.length <= 1 || !newsFiltersInitialized)) {
    const years = [...new Set(newsList.map(n => {
      if (n.publicationDate) return n.publicationDate.slice(0, 4);
      if (n.date) {
        const m = n.date.match(/\d{4}/);
        if (m) return m[0];
      }
      return null;
    }).filter(Boolean))].sort((a, b) => b - a);
    yearSelect.innerHTML = `<option value="all">Все годы</option>${years.map(y => `<option value="${y}">${y}</option>`).join('')}`;
    if (state.newsYear) yearSelect.value = state.newsYear;
  }

  if (regionSelect && (regionSelect.options.length <= 1 || !newsFiltersInitialized)) {
    const regionsMap = new Map();
    if (typeof GTO_REGIONS !== 'undefined' && Array.isArray(GTO_REGIONS)) {
      GTO_REGIONS.forEach(r => {
        regionsMap.set(String(r.id), r.name);
      });
    }
    newsList.forEach(n => {
      const rid = String(n.region_id || '');
      if (rid && rid !== '0' && rid !== '999' && !regionsMap.has(rid) && n.region_name) {
        regionsMap.set(rid, n.region_name);
      }
    });
    const sortedRegs = [...regionsMap.entries()].sort((a, b) => a[1].localeCompare(b[1], 'ru'));
    regionSelect.innerHTML = `<option value="all">Все регионы</option>${sortedRegs.map(([id, name]) => `<option value="${id}">${esc(name)}</option>`).join('')}`;
    if (state.newsRegion) regionSelect.value = state.newsRegion;
  }

  if (eventSelect && (eventSelect.options.length <= 1 || !newsFiltersInitialized)) {
    const eventIdsWithNews = new Set();
    newsList.forEach(n => {
      if (n.eventId) eventIdsWithNews.add(String(n.eventId));
    });
    const evOptions = [];
    eventIdsWithNews.forEach(evId => {
      const ev = GTO_CALENDAR_EVENTS.find(e => String(e.id) === String(evId));
      if (ev) {
        evOptions.push({ id: evId, title: ev.title, year: eventYear(ev) });
      }
    });
    evOptions.sort((a, b) => (b.year || 0) - (a.year || 0) || a.title.localeCompare(b.title, 'ru'));
    eventSelect.innerHTML = `<option value="all">Все турниры</option>${evOptions.map(o => `<option value="${o.id}">${esc(o.title)}</option>`).join('')}`;
    if (state.newsEvent) eventSelect.value = state.newsEvent;
  }

  if (typeSelect && state.newsType) {
    typeSelect.value = state.newsType;
  }

  if (!newsFiltersInitialized) {
    newsFiltersInitialized = true;
    yearSelect?.addEventListener('change', e => {
      state.newsDisplayLimit = 20;
      state.newsYear = e.target.value;
      renderNews();
    });
    regionSelect?.addEventListener('change', e => {
      state.newsDisplayLimit = 20;
      state.newsRegion = e.target.value;
      renderNews();
    });
    typeSelect?.addEventListener('change', e => {
      state.newsDisplayLimit = 20;
      state.newsType = e.target.value;
      renderNews();
    });
    eventSelect?.addEventListener('change', e => {
      state.newsDisplayLimit = 20;
      state.newsEvent = e.target.value;
      renderNews();
    });
    $('#news-reset-filters')?.addEventListener('click', () => {
      resetNewsFilters();
    });
  }
}

export function updateNewsActiveChips() {
  const bar = $('#news-active-bar');
  const container = $('#news-active-chips');
  if (!bar || !container) return;

  const chips = [];
  if (state.newsYear && state.newsYear !== 'all') {
    chips.push({ key: 'year', label: `Год: ${state.newsYear}` });
  }
  if (state.newsRegion && state.newsRegion !== 'all') {
    const reg = (typeof GTO_REGIONS !== 'undefined') ? GTO_REGIONS.find(r => String(r.id) === String(state.newsRegion)) : null;
    const rName = reg ? reg.name : `Регион #${state.newsRegion}`;
    chips.push({ key: 'region', label: `Регион: ${rName}` });
  }
  if (state.newsType && state.newsType !== 'all') {
    chips.push({ key: 'type', label: `Тип: ${formatNewsType(state.newsType)}` });
  }
  if (state.newsEvent && state.newsEvent !== 'all') {
    const ev = GTO_CALENDAR_EVENTS.find(e => String(e.id) === String(state.newsEvent));
    const evTitle = ev ? ev.title : `Турнир #${state.newsEvent}`;
    chips.push({ key: 'event', label: `Турнир: ${evTitle.slice(0, 25)}${evTitle.length > 25 ? '...' : ''}` });
  }
  if (state.newsQuery) {
    chips.push({ key: 'query', label: `Поиск: «${state.newsQuery}»` });
  }

  if (chips.length > 0) {
    bar.style.display = 'flex';
    container.innerHTML = chips.map(c => `
      <span class="active-chip" data-news-chip="${c.key}">
        <span>${esc(c.label)}</span>
        <span class="active-chip-remove" aria-label="Удалить фильтр">✕</span>
      </span>
    `).join('');
  } else {
    bar.style.display = 'none';
    container.innerHTML = '';
  }
}

export function resetNewsFilters() {
  state.newsYear = 'all';
  state.newsRegion = 'all';
  state.newsType = 'all';
  state.newsEvent = 'all';
  state.newsQuery = '';
  state.newsDisplayLimit = 20;
  const sInput = $('#news-search');
  if (sInput) sInput.value = '';
  const ySel = $('#news-year-filter');
  if (ySel) ySel.value = 'all';
  const rSel = $('#news-region-filter');
  if (rSel) rSel.value = 'all';
  const tSel = $('#news-type-filter');
  if (tSel) tSel.value = 'all';
  const eSel = $('#news-event-filter');
  if (eSel) eSel.value = 'all';
  renderNews();
}

function renderNews() {
  const q = (state.newsQuery || '').toLowerCase();
  const newsList = getUnifiedNews();
  const items = newsList.filter(x => {
    if (x.region_id === 999 || String(x.region_id) === '999') return false;
    if (x.status && x.status !== 'published') return false;
    if (state.newsYear && state.newsYear !== 'all') {
      const yr = x.publicationDate ? x.publicationDate.slice(0, 4) : (x.date ? x.date.match(/\d{4}/)?.[0] : null);
      if (String(yr) !== String(state.newsYear)) return false;
    }
    if (state.newsRegion && state.newsRegion !== 'all') {
      if (String(x.region_id) !== String(state.newsRegion) && x.region_name !== state.newsRegion) return false;
    }
    if (state.newsType && state.newsType !== 'all') {
      const ct = x.contentType || 'news';
      if (ct !== state.newsType) return false;
    }
    if (state.newsEvent && state.newsEvent !== 'all') {
      if (String(x.eventId) !== String(state.newsEvent)) return false;
    }
    if (q) {
      const haystack = `${x.title || ''} ${x.text || ''} ${x.date || ''}`.toLowerCase();
      if (!haystack.includes(q)) return false;
    }
    return true;
  });

  state.newsDisplayLimit = state.newsDisplayLimit || 20;
  const totalNews = items.length;
  const visibleNews = items.slice(0, state.newsDisplayLimit);

  const isMod = Boolean(localStorage.getItem('fmgto_hub_token'));
  const countEl = $('#news-count');
  if (countEl) {
    const modStatusHtml = isMod
      ? `<span style="display:inline-flex;align-items:center;gap:6px;margin-left:10px;"><b style="color:#38bdf8;font-size:11px;background:rgba(56,189,248,0.12);padding:2px 8px;border-radius:6px;border:1px solid rgba(56,189,248,0.3)"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-shield"/></svg> Модератор активен</b><button type="button" id="btn-mod-quick-logout" style="background:none;border:none;color:#94a3b8;font-size:11px;cursor:pointer;text-decoration:underline;">Выйти</button></span>`
      : '';
    countEl.innerHTML = `${totalNews} публикаций${totalNews > visibleNews.length ? ` (показано ${visibleNews.length})` : ''} ${modStatusHtml}`;
    countEl.querySelector('#btn-mod-quick-logout')?.addEventListener('click', () => {
      localStorage.removeItem('fmgto_hub_token');
      renderNews();
      alert('Вы вышли из режима модератора');
    });
  }

  updateNewsActiveChips();

  let loadMoreHtml = '';
  if (totalNews > visibleNews.length) {
    const remaining = totalNews - visibleNews.length;
    const chunk = Math.min(20, remaining);
    loadMoreHtml = `<button type="button" class="load-more" id="news-load-more">Показать ещё ${chunk} (осталось ${remaining})</button>`;
  }

  const modNewsBannerHtml = isMod ? `
    <div class="mod-action-banner" style="grid-column: 1 / -1; margin-bottom: 14px;">
      <div>
        <b style="color:#38bdf8;font-size:13px;display:block;">Управление публикациями и новостями</b>
        <span style="font-size:12px;color:#94a3b8;">Вы можете опубликовать новость на сайте или изменить статьи</span>
      </div>
      <button type="button" class="mod-top-btn" id="btn-mod-add-news-feed"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-plus"/></svg> Создать новость</button>
    </div>
  ` : '';

  const listEl = $('#news-list');
  if (listEl) {
    const newsContentHtml = visibleNews.length ? (visibleNews.map(x => `
      <button type="button" class="nwc" data-article="${x.id}">
        ${isMod ? `
          <div class="news-card-mod-bar" style="position:absolute;top:10px;right:10px;z-index:4;display:flex;gap:4px;">
            <span class="btn-card-mod-edit" data-article-id="${x.id}" title="Редактировать новость" style="display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:8px;background:rgba(14,165,233,0.9);color:#fff;font-size:12px;font-weight:700;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,0.4);border:1px solid rgba(255,255,255,0.2);"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-pencil"/></svg></span>
            <span class="btn-card-mod-delete" data-article-id="${x.id}" title="Снять с публикации" style="display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:8px;background:rgba(239,68,68,0.9);color:#fff;font-size:12px;font-weight:700;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,0.4);border:1px solid rgba(255,255,255,0.2);"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-trash-2"/></svg></span>
          </div>
        ` : ''}
        ${(() => {
          // как карточка «Стартов»: картинка с размытой подложкой, плашка даты, тип материала, «Читать →»
          const d0 = /^\d{4}-\d{2}-\d{2}/.test(x.publicationDate || '') ? new Date(x.publicationDate) : null;
          const bg = x.img && !/logo-clean/.test(x.img) ? rsUrl(x.img, 480) : '';
          return `<div class="nwc-media" ${bg ? `style="--evc-bg:url('${esc(bg)}')"` : ''}><img loading="lazy" ${rsImgAttrs(x.img, 640)} alt="" data-fb="logo">
            ${d0 && !isNaN(d0) ? `<span class="evc-date" aria-hidden="true"><b>${d0.getDate()}</b><small>${MONTHS_RU[d0.getMonth()].slice(0, 3).toLowerCase()}</small></span>` : ''}
            ${x.contentType && x.contentType !== 'news' ? `<span class="nwc-type">${esc(formatNewsType(x.contentType))}</span>` : ''}</div>
          <div class="nwc-body"><time>${esc(x.date)}</time><b>${esc(x.title)}</b>${x.text && x.text.trim() !== x.title.trim() ? `<p>${esc(x.text)}</p>` : ''}<span class="nwc-more">Читать <i>→</i></span></div>`;
        })()}
      </button>
    `).join('') + loadMoreHtml) : `
      <div class="empty" style="text-align:center;padding:32px 16px;">
        <p style="font-weight:600;font-size:15px;margin-bottom:8px;color:#fff;">Новостей по выбранным фильтрам не найдено</p>
        <p style="font-size:13px;color:#94a3b8;margin-bottom:16px;">Попробуйте выбрать другой год или сбросить фильтры</p>
        <button type="button" class="reset-filters-btn" id="news-empty-reset" style="margin:0 auto;display:inline-flex;padding:8px 16px;font-size:13px;">✕ Сбросить все фильтры</button>
      </div>
    `;
    listEl.innerHTML = modNewsBannerHtml + newsContentHtml;
  }
}


// книга рекордов: Россия (официальный реестр) или выбранный регион (regional_records.js?v=ea5f4281)
let regionalRecs = { id: '', items: [] };
// реестр хранит и прежних рекордсменов клетки (16.10.2026): в Книге — действующие (у них «прежний рекорд»), побитые — в карточке
// атлета с пометкой «побит» (records.json: current, beatenBy, previous; карточка атлета: current, beaten_by)
const isBeatenRecord = (r) => r && r.current === false;
const recordYear = (x) => String(x?.date || '').slice(0, 4);
const recordRefText = (x) => x ? `${x.result} — ${x.holder || ''}${recordYear(x) ? `, ${recordYear(x)}` : ''}` : '';
const recordSource = () => (state.recordRegion && regionalRecs.id === state.recordRegion ? regionalRecs.items : getUnifiedRecords().filter((r) => !isBeatenRecord(r)));
async function setupRecordRegions() {
  const sel = $('#record-region'); if (!sel || sel.dataset.ready) return;
  sel.dataset.ready = '1';
  const m = await regionalManifest();
  const opts = Object.entries(m.regions || {}).map(([id, n]) => ({ id, n, name: getRegionById(Number(id))?.name || '' })).filter((x) => x.name).sort((a, b) => a.name.localeCompare(b.name, 'ru'));
  sel.innerHTML = '<option value="">Россия — официальный реестр</option>' + opts.map((o) => `<option value="${o.id}">${esc(o.name)} · ${o.n}</option>`).join('');
  sel.value = state.recordRegion || '';
}
async function setRecordRegion(id) {
  state.recordRegion = id ? String(id) : '';
  if (state.recordRegion) regionalRecs = { id: state.recordRegion, items: await regionalRecords(state.recordRegion) };
  state.age = 'all'; state.discipline = 'all'; state.recordLimit = 30;
  const reg = state.recordRegion ? getRegionById(Number(state.recordRegion)) : null;
  const t = $('[data-screen="records"] .page-title');
  if (t) {
    t.querySelector('span').textContent = reg ? 'Лучшие результаты региона' : 'Официальный реестр';
    t.querySelector('h1').textContent = reg ? `Рекорды: ${reg.name}` : 'Рекорды России';
    t.querySelector('p').textContent = reg ? 'Лучший результат спортсменов региона в каждой дисциплине, по полу и возрасту: программа «Иду на рекорд» и реестр рекордов России.'
      : 'Фильтруйте реестр по полу, возрасту и дисциплине; выберите удобную группировку.';
  }
  const src = $('[data-screen="records"] .result-line small'); if (src) src.textContent = reg ? '«Иду на рекорд» + реестр рекордов России' : 'данные gto.com.ru';
  const sel = $('#record-region'); if (sel) sel.value = state.recordRegion;
  if (state.screen === 'records') { const h = '#records' + (state.recordRegion ? `?region=${state.recordRegion}` : ''); if (location.hash !== h) history.replaceState(history.state, '', h); }
  setupRecordFilters(); renderRecords();
}
// открытие экрана рекордов: регион из адреса (#records?region=27 — ссылкой можно поделиться)
function openRecordsScreen() {
  setupRecordRegions();
  const rq = new URLSearchParams(location.hash.split('?')[1] || '').get('region') || '';
  const want = /^\d{1,2}$/.test(rq) ? rq : '';
  if (want !== (state.recordRegion || '')) { setRecordRegion(want); return; }
  setupRecordFilters(); renderRecords(); mountRecordClaims();
}

// кнопка «Подать заявку на рекорд» в шапке экрана раскрывает форму прямо под собой. Раньше форма стояла под реестром
// (≈18 000 px на телефоне): плавная прокрутка через весь реестр вместе с клавиатурой Safari уводила в пустое место.
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-record-claim-go]');
  const box = btn && $('#record-claim');
  if (!box) return;
  const open = box.hidden;
  box.hidden = !open; btn.setAttribute('aria-expanded', String(open));
  if (!open) return;
  window.dispatchEvent(new CustomEvent('fmgto:account'));   // вошли в кабинет в другой вкладке — данные подтянутся
  box.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  box.querySelector('input[name=name]')?.focus({ preventScroll: true });
});
// «Иду на рекорд»: форма заявки под реестром и список поданных заявок для вошедших сотрудников (record_claim.js?v=8e9996d1)
function mountRecordClaims() {
  const list = $('#record-list');
  if (!list) return;
  let inbox = $('#record-claims-inbox'), box = $('#record-claim');
  if (!inbox) { inbox = document.createElement('section'); inbox.id = 'record-claims-inbox'; inbox.className = 'rci'; inbox.hidden = true; list.before(inbox); }
  if (!box) {   // форма — сразу под шапкой экрана, скрыта до нажатия «Подать заявку на рекорд»
    box = document.createElement('section'); box.id = 'record-claim'; box.className = 'record-claim'; box.hidden = true;
    const head = $('[data-screen="records"] .page-title');
    if (head) head.after(box); else list.after(box);
    $('[data-record-claim-go]')?.setAttribute('aria-controls', 'record-claim');
    $('[data-record-claim-go]')?.setAttribute('aria-expanded', 'false');
  }
  const disciplines = [...new Set(recordSource().map(x => clean(x.discipline || x.ex)).filter(Boolean))].sort((a, b) => a.localeCompare(b, 'ru'));
  const records = recordSource(), regions = GTO_REGIONS.map((r) => r.name).filter(Boolean).sort((a, b) => a.localeCompare(b, 'ru'));
  // сотруднику — календарь для «Открыть приём по соревнованию» (грузится, только если блок сотрудника показывается)
  const events = async () => (GTO_CALENDAR_EVENTS.length ? GTO_CALENDAR_EVENTS : await loadCalendar()).map((e) => ({ id: e.id, title: e.title, startDate: e.startDate, endDate: e.endDate }));
  import('./record_claim.js?v=8e9996d1').then((m) => { m.mountRecordClaim(box, { disciplines, regions, records }); m.mountClaimsInbox(inbox, { records, events, onAdd: (item) => openModRecordDialog(item) }); })
    .catch((err) => console.warn('record claim', err));
}

function setupRecordFilters() {
  const allRecs = recordSource();
  const ages = [...new Set(allRecs.map(x => clean(x.ageGroup || x.age)).filter(Boolean))].sort((a, b) => a.localeCompare(b, 'ru', { numeric: true }));
  const disciplines = [...new Set(allRecs.map(x => clean(x.discipline || x.ex)).filter(Boolean))].sort((a, b) => a.localeCompare(b, 'ru'));
  $('#record-age').innerHTML = '<option value="all">Все возрасты</option>' + ages.map(x => `<option value="${esc(x)}">${esc(x)}</option>`).join('');
  $('#record-discipline').innerHTML = '<option value="all">Все дисциплины</option>' + disciplines.map(x => `<option value="${esc(x)}">${esc(x)}</option>`).join('');
  $('#record-age').value = ages.includes(state.age) ? state.age : 'all'; $('#record-discipline').value = disciplines.includes(state.discipline) ? state.discipline : 'all';
}

const eventByTitleCache = new Map();
export function findEventByTitleOrRecord(eventTitle) {
  if (!eventTitle) return null;
  const t = String(eventTitle).toLowerCase().trim();
  if (eventByTitleCache.has(t)) return eventByTitleCache.get(t);
  let found = GTO_CALENDAR_EVENTS.find(e => e.title && e.title.toLowerCase().trim() === t);
  if (found) {
    eventByTitleCache.set(t, found);
    return found;
  }
  found = GTO_CALENDAR_EVENTS.find(e => e.title && (e.title.toLowerCase().includes(t) || t.includes(e.title.toLowerCase())));
  if (found) {
    eventByTitleCache.set(t, found);
    return found;
  }
  const words = t.replace(/[«»"'\-—–.,]/g, ' ').split(/\s+/).filter(w => w.length >= 4);
  if (words.length) {
    found = GTO_CALENDAR_EVENTS.find(e => {
      const et = (e.title || '').toLowerCase();
      return words.filter(w => et.includes(w)).length >= Math.min(2, words.length);
    });
  }
  const result = found || null;
  eventByTitleCache.set(t, result);
  return result;
}

export function renderUnifiedRecordCard(x, opts = {}) {
  if (!x) return '';
  const recId = x.id || (GTO_RECORDS.find(r => r.holder === x.holder && r.discipline === x.discipline)?.id) || '';
  const discipline = x.discipline || 'Многоборье ГТО';
  const result = x.result || x.record || '';
  const holder = x.holder || x.name || 'Рекордсмен';
  const city = x.city || opts.defaultCity || '';
  const event = x.event || x.tournament || '';
  const sex = x.sex || '';
  const sexLabel = sex === 'W' ? 'Женщины' : (sex === 'M' ? 'Мужчины' : '');
  const ageGroup = x.ageGroup || x.age_group || '';

  const metaParts = [sexLabel, ageGroup, city].filter(Boolean);
  const metaString = metaParts.join(' • ');
  const beatenBy = isBeatenRecord(x) ? (x.beatenBy || x.beaten_by || null) : null;

  let athleteId = x.athleteId || x.athlete_id || null;
  const athleteMatch = (state.athleteIndex || state.athleteLite)?.length ? findAthleteByName(holder) : null;
  if (!athleteId && athleteMatch) athleteId = athleteMatch.id;
  // лицо рекордсмена: фото из реестра рекордов (img) или из реестра спортсменов; оба пустые, если согласие на фото
  // отозвано (export_site_data.py); нет фото — инициалы
  const photo = x.img || x.photo_url || athleteMatch?.photo_url || '';
  const initials = holder.split(/\s+/).slice(0, 2).map((w) => w[0] || '').join('').toUpperCase();
  const avatar = `<span class="urc-ava" aria-hidden="true">${photo ? `<img loading="lazy" decoding="async" ${rsImgAttrs(photo, 48)} alt="" width="48" height="48">` : `<i>${esc(initials)}</i>`}</span>`;

  let eventId = x.eventId || x.event_id || null;
  if (!eventId && event) {
    const evMatch = findEventByTitleOrRecord(event);
    if (evMatch) eventId = evMatch.id;
  }

  const recJson = esc(JSON.stringify({
    type: 'record',
    id: recId,
    holder,
    discipline,
    result,
    sex,
    age: ageGroup,
    city,
    event
  }));

  const isMod = Boolean(localStorage.getItem('fmgto_hub_token'));
  return `
    <article class="record-card unified-record-card ${opts.hideDiscipline ? 'is-in-group' : ''}${isBeatenRecord(x) ? ' is-beaten' : ''}" data-record-id="${recId}" data-share-data="${recJson}">
      ${isMod ? `
        <div class="event-card-mod-bar" style="top:8px;right:8px;">
          <span class="btn-card-mod-edit-record" data-record-id="${recId}" title="Редактировать рекорд" style="display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:8px;background:rgba(14,165,233,0.9);color:#fff;font-size:12px;font-weight:700;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,0.4);border:1px solid rgba(255,255,255,0.2);"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-pencil"/></svg></span>
          <span class="btn-card-mod-del-record" data-record-id="${recId}" title="Удалить рекорд" style="display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:8px;background:rgba(239,68,68,0.9);color:#fff;font-size:12px;font-weight:700;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,0.4);border:1px solid rgba(255,255,255,0.2);"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-trash-2"/></svg></span>
        </div>
      ` : ''}
      <div class="urc-header">
        <div class="urc-disc-wrap">
          <span class="urc-icon" aria-hidden="true">${disciplineIcon(discipline)}</span>
          <span class="urc-discipline">${esc(discipline)}</span>
        </div>
        <span class="urc-head-arrow" aria-hidden="true">→</span>
      </div>

      <div class="urc-result-row">
        <strong class="urc-value">${esc(result)}</strong>
        <span class="urc-status-badge"><svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/><path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.45 1-1 1H7"/><path d="M14 14.66V17c0 .55.45 1 1 1h2"/><path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/></svg><span>${isBeatenRecord(x) ? 'Рекорд России · побит' : 'Рекорд России'}</span></span>
      </div>
      ${beatenBy ? `<div class="urc-beaten text-wrap-safe">Побит: ${esc(recordRefText(beatenBy))}</div>` : (x.previous ? `<div class="urc-beaten text-wrap-safe">Прежний рекорд: ${esc(recordRefText(x.previous))}</div>` : '')}

      <div class="urc-person">${avatar}<div class="urc-athlete-section">
        <button type="button" class="urc-athlete-btn rrc-athlete-btn" data-record-athlete="${esc(holder)}" ${athleteId ? `data-athlete-id="${athleteId}"` : ''} title="Открыть профиль спортсмена">
          <b class="urc-athlete-name">${esc(holder)}</b>
          <span class="urc-link-arrow" aria-hidden="true">↗</span>
        </button>
        ${metaString ? `<div class="urc-meta-line text-wrap-safe">${esc(metaString)}</div>` : ''}
      </div></div>

      ${event ? `
        <div class="urc-event-row">
          <button type="button" class="urc-event-btn rrc-event-btn" data-record-event="${esc(event)}" ${eventId ? `data-event-id="${eventId}"` : ''} title="Открыть турнир">
            <span class="urc-event-icon" aria-hidden="true"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-trophy"/></svg></span>
            <span class="urc-event-name">${esc(event)}</span>
            <span class="urc-link-arrow" aria-hidden="true">↗</span>
          </button>
        </div>
      ` : ''}

      <div class="urc-footer">
        <button type="button" class="urc-share-btn" data-share-record="${recId}" aria-label="Поделиться рекордом: ${esc(holder)}">
          <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
          <span>Поделиться</span>
        </button>
        <button type="button" class="urc-more-link" data-record-id="${recId}" aria-label="Подробнее: ${esc(discipline)} — ${esc(holder)}">Подробнее <span class="urc-arrow" aria-hidden="true">→</span></button>
      </div>
    </article>
  `;
}

export function renderRecordDetailScreen(rec) {
  const container = $('#record-detail-container');
  if (!container || !rec) return;

  const holder = rec.holder || 'Рекордсмен';
  const discipline = rec.discipline || 'Многоборье ГТО';
  const result = rec.result || rec.record || '';
  const city = rec.city || 'Россия';
  const event = rec.event || 'Официальный старт Федерации';
  const ageGroup = rec.ageGroup || rec.age_group || 'Без ограничений';
  const sex = rec.sex === 'W' ? 'Женщины' : (rec.sex === 'M' ? 'Мужчины' : 'Не указан');

  let athleteMatch = null;
  if (state.athleteIndex || state.athleteLite) {
    athleteMatch = findAthleteByName(holder);
  }

  let eventMatch = findEventByTitleOrRecord(event);
  const regId = normalizeRegionName(`${city} ${event}`);
  const regionMatch = regId ? getRegionById(regId) : null;

  const allRecs = getUnifiedRecords();
  const relatedRecords = allRecs.filter(r => (r.discipline === rec.discipline || r.ex === rec.discipline) && String(r.id) !== String(rec.id) && !isBeatenRecord(r)).slice(0, 3);

  const isMod = Boolean(localStorage.getItem('fmgto_hub_token'));
  const modRecordToolbarHtml = isMod ? `
    <div class="moderator-toolbar" id="mod-rec-toolbar" style="margin-bottom:14px;">
      <div class="mod-info">
        <span class="mod-tag"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-shield"/></svg> Модератор</span>
        <span class="mod-meta">Управление рекордом России</span>
      </div>
      <div class="mod-actions">
        <button type="button" class="mod-btn" id="btn-mod-edit-record-detail" data-record-id="${rec.id}"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-pencil"/></svg> Редактировать</button>
        <button type="button" class="mod-btn danger" id="btn-mod-del-record-detail" data-record-id="${rec.id}"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-trash-2"/></svg> Удалить рекорд</button>
      </div>
    </div>
  ` : '';

  container.innerHTML = `
    ${modRecordToolbarHtml}
    <div class="record-detail-hero-card">
      <div class="rd-status-pill">
        <span><svg class="ic ic-gold" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg> ${isBeatenRecord(rec) ? 'Рекорд России · побит' : 'Официальный рекорд России'}</span>
      </div>
      ${isBeatenRecord(rec) && rec.beatenBy ? `<p class="rd-beaten">Побит: ${esc(recordRefText(rec.beatenBy))}</p>` : rec.previous ? `<p class="rd-beaten">Прежний рекорд: ${esc(recordRefText(rec.previous))}</p>` : ''}
      ${holderAvaHtml({ holder, img: rec.img || rec.photo_url || athleteMatch?.photo_url }, 'rd-ava', 112)}
      <div class="rd-val">${esc(result)}</div>
      <h1 class="rd-disc">${esc(discipline)}</h1>
      <div class="rd-actions-row">
        <button type="button" class="rd-action-btn" data-record-athlete="${esc(holder)}" ${athleteMatch ? `data-athlete-id="${athleteMatch.id}"` : ''}>
          <span>Профиль спортсмена: <b>${esc(holder)}</b></span>
          <span>→</span>
        </button>
        ${eventMatch ? `
          <button type="button" class="rd-action-btn secondary" data-record-event="${esc(event)}" data-event-id="${eventMatch.id}">
            <span>Турнир: <b>${esc(eventMatch.title)}</b></span>
            <span>→</span>
          </button>
        ` : (event ? `
          <button type="button" class="rd-action-btn secondary" data-record-event="${esc(event)}">
            <span>Турнир: <b>${esc(event)}</b></span>
            <span>→</span>
          </button>
        ` : '')}
      </div>
    </div>

    <div class="detail-section">
      <h2>Параметры и регистрация рекорда</h2>
      <div class="record-detail-grid">
        <div class="rd-card-item">
          <span class="rd-label">Спортсмен</span>
          <span class="rd-text">${esc(holder)}</span>
        </div>
        <div class="rd-card-item">
          <span class="rd-label">Результат</span>
          <span class="rd-text" style="color:#f59e0b;font-weight:700;">${esc(result)}</span>
        </div>
        <div class="rd-card-item">
          <span class="rd-label">Пол</span>
          <span class="rd-text">${esc(sex)}</span>
        </div>
        <div class="rd-card-item">
          <span class="rd-label">Возрастная категория</span>
          <span class="rd-text">${esc(ageGroup)}</span>
        </div>
        <div class="rd-card-item">
          <span class="rd-label">Регион / Город</span>
          <span class="rd-text">${esc(city)}</span>
        </div>
        <div class="rd-card-item">
          <span class="rd-label">Место проведения</span>
          <span class="rd-text">${esc(eventMatch?.city || city || 'Россия')}</span>
        </div>
        <div class="rd-card-item" style="grid-column: 1 / -1;">
          <span class="rd-label">Официальный турнир</span>
          <span class="rd-text">${esc(event)}</span>
        </div>
        <div class="rd-card-item" style="grid-column: 1 / -1;">
          <span class="rd-label">Статус</span>
          <span class="rd-text" style="color:#31c987;">Действующий рекорд России · Утверждён судейской коллегией Федерации многоборья ГТО</span>
        </div>
      </div>
    </div>

    ${regionMatch ? `
      <div class="detail-section">
        <h2>Регион рекорда</h2>
        <p>Рекорд установлен атлетом, представляющим <b>${esc(regionMatch.name)}</b>.</p>
        <button class="primary-action" data-open-region="${regionMatch.id}" style="height:44px;font-size:13px;margin-top:10px;">
          <span>Открыть карту и рекорды региона</span>
          <span>→</span>
        </button>
      </div>
    ` : ''}

    ${relatedRecords.length ? `
      <div class="region-section-block" style="margin-top:10px;">
        <div class="region-section-head">
          <h3>Другие рекорды в этой дисциплине (${relatedRecords.length})</h3>
        </div>
        <div class="region-records-grid">
          ${relatedRecords.map(r => renderUnifiedRecordCard(r)).join('')}
        </div>
      </div>
    ` : ''}
  `;
}

export async function openRecordDetail(id, push = true, restoreScrollY = null) {
  const allRecs = getUnifiedRecords();
  const idStr = String(id);
  const rec = allRecs.find(r => String(r.id) === idStr) || allRecs[0];
  if (!rec) return;

  state.selectedRecordId = rec.id;
  state.selectedRecord = rec;

  if (state.screen !== 'record') {
    state.recordReturnScreen = state.screen;
  }

  if (push) {
    pushRoute({ screen: 'record', params: { id: rec.id } });
    resetScrollToTop();
  }

  go('record', false, push ? null : restoreScrollY);
  renderRecordDetailScreen(rec);

  const hashTarget = `#record/${rec.id}`;
  if (push && location.hash !== hashTarget) {
    history.pushState({ screen: 'record', id: rec.id }, '', hashTarget);
  } else if (location.hash !== hashTarget) {
    history.replaceState({ screen: 'record', id: rec.id }, '', hashTarget);
  }

  if (push) {
    resetScrollToTop();
  } else {
    const y = (typeof restoreScrollY === 'number') ? restoreScrollY : scrollStore.get(`record/${rec.id}`);
    if (typeof y === 'number') {
      restoreScrollPosition(y);
    } else {
      resetScrollToTop();
    }
  }

  const backBtn = $('#record-detail-back');
  if (backBtn) {
    const ret = state.recordReturnScreen || 'records';
    if (ret === 'region' && state.currentRegionId) backBtn.textContent = '← Назад в регион';
    else if (ret === 'athlete' && state.selectedAthleteId) backBtn.textContent = '← В профиль спортсмена';
    else if (ret === 'event' && state.athleteReturnEventId) backBtn.textContent = '← Назад к турниру';
    else backBtn.textContent = '← Все рекорды России';
  }
}

const recordCard = x => renderUnifiedRecordCard(x);

// ── Таблица рекордов по дисциплине (как таблицы рекордов в лёгкой атлетике) ──
const normAge = (a) => String(a || '').replace(/\s*лет\s*$/i, '').replace(/\s+/g, '').replace(/^\+$/, '').replace('-', '–');
const ageOrder = (a) => { const m = String(a).match(/\d+/); return m ? Number(m[0]) : 999; };
// лицо рекордсмена в таблице и на странице рекорда: фото из реестра (img — пусто, если согласие на фото отозвано) или инициалы
const holderInitials = (n) => String(n || '').split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join('').toUpperCase();
const holderAvaHtml = (r, cls, size) => {
  const photo = r.img || r.photo_url || '';
  return `<span class="${cls}" aria-hidden="true">${photo ? `<img loading="lazy" decoding="async" ${rsImgAttrs(photo, size)} alt="" width="${size}" height="${size}">` : `<i>${esc(holderInitials(r.holder))}</i>`}</span>`;
};
// карточка рекорда в сетке «один пол»: фото и ФИО — в профиль, результат и карточка — на страницу рекорда
function gridCard(r, age) {
  const yr = String(r.date || r.event || '').match(/20\d{2}/)?.[0] || '';
  const who = `data-record-athlete="${esc(r.holder || '')}" ${r.athlete_id ? `data-athlete-id="${esc(r.athlete_id)}"` : ''}`;
  const photo = r.img || r.photo_url || '';
  const pic = photo ? `<img loading="lazy" decoding="async" ${rsImgAttrs(photo, 200)} alt="" width="200" height="250">` : `<i>${esc(holderInitials(r.holder))}</i>`;
  return `<article class="rb-rec rbg-card${photo ? '' : ' no-photo'}" data-record-id="${esc(r.id)}">
    <button type="button" class="rb-photo" ${who} aria-label="${esc(`Профиль: ${r.holder || 'рекордсмен'}`)}">${pic}</button>
    <div class="rb-info">
      <span class="rbg-age">${esc(age ? `${age} лет` : '')}</span>
      <button type="button" class="rb-who" ${who} title="${esc(r.holder || '')}">${esc(r.holder || '')}</button>
      ${r.event ? `<small class="rb-ev">${esc(r.event)}</small>` : ''}
      <small>${esc([r.city, yr].filter(Boolean).join(' · '))}</small>
      ${r.previous ? `<small class="rb-prev" title="Прежний рекорд">прежний: ${esc(recordRefText(r.previous))}</small>` : ''}
      <button type="button" class="rb-val" data-record-id="${esc(r.id)}" aria-label="${esc(`${r.discipline}: ${r.result}, ${r.holder}`)}">${esc(r.result)}${r.russia ? '<i class="rb-ru" title="Это и рекорд России">РФ</i>' : ''}</button>
    </div></article>`;
}
function recordBoardsHtml(items) {
  const byDisc = new Map();
  items.forEach(x => { const d = clean(x.discipline || x.ex) || 'Без дисциплины'; if (!byDisc.has(d)) byDisc.set(d, []); byDisc.get(d).push(x); });
  const discs = [...byDisc.keys()].sort((a, b) => a.localeCompare(b, 'ru'));
  const showM = state.sex !== 'W', showW = state.sex !== 'M';
  const slug = (d) => 'rb-' + d.toLowerCase().replace(/[^a-zа-яё0-9]+/gi, '-').replace(/^-|-$/g, '').slice(0, 60);
  const nav = discs.length > 1 ? `<nav class="rb-nav" aria-label="Дисциплины">${discs.map(d => `<button type="button" data-rb-jump="${slug(d)}">${esc(d.replace(/\s*\(.*?\)\s*/g, ' ').trim())}<small>${byDisc.get(d).length}</small></button>`).join('')}</nav>` : '';
  return nav + discs.map(d => {
    const recs = byDisc.get(d);
    const ages = [...new Set(recs.map(r => normAge(r.ageGroup || r.age)))].sort((a, b) => ageOrder(a) - ageOrder(b));
    const at = (age, sx) => recs.filter(r => normAge(r.ageGroup || r.age) === age && ((r.sex || r.gender || 'M').toUpperCase() === sx));
    // сетка карточек по возрасту, как Книга рекордов старого сайта (14.10.2026): крупное фото, возраст, ФИО, турнир, город и
    // результат; оба пола — «Женщины», затем «Мужчины» (как «женщины / мужчины» старого сайта; таблица с колонкой возраста убрана)
    const sexes = [showW && 'W', showM && 'M'].filter(Boolean);
    const block = (sx) => {
      const cards = ages.flatMap((age) => at(age, sx).map((r) => gridCard(r, age)));
      if (!cards.length) return '';
      const head = sexes.length > 1 ? `<h3 class="rbg-sex is-${sx.toLowerCase()}">${sx === 'W' ? 'Женщины' : 'Мужчины'}<small>${cards.length}</small></h3>` : '';
      return `${head}<div class="rb-cards">${cards.join('')}</div>`;
    };
    return `<section class="rb rb-grid" id="${slug(d)}">
      <header class="rb-head"><span class="rb-icon" aria-hidden="true">${disciplineIcon(d)}</span><h2>${esc(d)}</h2><span class="rb-count">${recs.length} ${ruPlural(recs.length, 'рекорд', 'рекорда', 'рекордов')}</span></header>
      ${sexes.map(block).join('')}
    </section>`;
  }).join('');
}

// порядок рекордов на странице: дисциплины — в порядке реестра, внутри — по возрасту (6–7, 8–9, … 71+), мужчины перед
// женщинами; при группировке «по возрасту» сначала возраст. Раньше карточки шли как лежали в данных — вперемешку
const recordAgeFrom = (x) => { const m = String(x.ageGroup || x.age || '').match(/\d+/); return m ? Number(m[0]) : 999; };
const recordSexRank = (x) => (['W', 'F', 'Ж'].includes(String(x.sex || x.gender || 'M').toUpperCase()) ? 1 : 0);
function sortRecordsForPage(list, ageFirst) {
  const order = new Map();
  list.forEach((x) => { const d = clean(x.discipline || x.ex); if (!order.has(d)) order.set(d, order.size); });
  const disc = (x) => order.get(clean(x.discipline || x.ex));
  return [...list].sort((a, b) => (ageFirst
    ? recordAgeFrom(a) - recordAgeFrom(b) || disc(a) - disc(b)
    : disc(a) - disc(b) || recordAgeFrom(a) - recordAgeFrom(b)) || recordSexRank(a) - recordSexRank(b));
}

function renderRecords() {
  const isMod = Boolean(localStorage.getItem('fmgto_hub_token')) && !state.recordRegion;   // рекорды регионов считаются из протоколов — править нечего
  const q = state.recordQuery.toLowerCase();
  const allRecords = recordSource();
  const items = sortRecordsForPage(allRecords.filter(x => {
    const s = (x.sex || x.gender || 'M').toUpperCase();
    const ag = (x.ageGroup || x.age || '18-29');
    const disc = (x.discipline || x.ex || '');
    const holder = (x.holder || x.athlete || '');
    const city = (x.city || x.tournament || '');
    return (state.sex === 'ALL' || s === state.sex) &&
      (state.age === 'all' || clean(ag) === state.age) &&
      (state.discipline === 'all' || clean(disc) === state.discipline) &&
      `${holder} ${disc} ${city} ${ag}`.toLowerCase().includes(q);
  }), state.group === 'age');

  const countEl = $('#record-count');
  if (countEl) {
    const modCountTag = isMod
      ? `<span style="display:inline-flex;align-items:center;gap:6px;margin-left:10px;"><b style="color:#38bdf8;font-size:11px;background:rgba(56,189,248,0.12);padding:2px 8px;border-radius:6px;border:1px solid rgba(56,189,248,0.3)"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-shield"/></svg> Модератор</b></span>`
      : '';
    countEl.innerHTML = `${items.length} записей ${modCountTag}`;
  }

  const modBannerHtml = isMod ? `
    <div class="mod-action-banner" style="grid-column: 1 / -1; margin-bottom: 14px;">
      <div>
        <b style="color:#38bdf8;font-size:13px;display:block;">Управление рекордами России</b>
        <span style="font-size:12px;color:#94a3b8;">Вы можете добавить новый рекорд или изменить существующие</span>
      </div>
      <button type="button" class="mod-top-btn" id="btn-mod-add-record-feed"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-plus"/></svg> Добавить рекорд</button>
    </div>
  ` : '';

  if (!items.length) {
    $('#record-list').innerHTML = modBannerHtml + '<div class="empty">Записей не найдено.</div>';
    return;
  }

  const limit = state.recordLimit || 30;
  const visibleItems = items.slice(0, limit);
  const remaining = items.length - visibleItems.length;

  let loadMoreHtml = '';
  if (remaining > 0) {
    loadMoreHtml = `
      <div style="text-align: center; margin: 24px 0 16px; grid-column: 1 / -1; width: 100%;">
        <button class="load-more" id="records-load-more" type="button" style="max-width: 420px; margin: 0 auto; height: 48px; font-size: 13px;">
          Показать ещё рекорды · осталось ${remaining}
        </button>
      </div>
    `;
  }

  if (state.group === 'none') {
    $('#record-list').innerHTML = modBannerHtml + visibleItems.map(recordCard).join('') + loadMoreHtml;
    return;
  }

  // по дисциплине — таблица рекордов: строки возраст, колонки мужчины/женщины (модераторам — карточки с кнопками правки)
  if (state.group === 'discipline' && !isMod) {
    const holders = new Set(items.map(x => x.holder).filter(Boolean)).size;
    if (countEl) countEl.innerHTML = `${items.length} ${ruPlural(items.length, 'рекорд', 'рекорда', 'рекордов')} · ${(() => { const n = new Set(items.map(x => clean(x.discipline || x.ex))).size; return `${n} ${ruPlural(n, 'дисциплина', 'дисциплины', 'дисциплин')}`; })()} · ${holders} ${ruPlural(holders, 'рекордсмен', 'рекордсмена', 'рекордсменов')}`;
    $('#record-list').innerHTML = recordBoardsHtml(items);
    return;
  }

  const key = x => state.group === 'discipline' ? clean(x.discipline || x.ex) || 'Без дисциплины' : state.group === 'age' ? clean(x.ageGroup || x.age) || 'Возраст не указан' : (x.sex || x.gender) === 'W' ? 'Женщины' : 'Мужчины';
  
  const totalInGroups = new Map();
  items.forEach(x => {
    const name = key(x);
    totalInGroups.set(name, (totalInGroups.get(name) || 0) + 1);
  });

  const groups = new Map();
  visibleItems.forEach(x => {
    const name = key(x);
    if (!groups.has(name)) groups.set(name, []);
    groups.get(name).push(x);
  });

  const groupsHtml = [...groups].map(([name, values]) => {
    const total = totalInGroups.get(name) || values.length;
    const countBadge = values.length < total ? `${values.length} из ${total}` : `${total}`;
    // в группе по дисциплине название дисциплины уже в заголовке — в карточках его не повторяем
    const card = state.group === 'discipline' ? (x) => renderUnifiedRecordCard(x, { hideDiscipline: true }) : recordCard;
    return `<h2 class="record-group-title">${esc(name)} <span class="record-group-count">${countBadge}</span></h2>${values.map(card).join('')}`;
  }).join('');

  $('#record-list').innerHTML = modBannerHtml + groupsHtml + loadMoreHtml;
}

const vkImg = (src, alt = '', cls = '') => `<img class="${cls}" loading="lazy" referrerpolicy="no-referrer" src="${safeImage(src)}" alt="${esc(alt)}" data-fb="logo">`;
const VIDEO_PLATFORMS = [['all', 'Все'], ['rutube', 'Rutube'], ['vk', 'VK']];

function renderMedia() {
  state.media === 'video' ? renderVideoTab() : renderPhotoTab();
}

function mediaControls(items, type) {
  const years = [...new Set(items.map(x => mediaMeta(x, type).year).filter(Boolean))].sort((a, b) => b - a);
  const totalCount = items.length;

  const yearChips = `
    <div class="chips media-year-chips fchips" id="media-year-chips" aria-label="Фильтр по годам">
      <button class="${state.mediaYear === 'all' ? 'active' : ''}" data-media-year="all">Все годы <i>${totalCount}</i></button>
      ${years.map(y => {
        const count = items.filter(x => String(mediaMeta(x, type).year) === String(y)).length;
        return `<button class="${String(y) === String(state.mediaYear) ? 'active' : ''}" data-media-year="${y}">${y} <i>${count}</i></button>`;
      }).join('')}
    </div>
  `;

  return `
    <div class="media-toolbar">
      <label class="search media-search">
        <span><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-4.2-4.2"/></svg></span>
        <input id="media-search" type="search" value="${esc(state.mediaQuery)}" placeholder="${type === 'video' ? 'Поиск по видео, турниру или году' : 'Поиск по фотоальбомам, турниру или году'}">
      </label>
      ${yearChips}
    </div>
  `;
}

function mediaFiltered(items, type) {
  const q = (state.mediaQuery || '').trim().toLowerCase();
  return items.filter(x => {
    const m = mediaMeta(x, type);
    if (state.mediaYear !== 'all' && String(m.year) !== String(state.mediaYear)) return false;
    if (!q) return true;
    const haystack = `${x.title || ''} ${m.event?.title || ''} ${m.year || ''} ${m.year ? m.year + ' год' : ''} ${x.badge || ''} ${x.categoryLabel || ''}`.toLowerCase();
    return haystack.includes(q);
  });
}

function renderVideoTab() {
  const linkFilterEl = $('#media-link-filter');
  if (linkFilterEl) {
    linkFilterEl.style.display = 'flex';
    $$('#media-link-filter button').forEach(b => {
      b.classList.toggle('active', (b.dataset.mediaLink || 'all') === (state.mediaLinkFilter || 'all'));
    });
  }

  const platform = state.videoPlatform === 'all' ? SORTED_GTO_VIDEOS : SORTED_GTO_VIDEOS.filter(v => v.platform === state.videoPlatform);
  let videos = mediaFiltered(platform, 'video');
  if (state.mediaLinkFilter === 'linked') {
    videos = videos.filter(v => Boolean(mediaMeta(v, 'video').event));
  }
  const current = videos[0];
  const baseForCounts = state.mediaYear === 'all' ? SORTED_GTO_VIDEOS : SORTED_GTO_VIDEOS.filter(v => String(mediaMeta(v, 'video').year) === String(state.mediaYear));
  const chips = VIDEO_PLATFORMS.map(([k, label]) => {
    const n = k === 'all' ? baseForCounts.length : baseForCounts.filter(v => v.platform === k).length;
    return `<button class="${state.videoPlatform === k ? 'active' : ''}" data-vplat="${k}">${label} <i>${n}</i></button>`;
  }).join('');
  const limit = state.videoLimit || 24;
  const shownVideos = videos.slice(0, limit);
  const restCount = videos.length - shownVideos.length;

  const playerHtml = state.activeMediaVideo ? `
    <div id="media-video-player-slot" class="video-feature-slot">
      <iframe id="video-player" class="video-feature" src="${safeUrl(state.activeMediaVideo)}" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Видео"></iframe>
    </div>
  ` : current ? `
    <div id="media-video-player-slot" class="video-feature-slot">
      <div class="video-feature-poster" data-video="${safeUrl(current.embedUrl)}" role="button" tabindex="0" aria-label="Смотреть видео: ${esc(current.title)}">
        <img src="${safeImage(state.videoThumbs[current.embedUrl] || current.thumb)}" alt="" loading="eager" data-fb="logo">
        <div class="video-feature-overlay">
          <span class="video-feature-play" aria-hidden="true"><svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true"><path d="M8 5.14v13.72a1 1 0 0 0 1.5.86l11-6.86a1 1 0 0 0 0-1.72l-11-6.86A1 1 0 0 0 8 5.14z"/></svg></span>
          <div class="video-feature-copy">
            <span class="video-feature-badge">${esc((current.platform || 'video').toUpperCase())}</span>
            <b>${esc(current.title)}</b>
            <small>Нажмите для воспроизведения видео</small>
          </div>
        </div>
      </div>
    </div>
  ` : '';

  const groups = mediaGroups(shownVideos, 'video');
  const contentHtml = videos.length === 0 ? `
    <div class="empty" style="padding: 36px 16px; text-align: center; color: var(--muted); border: 1px dashed rgba(255,255,255,0.12); border-radius: 20px; background: rgba(12,24,40,0.4); margin-top: 12px;">
      <p style="font-size: 15px; font-weight: 700; color: #fff; margin-bottom: 6px;">Видео не найдены</p>
      <p style="font-size: 13px; margin-bottom: 16px; color: #94a3b8;">Попробуйте выбрать другой год или сбросить фильтры</p>
      <button class="gto-btn-outline" data-media-reset style="padding: 9px 20px; border-radius: 12px; border: 1px solid rgba(255,255,255,0.22); background: rgba(255,255,255,0.07); color: #fff; font-size: 13px; font-weight: 700; cursor: pointer;">Сбросить фильтры</button>
    </div>
  ` : `
    ${playerHtml}
    ${isModMode() ? `<div class="mod-inline-bar"><span><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-shield"/></svg> Открытое видео</span><div class="mod-inline-tools"><button type="button" data-mod-video-edit>✎ Изменить</button><button type="button" class="danger" data-mod-video-hide>Скрыть</button><button type="button" class="mod-inline-add" data-mod-video-add>＋ Добавить видео</button></div></div>` : ''}
    <div class="media-tournament-list">
      ${groups.map(group => `<section class="media-tournament-group ${group.event ? '' : 'unlinked'}">
        <div class="media-group-head"><span><small>${group.event ? esc(eventYear(group.event) || '') : 'Официальный медиацентр'}</small><b>${esc(group.event?.title || 'Другие видео Федерации')}</b></span>${group.event ? `<button data-event="${group.event.id}" data-event-pane="event-videos">К видео турнира →</button>` : ''}<i>${group.items.length}</i></div>
        <div class="media-list">${group.items.map((x) => {
        const m = mediaMeta(x, 'video');
        const isCurrent = state.activeMediaVideo ? x.embedUrl === state.activeMediaVideo : x === current;
        return `
          <button class="media-card ${isCurrent ? 'playing' : ''}" data-video="${safeUrl(x.embedUrl)}">
            <div class="media-thumb-wrap">
              ${vkImg(state.videoThumbs[x.embedUrl] || x.thumb, x.title)}
              <span class="media-play-icon"><svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" stroke="none" aria-hidden="true"><polygon points="6 3 20 12 6 21 6 3"/></svg></span>
            </div>
            <span>
              <b>${esc(x.title)}</b>
              <small>${esc((x.platform || 'video').toUpperCase())}${m.year ? ' · ' + m.year : ''}${m.event ? ' · ' + esc(m.event.title) : ''}</small>
            </span>
          </button>
        `;
        }).join('')}</div>
      </section>`).join('')}
    </div>
    ${restCount > 0 ? `<button class="load-more" id="media-video-more">Показать ещё видео · осталось ${restCount}</button>` : ''}
  `;

  $('#media-content').innerHTML = `
    ${mediaControls(SORTED_GTO_VIDEOS, 'video')}
    <div class="chips media-filter fchips" id="video-filter" aria-label="Платформа">${chips}</div>
    ${contentHtml}
  `;
  bindMediaControls();
}

function mediaGroups(items, type) {
  const groups = new Map();
  items.forEach(item => {
    const meta = mediaMeta(item, type);
    const key = meta.event ? String(meta.event.id) : 'other';
    if (!groups.has(key)) groups.set(key, { event: meta.event, items: [] });
    groups.get(key).items.push(item);
  });
  if (type === 'album') {
    groups.forEach(group => group.items.sort((a, b) => Number(b.id) - Number(a.id)));
  }
  return [...groups.values()].sort((a, b) => {
    if (!a.event) return 1;
    if (!b.event) return -1;
    return eventYear(b.event) - eventYear(a.event) || Number(b.event.id) - Number(a.event.id);
  });
}

function localAlbum(album) {
  const local = state.vkLocal.albums[String(album.id)] || {};
  const photos = local.photos?.length ? local.photos : (album.photos || []);
  return {
    ...local,
    photos,
    cover: local.cover || album.cover || photos[0]?.thumb || photos[0]?.src || ''
  };
}

function bindMediaControls() {
  $('#media-search')?.addEventListener('input', e => { state.mediaQuery = e.target.value.trim(); renderMedia(); });
  $('#media-year')?.addEventListener('change', e => { state.mediaYear = e.target.value; renderMedia(); });
  $('#media-platform')?.addEventListener('change', e => { state.videoPlatform = e.target.value; renderMedia(); });
  $('#media-video-more')?.addEventListener('click', () => {
    state.videoLimit = (state.videoLimit || 24) + 24;
    renderVideoTab();
  });
  $('#media-album-more')?.addEventListener('click', () => {
    state.albumLimit = (state.albumLimit || 24) + 24;
    renderPhotoTab();
  });
}

async function renderPhotoTab() {
  const linkFilterEl = $('#media-link-filter');
  if (linkFilterEl) linkFilterEl.style.display = 'none';
  await getVkAlbums();
  const albums = mediaFiltered(GTO_VK_ALBUMS, 'album');
  const limit = state.albumLimit || 24;
  const shownAlbums = albums.slice(0, limit);
  const restCount = albums.length - shownAlbums.length;
  const groups = mediaGroups(shownAlbums, 'album');

  const contentHtml = albums.length === 0 ? `
    <div class="empty" style="padding: 36px 16px; text-align: center; color: var(--muted); border: 1px dashed rgba(255,255,255,0.12); border-radius: 20px; background: rgba(12,24,40,0.4); margin-top: 12px;">
      <p style="font-size: 15px; font-weight: 700; color: #fff; margin-bottom: 6px;">Фотоальбомы не найдены</p>
      <p style="font-size: 13px; margin-bottom: 16px; color: #94a3b8;">Попробуйте выбрать другой год или сбросить фильтры</p>
      <button class="gto-btn-outline" data-media-reset style="padding: 9px 20px; border-radius: 12px; border: 1px solid rgba(255,255,255,0.22); background: rgba(255,255,255,0.07); color: #fff; font-size: 13px; font-weight: 700; cursor: pointer;">Сбросить фильтры</button>
    </div>
  ` : `
    <div class="trust-note" style="margin-top: 4px; margin-bottom: 16px;">
      <span><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg></span>
      <p><b>${albums.length} официальных фотоальбомов</b><small>Превью открываются внутри сайта, оригиналы доступны во VK.</small></p>
    </div>
    <div class="media-tournament-list">
      ${groups.map(group => `<section class="media-tournament-group ${group.event ? '' : 'unlinked'}"><div class="media-group-head"><span><small>${group.event ? esc(eventYear(group.event) || '') : 'Официальный медиацентр'}</small><b>${esc(group.event?.title || 'Другие фотоальбомы')}</b></span>${group.event ? `<button data-event="${group.event.id}" data-event-pane="event-photos">К фото турнира →</button>` : ''}<i>${group.items.length}</i></div><div class="album-list">
      ${group.items.map(x => {
        const i = GTO_VK_ALBUMS.indexOf(x), local = localAlbum(x), m = mediaMeta(x, 'album');
        return `
          <button class="album-card" data-album="${i}">
            <div class="album-cover-wrap">
              ${vkImg(local.cover, x.title)}
              <span class="album-count-badge"><svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/><circle cx="12" cy="13" r="3"/></svg>${esc(x.totalPhotosText)}</span>
            </div>
            <span>
              <b>${esc(x.title)}</b>
              <small>${m.year ? m.year + ' год' : ''}${m.event ? ' · ' + esc(m.event.title) : ''}</small>
            </span>
          </button>
        `;
      }).join('')}</div></section>`).join('')}
    </div>
    ${restCount > 0 ? `<button class="load-more" id="media-album-more">Показать ещё альбомы · осталось ${restCount}</button>` : ''}
  `;

  $('#media-content').innerHTML = `
    ${mediaControls(GTO_VK_ALBUMS, 'album')}
    ${contentHtml}
  `;
  bindMediaControls();
}

async function openAlbum(index, limit = 60) {
  await getVkAlbums();
  const album = GTO_VK_ALBUMS[Number(index)];
  if (!album) return;
  const local = localAlbum(album);
  const shown = (local.photos || []).slice(0, limit);
  const rest = (local.photos || []).length - shown.length;
  const isEvent = state.screen === 'event';
  const eventTarget = $('[data-pane-content="event-photos"]') || $('[data-pane-content="event-media"]');
  const target = (isEvent && eventTarget) ? eventTarget : $('#media-content');
  if (!target) return;

  if (isEvent) {
    const activeTab = $('.detail-tabs [data-pane="event-photos"]') || $('.detail-tabs [data-pane="event-media"]');
    if (activeTab) {
      $$('.detail-tabs button').forEach(x => x.classList.toggle('active', x === activeTab));
      $$('.detail-pane').forEach(x => x.classList.toggle('active', x.dataset.paneContent === activeTab.dataset.pane));
    }
  }

  target.innerHTML = `
    <div class="gallery-head">
      <div>
        <b>${esc(album.title)}</b>
        <small>${esc(album.totalPhotosText)}</small>
      </div>
      <button ${isEvent ? 'data-event-photos-back' : 'data-media="photo"'} class="gallery-back-btn"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="margin-right:6px;vertical-align:-2px;"><path d="m15 18-6-6 6-6"/></svg>Все альбомы</button>
    </div>
    <div class="photo-grid">
      ${shown.map((x, i) => `<button class="photo-item" data-photo="${i}" data-photo-album="${index}">${vkImg(x.src, x.title)}</button>`).join('')}
    </div>
    ${rest > 0 ? `<button class="load-more" data-album-more="${index}" data-limit="${limit + 60}">Показать ещё · осталось ${rest}</button>` : ''}
    <a class="source-action" href="${safeUrl(album.vkUrl)}" target="_blank" rel="noopener">Исходный альбом во VK <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="margin-left:5px;vertical-align:-1px;"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg></a>
  `;

  if (isEvent) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

// ---------- Просмотр фото: PhotoSwipe v5 (MIT, github.com/dimsemenov/PhotoSwipe) ----------
// Грузится лениво при первом открытии фото; если не загрузился — работает прежний lightbox ниже.
let _pswpPromise = null;
const _photoDims = new Map();
function loadPhotoSwipe() {
  if (!_pswpPromise) {
    const css = document.createElement('link'); css.rel = 'stylesheet'; css.href = './css/photoswipe.css?v=24bcf68f'; document.head.appendChild(css);
    _pswpPromise = import('./vendor/photoswipe.esm.min.js?v=41ff408a').then(m => m.default).catch(() => null);
  }
  return _pswpPromise;
}
function measurePhoto(src) {
  if (_photoDims.has(src)) return Promise.resolve(_photoDims.get(src));
  return new Promise(resolve => {
    const img = new Image();
    const done = () => { const d = img.naturalWidth ? { w: img.naturalWidth, h: img.naturalHeight } : { w: 604, h: 403 }; _photoDims.set(src, d); resolve(d); };
    img.onload = done; img.onerror = done; img.src = src;
    setTimeout(done, 1500);
  });
}
async function openPhotoSwipe(albumIndex, index) {
  const PhotoSwipe = await loadPhotoSwipe();
  if (!PhotoSwipe) return false;
  await getVkAlbums();
  const album = GTO_VK_ALBUMS[albumIndex], photos = localAlbum(album).photos || [];
  if (!photos.length) return false;
  index = (index + photos.length) % photos.length;
  // размеры текущей и соседних — до открытия, остальных — по мере листания
  await Promise.all([-1, 0, 1].map(d => measurePhoto(safeImage(photos[(index + d + photos.length) % photos.length].src))));
  const items = photos.map(p => { const src = safeImage(p.src); const d = _photoDims.get(src) || { w: 604, h: 403 }; return { src, width: d.w, height: d.h, alt: p.title || album.title }; });
  const pswp = new PhotoSwipe({
    dataSource: items, index, bgOpacity: 1, showHideAnimationType: 'fade', loop: true, wheelToZoom: true,
    padding: { top: 48, bottom: 56, left: 0, right: 0 }, imageClickAction: 'zoom', tapAction: 'toggle-controls',
    closeTitle: 'Закрыть (Esc)', zoomTitle: 'Увеличить', arrowPrevTitle: 'Предыдущее фото', arrowNextTitle: 'Следующее фото', errorMsg: 'Фото не загрузилось',
    indexIndicatorSep: ' из '
  });
  pswp.on('uiRegister', () => {
    pswp.ui.registerElement({
      name: 'caption', order: 9, isButton: false, appendTo: 'root', className: 'pswp__fm-caption',
      onInit: (el) => { const upd = () => { el.textContent = items[pswp.currIndex]?.alt || album.title; }; pswp.on('change', upd); upd(); }
    });
  });
  pswp.on('change', () => {
    [pswp.currIndex + 1, pswp.currIndex + 2, pswp.currIndex - 1].forEach(i => {
      const k = (i + items.length) % items.length; const it = items[k];
      if (_photoDims.has(it.src)) return;
      measurePhoto(it.src).then(d => { it.width = d.w; it.height = d.h; pswp.refreshSlideContent(k); });
    });
  });
  pswp.init();
  return true;
}

async function showPhoto(albumIndex, index) {
  if (!state.gallery && await openPhotoSwipe(albumIndex, index)) return;
  await getVkAlbums();
  const album = GTO_VK_ALBUMS[albumIndex], photos = localAlbum(album).photos || [];
  if (!photos.length) return;
  const opening = !state.gallery;
  if (opening) state.galleryTrigger = document.activeElement;
  index = (index + photos.length) % photos.length;
  state.gallery = { albumIndex, index };
  let box = $('#lightbox');
  if (!box) {
    box = document.createElement('div');
    box.id = 'lightbox';
    box.className = 'lightbox';
    document.body.append(box);
  }
  box.setAttribute('role', 'dialog');
  box.setAttribute('aria-modal', 'true');
  box.setAttribute('aria-label', `Фотография из альбома «${album.title}»`);
  box.innerHTML = `<button data-lightbox-close aria-label="Закрыть галерею"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button><button data-lightbox-prev aria-label="Предыдущая фотография"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 5-7 7 7 7"/></svg></button><img src="${safeImage(photos[index].src)}" alt="${esc(photos[index].title || album.title)}"><button data-lightbox-next aria-label="Следующая фотография"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg></button><small aria-live="polite">${index + 1} / ${photos.length}</small>`;
  box.classList.add('open');
  document.body.classList.add('lightbox-open');
  if (opening) requestAnimationFrame(() => box.querySelector('[data-lightbox-close]')?.focus());
}

function closeLightbox() {
  $('#lightbox')?.classList.remove('open');
  document.body.classList.remove('lightbox-open');
  state.gallery = null;
  const trigger = state.galleryTrigger;
  state.galleryTrigger = null;
  if (trigger?.isConnected) trigger.focus({ preventScroll: true });
}

const FEDERATION = {
  name: 'Федерация многоборья ГТО России',
  definition: 'Многоборье ГТО — официально признанный вид спорта, направленный на развитие общефизической подготовки. Это непрерывное последовательное прохождение дистанции с упражнениями на силу, скорость, гибкость, выносливость, меткость и ловкость.',
  // первые две — сводные цифры Федерации (/api/health, как на главной); значения ниже — запасные до ответа (syncFactGrids)
  stats: [['105 311', 'участников'], ['233', 'соревнования'], [String(regionalFedCount() || 51), 'региональных федераций в каталоге'], ['с 6 лет', 'возраст атлетов']],
  history: [
    'Комплекс ГТО зародился в СССР в 1930-х годах как государственная программа физической подготовки. Сдача нормативов и знак ГТО считались престижными и массовыми.',
    'В декабре 2020 года в Кисловодске прошёл первый в современной России чемпионат по многоборью ГТО — этот старт положил начало возрождению движения.',
    'В 2022 году, после серии соревнований в формате «Игры ГТО», была учреждена Федерация многоборья ГТО России.',
    '28 марта 2023 года многоборье ГТО официально признано самостоятельным видом спорта. К концу 2024 года действовало 45 региональных федераций (28 из них государственно аккредитованы), проводилось более 100 соревнований и участвовало свыше 50 000 спортсменов ежегодно.'
  ],
  qualities: ['Сила', 'Скорость', 'Гибкость', 'Выносливость', 'Меткость', 'Ловкость'],
  links: [
    ['Руководство', 'structure', true],
    ['Региональные федерации', 'regions', true],
    ['Официальные документы', 'documents', true],
    ['Антидопинг', 'antidoping', true],
    ['Площадки ГТО', 'platforms', true],
    ['Фирменный стиль', 'brand', true],
    ['Дисциплины многоборья', 'disciplines', true]
  ]
};

const FED_STRUCTURE = [
  { role: 'Президент Федерации', lead: true, people: [{ name: 'Кемал Шаманов', photo: 'kemal-shamanov' }] },
  { role: 'Высший наблюдательный совет', tag: 'Член совета', people: [{ name: 'Кемал Шаманов', photo: 'kemal-shamanov' }, { name: 'Михаил Стенин', photo: 'mikhail-stenin' }, { name: 'Владимир Войтеховский', photo: 'vladimir-voytekhovsky', note: 'Генеральный секретарь' }, { name: 'Алексей Михайлин', photo: 'alexey-mikhaylin' }] },
  { role: 'Вице-президенты', people: [{ name: 'Владимир Мазей', photo: 'vladimir-mazey-2', tag: 'Вице-президент' }, { name: 'Павел Филатов', photo: 'pavel-filatov', tag: 'Вице-президент' }] },
  { role: 'Руководитель проекта «Салки ГТО»', people: [{ name: 'Александр Песков', photo: 'alexander-peskov' }] }
];

const FED_DOCUMENTS = [
  { title: 'Устав Федерации', url: 'https://gto.com.ru/data/1705579404/files/1743175982.pdf' },
  { title: 'Свидетельство о регистрации', url: 'https://gto.com.ru/data/1705579404/files/1778745849.pdf' },
  { title: 'Свидетельство ИНН', url: 'https://gto.com.ru/data/1705579404/files/1738243218.pdf' },
  { title: 'Протокол учредительной конференции · 12 сентября 2022', url: 'https://gto.com.ru/data/1763371044/files/1778745490.pdf' },
  { title: 'Протокол внеочередной конференции · 29 мая 2023', url: 'https://gto.com.ru/data/1763371044/files/1778745526.pdf' },
  { title: 'Протокол конференции · 20 декабря 2024', url: 'https://gto.com.ru/data/1763371044/files/1778745568.pdf' },
  { title: 'Правила вида спорта «многоборье ГТО»', url: 'https://gto.com.ru/data/1703837629/files/1759417287.pdf' },
  // проекты АНО «Спортум» (файлы у нас, assets/sportum/docs); добавлены в конец — номера «fd-N» правок модераторов не сдвигаются
  // «Герой ГТО» — пресс-релиз и итоги отбора и финала убраны с этой страницы 16.10.2026 (Соня); они остаются на странице «Героя ГТО».
  // Места в списке пустые: номера «fd-N» правок модераторов (и «Скрытое на сайте») не сдвигаются
  ...SPORTUM_DOCS.hero.map(() => ({ gone: true })),
  { title: SPORTUM_DOCS.presentation.title, url: SPORTUM_DOCS.presentation.url }
];

const FED_ANTIDOPING = {
  intro: 'Федерация ведёт системную антидопинговую работу совместно с РАА «РУСАДА» в соответствии с Всемирным антидопинговым кодексом и общероссийскими антидопинговыми правилами.',
  contact: { name: 'Свищев Иосиф Юрьевич', role: 'Специалист по антидопинговому обеспечению', phone: '+79646457534', phoneText: '8 (964) 645-75-34', email: 'iosif@gto.com.ru' },
  notes: ['РАА «РУСАДА» запустило портал онлайн-образования: спортсмены и их персонал проходят обязательные антидопинговые курсы в удобное время.', 'Сервис проверки субстанций показывает статус лекарственных средств по действующему Запрещённому списку ВАДА.'],
  docs: ['Общероссийские антидопинговые правила 2026', 'Запрещённый список 2026', 'Обзор основных изменений 2026', 'Нарушения антидопинговых правил', 'Памятка по правам спортсменов', 'Памятка для тренера', 'Информация для родителей юных спортсменов', 'План по борьбе с допингом ФМГТОР на 2026', 'Всемирный антидопинговый кодекс 2021'],
  links: [['Сайт РАА «РУСАДА»', 'https://rusada.ru/'], ['Проверка субстанций (list.rusada.ru)', 'https://list.rusada.ru/'], ['Все антидопинговые документы', 'https://gto.com.ru/o-federacii/antidoping/']]
};

function renderStructure() {
  $('#structure-content').innerHTML = `
    <div class="page-title">
      <span>Руководящие органы</span>
      <h1>Руководство Федерации</h1>
      <p>Официальный состав Президиума и руководства Федерации многоборья ГТО России.</p>
    </div>
    ${FED_STRUCTURE.map(g => `
      <section class="org-block${g.lead ? ' org-block--lead' : ''}" data-count="${g.people.length}">
        <h2 class="org-role-title">${esc(g.role)}</h2>
        <div class="org-people-list">
          ${g.people.map(p => `
            <div class="org-person">
              <div class="org-person-avatar-wrap">
                ${p.photo ? `<img loading="lazy" decoding="async" width="831" height="900" src="./assets/leadership/${p.photo}.webp" alt="${esc(p.name)}" class="org-person-img" data-fb="logo">` : `<div class="org-person-placeholder"><svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="8" r="5"/><path d="M20 21a8 8 0 1 0-16 0"/></svg></div>`}
              </div>
              <div class="org-person-info">
                <b class="org-person-name">${esc(p.name)}</b>
                ${p.note ? `<small class="org-person-note">${esc(p.note)}</small>` : ''}
                <small class="org-person-tag">${esc(p.tag || g.tag || g.role)}</small>
              </div>
            </div>
          `).join('')}
        </div>
      </section>
    `).join('')}
    <div class="legal">Фотографии и состав руководства синхронизированы с официальным реестром Федерации многоборья ГТО России.</div>
  `;
}

const isModMode = () => { try { return Boolean(localStorage.getItem('fmgto_hub_token')); } catch (_) { return false; } };

if (typeof window !== 'undefined') window.__fmgtoDocs = FED_DOCUMENTS;
// фотоальбомы турниров, перенесённые со старого сайта Федерации на наш сервер: assets/events/photos/<id>/<альбом>/NNN.webp
let EVENT_PHOTO_ALBUMS = {};
fetch('./data/event_photos.json', { cache: 'no-cache' }).then((r) => (r.ok ? r.json() : {})).then((m) => {
  EVENT_PHOTO_ALBUMS = m || {};
  // страница турнира успела открыться раньше — дорисовываем вкладку «Фото»
  if (state.screen === 'event' && EVENT_PHOTO_ALBUMS[String(state.currentEventId)]) { const pane = document.querySelector('.event-photos-pane'); if (pane && !pane.querySelector('.ev-local-album')) pane.innerHTML = localAlbumsHtml(state.currentEventId) + pane.innerHTML; }
}).catch(() => {});
function localEventAlbums(eventId) {
  const ev = EVENT_PHOTO_ALBUMS[String(eventId)]; if (!ev) return [];
  return ev.albums.filter((al) => al.photos.length).map((al, ai) => {
    const key = `ev${eventId}-${ai}`;
    const title = al.title || (ev.albums.length > 1 ? `Фотоальбом ${ai + 1}` : 'Фотоальбом турнира');
    registerGallery(key, { title, count: al.photos.length, src: (i, t) => `./assets/events/photos/${encodeURIComponent(eventId)}/${ai}/${t ? 't/' : ''}${String(i).padStart(3, '0')}.webp` });
    return { key, title, count: al.photos.length, source: al.source || '', credit: String(al.credit || '').slice(0, 80) };
  });
}
function localAlbumsHtml(eventId) {
  // альбом с Яндекс Диска (import_disk_photos.py): на сайте — сжатые копии, оригиналы в полном размере — по ссылке на папку
  // альбом из галереи фотографа (import_gallery_photos.py) — автор и ссылка на всю галерею
  // автор снимков (credit) — у любого альбома, не только из галереи фотографа (12.10.2026: фото церемонии награждения с Диска)
  const by = (a, sep = ' · ') => (a.credit ? `Фото: <b>${esc(a.credit)}</b>${sep}` : '');
  const orig = (a) => (/^https:\/\/disk\.yandex\.(ru|com)\//.test(a.source) ? `<p class="ev-album-orig">${by(a)}Оригиналы в полном размере — ${extLink(esc(a.source), 'Яндекс Диск')}</p>`
    : /^https:\/\/[a-z0-9-]+\.gallery\.photo\/gallery\//.test(a.source) ? `<p class="ev-album-orig">${by(a)}${extLink(esc(a.source), 'вся галерея фотографа')}</p>`
    : a.credit ? `<p class="ev-album-orig">${by(a, '')}</p>` : '');
  return localEventAlbums(eventId).map((a) => `<section class="ev-local-album"><h2>${esc(a.title)} <span class="section-count">${a.count}</span></h2>${orig(a)}${galleryHtml(a.key, { first: 24 })}</section>`).join('');
}
// «Требует внимания» (js/mod_attention.js?v=0076cf7f): турниры, новости и открытие окна правки турнира
if (typeof window !== 'undefined') window.__fmgtoModData = async () => {
  await loadResultsManifest();
  return { events: getUnifiedEvents(), manifest: state.resultsManifest, news: getUnifiedNews(), eventDateRange,
    openEventEdit: (id) => { const ev = getUnifiedEvents().find((x) => String(x.id) === String(id)) || GTO_CALENDAR_EVENTS.find((x) => String(x.id) === String(id)); if (ev) openModEventDialog(ev); } };
};

function renderDocuments() {
  $('#documents-content').innerHTML = `
    <div class="page-title">
      <span>Официально</span>
      <h1>Официальные документы</h1>
      <p>Учредительные, уставные документы и правила вида спорта «Многоборье ГТО».</p>
    </div>
    <section class="organizers-card">
      <span class="organizers-eyebrow">Организаторам</span>
      <h2>Как сдать протокол соревнований на сайт</h2>
      <ol>
        <li>Скачайте шаблон и заполните: одна строка — один участник, ФИО полностью, регион, категория, результат, место.</li>
        <li>Панель организатора → «Результаты» → <b>«Импорт протокола»</b>: выберите турнир и файл, нажмите «Проверить», затем «Загрузить».</li>
        <li>Через 1–2 минуты протокол появится на странице турнира, у атлетов — в карточках, в рейтинге — очки.</li>
      </ol>
      <div class="organizers-actions">
        <a class="primary-action" href="./files/templates/protocol_template.xlsx" download>Шаблон протокола (Excel)</a>
        <a class="secondary-action" href="mailto:info@gto.com.ru?subject=Протокол соревнований">Прислать на почту</a>
      </div>
      <p class="organizers-note">Принимаем Excel, CSV и PDF-протоколы; сканы распознаём. 96 турниров в календаре ещё ждут своих протоколов.</p>
    </section>
    ${isModMode() ? `<div class="mod-inline-bar"><span><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-shield"/></svg> Документы на сайте</span><button type="button" class="mod-inline-add" data-mod-doc-add><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-plus"/></svg> Добавить документ</button></div>` : ''}
    <div class="documents-grid">
      ${overlayList('documents', FED_DOCUMENTS, (d, i) => 'fd-' + i).filter((d) => !d.gone).map(d => `<div class="doc-card-wrap">
        <a href="${safeFileUrl(d.url)}" target="_blank" rel="noopener" class="doc-card">
          <div class="doc-icon-wrap" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/>
              <polyline points="14 2 14 8 20 8"/>
              <line x1="16" y1="13" x2="8" y2="13"/>
              <line x1="16" y1="17" x2="8" y2="17"/>
              <line x1="10" y1="9" x2="8" y2="9"/>
            </svg>
          </div>
          <div class="doc-content">
            <b class="doc-title">${esc(d.title)}</b>
            <div class="doc-meta">
              <span class="doc-badge">${esc(String(d.ext || (String(d.url).match(/\.([a-z0-9]{2,4})(?:$|\?)/i) || [])[1] || 'pdf').toUpperCase())}</span>
              <span class="doc-source">${d._custom ? 'Документ Федерации' : 'Официальный документ · gto.com.ru'}</span>
            </div>
          </div>
          <div class="doc-action-btn" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7 10 12 15 17 10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
          </div>
        </a>${isModMode() ? `<div class="mod-inline-tools"><button type="button" data-mod-doc-edit="${esc(d._cid)}">✎ Изменить</button><button type="button" class="danger" data-mod-doc-hide="${esc(d._cid)}">Скрыть</button></div>` : ''}</div>
      `).join('')}
    </div>
    <a class="source-action" href="https://gto.com.ru/o-federacii/dokumenty/" target="_blank" rel="noopener">
      <span>Все документы на сайте gto.com.ru</span>
      <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
    </a>
  `;
}

function renderAntidoping() {
  const a = FED_ANTIDOPING;
  $('#antidoping-content').innerHTML = `<div class="page-title"><span>Чистый спорт</span><h1>Антидопинг</h1><p>${esc(a.intro)}</p></div><div class="about-history">${a.notes.map(n => `<p>${esc(n)}</p>`).join('')}</div><div class="section-head"><div><span>Ответственный</span><h2>Контакт по антидопингу</h2></div></div><div class="link-stack"><a href="tel:${esc(a.contact.phone)}"><span><b>${esc(a.contact.name)}</b><small>${esc(a.contact.role)} · ${esc(a.contact.phoneText)}</small></span><strong>→</strong></a><a href="mailto:${esc(a.contact.email)}"><span><b>${esc(a.contact.email)}</b><small>Написать по антидопингу</small></span><strong>→</strong></a></div><div class="section-head"><div><span>Материалы</span><h2>Документы и памятки</h2></div></div><div class="quality-chips">${a.docs.map(d => `<span>${esc(d)}</span>`).join('')}</div><div class="section-head"><div><span>Ресурсы</span><h2>Полезные ссылки</h2></div></div><div class="link-stack">${a.links.map(([t, u]) => `<a href="${safeUrl(u)}" target="_blank" rel="noopener"><span><b>${esc(t)}</b></span><strong>↗</strong></a>`).join('')}</div>`;
}

async function ensureRegionStats() {
  if (state.regionStats && state.athleteIndex) return state.regionStats;
  let athletes = state.athleteIndex;
  if (!athletes) {
    if (!state.athleteLoading) {
      buildAthleteIndex().then(() => {
        if (state.athleteIndex) {
          const { stats, summary } = buildRegionStats(state.athleteIndex, GTO_CALENDAR_EVENTS, GTO_RECORDS, GTO_FEDERATIONS);
          state.regionStats = stats;
          state.regionSummary = summary;
          updateMapHeatmap();
          syncMapSummaryCards();
          if (state.screen === 'region' && state.currentRegionId) {
            openRegion(state.currentRegionId, false);
          }
        }
      });
    }
    athletes = [];
  }
  const { stats, summary } = buildRegionStats(athletes, GTO_CALENDAR_EVENTS, GTO_RECORDS, GTO_FEDERATIONS);
  state.regionStats = stats;
  state.regionSummary = summary;
  syncMapSummaryCards();
  return stats;
}

// карта регионов: те же сводные цифры, что на главной и в «О Федерации» (/api/health, site_counters.py), — раньше здесь были
// свои подсчёты по загруженным данным (7 556 / 85 / 134) и старый текст «4 000+ спортсмена, 114 турниров» (07.10.2026)
let _siteCountsPromise = null;
const siteCounts = () => (_siteCountsPromise ||= fetch('/api/health', { cache: 'no-store' }).then((r) => r.json()).then((d) => (d && d.ok ? d : null)).catch(() => null));
// «Ещё» и «О Федерации»: первые две ячейки — участники и соревнования, те же сводные цифры, что на главной и карте
// (раньше вписанные вручную «50 000+ участников в год» и «100+ соревнований в год»)
function syncFactGrids() {
  siteCounts().then((d) => {
    if (!d) return;
    $$('.fact-grid').forEach((g) => {
      const cells = g.querySelectorAll(':scope > div');
      [[d.athletes_count, ['участник', 'участника', 'участников']], [d.events_count, ['соревнование', 'соревнования', 'соревнований']]].forEach(([v, forms], i) => {
        const c = cells[i]; if (!c || !v) return;
        c.querySelector('b').textContent = Number(v).toLocaleString('ru-RU'); c.querySelector('span').textContent = ruPlural(v, ...forms);
      });
    });
  });
}

function syncMapSummaryCards() {
  siteCounts().then((d) => {
    if (!d) return;
    const n = (v) => Number(v).toLocaleString('ru-RU');
    const items = [[d.athletes_count, ['участник', 'участника', 'участников']], [d.regions_count, ['регион РФ', 'региона РФ', 'регионов РФ']],
      [d.events_count, ['соревнование', 'соревнования', 'соревнований']], [d.records_count, ['рекорд России', 'рекорда России', 'рекордов России']]];
    $$('.map-summary-strip .map-summary-card').forEach((card, i) => {
      const [v, forms] = items[i] || []; if (!v) return;
      card.querySelector('b').textContent = n(v); card.querySelector('span').textContent = ruPlural(v, ...forms);
    });
    const lead = $('[data-screen="regions"] .page-title p');
    if (lead) lead.textContent = `${items.map(([v, f]) => `${n(v)} ${ruPlural(v, ...f)}`).join(', ').replace(/, ([^,]+)$/, ' и $1')}. Наведите или нажмите на субъект для просмотра статистики.`;
  });
}

function updateMapHeatmap() {
  const svgWrap = $('#russia-map-svg-wrap');
  if (!svgWrap) return;
  const els = svgWrap.querySelectorAll('.russia-region, .region-hit-area');
  if (!els.length || !state.regionStats) return;

  const mode = state.mapMode || 'athletes';

  els.forEach(el => {
    const regId = Number(el.dataset.regionId);
    const item = state.regionStats[regId];
    let val = 0;
    if (item) {
      if (mode === 'athletes') val = item.athletes_count || 0;
      else if (mode === 'tournaments') val = item.tournaments_count || 0;
      else if (mode === 'records') val = item.records_count || 0;
      else if (mode === 'all') val = (item.athletes_count || 0) + (item.tournaments_count || 0) * 5 + (item.records_count || 0) * 6;
    }

    let heat = 0;
    if (mode === 'athletes') {
      if (val === 0) heat = 0;
      else if (val <= 15) heat = 1;
      else if (val <= 50) heat = 2;
      else if (val <= 150) heat = 3;
      else heat = 4;
    } else if (mode === 'tournaments') {
      if (val === 0) heat = 0;
      else if (val === 1) heat = 1;
      else if (val <= 3) heat = 2;
      else if (val <= 8) heat = 3;
      else heat = 4;
    } else if (mode === 'records') {
      if (val === 0) heat = 0;
      else if (val === 1) heat = 1;
      else if (val <= 3) heat = 2;
      else if (val <= 6) heat = 3;
      else heat = 4;
    } else { // 'all'
      if (val === 0) heat = 0;
      else if (val <= 25) heat = 1;
      else if (val <= 80) heat = 2;
      else if (val <= 200) heat = 3;
      else heat = 4;
    }

    el.setAttribute('data-heat', String(heat));
  });

  const container = $('#russia-map-container');
  if (container) {
    container.setAttribute('data-map-mode', mode);
  }
}

function applyMapTransform() {
  const svg = $('#russia-map-svg-wrap svg');
  if (svg) {
    svg.style.transform = `translate(${state.mapPanX}px, ${state.mapPanY}px) scale(${state.mapZoom})`;
  }
}

function zoomMapBy(delta) {
  state.mapZoom = Math.min(3.5, Math.max(1.0, Number((state.mapZoom + delta).toFixed(2))));
  if (state.mapZoom === 1.0) {
    state.mapPanX = 0;
    state.mapPanY = 0;
  }
  applyMapTransform();
}

function resetMapZoom() {
  state.mapZoom = 1.0;
  state.mapPanX = 0;
  state.mapPanY = 0;
  applyMapTransform();
}

function regionHaptic() {
  try {
    if (navigator.vibrate) navigator.vibrate(15);
  } catch (_) {}
}

function updateMapFloatingIndicator(reg) {
  const ind = $('#map-floating-indicator');
  const nameEl = $('#mfi-name');
  const distEl = $('#mfi-district');
  if (!ind || !nameEl || !distEl) return;

  if (!reg) {
    ind.hidden = true;
    return;
  }

  nameEl.textContent = reg.name.toUpperCase();
  distEl.textContent = `${reg.district} · Субъект №${reg.id}`;
  ind.hidden = false;
}

function updateMapSelectedCard(reg) {
  const card = $('#map-selected-card');
  const nameEl = $('#msc-name');
  const distEl = $('#msc-district');
  const statsEl = $('#msc-stats');
  const actionBtn = $('#msc-action-btn');
  if (!card || !nameEl || !statsEl) return;

  if (!reg) {
    card.classList.remove('is-active');
    nameEl.textContent = 'Выберите регион на карте';
    if (distEl) distEl.hidden = true;
    statsEl.innerHTML = '<span>Нажмите на любой субъект РФ для просмотра статистики</span>';
    if (actionBtn) actionBtn.hidden = true;
    return;
  }

  card.classList.add('is-active');
  nameEl.textContent = reg.name;
  if (distEl) {
    distEl.textContent = reg.district;
    distEl.hidden = false;
  }

  const st = state.regionStats?.[reg.id];
  if (st && (st.athletes_count > 0 || st.tournaments_count > 0 || st.records_count > 0)) {
    const parts = [];
    if (st.athletes_count > 0) parts.push(`<b>${pluralize(st.athletes_count, ['атлет', 'атлета', 'атлетов'])}</b>`);
    if (st.tournaments_count > 0) parts.push(`<b>${pluralize(st.tournaments_count, ['турнир', 'турнира', 'турниров'])}</b>`);
    if (st.records_count > 0) parts.push(`<b>${pluralize(st.records_count, ['рекорд', 'рекорда', 'рекордов'])}</b>`);
    
    let tournsHtml = '';
    if (st.tournaments && st.tournaments.length) {
      const topTourns = st.tournaments.slice(0, 3);
      tournsHtml = `
        <div class="msc-tourn-list" style="margin-top:10px;display:flex;flex-direction:column;gap:6px">
          <div style="font-size:11px;font-weight:700;color:#94a3b8;text-transform:uppercase;letter-spacing:0.5px">Турниры в регионе:</div>
          ${topTourns.map(t => `
            <div class="msc-tourn-row" data-event="${esc(t.id)}" style="display:flex;align-items:center;justify-content:space-between;padding:8px 10px;background:rgba(255,255,255,0.04);border:1px solid rgba(255,255,255,0.08);border-radius:10px;cursor:pointer">
              <div style="min-width:0">
                <div style="font-size:12.5px;font-weight:700;color:#f8fafc;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">${esc(t.title)}</div>
                <div style="font-size:11px;color:#38bdf8">${esc(t.period || '')}</div>
              </div>
              <span style="font-size:12px;color:#38bdf8;font-weight:700;flex-shrink:0;margin-left:8px">Протокол →</span>
            </div>
          `).join('')}
        </div>
      `;
    }
    statsEl.innerHTML = `<span>${parts.join(' &nbsp;•&nbsp; ')}</span>${tournsHtml}`;
  } else {
    statsEl.innerHTML = `<span>Центр: <b>${esc(reg.capital)}</b> &nbsp;•&nbsp; Официальные данные формируются</span>`;
  }

  if (actionBtn) {
    actionBtn.hidden = false;
    actionBtn.dataset.openRegionId = String(reg.id);
  }
}

function focusRegionOnMap(regionId) {
  const svg = $('#russia-map-svg-wrap svg');
  if (!svg) return;
  const target = svg.querySelector(`[data-region-id="${regionId}"]`);
  if (!target) return;

  try {
    if (typeof target.getBBox === 'function') {
      const bbox = target.getBBox();
      if (bbox && bbox.width > 0 && bbox.height > 0) {
        const cx = bbox.x + bbox.width / 2;
        const cy = bbox.y + bbox.height / 2;
        const isMobile = window.innerWidth <= 768;
        const maxScale = isMobile ? 1.25 : 1.6;
        const minScale = 1.05;
        const factor = Math.min(maxScale, Math.max(minScale, 480 / Math.max(bbox.width, bbox.height)));
        state.mapZoom = Number(factor.toFixed(2));
        const container = $('#russia-map-container');
        const cw = container ? container.clientWidth : (isMobile ? 360 : 900);
        const ch = container ? container.clientHeight : (isMobile ? 280 : 500);
        const scale = Math.min(cw / 1090, ch / 620);
        const rawPanX = (545 - cx) * scale * 0.35;
        const rawPanY = (310 - cy) * scale * 0.35;
        const maxPanX = cw * 0.15;
        const maxPanY = ch * 0.15;
        state.mapPanX = Math.max(-maxPanX, Math.min(maxPanX, rawPanX));
        state.mapPanY = Math.max(-maxPanY, Math.min(maxPanY, rawPanY));
        applyMapTransform();
      }
    }
  } catch (_) {}
}

const DISTRICT_BOUNDS = {
  'ЦФО':  { minX: 63,  minY: 216, maxX: 211,  maxY: 337 },
  'СЗФО': { minX: 30,  minY: 12,  maxX: 462,  maxY: 289 },
  'УФО':  { minX: 230, minY: 165, maxX: 462,  maxY: 404 },
  'ПФО':  { minX: 119, minY: 255, maxX: 295,  maxY: 421 },
  'СФО':  { minX: 325, minY: 53,  maxX: 672,  maxY: 518 },
  'ЮФО':  { minX: 2,   minY: 325, maxX: 139,  maxY: 418 },
  'ДФО':  { minX: 526, minY: 72,  maxX: 1002, maxY: 580 },
  'СКФО': { minX: 40,  minY: 373, maxX: 93,   maxY: 458 }
};

function focusDistrictOnMap(districtCode) {
  if (!districtCode || districtCode === 'all') {
    resetMapZoom();
    return;
  }
  const svgWrap = $('#russia-map-svg-wrap');
  if (!svgWrap) return;
  const paths = svgWrap.querySelectorAll(`.russia-region[data-district="${districtCode}"]`);

  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  if (paths.length) {
    paths.forEach(p => {
      try {
        if (typeof p.getBBox === 'function') {
          const b = p.getBBox();
          if (b && b.width > 0 && b.height > 0) {
            minX = Math.min(minX, b.x);
            minY = Math.min(minY, b.y);
            maxX = Math.max(maxX, b.x + b.width);
            maxY = Math.max(maxY, b.y + b.height);
          }
        }
      } catch (_) {}
    });
  }

  const fb = DISTRICT_BOUNDS[districtCode];
  if ((minX === Infinity || maxX - minX <= 0) && fb) {
    minX = fb.minX;
    minY = fb.minY;
    maxX = fb.maxX;
    maxY = fb.maxY;
  }

  if (minX < Infinity && maxX > -Infinity) {
    const width = maxX - minX;
    const height = maxY - minY;
    const cx = minX + width / 2;
    const cy = minY + height / 2;
    const isMobile = window.innerWidth <= 768;
    const maxScale = isMobile ? 1.6 : 2.2;
    const minScale = 1.25;
    const fitScale = Math.min(950 / Math.max(width, 100), 550 / Math.max(height, 100));
    const factor = Math.min(maxScale, Math.max(minScale, fitScale));
    state.mapZoom = Number(factor.toFixed(2));
    const container = $('#russia-map-container');
    const cw = container ? container.clientWidth : (isMobile ? 360 : 900);
    const ch = container ? container.clientHeight : (isMobile ? 280 : 500);
    const scale = Math.min(cw / 1090, ch / 620);
    const rawPanX = (545 - cx) * scale * 0.7;
    const rawPanY = (310 - cy) * scale * 0.7;
    const maxPanX = cw * 0.45;
    const maxPanY = ch * 0.45;
    state.mapPanX = Math.max(-maxPanX, Math.min(maxPanX, rawPanX));
    state.mapPanY = Math.max(-maxPanY, Math.min(maxPanY, rawPanY));
    applyMapTransform();
  }
}
window.focusDistrictOnMap = focusDistrictOnMap;

function updateDistrictHighlights() {
  const svgWrap = $('#russia-map-svg-wrap');
  if (!svgWrap) return;
  const d = state.districtQuery;
  const paths = svgWrap.querySelectorAll('.russia-region');
  if (!d || d === 'all') {
    paths.forEach(p => {
      p.classList.remove('is-district-match', 'is-district-dim');
    });
  } else {
    paths.forEach(p => {
      const match = p.dataset.district === d;
      p.classList.toggle('is-district-match', match);
      p.classList.toggle('is-district-dim', !match);
    });
  }
}

function selectRegion(regionId, { source = 'map' } = {}) {
  const reg = getRegionById(regionId);
  if (!reg) return;

  state.selectedRegionId = reg.id;
  regionHaptic();

  // Update SVG elements: remove .is-selected from previous, add to current
  const svgWrap = $('#russia-map-svg-wrap');
  if (svgWrap) {
    svgWrap.querySelectorAll('.russia-region, .region-hit-area').forEach(el => {
      const isSel = Number(el.dataset.regionId) === reg.id;
      el.classList.toggle('is-selected', isSel);
    });
  }

  // Update In-Map Floating Indicator
  updateMapFloatingIndicator(reg);

  // Update Compact Status Card
  updateMapSelectedCard(reg);

  // If on mobile and clicked on map, also show bottom sheet
  if (window.innerWidth <= 768 && source === 'map') {
    showRegionBottomSheet(reg.id);
  }

  // If from search, center/focus on map
  if (source === 'search') {
    focusRegionOnMap(reg.id);
  }
}
window.selectRegion = selectRegion;

function showRegionBottomSheet(regId) {
  const reg = getRegionById(regId);
  if (!reg) return;
  const st = state.regionStats?.[reg.id];
  const fed = st?.federation || GTO_FEDERATIONS.find(f => normalizeRegionName(f.region) === reg.id);
  const pres = fed ? realPresident(fed.president) : '';

  const sheet = $('#region-bottom-sheet');
  const backdrop = $('#region-bottom-sheet-backdrop');
  if (!sheet) return;

  sheet.innerHTML = `
    <div class="bottom-sheet-handle"></div>
    <button class="bottom-sheet-close" id="region-sheet-close" aria-label="Закрыть">✕</button>
    <div class="sheet-head">
      <span class="sheet-badge">${esc(reg.district)} · Субъект №${reg.id}</span>
      <h3>${esc(reg.name)}</h3>
      <small>Центр: ${esc(reg.capital)}</small>
    </div>
    <div class="sheet-stats-grid">
      <div class="sheet-stat-box">
        <b>${st ? st.athletes_count : 0}</b>
        <span>${pluralize(st ? st.athletes_count : 0, ['спортсмен', 'спортсмена', 'спортсменов']).replace(/^\d+[\s\u00A0]*/, '')}</span>
      </div>
      <div class="sheet-stat-box">
        <b>${st ? st.tournaments_count : 0}</b>
        <span>${pluralize(st ? st.tournaments_count : 0, ['турнир', 'турнира', 'турниров']).replace(/^\d+[\s\u00A0]*/, '')}</span>
      </div>
      <div class="sheet-stat-box">
        <b>${st ? st.records_count : 0}</b>
        <span>${pluralize(st ? st.records_count : 0, ['рекорд', 'рекорда', 'рекордов']).replace(/^\d+[\s\u00A0]*/, '')}</span>
      </div>
    </div>
    ${pres ? `
      <div class="sheet-fed-preview">
        <small>Председатель отделения</small>
        <b>${esc(pres)}</b>
      </div>
    ` : ''}
    <button class="sheet-open-btn" data-open-region-id="${reg.id}">
      <span>ОТКРЫТЬ РЕГИОН</span>
      <strong>→</strong>
    </button>
  `;

  sheet.hidden = false;
  if (backdrop) backdrop.hidden = false;
  requestAnimationFrame(() => {
    sheet.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
  });
}

function hideRegionBottomSheet() {
  const sheet = $('#region-bottom-sheet');
  const backdrop = $('#region-bottom-sheet-backdrop');
  if (sheet) {
    sheet.classList.remove('is-open');
    setTimeout(() => { sheet.hidden = true; }, 220);
  }
  if (backdrop) {
    backdrop.classList.remove('is-open');
    setTimeout(() => { backdrop.hidden = true; }, 220);
  }
}

let mapEventsBound = false;

async function renderRegionMap() {
  await ensureRegionStats();

  const svgWrap = $('#russia-map-svg-wrap');
  if (!svgWrap) return;

  if (!state.mapSvgLoaded) {
    try {
      const res = await fetch('./assets/maps/russia-regions.svg?v=85');
      if (res.ok) {
        const svgContent = await res.text();
        svgWrap.innerHTML = svgContent;
        state.mapSvgLoaded = true;
      }
    } catch (e) {
      console.error('Failed to load Russia map SVG', e);
    }
  }

  updateMapHeatmap();
  updateDistrictHighlights();

  if (state.selectedRegionId) {
    const activeReg = getRegionById(state.selectedRegionId);
    if (activeReg) {
      svgWrap.querySelectorAll('.russia-region, .region-hit-area').forEach(el => {
        el.classList.toggle('is-selected', Number(el.dataset.regionId) === activeReg.id);
      });
      updateMapFloatingIndicator(activeReg);
      updateMapSelectedCard(activeReg);
    }
  }

  if (mapEventsBound) return;
  mapEventsBound = true;

  const container = $('#russia-map-container');
  const tooltip = $('#region-map-tooltip');

  // Heatmap mode buttons
  const modeChips = $$('#map-heatmap-modes button');
  modeChips.forEach(btn => {
    btn.addEventListener('click', () => {
      modeChips.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      state.mapMode = btn.dataset.mode;
      haptic(10);
      updateMapHeatmap();
    });
  });

  // Search input
  const mapSearchInput = $('#map-search-input');
  if (mapSearchInput) {
    mapSearchInput.addEventListener('input', e => {
      const query = (e.target.value || '').trim().toLowerCase();
      const allPaths = svgWrap.querySelectorAll('.russia-region, .region-hit-area');
      allPaths.forEach(p => p.classList.remove('is-search-match'));

      if (!query) return;

      const matches = GTO_REGIONS.filter(r =>
        r.name.toLowerCase().includes(query) ||
        r.capital.toLowerCase().includes(query) ||
        String(r.id) === query ||
        r.aliases.some(a => a.toLowerCase().includes(query))
      );

      matches.forEach(m => {
        svgWrap.querySelectorAll(`[data-region-id="${m.id}"]`).forEach(p => {
          p.classList.add('is-search-match');
        });
      });

      if (matches.length === 1 || query.length >= 4) {
        const topMatch = matches[0];
        if (topMatch && topMatch.id !== state.selectedRegionId) {
          selectRegion(topMatch.id, { source: 'search' });
        }
      }
    });

    mapSearchInput.addEventListener('keydown', e => {
      if (e.key === 'Enter') {
        const query = (mapSearchInput.value || '').trim().toLowerCase();
        if (!query) return;
        const match = GTO_REGIONS.find(r =>
          r.name.toLowerCase().includes(query) ||
          r.capital.toLowerCase().includes(query) ||
          String(r.id) === query ||
          r.aliases.some(a => a.toLowerCase().includes(query))
        );
        if (match) {
          openRegion(match.id);
        }
      }
    });
  }

  // Zoom buttons
  $('#map-zoom-in')?.addEventListener('click', () => { haptic(10); zoomMapBy(0.35); });
  $('#map-zoom-out')?.addEventListener('click', () => { haptic(10); zoomMapBy(-0.35); });
  $('#map-zoom-reset')?.addEventListener('click', () => { haptic(10); resetMapZoom(); });

  // Tooltip & hover
  function showTooltipAt(e, regId) {
    if (!tooltip) return;
    const reg = getRegionById(regId);
    if (!reg) return;
    const st = state.regionStats?.[reg.id];

    tooltip.innerHTML = `
      <div class="tooltip-title">
        <b>${esc(reg.name)}</b>
        <span class="tooltip-badge">${esc(reg.district)}</span>
      </div>
      <div class="tooltip-stats">
        <span><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-user"/></svg> <b>${st ? st.athletes_count : 0}</b> атлетов</span>
        <span><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-trophy"/></svg> <b>${st ? st.tournaments_count : 0}</b> турниров</span>
        <span><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-star"/></svg> <b>${st ? st.records_count : 0}</b> рекордов</span>
      </div>
      ${st && st.federation ? `<div class="tooltip-fed"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-landmark"/></svg> ${esc(st.federation.name)}</div>` : ''}
    `;

    tooltip.hidden = false;

    const pad = 12;
    let left = e.clientX + pad;
    let top = e.clientY + pad;

    if (left + 220 > window.innerWidth) left = e.clientX - 225;
    if (top + 100 > window.innerHeight) top = e.clientY - 105;

    tooltip.style.left = `${Math.max(6, left)}px`;
    tooltip.style.top = `${Math.max(6, top)}px`;
  }

  function hideTooltip() {
    if (tooltip) tooltip.hidden = true;
    svgWrap.querySelectorAll('.is-hovered').forEach(el => el.classList.remove('is-hovered'));
  }

  if (container) {
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let initialPanX = 0;
    let initialPanY = 0;
    let hasMoved = false;

    container.addEventListener('pointerdown', e => {
      const targetRegion = e.target.closest('.russia-region, .region-hit-area');
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      isDragging = true;
      hasMoved = false;
      startX = e.clientX;
      startY = e.clientY;
      initialPanX = state.mapPanX;
      initialPanY = state.mapPanY;
    });

    window.addEventListener('pointermove', e => {
      if (isDragging) {
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;
        if (Math.hypot(dx, dy) > 5) {
          hasMoved = true;
          if (state.mapZoom > 1.0) {
            state.mapPanX = initialPanX + dx;
            state.mapPanY = initialPanY + dy;
            applyMapTransform();
          }
        }
      }

      if (!isDragging && container.contains(e.target)) {
        const target = e.target.closest('.russia-region, .region-hit-area');
        if (target) {
          const regId = Number(target.dataset.regionId);
          svgWrap.querySelectorAll('.is-hovered').forEach(el => el.classList.remove('is-hovered'));
          svgWrap.querySelectorAll(`[data-region-id="${regId}"]`).forEach(el => el.classList.add('is-hovered'));
          if (window.innerWidth > 768) {
            showTooltipAt(e, regId);
          }
        } else {
          hideTooltip();
        }
      }
    });

    window.addEventListener('pointerup', e => {
      if (isDragging) {
        isDragging = false;
      }
    });

    container.addEventListener('pointerleave', () => {
      if (!isDragging) hideTooltip();
    });

    // Wheel zoom inside map container
    container.addEventListener('wheel', e => {
      if (e.ctrlKey || Math.abs(e.deltaY) > 0) {
        e.preventDefault();
        const delta = e.deltaY < 0 ? 0.2 : -0.2;
        zoomMapBy(delta);
      }
    }, { passive: false });

    // Region Click / Tap
    container.addEventListener('click', e => {
      const target = e.target.closest('.russia-region, .region-hit-area');
      if (!target || hasMoved) return;

      e.preventDefault();
      const regId = Number(target.dataset.regionId);
      if (!regId) return;

      if (state.selectedRegionId === regId) {
        // Second tap on already selected region -> open region page!
        hideRegionBottomSheet();
        openRegion(regId);
      } else {
        selectRegion(regId, { source: 'map' });
      }
    });

    // Keyboard accessibility for regions
    container.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        const target = e.target.closest('.russia-region, .region-hit-area');
        if (target) {
          e.preventDefault();
          const regId = Number(target.dataset.regionId);
          if (regId) {
            if (state.selectedRegionId === regId) {
              openRegion(regId);
            } else {
              selectRegion(regId, { source: 'keyboard' });
            }
          }
        }
      }
    });
  }
}

const DISTRICTS = [
  { code: 'ЦФО', re: /москв|белгород|брянск|владимир|воронеж|иванов|калуж|костром|курск|липецк|орлов|рязан|смоленск|тамбов|твер|тул|ярослав/i },
  { code: 'СЗФО', re: /петербург|ленинград|архангельск|волог|калининград|карел|коми|мурманск|новгород|псков|(?<!ямало-)ненецк/i },   // Ямало-Ненецкий — УФО
  { code: 'ЮФО', re: /краснодар|ростов|волгоград|астрахан|адыге|калмык|крым|севастопол/i },
  { code: 'СКФО', re: /дагестан|ингушет|кабардин|карачаев|осети|ставропол|чечен/i },
  { code: 'ПФО', re: /башкортостан|татарстан|удмурт|чуваш|марий|мордови|перм|киров|нижегород|оренбург|пензен|самар|саратов|ульянов/i },
  { code: 'УФО', re: /свердлов|челябинск|тюмен|курган|хмао|янао|ямало|югр/i },
  { code: 'СФО', re: /красноярск|алтай|иркутск|кемеров|новосибирск|омск|томск|хакас|тыва/i },
  { code: 'ДФО', re: /примор|хабаровск|амур|сахалин|камчат|магадан|якут|бурят|забайкал|чукот|еврейск/i }
];

function getDistrict(regName) {
  for (const d of DISTRICTS) {
    if (d.re.test(regName || '')) return d.code;
  }
  return 'ЦФО';
}

function renderRegionsLeaderboard() {
  const container = $('#region-leaderboard-container');
  if (!container) return;

  const stats = state.regionStats;
  if (!stats) {
    container.innerHTML = skeletonHtml('list', 'Загружаем рейтинг регионов…', { rows: 8 });
    ensureRegionStats().then(() => {
      if ((state.regionsView || 'catalog') === 'leaderboard') {
        renderRegionsLeaderboard();
      }
    });
    return;
  }

  const sortBy = state.regionsSortBy || 'points';
  const district = state.districtQuery || 'all';
  const query = state.regionQuery || '';

  const list = getRegionsLeaderboard(stats, { sortBy, district, query });

  const cntEl = $('#region-count');
  if (cntEl) cntEl.textContent = `${list.length} регионов РФ`;

  // Top 3 Podium (shown when not searching by text query and at least 3 items present)
  let podiumHtml = '';
  if (list.length >= 3 && !query) {
    const p1 = list[0];
    const p2 = list[1];
    const p3 = list[2];

    podiumHtml = `
      <div class="region-podium-grid">
        <!-- 2nd Place -->
        <div class="podium-card second" data-region-id="${p2.region.id}">
          <div class="podium-cup"><svg class="ic ic-silver" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg></div>
          <div class="podium-rank">2 место</div>
          <div class="podium-name">${esc(p2.region.name)}</div>
          <div class="podium-district">${esc(p2.region.district || '')}</div>
          <div class="podium-points">${p2.gto_points}<small>очков</small></div>
          <div class="podium-medals-mini">
            <span><svg class="ic ic-gold" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg> ${p2.gold_count}</span>
            <span><svg class="ic ic-silver" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg> ${p2.silver_count}</span>
            <span><svg class="ic ic-bronze" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg> ${p2.bronze_count}</span>
          </div>
        </div>

        <!-- 1st Place -->
        <div class="podium-card first" data-region-id="${p1.region.id}">
          <div class="podium-cup"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-trophy"/></svg></div>
          <div class="podium-rank">1 место</div>
          <div class="podium-name">${esc(p1.region.name)}</div>
          <div class="podium-district">${esc(p1.region.district || '')}</div>
          <div class="podium-points">${p1.gto_points}<small>очков</small></div>
          <div class="podium-medals-mini">
            <span><svg class="ic ic-gold" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg> ${p1.gold_count}</span>
            <span><svg class="ic ic-silver" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg> ${p1.silver_count}</span>
            <span><svg class="ic ic-bronze" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg> ${p1.bronze_count}</span>
          </div>
        </div>

        <!-- 3rd Place -->
        <div class="podium-card third" data-region-id="${p3.region.id}">
          <div class="podium-cup"><svg class="ic ic-bronze" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg></div>
          <div class="podium-rank">3 место</div>
          <div class="podium-name">${esc(p3.region.name)}</div>
          <div class="podium-district">${esc(p3.region.district || '')}</div>
          <div class="podium-points">${p3.gto_points}<small>очков</small></div>
          <div class="podium-medals-mini">
            <span><svg class="ic ic-gold" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg> ${p3.gold_count}</span>
            <span><svg class="ic ic-silver" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg> ${p3.silver_count}</span>
            <span><svg class="ic ic-bronze" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg> ${p3.bronze_count}</span>
          </div>
        </div>
      </div>
    `;
  }

  // Leaderboard Table Rows
  const tableRows = list.map((item, idx) => {
    const r = item.region;
    const rankClass = idx === 0 ? 'gold' : idx === 1 ? 'silver' : idx === 2 ? 'bronze' : '';
    return `
      <tr data-region-id="${r.id}" title="Нажмите для перехода к региону на карте">
        <td><span class="rl-rank-num ${rankClass}">${idx + 1}</span></td>
        <td>
          <div class="rl-reg-cell">
            <span class="rl-reg-name">${esc(r.name)}</span>
            <span class="rl-reg-district">${esc(r.district || '')}</span>
          </div>
        </td>
        <td><span class="rl-medal-num gold">${item.gold_count}</span></td>
        <td><span class="rl-medal-num silver">${item.silver_count}</span></td>
        <td><span class="rl-medal-num bronze">${item.bronze_count}</span></td>
        <td><span>${item.records_count}</span></td>
        <td><span>${item.athletes_count}</span></td>
        <td class="rl-points-cell">${item.gto_points}</td>
      </tr>
    `;
  }).join('');

  container.innerHTML = `
    ${podiumHtml}

    <div class="regions-leaderboard-card">
      <div class="rl-toolbar">
        <span class="rl-sort-label">Сортировка:</span>
        <div class="rl-sort-chips">
          <button type="button" class="rl-sort-btn ${sortBy === 'points' ? 'active' : ''}" data-rl-sort="points">
            <span>Очки ГТО</span>
          </button>
          <button type="button" class="rl-sort-btn ${sortBy === 'gold' ? 'active' : ''}" data-rl-sort="gold">
            <span><svg class="ic ic-gold" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg> Золото</span>
          </button>
          <button type="button" class="rl-sort-btn ${sortBy === 'medals' ? 'active' : ''}" data-rl-sort="medals">
            <span><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg> Все медали</span>
          </button>
          <button type="button" class="rl-sort-btn ${sortBy === 'athletes' ? 'active' : ''}" data-rl-sort="athletes">
            <span><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-users"/></svg> Атлеты</span>
          </button>
        </div>
      </div>

      <div class="rl-table-wrap" tabindex="0" role="region" aria-label="Таблица рейтинга (прокручивается)">
        <table class="rl-table" aria-label="Кубок и рейтинг субъектов РФ">
          <thead>
            <tr>
              <th style="width:34px;">#</th>
              <th>Субъект РФ</th>
              <th style="width:36px;" title="Золотые медали"><svg class="ic ic-gold" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg></th>
              <th style="width:36px;" title="Серебряные медали"><svg class="ic ic-silver" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg></th>
              <th style="width:36px;" title="Бронзовые медали"><svg class="ic ic-bronze" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg></th>
              <th style="width:40px;" title="Рекорды России">Рек.</th>
              <th style="width:44px;" title="Количество атлетов">Атл.</th>
              <th style="width:56px;text-align:right;" title="Официальные баллы рейтинга">Очки</th>
            </tr>
          </thead>
          <tbody>
            ${tableRows || '<tr><td colspan="8" style="text-align:center;padding:20px;color:#94a3b8;">По вашему запросу регионов не найдено.</td></tr>'}
          </tbody>
        </table>
      </div>

      <div class="rl-formula-hint">
        ℹ️ <b>Официальная формула Кубка регионов ГТО:</b> Золото × 10 + Серебро × 6 + Бронза × 4 + Рекорды × 3 + Атлеты × 1. Нажмите на субъект для просмотра на карте.
      </div>
    </div>
  `;
}

function renderRegions() {
  const isLeaderboard = (state.regionsView || 'catalog') === 'leaderboard';

  $$('#regions-view-tabs .rv-tab').forEach(t => {
    t.classList.toggle('active', t.dataset.regionsView === (isLeaderboard ? 'leaderboard' : 'catalog'));
  });

  const lbContainer = $('#region-leaderboard-container');
  const catWrapper = $('#region-catalog-wrapper');
  const regList = $('#region-list');

  if (isLeaderboard) {
    if (lbContainer) lbContainer.hidden = false;
    if (catWrapper) catWrapper.hidden = true;
    if (regList) regList.hidden = true;
    renderRegionsLeaderboard();
  } else {
    if (lbContainer) lbContainer.hidden = true;
    if (catWrapper) catWrapper.hidden = false;
    if (regList) regList.hidden = false;

    const q = state.regionQuery.toLowerCase();
    const items = GTO_FEDERATIONS.filter(f => {
      if (state.districtQuery !== 'all' && getDistrict(f.region) !== state.districtQuery) return false;
      return `${f.name} ${f.region} ${f.address} ${f.president}`.toLowerCase().includes(q);
    });

    const cntEl = $('#region-count');
    const nReg = items.filter((f) => String(f.code) !== 'RU').length;   // центральный аппарат — не отделение
    if (cntEl) cntEl.textContent = `${nReg} ${ruPlural(nReg, 'отделение', 'отделения', 'отделений')}`;

    if (regList) {
      regList.innerHTML = items.length ? items.map(f => {
        const pres = realPresident(f.president);
        const emblem = regionLogo(f.region, f.photo);
        const yandexUrl = `https://yandex.ru/maps/?text=${encodeURIComponent((f.region || '') + ' ' + (f.address || ''))}`;
        return `<div class="region-card" data-region="${f.id}">
          <div class="region-card-emblem-wrap">
            ${emblem}
          </div>
          <div class="region-card-body">
            <div class="region-card-title-row">
              <b>${esc(f.region)}</b>
              <span class="region-district-pill">${getDistrict(f.region)}</span>
            </div>
            ${pres ? `<small class="reg-pres">Председатель · ${esc(pres)}</small>` : '<small class="reg-pres">Региональное отделение</small>'}
            ${f.address ? `<small class="reg-addr">${esc(f.address)}</small>` : ''}
            <div class="region-card-actions">
              <button type="button" class="region-page-btn" data-region-open="${f.id}">
                <span>Страница региона</span>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>
              </button>
              <a class="route-btn" href="${yandexUrl}" target="_blank" rel="noopener">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="3 11 22 2 13 21 11 13 3 11"/></svg>
                <span>Маршрут</span>
              </a>
            </div>
          </div>
        </div>`;
      }).join('') : '<div class="empty">В этом округе отделений пока не найдено.</div>';
    }
  }

  renderRegionMap();
}

// пол атлета из разных форматов данных: «Мужчины»/«Женщины», «М»/«Ж», M/W/F
function athleteSex(a) {
  const g = String(a?.gender || a?.sex || '').trim().toLowerCase();
  if (/^(w|f|ж|жен)/.test(g)) return 'W';
  if (/^(m|м|муж)/.test(g)) return 'M';
  return '';
}

// карточка атлета региона: аватар, ФИО, город, число стартов
function regionAthleteCardHtml(a, reg) {
  const n = (a.competitions && a.competitions.length) || Number(a.competitions_count) || 0;
  return `<div class="region-athlete-card region-leader-card" data-open-athlete-id="${a.id}">
    <div class="region-leader-avatar">${getAthleteAvatarHtml(a, 44)}</div>
    <div class="region-athlete-info region-leader-info"><b class="region-leader-name text-wrap-safe">${esc(a.name)}</b><span class="text-wrap-safe">${esc(a.club || a.city || reg.capital)}</span></div>
    <div class="region-athlete-badges region-leader-badges">${n ? `<span class="reg-badge-rec" title="Стартов в протоколах">${n} ${ruPlural(n, 'старт', 'старта', 'стартов')}</span>` : ''}</div>
  </div>`;
}

// «Рекорды региона» на странице региона: число, свежие записи, ссылка на полный список (#records?region=<код>)
async function mountRegionRecords(reg) {
  const box = document.getElementById('region-own-records'); if (!box) return;
  const m = await regionalManifest(); const n = m.regions?.[String(reg.id)] || 0;
  if (!n || Number(box.dataset.regionId) !== reg.id) return;
  const items = await regionalRecords(reg.id);
  const fresh = [...items].sort((a, b) => Number(b.russia) - Number(a.russia) || String(b.date).localeCompare(String(a.date))).slice(0, 6);
  box.innerHTML = `<div class="region-section-head"><h3>Рекорды региона (${n})</h3><a class="rg-rec-all" href="#records?region=${reg.id}">Все рекорды региона →</a></div>
    <p class="rg-rec-note">Лучшие результаты спортсменов региона по дисциплинам, полу и возрасту — программа «Иду на рекорд» и реестр рекордов России.</p>
    <div class="region-records-grid">${fresh.map((r) => renderUnifiedRecordCard(r, { defaultCity: reg.name })).join('')}</div>`;
  box.hidden = false;
}

async function openRegion(idOrCodeOrSlug, push = true, restoreScrollY = null) {
  let reg = getRegionById(idOrCodeOrSlug);
  if (!reg) {
    const fed = GTO_FEDERATIONS.find(f => String(f.id) === String(idOrCodeOrSlug));
    if (fed) {
      const regId = normalizeRegionName(`${fed.region} ${fed.name}`);
      if (regId) reg = getRegionById(regId);
    }
  }
  if (!reg) {
    const regId = normalizeRegionName(String(idOrCodeOrSlug));
    if (regId) reg = getRegionById(regId);
  }
  if (!reg) return;

  if (push) {
    pushRoute({ screen: 'region', params: { id: reg.id } });
    resetScrollToTop();
  }

  state.currentRegionId = reg.id;
  await ensureRegionStats();

  const st = state.regionStats?.[reg.id] || {
    region: reg,
    athletes_count: 0,
    tournaments_count: 0,
    records_count: 0,
    podiums_count: 0,
    wins_count: 0,
    athletes: [],
    tournaments: [],
    records: [],
    federation: null,
    topAthletes: []
  };

  const fedBase = st.federation || GTO_FEDERATIONS.find(f => normalizeRegionName(f.region) === reg.id);
  const fedO = contentOverride('federations', reg.id);   // правка модератора: заполненные поля поверх исходных
  const fed = fedO && !fedO.deleted ? { ...(fedBase || {}), ...Object.fromEntries(Object.entries(fedO).filter(([, v]) => v)) } : fedBase;
  const pres = fedO?.president || (fed ? realPresident(fed.president) : '');
  const yandexUrl = fed ? `https://yandex.ru/maps/?text=${encodeURIComponent((reg.name || '') + ' ' + (fed.address || ''))}` : '';

  const detailEl = $('#region-detail');
  if (!detailEl) return;

  detailEl.innerHTML = `
    <div class="region-page-container">
      <div class="region-hero region-hero-card">
        <div class="region-hero-logo region-hero-emblem">${regionLogo(reg.name, fed?.photo)}</div>
        <div class="region-hero-content region-hero-info">
          <div class="region-meta region-district-tag text-wrap-safe">${esc(reg.district)} · Субъект №${reg.id}</div>
          <h1 class="region-title region-hero-name text-wrap-safe">${esc(reg.name)}</h1>
          ${reg.capital ? `<div class="region-center region-hero-capital text-wrap-safe">Центр: <b>${esc(reg.capital)}</b></div>` : ''}
        </div>
      </div>

      ${(() => {
        const men = st.athletes.filter(a => athleteSex(a) === 'M').length, women = st.athletes.filter(a => athleteSex(a) === 'W').length;
        const tot = Math.max(1, men + women);
        return `<section class="ath-bento rg-bento" aria-label="Регион в цифрах">
          <div class="ath-bento-cell is-main"><span class="ath-num" data-count="${st.athletes_count}">${st.athletes_count.toLocaleString('ru-RU')}</span><span class="ath-lbl">${ruPlural(st.athletes_count, 'спортсмен', 'спортсмена', 'спортсменов')} в реестре</span>
            ${men + women ? `<div class="rg-split" role="img" aria-label="Мужчины ${men}, женщины ${women}"><div class="rg-split-bar"><i class="m" style="width:${(men / tot * 100).toFixed(1)}%"></i><i class="w" style="width:${(women / tot * 100).toFixed(1)}%"></i></div><div class="rg-split-legend"><span><i class="m"></i>Мужчины <b>${men}</b></span><span><i class="w"></i>Женщины <b>${women}</b></span></div></div>` : ''}</div>
          <div class="ath-bento-cell blue"><span class="ath-num" data-count="${st.tournaments_count}">${st.tournaments_count}</span><span class="ath-lbl">${ruPlural(st.tournaments_count, 'турнир', 'турнира', 'турниров')} с участием</span></div>
          <div class="ath-bento-cell green"><span class="ath-num" data-count="${st.records_count}">${st.records_count}</span><span class="ath-lbl">${ruPlural(st.records_count, 'рекорд', 'рекорда', 'рекордов')} России</span></div>
          <div class="ath-bento-cell red"><span class="ath-num" data-count="${st.wins_count || 0}">${st.wins_count || 0}</span><span class="ath-lbl">${ruPlural(st.wins_count || 0, 'победа', 'победы', 'побед')}</span></div>
          <div class="ath-bento-cell gold"><span class="ath-num" data-count="${st.podiums_count || 0}">${st.podiums_count || 0}</span><span class="ath-lbl">${ruPlural(st.podiums_count || 0, 'подиум', 'подиума', 'подиумов')}</span></div>
        </section>`;
      })()}

      <div style="margin:-4px 0 16px 0;display:flex;justify-content:flex-start;">
        <button type="button" class="region-contact-btn contact-chip" data-open-ratings-region="${reg.id}" style="color:#38bdf8;border-color:rgba(56,189,248,0.4);background:rgba(56,189,248,0.1);font-weight:700;font-size:13px;padding:8px 16px;">
          <svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-trophy"/></svg> Рейтинг России: результаты, очки и медали региона →
        </button>
      </div>

      <div class="region-federation-card">
        ${fed ? `
          <div class="region-federation-details">
            <span class="standard-tag" style="width:fit-content">Официальное региональное отделение</span>
            <h3 class="region-federation-title text-wrap-safe">${esc(fed.name)}</h3>
            ${federationSourceHtml(fed)}
            ${pres ? `<p class="text-wrap-safe"><b>Председатель:</b> ${esc(pres)}</p>` : ''}
            ${fed.address ? `<p class="text-wrap-safe"><b>Адрес:</b> ${esc(fed.address)}</p>` : ''}
            <div class="region-federation-contacts">
              ${fed.phone ? `<a class="region-contact-btn contact-chip" href="tel:${esc(String(fed.phone).replace(/[^+\d]/g, ''))}"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-phone"/></svg> ${esc(formatPhone(fed.phone))}</a>` : ''}
              ${fed.email ? `<a class="region-contact-btn contact-chip" href="mailto:${esc(fed.email)}" title="${esc(fed.email)}"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-mail"/></svg> ${esc(fed.email)}</a>` : ''}
              ${yandexUrl ? `<a class="region-contact-btn contact-chip" href="${yandexUrl}" target="_blank" rel="noopener">↗ Яндекс Карты</a>` : ''}
              ${fed.site ? `<a class="region-contact-btn contact-chip" href="${safeUrl(fed.site)}" target="_blank" rel="noopener">↗ ${/vk\.com/.test(fed.site) ? 'ВКонтакте' : /t\.me/.test(fed.site) ? 'Telegram' : 'Сайт'}</a>` : ''}
            </div>
          </div>
        ` : `
          <div class="region-federation-details">
            <span class="standard-tag" style="width:fit-content;background:rgba(255,255,255,0.08);color:#94a3b8">Федерация</span>
            <h3 class="region-federation-title text-wrap-safe">Региональное отделение формируется</h3>
            <p class="text-wrap-safe">В ${esc(reg.name)} формируется официальное представительство Федерации многоборья ГТО России.</p>
            <div class="region-federation-contacts">
              <a class="region-contact-btn contact-chip" href="mailto:info@gto.com.ru"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-mail"/></svg> Подать заявку: info@gto.com.ru</a>
              <a class="region-contact-btn contact-chip" href="tel:+79863333333"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-phone"/></svg> +7 (986) 333-33-33</a>
            </div>
          </div>
        `}
        ${isModMode() ? `<button type="button" class="mod-inline-add" data-mod-fed-edit="${esc(reg.id)}" data-mod-fed-name="${esc(reg.name)}" data-mod-fed-json="${esc(JSON.stringify({ name: fed?.name || '', president: pres || '', address: fed?.address || '', phone: fed?.phone || '', email: fed?.email || '', site: fed?.site || '' }))}">✎ Изменить данные отделения</button>` : ''}
      </div>

      ${st.tournaments.length ? `
        <div class="region-section-block">
          <div class="region-section-head">
            <h3>Турниры в регионе (${st.tournaments.length})</h3>
          </div>
          <div class="region-tournaments-grid">
            ${st.tournaments.map(t => {
              const isLong = (t.title || '').length > 45;
              return `
              <article class="region-tournament-card" data-event="${t.id}">
                <div class="region-tournament-thumb">
                  ${getTournamentThumbnailHtml(t)}
                </div>
                <div class="region-tournament-body region-tournament-content">
                  <span class="rtc-city text-wrap-safe">${esc(t.city || reg.capital)}</span>
                  <h4 class="rtc-title region-tournament-title text-wrap-safe ${isLong ? 'is-extra-long' : ''}">${esc(t.title)}</h4>
                  <time class="rtc-date">${esc(t.date || t.year || '')}</time>
                  <span class="rtc-link">Протоколы и результаты →</span>
                </div>
              </article>
            `;}).join('')}
          </div>
        </div>
      ` : ''}

      ${st.records.length ? `
        <div class="region-section-block">
          <div class="region-section-head">
            <h3>Рекорды России региона (${st.records.length})</h3>
          </div>
          <div class="region-records-grid">
            ${st.records.map(r => renderUnifiedRecordCard(r, { defaultCity: reg.name })).join('')}
          </div>
        </div>
      ` : ''}

      <div class="region-section-block" id="region-own-records" data-region-id="${reg.id}" hidden></div>

      ${st.topAthletes.length ? `
        <div class="region-section-block">
          <div class="region-section-head">
            <h3>Лидеры региона</h3>
            <span class="rg-bars-legend"><i class="w"></i>победы <i class="p"></i>подиумы</span>
          </div>
          ${(() => {
            const score = (a) => (a.wins_count || 0) * 3 + (a.podiums_count || 0);
            const max = Math.max(1, ...st.topAthletes.map(score));
            return `<div class="rg-bars" role="group" aria-label="Лучшие атлеты региона">${st.topAthletes.map((a, k) => `
              <div class="rg-bar" data-open-athlete-id="${a.id}" tabindex="0" role="button" aria-label="${esc(a.name)}: побед ${a.wins_count || 0}, подиумов ${a.podiums_count || 0}">
                <span class="rg-bar-rank ${k < 3 ? 'top' + (k + 1) : ''}">${k + 1}</span>
                <span class="rg-bar-ava">${getAthleteAvatarHtml(a, 36)}</span>
                <span class="rg-bar-main"><span class="rg-bar-fill" style="--w:${(score(a) / max * 100).toFixed(1)}%"></span><b>${esc(a.name)}</b><small>${esc([a.club || a.city || reg.capital, athleteSex(a) === 'W' ? 'Женщины' : athleteSex(a) === 'M' ? 'Мужчины' : ''].filter(Boolean).join(' · '))}</small></span>
                <span class="rg-bar-val"><span class="w" title="Победы">${a.wins_count || 0}</span><span class="p" title="Подиумы">${a.podiums_count || 0}</span></span>
              </div>`).join('')}</div>`;
          })()}
          </div>
        </div>
      ` : ''}

      ${st.athletes.length ? `
        <div class="region-section-block" id="region-all-athletes-section">
          <div class="region-section-head">
            <h3>Все атлеты региона (${st.athletes.length})</h3>
          </div>
          <label class="search" style="margin-bottom:8px">
            <span>⌕</span>
            <input id="region-athlete-filter" type="search" placeholder="Поиск спортсмена по фамилии...">
          </label>
          <div class="region-athletes-grid" id="region-athletes-list">
            ${st.athletes.slice(0, 30).map(a => regionAthleteCardHtml(a, reg)).join('')}
          </div>
          ${st.athletes.length > 30 ? `
            <div style="text-align:center;margin-top:12px">
              <button type="button" class="tl-btn rg-more" id="region-load-more-athletes">Показать ещё атлетов <span>↓</span></button>
            </div>
          ` : ''}
        </div>
      ` : ''}

      ${(() => {
        const regNews = getUnifiedNews().filter(n => {
          if (n.region_id && String(n.region_id) === String(reg.id)) return true;
          if (n.region_name && (n.region_name.toLowerCase().includes(reg.shortName.toLowerCase()) || n.region_name.toLowerCase().includes(reg.name.toLowerCase()))) return true;
          if (n.category && (n.category.toLowerCase().includes(reg.shortName.toLowerCase()) || n.category.toLowerCase().includes(reg.name.toLowerCase()))) return true;
          return false;
        });
        if (!regNews.length) return '';
        return `
          <div class="region-section-block">
            <div class="region-section-head">
              <h3>Новости региона (${regNews.length})</h3>
            </div>
            <div class="news-list" style="margin-top:12px;display:grid;gap:12px;">
              ${regNews.slice(0, 5).map(x => `
                <button type="button" class="nwc" data-article="${x.id}">
                  <div>
                    <div style="display:flex;align-items:center;gap:6px;margin-bottom:4px;">
                      <time>${esc(x.date)}</time>
                      ${x.isHub ? `<span class="event-fmt-badge" style="font-size:10px;padding:2px 6px;background:rgba(56,189,248,0.15);color:#38bdf8;">Новостной хаб</span>` : ''}
                    </div>
                    <b>${esc(x.title)}</b>
                    <p>${esc(x.text)}</p>
                  </div>
                  <img loading="lazy" ${rsImgAttrs(x.img, 480)} alt="" data-fb="logo">
                </button>
              `).join('')}
            </div>
          </div>
        `;
      })()}

      <div class="legal" style="margin-top:24px">
        Статистика сформирована на основе официальных протоколов соревнований, ${(state.athleteIndex?.length || 4152).toLocaleString('ru-RU')} профилей атлетов и открытых данных Федерации многоборья ГТО.
      </div>
    </div>
  `;
  mountRegionRecords(reg);   // «Рекорды региона» — дорисовываются, когда придёт файл региона

  // Attach search filter for athletes list
  const athleteFilterInput = $('#region-athlete-filter');
  const athletesList = $('#region-athletes-list');
  let renderedCount = 30;

  if (athleteFilterInput && athletesList) {
    athleteFilterInput.addEventListener('input', e => {
      const q = (e.target.value || '').trim().toLowerCase();
      const filtered = q ? st.athletes.filter(a => (a.name || '').toLowerCase().includes(q)) : st.athletes.slice(0, renderedCount);
      athletesList.innerHTML = filtered.length ? filtered.map(a => regionAthleteCardHtml(a, reg)).join('') : '<div class="empty">Спортсменов по данному запросу не найдено.</div>';
    });
  }

  const loadMoreBtn = $('#region-load-more-athletes');
  if (loadMoreBtn && athletesList) {
    loadMoreBtn.addEventListener('click', () => {
      renderedCount += 30;
      const q = (athleteFilterInput?.value || '').trim().toLowerCase();
      const slice = q ? st.athletes.filter(a => (a.name || '').toLowerCase().includes(q)) : st.athletes.slice(0, renderedCount);
      athletesList.innerHTML = slice.map(a => regionAthleteCardHtml(a, reg)).join('');
      if (renderedCount >= st.athletes.length) {
        loadMoreBtn.remove();
      }
    });
  }

  go('region', false, push ? null : restoreScrollY);
  animateCounters(detailEl);

  const hashTarget = `#region/${reg.id}`;
  if (push && location.hash !== hashTarget) {
    history.pushState({ screen: 'region', id: reg.id }, '', hashTarget);
  } else if (location.hash !== hashTarget) {
    history.replaceState({ screen: 'region', id: reg.id }, '', hashTarget);
  }

  if (push) {
    resetScrollToTop();
  } else {
    const y = (typeof restoreScrollY === 'number') ? restoreScrollY : scrollStore.get(`region/${reg.id}`);
    if (typeof y === 'number') {
      restoreScrollPosition(y);
    } else {
      resetScrollToTop();
    }
  }
}


const DISCIPLINES = [
  ['3-Борье с бегом', 'Бег 800 / 1000 / 2000 м или 1000 / 1500 / 3000 м, комплекс функциональных упражнений и стрельба ПК-10 или К-25.'],
  ['3-Борье с плаванием', 'Плавание 50 / 100 / 200 / 400 м, комплекс функциональных упражнений и стрельба ПК-10 или К-25.'],
  ['3-Борье с лыжной гонкой', 'Лыжная гонка 1000 / 2500 м либо дистанция 3000 / 5000 м, функциональный комплекс и стрельба.'],
  ['Салки ГТО', 'Индивидуальный формат 1×1 или командный до 6 человек; 6–12 раундов до 30 секунд с препятствиями и упражнениями на ловкость.']
];

// «История» и «Фирменный стиль» — отдельный модуль about_screens.js (грузится при открытии экрана)
function renderHistory() {
  import('./about_screens.js?v=9f48deda').then((m) => m.renderHistoryScreen($('#history-content'))).catch(() => { $('#history-content').innerHTML = '<div class="empty">Не удалось загрузить раздел — обновите страницу</div>'; });
}

function renderDisciplines() {
  $('#disciplines-content').innerHTML = `
    <div style="font-size:11px;font-weight:700;color:#38bdf8;text-transform:uppercase;letter-spacing:1px;margin-bottom:8px">
      Главная / О Федерации / Дисциплины Многоборья Готов к труду и обороне
    </div>
    <div class="page-title" style="margin-bottom:16px">
      <span style="color:#ef4444;font-weight:700">Официально признанный вид спорта (ВРВС 1810001411Я)</span>
      <h1 style="font-family:var(--display);font-size:22px;line-height:1.2;margin:4px 0 8px">
        ДИСЦИПЛИНЫ МНОГОБОРЬЯ ГОТОВ К ТРУДУ И ОБОРОНЕ
      </h1>
      <p style="font-size:13px;color:#94a3b8;line-height:1.5">
        Многоборье ГТО объединяет беговые, лыжные, плавательные дистанции, комплексы функциональных силовых упражнений, стрельбу и динамичные командные салки.
      </p>
    </div>

    <!-- КАРТОЧКИ ДИСЦИПЛИН В СТИЛЕ ЭТАЛОНА GTO.COM.RU -->
    <div class="gto-disciplines-grid" style="display:flex;flex-direction:column;gap:18px">
      
      <!-- 1. 3-БОРЬЕ С БЕГОМ -->
      <article class="gto-disc-fullcard" style="background:radial-gradient(circle at 50% 0%, rgba(30,58,138,0.45) 0%, rgba(7,17,31,0.95) 100%);border:1px solid rgba(56,189,248,0.3);border-radius:20px;padding:22px;box-shadow:0 12px 32px rgba(0,0,0,0.5)">
        <div style="display:flex;align-items:center;gap:14px;margin-bottom:16px">
          <div class="gto-disc-icon-wrap" style="width:48px;height:48px;border-radius:14px;background:linear-gradient(135deg,#ef4444,#b91c1c);display:flex;align-items:center;justify-content:center;color:#fff;box-shadow:0 4px 14px rgba(239,68,68,0.4)">
            <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="14" cy="4.5" r="1.7"/><path d="M5 20l3-4 2.5-1.6L9 9 5.5 12"/><path d="M10.5 14.4 14 16l1.8 4"/><path d="M10 9l4-1.2 2 2.6 3 .8"/></svg>
          </div>
          <div>
            <h2 style="font-family:var(--display);font-size:20px;color:#fff;margin:0;letter-spacing:0.5px">3-БОРЬЕ С БЕГОМ</h2>
            <small style="color:#38bdf8;font-weight:600">Бег + Функциональный комплекс + Стрельба</small>
          </div>
        </div>

        <div style="background:rgba(255,255,255,0.03);border:1px solid rgba(255,255,255,0.08);border-radius:14px;padding:16px;display:flex;flex-direction:column;gap:12px;margin-bottom:14px">
          <div>
            <div style="color:#38bdf8;font-weight:800;font-size:15px;margin-bottom:4px">
              Бег 800 / 1000 / 2000 м
            </div>
            <div style="font-size:13px;color:#cbd5e1;line-height:1.5">
              + Комплекс функциональных упражнений<br>
              + Стрельба – упражнение ПК-10
            </div>
          </div>
          <div style="height:1px;background:rgba(255,255,255,0.08)"></div>
          <div>
            <div style="color:#38bdf8;font-weight:800;font-size:15px;margin-bottom:4px">
              Бег 1000 / 1500 / 3000 м
            </div>
            <div style="font-size:13px;color:#cbd5e1;line-height:1.5">
              + Комплекс функциональных упражнений<br>
              + Стрельба – упражнение К-25
            </div>
          </div>
        </div>

        <div style="font-size:12.5px;color:#94a3b8;line-height:1.6">
          <b style="color:#e2e8f0;display:block;margin-bottom:4px">Возрастные категории спортсменов (или команд из 6 спортсменов):</b>
          <div>+ Девушки и юноши 14-15 лет</div>
          <div>+ Девушки и юноши 16-17 лет</div>
          <div>+ Юниорки и юниоры 18-20 лет</div>
          <div>+ Юниорки и юниоры 21-23 года</div>
          <div>+ Женщины и мужчины 24-34 года, 35+ лет</div>
        </div>
      </article>

      <!-- 2. 3-БОРЬЕ С ПЛАВАНИЕМ -->
      <article class="gto-disc-fullcard" style="background:radial-gradient(circle at 50% 0%, rgba(14,116,144,0.45) 0%, rgba(7,17,31,0.95) 100%);border:1px solid rgba(6,182,212,0.3);border-radius:20px;padding:22px;box-shadow:0 12px 32px rgba(0,0,0,0.5)">
        <div style="display:flex;align-items:center;gap:14px;margin-bottom:16px">
          <div class="gto-disc-icon-wrap" style="width:48px;height:48px;border-radius:14px;background:linear-gradient(135deg,#06b6d4,#0e7490);display:flex;align-items:center;justify-content:center;color:#fff;box-shadow:0 4px 14px rgba(6,182,212,0.4)">
            <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="8" cy="7.5" r="1.7"/><path d="M4 16c2-1.2 3 .8 5 0s3-.8 5 0 3 .8 5 0M6.5 14l4-3 3 1.2"/></svg>
          </div>
          <div>
            <h2 style="font-family:var(--display);font-size:20px;color:#fff;margin:0;letter-spacing:0.5px">3-БОРЬЕ С ПЛАВАНИЕМ</h2>
            <small style="color:#67e8f9;font-weight:600">Плавание + Силовая гимнастика + Стрельба</small>
          </div>
        </div>

        <div style="background:rgba(255,255,255,0.03);border:1px solid rgba(255,255,255,0.08);border-radius:14px;padding:16px;display:flex;flex-direction:column;gap:12px;margin-bottom:14px">
          <div>
            <div style="color:#67e8f9;font-weight:800;font-size:15px;margin-bottom:4px">
              Плавание 50 / 100 / 200 м
            </div>
            <div style="font-size:13px;color:#cbd5e1;line-height:1.5">
              + Комплекс функциональных упражнений<br>
              + Стрельба – упражнение ПК-10
            </div>
          </div>
          <div style="height:1px;background:rgba(255,255,255,0.08)"></div>
          <div>
            <div style="color:#67e8f9;font-weight:800;font-size:15px;margin-bottom:4px">
              Плавание 50 / 100 / 200 / 400 м
            </div>
            <div style="font-size:13px;color:#cbd5e1;line-height:1.5">
              + Комплекс функциональных упражнений<br>
              + Стрельба – упражнение К-25
            </div>
          </div>
        </div>

        <div style="font-size:12.5px;color:#94a3b8;line-height:1.6">
          <b style="color:#e2e8f0;display:block;margin-bottom:4px">Возрастные категории спортсменов (или команд из 6 спортсменов):</b>
          <div>+ Девушки и юноши 14-15 лет</div>
          <div>+ Девушки и юноши 16-17 лет</div>
          <div>+ Юниорки и юниоры 18-20 лет</div>
          <div>+ Юниорки и юниоры 21-23 года</div>
          <div>+ Женщины и мужчины 24-34 года, 35+ лет</div>
        </div>
      </article>

      <!-- 3. 3-БОРЬЕ С ЛЫЖНОЙ ГОНКОЙ -->
      <article class="gto-disc-fullcard" style="background:radial-gradient(circle at 50% 0%, rgba(79,70,229,0.45) 0%, rgba(7,17,31,0.95) 100%);border:1px solid rgba(99,102,241,0.3);border-radius:20px;padding:22px;box-shadow:0 12px 32px rgba(0,0,0,0.5)">
        <div style="display:flex;align-items:center;gap:14px;margin-bottom:16px">
          <div class="gto-disc-icon-wrap" style="width:48px;height:48px;border-radius:14px;background:linear-gradient(135deg,#6366f1,#4338ca);display:flex;align-items:center;justify-content:center;color:#fff;box-shadow:0 4px 14px rgba(99,102,241,0.4)">
            <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="4" r="2"/><path d="M12 6v6l4 2M8 22l6-10M4 18l4-4"/></svg>
          </div>
          <div>
            <h2 style="font-family:var(--display);font-size:20px;color:#fff;margin:0;letter-spacing:0.5px">3-БОРЬЕ С ЛЫЖНОЙ ГОНКОЙ</h2>
            <small style="color:#a5b4fc;font-weight:600">Лыжная гонка / Кросс + Комплекс + Стрельба</small>
          </div>
        </div>

        <div style="background:rgba(255,255,255,0.03);border:1px solid rgba(255,255,255,0.08);border-radius:14px;padding:16px;display:flex;flex-direction:column;gap:12px;margin-bottom:14px">
          <div>
            <div style="color:#a5b4fc;font-weight:800;font-size:15px;margin-bottom:4px">
              Лыжная гонка 1000 / 2500 м
            </div>
            <div style="font-size:13px;color:#cbd5e1;line-height:1.5">
              + Комплекс функциональных упражнений<br>
              + Стрельба – упражнение ПК-10
            </div>
          </div>
          <div style="height:1px;background:rgba(255,255,255,0.08)"></div>
          <div>
            <div style="color:#a5b4fc;font-weight:800;font-size:15px;margin-bottom:4px">
              Бег 3000 / 5000 м или Лыжная гонка
            </div>
            <div style="font-size:13px;color:#cbd5e1;line-height:1.5">
              + Комплекс функциональных упражнений<br>
              + Стрельба – упражнение К-25
            </div>
          </div>
        </div>

        <div style="font-size:12.5px;color:#94a3b8;line-height:1.6">
          <b style="color:#e2e8f0;display:block;margin-bottom:4px">Возрастные категории спортсменов (или команд из 6 спортсменов):</b>
          <div>+ Девушки и юноши 14-15 лет</div>
          <div>+ Девушки и юноши 16-17 лет</div>
          <div>+ Юниорки и юниоры 18-20 лет</div>
          <div>+ Юниорки и юниоры 21-23 года</div>
        </div>
      </article>

      <!-- 4. САЛКИ ГТО -->
      <article class="gto-disc-fullcard" style="background:radial-gradient(circle at 50% 0%, rgba(217,119,6,0.45) 0%, rgba(7,17,31,0.95) 100%);border:1px solid rgba(245,158,11,0.3);border-radius:20px;padding:22px;box-shadow:0 12px 32px rgba(0,0,0,0.5)">
        <div style="display:flex;align-items:center;gap:14px;margin-bottom:16px">
          <div class="gto-disc-icon-wrap" style="width:48px;height:48px;border-radius:14px;background:linear-gradient(135deg,#f59e0b,#d97706);display:flex;align-items:center;justify-content:center;color:#fff;box-shadow:0 4px 14px rgba(245,158,11,0.4)">
            <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
          </div>
          <div>
            <h2 style="font-family:var(--display);font-size:20px;color:#fff;margin:0;letter-spacing:0.5px">САЛКИ ГТО (TAG SPORT)</h2>
            <small style="color:#fde68a;font-weight:600">Скорость, ловкость и преодоление полосы препятствий</small>
          </div>
        </div>

        <div style="background:rgba(255,255,255,0.03);border:1px solid rgba(255,255,255,0.08);border-radius:14px;padding:16px;display:flex;flex-direction:column;gap:10px;margin-bottom:14px">
          <div style="font-size:13.5px;color:#fde68a;font-weight:700">
            Индивидуальный зачёт: 1х1 (6–12 раундов, каждый до 30 секунд)
          </div>
          <div style="font-size:13.5px;color:#fde68a;font-weight:700">
            Командный зачёт: 2х2, 3х3, 4х4, 5х5, 6х6 (6–12 раундов до 30 секунд)
          </div>
          <p style="font-size:12.5px;color:#cbd5e1;line-height:1.5;margin:4px 0 0">
            Прыжки в длину и высоту, перелезания, пролазанья, кувырки, челночный бег, упражнения на гибкость, моторику, реакцию и пространственную ловкость.
          </p>
        </div>

        <div style="font-size:12.5px;color:#94a3b8;line-height:1.6">
          <b style="color:#e2e8f0;display:block;margin-bottom:4px">Возрастные категории:</b>
          <div>+ Девушки и юноши: 14-15 лет, 16-17 лет</div>
          <div>+ Юниорки и юниоры: 18-20 лет, 21-23 года</div>
          <div>+ Женщины и мужчины: 24-34 года, 35+ лет</div>
        </div>
      </article>

      <!-- 5. ГЕРОЙ ГТО / НАРОДНЫЕ ИГРЫ -->
      <article class="gto-disc-fullcard" style="background:radial-gradient(circle at 50% 0%, rgba(220,38,38,0.45) 0%, rgba(7,17,31,0.95) 100%);border:1px solid rgba(239,68,68,0.35);border-radius:20px;padding:22px;box-shadow:0 12px 32px rgba(0,0,0,0.5)">
        <div style="display:flex;align-items:center;gap:14px;margin-bottom:16px">
          <div class="gto-disc-icon-wrap" style="width:48px;height:48px;border-radius:14px;background:linear-gradient(135deg,#ef4444,#991b1b);display:flex;align-items:center;justify-content:center;color:#fff;box-shadow:0 4px 14px rgba(239,68,68,0.4)">
            <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></svg>
          </div>
          <div>
            <h2 style="font-family:var(--display);font-size:20px;color:#fff;margin:0;letter-spacing:0.5px">ГЕРОЙ ГТО</h2>
            <small style="color:#fca5a5;font-weight:600">Многоборье гибридного атлета (Кардио + Сила)</small>
          </div>
        </div>

        <div style="background:rgba(255,255,255,0.03);border:1px solid rgba(255,255,255,0.08);border-radius:14px;padding:16px;display:flex;flex-direction:column;gap:10px;margin-bottom:14px">
          <div style="color:#fff;font-size:13.5px;line-height:1.5">
            Уникальный формат проверки атлета в силовой и кардионагрузке одновременно:
            <b style="color:#38bdf8;display:block;margin-top:6px">
              Бег + 5 последовательных функциональных станций:
            </b>
            <div style="display:grid;grid-template-columns:repeat(auto-fit, minmax(130px, 1fr));gap:6px;margin-top:8px;font-size:12px;color:#cbd5e1">
              <span style="background:rgba(255,255,255,0.05);padding:6px;border-radius:8px;text-align:center">1. Строгие подтягивания</span>
              <span style="background:rgba(255,255,255,0.05);padding:6px;border-radius:8px;text-align:center">2. Отжимания</span>
              <span style="background:rgba(255,255,255,0.05);padding:6px;border-radius:8px;text-align:center">3. Приседания</span>
              <span style="background:rgba(255,255,255,0.05);padding:6px;border-radius:8px;text-align:center">4. Зашагивания на короб</span>
              <span style="background:rgba(255,255,255,0.05);padding:6px;border-radius:8px;text-align:center">5. Пресс</span>
            </div>
          </div>
        </div>

        <div style="display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:10px">
          <div style="font-size:12px;color:#94a3b8">
            Категории: «Первая попытка» (6+), «Любители» (12+), «Продвинутые» (14+), «Профессионалы» (16+)
          </div>
          <button type="button" data-go="hero" class="link-action" style="padding:8px 14px;font-size:12px">
            Перейти в кабинет Героя ГТО ↗
          </button>
        </div>
      </article>

    </div>

    <!-- ЕВСК СПОРТИВНЫЕ РАЗРЯДЫ -->
    <div class="section-head" style="margin-top:32px">
      <div>
        <span style="color:#38bdf8;font-weight:700">Минспорт России · ЕВСК</span>
        <h2 style="font-family:var(--display);font-size:18px">Спортивные разряды по Многоборью ГТО</h2>
      </div>
    </div>
    <p class="fact-source" style="margin-bottom:14px">
      Официальные разрядные нормативы Единой всероссийской спортивной классификации по виду спорта «Многоборье ГТО» (номер-код ВРВС: 1810001411Я).

    </p>

    <div class="evsk-disciplines">
      ${EVSK_DISCIPLINES.map(disc => `
        <section class="evsk-disc">
          <h3>${esc(disc.title)}</h3>
          <p>${esc(disc.description)}</p>
          <div class="table-scroll" tabindex="0" role="region" aria-label="Разрядные нормативы: ${esc(disc.title)} — таблица прокручивается">
            <table class="evsk-tbl">
              <thead><tr><th scope="col">Разряд</th><th scope="col">Мужчины</th><th scope="col">Женщины</th><th scope="col">Условия выполнения</th></tr></thead>
              <tbody>
              ${disc.malePoints.map((mp, idx) => {
                const fp = disc.femalePoints[idx] || {};
                if (mp.dev) return `<tr class="is-dev"><th scope="row">${esc(mp.rank)}</th><td colspan="3"><span class="evsk-dev">В разработке</span></td></tr>`;
                return `<tr><th scope="row">${esc(mp.rank)}</th>
                    <td>${esc(mp.points)}${typeof mp.points === 'number' ? ' очков' : ''}</td>
                    <td>${esc(fp.points || '—')}${typeof fp.points === 'number' ? ' очков' : ''}</td>
                    <td class="evsk-cond">${esc(mp.conditions)}</td></tr>`;
              }).join('')}
              </tbody>
            </table>
          </div>
        </section>
      `).join('')}
    </div>
  `;
}

function renderAbout() {
  $('#about-content').innerHTML = `<div class="page-title"><span>Официально</span><h1>О Федерации</h1><p>${esc(FEDERATION.definition)}</p></div>
<div class="fact-grid">${FEDERATION.stats.map(([v, l]) => [l.startsWith('региональных') ? String(regionalFedCount() || 51) : v, l]).map(([v, l]) => `<div><b>${esc(v)}</b><span>${esc(l)}</span></div>`).join('')}</div><p class="fact-source">Сводные показатели Федерации многоборья ГТО России, обновляются автоматически.</p>
<div class="section-head"><div><span>Как всё начиналось</span><h2>История</h2></div></div><div class="about-history">${FEDERATION.history.map(p => `<p>${esc(p)}</p>`).join('')}</div>
<div class="section-head"><div><span>Что развивает спорт</span><h2>Дисциплины</h2></div></div><div class="quality-chips">${FEDERATION.qualities.map(q => `<span>${esc(q)}</span>`).join('')}</div>
<div class="section-head"><div><span>Разделы Федерации</span><h2>Подробнее</h2></div></div><div class="link-stack">${FEDERATION.links.map(([t, u, go]) => go ? `<button data-go="${esc(u)}"><span><b>${esc(t)}</b></span><strong>→</strong></button>` : `<a href="${safeUrl(u)}" target="_blank" rel="noopener"><span><b>${esc(t)}</b></span><strong>↗</strong></a>`).join('')}</div>
${partnerBlockHtml()}
<div class="legal">Раздел собран из открытых официальных материалов Федерации. Имена и составы руководящих органов не публикуются здесь во избежание неточностей — открывайте первоисточник.</div>`;
  bindPartnerVideo($('#about-content'));   // ролик «Героя ГТО» — по кругу без звука, как на главной
  syncFactGrids();
}

// ----------------------------------------------------
// КАЛЬКУЛЯТОР СТУПЕНЕЙ ГТО — отдельный модуль calculator_screen.js, грузится при первом открытии
// ----------------------------------------------------
let calcMod = null, calcModPromise = null;
function calculatorModule() {
  if (!calcModPromise) calcModPromise = import('./calculator_screen.js?v=e452c053').then((m) => (calcMod = m)).catch((err) => { calcModPromise = null; throw err; });
  return calcModPromise;
}
function renderCalculator(...args) { return calculatorModule().then((m) => m.renderCalculator(...args)); }
function applyCalculatorPreset(...args) { return calculatorModule().then((m) => m.applyCalculatorPreset(...args)); }
function updateCalculatorValue(...args) { return calculatorModule().then((m) => m.updateCalculatorValue(...args)); }
// ----------------------------------------------------
// ИНФОГРАФИКА «ПУТЬ АТЛЕТА: 5 ШАГОВ К РАЗРЯДУ»
// ----------------------------------------------------
export function renderAthletePath() {
  const box = $('#path-content');
  if (!box) return;

  box.innerHTML = `
    <div class="path-stepper">
      <!-- Шаг 1 -->
      <div class="path-step-card step-1">
        <div class="path-step-badge-num">
          <span>Шаг</span>
          <b>01</b>
        </div>
        <div class="path-step-body">
          <span class="path-step-tag red">Регистрация</span>
          <h3 class="path-step-title">Получение УИН на официальном портале gto.ru</h3>
          <p class="path-step-desc">Зарегистрируйтесь на федеральном портале и получите уникальный 11-значный идентификационный номер. Номер привязывается к вашему профилю Госуслуг и действует бессрочно.</p>
          <div class="path-step-perks">
            <span class="path-step-perk"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-key-round"/></svg> УИН из 11 цифр</span>
            <span class="path-step-perk">🇷🇺 Привязка к Госуслугам</span>
            <span class="path-step-perk"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-baby"/></svg> До 14 лет — через родителей</span>
          </div>
          <a href="https://gto.ru" target="_blank" rel="noopener" class="path-step-action">
            <span>Регистрация на gto.ru</span>
            <span>↗</span>
          </a>
        </div>
      </div>

      <!-- Шаг 2 -->
      <div class="path-step-card step-2">
        <div class="path-step-badge-num">
          <span>Шаг</span>
          <b>02</b>
        </div>
        <div class="path-step-body">
          <span class="path-step-tag orange">Медицина</span>
          <h3 class="path-step-title">Медицинский допуск и диспансеризация</h3>
          <p class="path-step-desc">Пройдите плановый медосмотр в поликлинике по месту жительства и получите медицинскую справку-допуск (форма № 1144-н). Прохождение диспансеризации в том же году открывает право на <b>налоговый вычет 18 000 ₽</b>.</p>
          <div class="path-step-perks">
            <span class="path-step-perk"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-stethoscope"/></svg> Справка № 1144-н</span>
            <span class="path-step-perk"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-wallet"/></svg> Вычет 18 000 ₽ (ст. 218 НК РФ)</span>
            <span class="path-step-perk"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-hospital"/></svg> По ОМС бесплатно</span>
          </div>
          <button type="button" class="path-step-action" data-go="faq">
            <span>Как оформить вычет? (FAQ)</span>
            <span>→</span>
          </button>
        </div>
      </div>

      <!-- Шаг 3 -->
      <div class="path-step-card step-3">
        <div class="path-step-badge-num">
          <span>Шаг</span>
          <b>03</b>
        </div>
        <div class="path-step-body">
          <span class="path-step-tag blue">Тренинг</span>
          <h3 class="path-step-title">Подготовка и тренировки с таймером ФМГТО</h3>
          <p class="path-step-desc">Тренируйтесь по профессиональным интервальным протоколам Табата, EMOM и AMRAP с встроенным звуковым таймером приложения. Изучите официальные судейские критерии, чтобы избежать срывов повторений No-Rep.</p>
          <div class="path-step-perks">
            <span class="path-step-perk"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-timer"/></svg> WOD-таймер без интернета</span>
            <span class="path-step-perk"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-ruler"/></svg> Судейские стандарты No-Rep</span>
            <span class="path-step-perk"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-biceps-flexed"/></svg> 3-борье и функционал</span>
          </div>
          <div style="display:flex;gap:8px;flex-wrap:wrap">
            <button type="button" class="path-step-action" data-go="timer">
              <span>Открыть WOD-таймер</span>
              <span>→</span>
            </button>
            <button type="button" class="path-step-action" data-go="standards">
              <span>Стандарты No-Rep</span>
              <span>→</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Шаг 4 -->
      <div class="path-step-card step-4">
        <div class="path-step-badge-num">
          <span>Шаг</span>
          <b>04</b>
        </div>
        <div class="path-step-body">
          <span class="path-step-tag green">Тестирование</span>
          <h3 class="path-step-title">Выполнение нормативов на Золотой знак</h3>
          <p class="path-step-desc">Запишитесь в центр тестирования и выполните испытания своей возрастной ступени. Наш калькулятор заранее рассчитает, сколько обязательных тестов и видов по выбору вам необходимо сдать.</p>
          <div class="path-step-perks">
            <span class="path-step-perk"><svg class="ic ic-gold" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg> Золотой знак Минспорта РФ</span>
            <span class="path-step-perk"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-graduation-cap"/></svg> До 10 баллов к ЕГЭ в вузы</span>
            <span class="path-step-perk"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-trending-up"/></svg> Повышенная стипендия</span>
          </div>
          <button type="button" class="path-step-action" data-go="calculator">
            <span>Рассчитать нормы в калькуляторе</span>
            <span>→</span>
          </button>
        </div>
      </div>

      <!-- Шаг 5 -->
      <div class="path-step-card step-5">
        <div class="path-step-badge-num">
          <span>Шаг</span>
          <b>05</b>
        </div>
        <div class="path-step-body">
          <span class="path-step-tag gold">Спорт высших достижений</span>
          <h3 class="path-step-title">Турниры ФМГТО РФ и спортивные разряды ЕВСК</h3>
          <p class="path-step-desc">Переходите из любителей в официальный спорт! Участвуйте в соревнованиях Единого календарного плана Минспорта (№ 216), шоу «Иду на рекорд», Играх ГТО и выполняйте спортивные разряды от 3-го юношеского до Мастера спорта России.</p>
          <div class="path-step-perks">
            <span class="path-step-perk"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-scroll-text"/></svg> Разряды ЕВСК (1810001411Я)</span>
            <span class="path-step-perk"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-trophy"/></svg> 114 официальных стартов</span>
            <span class="path-step-perk"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-award"/></svg> I–III разряды · МС и КМС — в разработке</span>
          </div>
          <div style="display:flex;gap:8px;flex-wrap:wrap">
            <button type="button" class="path-step-action" data-go="events">
              <span>Календарь соревнований</span>
              <span>→</span>
            </button>
            <button type="button" class="path-step-action" data-go="records">
              <span>Рекорды России</span>
              <span>→</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  `;
}

// ----------------------------------------------------
// РАЗДЕЛ «ЗВЁЗДЫ И АМБАССАДОРЫ МНОГОБОРЬЯ ГТО РОССИИ»
// ----------------------------------------------------
export function renderAmbassadors() {
  const box = $('#ambassadors-content');
  if (!box) return;

  box.innerHTML = `
    <div class="ambassadors-grid">
      ${GTO_AMBASSADORS.map(a => `
        <div class="ambassador-card" id="ambassador-${a.id}">
          <div class="ambassador-top">
            <div class="ambassador-avatar-wrap">
              <img class="ambassador-avatar" src="${esc(a.avatar)}" alt="${esc(a.name)}" data-fb="logo" loading="lazy">
              <span class="ambassador-badge-tag">${esc(a.badge)}</span>
            </div>
            <div class="ambassador-info">
              <h3 class="ambassador-name">${esc(a.name)}</h3>
              <div class="ambassador-title">${esc(a.title)}</div>
              <div class="ambassador-city"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-map-pin"/></svg> ${esc(a.city)} · ${esc(a.role)}</div>
            </div>
          </div>

          <div class="ambassador-stats-row">
            ${a.stats.map(s => `
              <div class="ambassador-stat-col">
                <b>${esc(s.val)}</b>
                <small>${esc(s.label)}</small>
              </div>
            `).join('')}
          </div>

          <div class="ambassador-quote">${esc(a.quote)}</div>

          <ul class="ambassador-achievements">
            ${a.achievements.map(ach => `<li>${esc(ach)}</li>`).join('')}
          </ul>
        </div>
      `).join('')}
    </div>
  `;
}

// ----------------------------------------------------
// ИНТЕРАКТИВНАЯ БАЗА ЗНАНИЙ И FAQ
// ----------------------------------------------------
export function renderFaq() {
  const box = $('#faq-content');
  if (!box) return;

  const currentCat = state.faqCategory || 'all';
  const query = (state.faqQuery || '').toLowerCase().trim();

  const filteredItems = GTO_FAQ_ITEMS.filter(item => {
    if (currentCat !== 'all' && item.cat !== currentCat) return false;
    if (query) {
      const qText = (item.q + ' ' + item.badge + ' ' + item.answer).toLowerCase();
      if (!qText.includes(query)) return false;
    }
    return true;
  });

  box.innerHTML = `
    <div class="faq-search-wrap">
      <span>⌕</span>
      <input type="search" id="faq-search-input" value="${esc(state.faqQuery)}" placeholder="Поиск (налог, вычет 18 000, ЕГЭ, No-Rep, приказы)...">
    </div>

    <div class="faq-filter-chips">
      <button class="faq-chip ${currentCat === 'all' ? 'active' : ''}" data-faq-cat="all">Все вопросы</button>
      ${GTO_FAQ_CATEGORIES.map(c => `
        <button class="faq-chip ${currentCat === c.id ? 'active' : ''}" data-faq-cat="${c.id}">
          <span>${c.icon}</span>
          <span>${esc(c.name)}</span>
        </button>
      `).join('')}
    </div>

    <div class="faq-accordion-list">
      ${filteredItems.length === 0 ? `
        <div style="text-align:center;padding:30px 20px;color:#94a3b8">По вашему запросу вопросов не найдено. Попробуйте скорректировать поиск.</div>
      ` : filteredItems.map(item => {
        const isOpen = state.faqExpanded.has(item.id);
        return `
          <div class="faq-accordion-item ${isOpen ? 'open' : ''}" id="faq-item-${item.id}">
            <div class="faq-header" data-faq-toggle="${item.id}">
              <div class="faq-header-content">
                <span class="faq-badge-tag">${esc(item.badge)}</span>
                <h4 class="faq-question-title">${esc(item.q)}</h4>
              </div>
              <div class="faq-chevron">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
              </div>
            </div>
            ${isOpen ? `<div class="faq-body">${item.answer}</div>` : ''}
          </div>
        `;
      }).join('')}
    </div>
  `;
}


// ----------------------------------------------------
// ТАЙМЕР И ЗАПИСЬ ОТБОРА — отдельный модуль timer_screen.js, грузится при первом открытии #timer
// ----------------------------------------------------
let timerMod = null, timerModPromise = null;
function loadTimerModule() {
  if (!timerModPromise) timerModPromise = import('./timer_screen.js?v=804414bb').then((m) => (timerMod = m)).catch((err) => { timerModPromise = null; throw err; });
  return timerModPromise;
}
function renderTimer() {
  loadTimerModule().then((m) => m.renderTimer()).catch(() => { const box = $('#timer-content'); if (box) box.innerHTML = '<div class="empty">Не удалось загрузить таймер — обновите страницу</div>'; });
}

// «Отменить» 10 секунд после удаления/снятия (модератор); undo() → { ok, error }
function offerUndo(message, undo) {
  import('./mod_ui.js?v=9a7f86f1')
    .then((m) => m.undoToast(message, async () => { const r = await undo(); if (r && r.ok === false) throw new Error(r.error || 'сервер отказал'); }))
    .catch(() => showToast(`✓ ${message}`));
}

export function showToast(msg, duration = 2800) {
  if (typeof window.fmgtoNotify === 'function') { window.fmgtoNotify(msg); return; }
  let toast = $('#gto-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'gto-toast';
    toast.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:rgba(16,185,129,0.95);color:#fff;font-weight:800;font-size:13px;padding:12px 20px;border-radius:14px;box-shadow:0 8px 24px rgba(0,0,0,0.5);z-index:999999;pointer-events:none;transition:opacity .25s ease;backdrop-filter:blur(8px);text-align:center;max-width:90vw;';
    document.body.appendChild(toast);
  }
  toast.textContent = msg;
  toast.style.opacity = '1';
  clearTimeout(toast._tid);
  toast._tid = setTimeout(() => {
    toast.style.opacity = '0';
  }, duration);
}
// ----------------------------------------------------
// СУДЕЙСКИЕ СТАНДАРТЫ И NO-REP
// ----------------------------------------------------
function renderStandards() {
  const box = $('#standards-content');
  if (!box) return;
  const q = state.standardCat;
  const items = GTO_STANDARDS.filter(s => q === 'all' || s.category.includes(q) || (q === 'Скоростно-силовые качества' && /прыж|скорост/i.test(s.category)));

  // «можно / нельзя» (как do/don't в гайдлайнах дизайн-систем): раскрывающаяся карточка, зачёт и нарушения рядом
  const cnt = $('#standards-count');
  if (cnt) cnt.textContent = `${items.length} ${ruPlural(items.length, 'упражнение', 'упражнения', 'упражнений')} · ${items.reduce((n, s) => n + s.noRep.length, 0)} типичных нарушений`;
  box.innerHTML = items.map((s, k) => `
    <details class="stdc" ${k === 0 ? 'open' : ''}>
      <summary class="stdc-head">
        <span class="stdc-icon" aria-hidden="true">${disciplineIcon(s.title)}</span>
        <span class="stdc-title"><b>${esc(s.title)}</b><small>${esc(s.equipment)}</small></span>
        <span class="stdc-meta"><span class="stdc-tag">${esc(s.category)}</span><span class="stdc-n ok">✓ ${s.repStandard.length}</span><span class="stdc-n no">✕ ${s.noRep.length}</span></span>
        <span class="stdc-chev" aria-hidden="true"></span>
      </summary>
      <div class="stdc-body">
        <p class="stdc-start"><b>Исходное положение</b>${esc(s.startingPosition)}</p>
        <div class="stdc-cols">
          <section class="stdc-col ok"><h3><i aria-hidden="true">✓</i>Зачёт (Rep)</h3><ul>${s.repStandard.map(r => `<li>${esc(r)}</li>`).join('')}</ul></section>
          <section class="stdc-col no"><h3><i aria-hidden="true">✕</i>Не зачёт (No-Rep)</h3><ul>${s.noRep.map(r => `<li>${esc(r)}</li>`).join('')}</ul></section>
        </div>
        <p class="stdc-tip"><b>Совет судьи</b>${esc(s.judgeTip)}</p>
      </div>
    </details>
  `).join('');
}

// ----------------------------------------------------
// ГЛОБАЛЬНЫЙ ПОИСК АТЛЕТА ПО ВСЕМ 21 ПРОТОКОЛАМ
// ----------------------------------------------------
// профиль и поиск без 21 МБ: data/athletes/index.json (лёгкий индекс) и data/athletes/<ATH>.json (карточка + место в рейтинге)
// собирает publish (scripts/server/split_athletes.py); полный каталог (buildAthleteIndex) — только статистике регионов и кабинету
let athleteLitePromise = null;
function loadAthleteLite() {
  if (state.athleteIndex) return Promise.resolve(state.athleteIndex);
  if (state.athleteLite) return Promise.resolve(state.athleteLite);
  athleteLitePromise ||= fetch('./data/athletes/index.json').then((r) => r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status)))
    .then((list) => { state.athleteLite = list.map((a) => ({ ...a, kind: 'profile' })); athleteByNameCache.clear(); return state.athleteLite; })
    .catch(() => { athleteLitePromise = null; return buildAthleteIndex(); });
  return athleteLitePromise;
}
async function fetchAthleteCard(strId) {
  let aid = strId;
  if (!/^ATH-/i.test(aid)) {
    const hit = (await loadAthleteLite()).find((a) => String(a.id) === aid || (Number(aid) && Number(a.id) === Number(aid)));
    if (!hit?.athlete_id) return null; aid = hit.athlete_id;
  }
  const r = await fetch(`./data/athletes/${encodeURIComponent(aid)}.json`).catch(() => null);
  return r && r.ok ? { ...(await r.json()), kind: 'profile' } : null;
}

async function buildAthleteIndex() {
  if (state.athleteIndex) return state.athleteIndex;
  state.athleteLoading = true;
  const countEl = $('#athlete-search-count');
  if (countEl) countEl.textContent = 'Загружаем каталог атлетов…';
  try {
    const response = await fetch('./data/master/athletes.json?v=82');
    if (response.ok) {
      const athletes = await response.json();
      if (Array.isArray(athletes) && athletes.length) {
        state.athleteIndex = athletes.map(athlete => ({ ...athlete, kind: 'profile' }));
        athleteByNameCache.clear();
        state.athleteMap = new Map();
        state.athleteIndex.forEach(a => state.athleteMap.set(Number(a.id), a));
        state.athleteLoading = false;
        // человек начал печатать до того, как каталог догрузился (медленная сеть): его запрос не потерян — ищем сейчас
        const pending = $('#global-athlete-search');
        if (pending && pending.value.trim().length >= 2 && pending.value !== state.athleteQuery) {
          state.athleteQuery = pending.value;
          setTimeout(renderAthleteSearch, 0);
        }
        return state.athleteIndex;
      }
    }
  } catch (_) {}

  const index = [];
  const eventIds = Object.keys(state.eventManifest.events || {}).filter(id => state.eventManifest.events[id].results);

  await Promise.all(eventIds.map(async id => {
    try {
      const res = await fetch(`./data/events/${id}.json?v=18`);
      if (!res.ok) return;
      const data = await res.json();
      (data.results || []).forEach(sec => {
        (sec.tables || []).forEach(tbl => {
          const hi = findHeaderRow(tbl);
          if (hi < 0) return;
          const H = tbl[hi].map(x => String(x || '').trim().toLowerCase());
          const find = re => H.findIndex(h => re.test(h));
          const iSurname = find(/фамил/);
          const iName = find(/^имя|^ф\.?и\.?о/);
          if (iSurname < 0 && iName < 0) return;
          const iRank = find(/^(№|n|место|п\/п)$/);
          const iRes = find(/результат|очки|балл|сумма|итог/);
          const iCat = find(/категор|группа|возраст/);

          for (let i = hi + 1; i < tbl.length; i++) {
            const row = tbl[i];
            const name = [iSurname, iName].filter(x => x >= 0).map(x => row[x]).filter(Boolean).join(' ').trim();
            if (!name || name.length < 3 || HEADER_TOKENS.test(name)) continue;
            index.push({
              eventId: id,
              eventTitle: data.title || '',
              eventPeriod: data.period || '',
              section: sec.title || '',
              name,
              rank: iRank >= 0 && row[iRank] ? String(row[iRank]).trim() : '',
              result: iRes >= 0 && row[iRes] ? String(row[iRes]).trim() : '',
              cat: iCat >= 0 && row[iCat] ? String(row[iCat]).trim() : ''
            });
          }
        });
      });
    } catch (_) {}
  }));

  state.athleteIndex = index;
  athleteByNameCache.clear();
  state.athleteLoading = false;
  return index;
}

const athleteByNameCache = new Map();
function findAthleteByName(name) {
  const list = state.athleteIndex || state.athleteLite;
  if (!list || !name) return null;
  const n = clean(name).toLowerCase();
  if (athleteByNameCache.has(n)) return athleteByNameCache.get(n);
  let match = list.find(a => clean(a.name).toLowerCase() === n);
  if (match) {
    athleteByNameCache.set(n, match);
    return match;
  }
  const parts = n.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    const rev = `${parts[1]} ${parts[0]}`;
    match = list.find(a => clean(a.name).toLowerCase() === rev);
    if (match) {
      athleteByNameCache.set(n, match);
      return match;
    }
  }
  const partials = list.filter(a => clean(a.name).toLowerCase().includes(n));
  if (partials.length === 1) {
    athleteByNameCache.set(n, partials[0]);
    return partials[0];
  }
  athleteByNameCache.set(n, null);
  return null;
}
window.findAthleteByName = findAthleteByName;
// кабинет «Герой ГТО» берёт историю по ID из того же источника, что и публичный профиль (иначе копия в браузере устаревает)
window.getAthleteRecord = async (id) => {
  const strId = String(id || '').trim(); const numId = Number(strId.replace(/^ATH-0*/i, ''));
  if (!strId) return null;
  const card = (state.athleteMap && (state.athleteMap.get(numId) || state.athleteMap.get(strId))) || await fetchAthleteCard(strId).catch(() => null);
  if (card) return card;
  const index = await buildAthleteIndex();
  return index.find(a => Number(a.id) === numId || a.athlete_id === strId)
    || await fetchMasterAthlete(strId).catch(() => null);
};

function formatPlacementBadge(rank) {
  const r = String(rank || '').trim().toLowerCase();
  if (r === '1' || r.includes('золото') || r.includes('1 место') || r.includes('1-е место')) {
    return '<span class="athlete-badge-gold"><svg class="ic ic-gold" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg> 1 место</span>';
  }
  if (r === '2' || r.includes('серебро') || r.includes('2 место') || r.includes('2-е место')) {
    return '<span class="athlete-badge-silver"><svg class="ic ic-silver" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg> 2 место</span>';
  }
  if (r === '3' || r.includes('бронза') || r.includes('3 место') || r.includes('3-е место')) {
    return '<span class="athlete-badge-bronze"><svg class="ic ic-bronze" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg> 3 место</span>';
  }
  if (r && r !== '-') {
    return `<span class="athlete-badge-rank">№ ${esc(rank)}</span>`;
  }
  return '<span class="athlete-badge-participant">Участник</span>';
}


// ---------- Личные рекорды и динамика (из единой базы: /api/athletes/:id/bests, график uPlot) ----------
let _uplotPromise = null;
function ensureUPlot() {
  if (window.uPlot) return Promise.resolve();
  if (_uplotPromise) return _uplotPromise;
  _uplotPromise = new Promise((resolve, reject) => {
    const css = document.createElement('link'); css.rel = 'stylesheet'; css.href = './js/vendor/uPlot.min.css?v=67765ea7'; document.head.appendChild(css);
    const s = document.createElement('script'); s.src = './js/vendor/uPlot.iife.min.js?v=bf2d0290'; s.onload = resolve; s.onerror = reject; document.head.appendChild(s);
  });
  return _uplotPromise;
}
function fmtBest(b) {
  const v = Number(b.best);
  if (b.kind === 'time') return v >= 60 ? `${Math.floor(v / 60)}:${String(Math.round(v % 60)).padStart(2, '0')}` : `${v} с`;
  if (b.kind === 'points') return `${v} б.`;
  return String(v);
}
// график и его библиотеку (uPlot) грузим, только когда блок подъехал к экрану — профиль открывается быстрее (Lighthouse: bootup)
function whenNearViewport(el, margin = '300px') {
  if (!el || !('IntersectionObserver' in window)) return Promise.resolve();
  return new Promise((resolve) => {
    const io = new IntersectionObserver((entries) => { if (entries.some((e) => e.isIntersecting)) { io.disconnect(); resolve(); } }, { rootMargin: margin });
    io.observe(el);
  });
}
async function loadAthleteProgress(athlete) {
  const box = $('#athlete-progress');
  if (!box) return;
  await whenNearViewport(box);
  if (!box.isConnected) return;
  const id = athlete.athlete_id || athlete.id;
  if (box.dataset.loadedFor === String(id)) return;   // экран перерисовывается несколько раз — грузим один раз
  box.dataset.loadedFor = String(id);
  let data = null;
  try { const r = await fetch(`/api/athletes/${encodeURIComponent(id)}/bests`); if (r.ok) data = await r.json(); } catch (_) {}
  if (!data || !data.ok || !data.bests || !data.bests.length) return;
  // график только там, где есть результаты хотя бы на двух разных датах
  const seriesKeys = Object.keys(data.series || {}).filter(k => new Set((data.series[k] || []).map(r => r.date)).size >= 2);
  box.hidden = false;
  box.innerHTML = `
    <div class="athlete-section-title section-title">
      <span>Личные рекорды</span>
      <span class="athlete-section-count">${data.bests.length}</span>
    </div>
    <div class="athlete-bests-grid" style="display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:10px">
      ${data.bests.map(b => `
        <div class="athlete-best-card" style="background:rgba(56,189,248,0.06);border:1px solid rgba(56,189,248,0.18);border-radius:14px;padding:12px 14px">
          <div style="font-size:11px;color:#94a3b8;line-height:1.3;min-height:28px">${esc(b.discipline)}</div>
          <div style="font-size:26px;font-weight:800;color:#fff;line-height:1.1;margin-top:6px">${esc(fmtBest(b))}</div>
          <div style="font-size:11px;color:#64748b;margin-top:4px">${b.attempts} ${b.attempts === 1 ? 'попытка' : b.attempts < 5 ? 'попытки' : 'попыток'}${b.last_date ? ' · ' + esc(b.last_date.slice(0, 4)) : ''}</div>
        </div>`).join('')}
    </div>
    ${seriesKeys.length ? `
      <div style="margin-top:14px">
        <div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:8px">
          ${seriesKeys.map((k, i) => `<button type="button" class="athlete-progress-chip${i === 0 ? ' active' : ''}" data-progress-key="${esc(k)}" style="font-size:11.5px;padding:6px 11px;border-radius:999px;border:1px solid rgba(56,189,248,${i === 0 ? '0.6' : '0.25'});background:${i === 0 ? 'rgba(56,189,248,0.18)' : 'rgba(56,189,248,0.06)'};color:${i === 0 ? '#e0f2fe' : '#94a3b8'};cursor:pointer">${esc(k.replace(/\s*\(.*?\)\s*/g, ''))}</button>`).join('')}
        </div>
        <div id="athlete-progress-chart" style="background:rgba(5,11,22,0.5);border:1px solid rgba(148,163,184,0.14);border-radius:14px;padding:8px 6px 2px;min-height:200px"></div>
        <div style="font-size:11px;color:#64748b;margin-top:6px">Динамика результата по официальным протоколам</div>
      </div>` : ''}
  `;
  if (!seriesKeys.length) return;
  let plot = null;
  const draw = async (key) => {
    try { await ensureUPlot(); } catch (_) { return; }
    const rows = data.series[key]; const el = $('#athlete-progress-chart'); if (!el) return;
    if (plot) { plot.destroy(); plot = null; }
    const xs = rows.map(r => Math.floor(new Date(r.date).getTime() / 1000)); const ys = rows.map(r => r.value);
    const lower = /^(Бег|Челночн)/.test(key);
    plot = new uPlot({
      width: el.clientWidth - 12, height: 190, padding: [10, 8, 0, 0],
      scales: { x: { time: true }, y: { dir: lower ? -1 : 1 } },
      axes: [
        { stroke: '#64748b', grid: { stroke: 'rgba(148,163,184,0.08)' }, ticks: { stroke: 'rgba(148,163,184,0.15)' }, values: (u, vals) => vals.map(v => new Date(v * 1000).toLocaleDateString('ru-RU', { month: 'short', year: '2-digit' })) },
        { stroke: '#64748b', grid: { stroke: 'rgba(148,163,184,0.08)' }, size: 44 }
      ],
      series: [ {}, { label: key, stroke: '#38bdf8', width: 2.5, fill: 'rgba(56,189,248,0.10)', points: { size: 8, fill: '#0b1628', stroke: '#38bdf8', width: 2 } } ],
      cursor: { drag: { x: false, y: false } }, legend: { show: false }
    }, [xs, ys], el);
  };
  draw(seriesKeys[0]);
  box.querySelectorAll('[data-progress-key]').forEach(btn => btn.addEventListener('click', () => {
    box.querySelectorAll('[data-progress-key]').forEach(b => { const on = b === btn; b.classList.toggle('active', on); b.style.background = on ? 'rgba(56,189,248,0.18)' : 'rgba(56,189,248,0.06)'; b.style.color = on ? '#e0f2fe' : '#94a3b8'; b.style.borderColor = on ? 'rgba(56,189,248,0.6)' : 'rgba(56,189,248,0.25)'; });
    draw(btn.dataset.progressKey);
  }));
}

function loadAthleteTeamRosters(athlete) {
  const self = (athlete?.name || '').trim();
  $$('.ath-team-roster[data-event]').forEach(box => {
    if (box.dataset.loaded) return; box.dataset.loaded = '1';
    fetchResultsJson(box.dataset.event).then(r => r ? r.json() : null).then(d => {
      const team = box.dataset.team;
      const names = [...new Set(((d && d.results) || []).filter(x => (x.team || '') === team).map(x => (x.display_name || x.participant || '').trim()).filter(n => n && n !== team))];
      box.innerHTML = names.length
        ? `<span class="ath-team-roster-note">Состав · ${names.length}</span><div class="lb-members res-members">${names.map(n => `<button type="button" class="res-member ${n === self ? 'is-self' : ''}" data-athlete-query="${esc(n)}">${esc(n)}${n === self ? ' · вы' : ''}</button>`).join('')}</div>`
        : '<span class="ath-team-roster-note">Состав в протоколе не указан</span>';
    }).catch(() => { box.innerHTML = ''; });
  });
}

// ---------- бенто профиля: личные рекорды, % от золота ГТО, значки-вехи ----------
const BADGE_STEPS = [1, 5, 10, 25, 50];
function athleteBests(competitions) {
  const best = new Map();
  competitions.forEach((c) => (c.events || []).forEach((e) => {
    const cat = String(e.category || e.event_name || '');
    if (!/рекорд/i.test(cat)) return;   // в многоборье комплексы разные — сравнимы только дисциплины «Иду на рекорд»
    const v = parseFloat(String(e.result || '').replace(',', '.')); if (!Number.isFinite(v) || v <= 0) return;
    const disc = cat.replace(/^.*?\[/, '').replace(/\]\s*$/, '').replace(/\s*\(за .*?\)/i, '').trim();
    const cur = best.get(disc);
    if (!cur || v > cur.v) best.set(disc, { disc, v, result: e.result, norm: e.norm || null, t: c.tournament_title || '' });
  }));
  return [...best.values()].sort((a, b) => (b.norm?.pct || 0) - (a.norm?.pct || 0) || b.v - a.v);
}
function athleteBadges({ starts, podiums, wins, records, bestNormPct, years, online }) {
  const b = BADGE_STEPS.map((n) => ({ id: `s${n}`, label: n === 1 ? 'Первый старт' : `${n} стартов`, ok: starts >= n, hint: `Выступить в ${n} ${ruPlural(n, 'турнире', 'турнирах', 'турнирах')}` }));
  b.push({ id: 'podium', label: 'Призёр', ok: podiums > 0, hint: 'Место в тройке' }, { id: 'win', label: 'Победитель', ok: wins > 0, hint: 'Первое место' },
    { id: 'record', label: 'Рекордсмен России', ok: records > 0, hint: 'Рекорд России в реестре ФМГТО' }, { id: 'gold', label: 'Выше золота ГТО', ok: bestNormPct >= 100, hint: 'Результат выше золотого знака своей ступени' },
    { id: 'seasons', label: 'Три сезона', ok: years >= 3, hint: 'Старты в трёх разных годах' }, { id: 'online', label: 'Онлайн-этап', ok: online, hint: 'Участие в онлайн-этапе по видео' });
  const nextStep = BADGE_STEPS.find((n) => starts < n);
  return { list: b, next: nextStep ? `До значка «${nextStep === 1 ? 'Первый старт' : nextStep + ' стартов'}» — ${nextStep - starts} ${ruPlural(nextStep - starts, 'старт', 'старта', 'стартов')}` : '' };
}

function renderAthleteProfileScreen(athlete, opts = {}) {
  const container = $('#athlete-profile-detail');
  if (!container || !athlete) return;

  const records = Array.isArray(athlete.records) ? athlete.records : [];
  const competitions = Array.isArray(athlete.competitions) ? athlete.competitions : [];

  const startsCount = Number(athlete.competitions_count ?? competitions.length);
  const podiumsCount = Number(athlete.podiums_count ?? 0);
  const recordsCount = Number(athlete.records_count ?? records.length);
  const winsCount = Number(athlete.wins_count ?? 0);

  const initials = getAthleteInitials(athlete.name);
  const colorIdx = getAvatarColorIndex(athlete.id || athlete.name);
  const avatarHtml = (athlete.photo_url && athlete.photo_url !== './assets/logo-clean.png' && !athlete.photo_url.includes('logo-clean'))
    ? `<img class="athlete-hero-photo" loading="eager" referrerpolicy="no-referrer" src="${safeImage(athlete.photo_url)}" alt="Фото: ${esc(athlete.name)}" data-fb="mono" data-fb-class="athlete-hero-avatar-placeholder athlete-avatar-monogram color-${colorIdx}" data-fb-text="${esc(initials)}">`
    : `<div class="athlete-hero-avatar-placeholder athlete-avatar-monogram color-${colorIdx}" aria-hidden="true">${esc(initials)}</div>`;

  const athleteIdStr = athlete.athlete_id || ('ATH-' + String(athlete.id).padStart(7, '0'));
  const shareData = esc(JSON.stringify({
    type: 'athlete',
    id: athleteIdStr,
    name: athlete.name,
    region: athlete.region || 'Российская Федерация',
    gender: athlete.gender || '',
    starts: startsCount,
    podiums: podiumsCount,
    records: recordsCount,
    wins: winsCount,
    topEvents: competitions.slice(0, 3).map(c => c.tournament_title).filter(Boolean)
  }));

  const upcoming = [];
  const past = [];
  competitions.forEach(c => {
    const t = `${c.tournament_title || ''} ${c.tournament_slug || ''}`.toLowerCase();
    if (t.includes('предстоящ') || (t.includes('2026') && !c.rank && !c.result)) {
      upcoming.push(c);
    } else {
      past.push(c);
    }
  });

  athlete._upcomingCompetitions = upcoming;
  athlete._pastCompetitions = past;

  const renderTournCard = (c, cIdx = 0, listType = 'past') => {
    const ev = findTournamentForCompetition(c);
    const title = ev?.title || c.tournament_title || 'Соревнование ГТО';
    const period = ev?.period || c.tournament_date || '';
    const city = ev?.location ? ev.location.slice(0, 45) : (c.city || (c.is_online_platform ? 'Онлайн-этап' : ''));
    const eventId = competitionEventId(c) || ev?.id || null;
    const badgeHtml = getResultPlaceBadgeHtml(c.rank || (c.overall_place ? `${c.overall_place} место` : ''));
    const catText = [c.category, c.subgroup].filter(Boolean).join(' · ');
    const teamText = c.team_name ? `Команда: ${c.team_name}` : (c.is_team ? 'Командный зачёт' : '');
    const events = Array.isArray(c.events) ? c.events : [];

    const eventsHtml = events.length > 1 ? `
      <details class="athlete-tourn-events-accordion">
        <summary class="athlete-tourn-events-head">
          <span>Этапы и комплексы (${events.length})</span>
          <span class="accordion-arrow" aria-hidden="true">▾</span>
        </summary>
        <div class="athlete-tourn-events-list">
          ${events.map((e, idx) => `
            <div class="athlete-tourn-event-item">
              <div class="athlete-tourn-event-name">
                <span class="athlete-tourn-event-idx">${idx + 1}.</span>
                <span>${esc(e.event_name || `Этап ${idx + 1}`)}</span>
                ${e.subgroup && e.subgroup !== e.event_name ? `<small class="athlete-tourn-event-sub">(${esc(e.subgroup)})</small>` : ''}
              </div>
              <div class="athlete-tourn-event-res">
                ${e.result ? `<span class="athlete-tourn-event-val">${esc(resultMainText(e.result) || '—')}</span>` : ''}
                ${e.rank ? `<span class="athlete-tourn-event-rank">${esc(e.rank)}</span>` : ''}
              </div>
            </div>
          `).join('')}
        </div>
      </details>
    ` : (events.length === 1 && events[0].event_name && events[0].event_name !== title && events[0].event_name !== c.category ? `
      <div class="athlete-tourn-events-single">
        <span>Дисциплина: <b>${esc(events[0].event_name)}</b></span>
      </div>
    ` : '');

    const place = Number(c.overall_place) || parseRank(c.rank || '');
    const placeNum = place && place < 999999 ? place : 0;
    const medal = placeNum === 1 ? 'gold' : placeNum === 2 ? 'silver' : placeNum === 3 ? 'bronze' : placeNum ? 'field' : 'none';
    const yr = (ev && eventDateRange(ev)?.start?.getFullYear()) || (String(c.tournament_date || period).match(/20\d{2}/) || [''])[0];
    const stagesHtml = c.result ? resultStagesHtml(c.result) : '';
    const hasStages = /tl-stage/.test(stagesHtml);
    const isDiploma = /^[a-z0-9]+-[a-f0-9]{10}$/.test(c.diploma || '');
    // «Иду на рекорд» мест не даёт — вместо «без места» (17.10.2026: атлет решил, что его результат не засчитан)
    const isRecordTry = !placeNum && events.length > 0 && events.every((e) => /^Иду на рекорд/i.test(String(e.event_name || e.category || c.category || '')));
    return `
      <article class="tl-card athlete-tourn-card history-card is-${medal}" data-tourn-card-idx="${cIdx}" data-tourn-list="${listType}">
        <div class="tl-rail" aria-hidden="true">
          ${yr ? `<span class="tl-year">${esc(String(yr))}</span>` : ''}
          <span class="tl-place ${medal}">${placeNum ? `<b>${placeNum}</b><small>место</small>` : `<small>${isRecordTry ? 'попытка рекорда' : 'без места'}</small>`}</span>
        </div>
        <div class="tl-body">
          <header class="tl-head">
            <h3 class="tl-title">${esc(title)}</h3>
            <div class="tl-meta">${[period, city].filter(Boolean).map(esc).join(' · ')}</div>
          </header>
          <div class="tl-tags">
            ${catText ? `<span class="tl-tag">${esc(catText)}</span>` : ''}
            ${c.team_name ? `<button type="button" class="tl-tag is-team" data-open-team="${esc(c.team_name)}"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-users"/></svg>${esc(c.team_name)}<i>→</i></button>` : (c.is_team ? '<span class="tl-tag is-team">Командный зачёт</span>' : '')}
            ${c.place_computed ? '<span class="tl-tag is-muted" title="Место рассчитано по результатам: в протоколе мест не было">место расч.</span>' : ''}
            ${c.is_online_platform ? '<span class="tl-tag is-online">Онлайн</span>' : ''}
          </div>
          ${stagesHtml}
          ${hasStages ? '' : eventsHtml}
          <footer class="tl-actions">
            ${eventId ? `<button type="button" class="tl-btn" data-event="${eventId}" data-event-pane="results"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-file-text"/></svg>Протокол</button>` : ''}
            <button type="button" class="tl-btn" data-open-tourn-modal="${cIdx}" data-tourn-list="${listType}"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg>Мой результат</button>
            ${isDiploma ? `<a class="tl-btn is-doc" href="/diploma/${c.diploma}.pdf" target="_blank" rel="noopener"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-file-text"/></svg>${placeNum >= 1 && placeNum <= 3 ? 'Диплом' : 'Сертификат'}</a>` : ''}
            ${eventId ? `<button type="button" class="tl-link" data-event="${eventId}">Турнир <i>→</i></button>` : ''}
          </footer>
        </div>
      </article>
    `;
  };

  const renderRecordCard = r => renderUnifiedRecordCard({ ...r, holder: r.holder || athlete.name, athleteId: athlete.id }, { defaultCity: athlete.region });

  const rawRegion = athlete.region || '';
  const regId = normalizeRegionName(rawRegion);
  const regObj = regId ? getRegionById(regId) : null;
  const districtName = regObj ? (DISTRICT_NAMES[regObj.district] || regObj.district) : 'Российская Федерация';
  const regionDisplayName = regObj ? regObj.name : (rawRegion || 'Российская Федерация');

  let teamName = athlete.team_name || athlete.team || athlete.club || '';
  // команда с одного турнира — не клуб атлета: подписываем её как команду на старте
  let teamLabel = 'Клуб / Сборная команда';
  if (!teamName) {
    const compWithTeam = competitions.find(c => c.team_name);
    if (compWithTeam) { teamName = compWithTeam.team_name; teamLabel = 'Команда на турнире'; }
    else if (competitions.some(c => c.is_team)) { teamName = 'Командный зачёт'; teamLabel = 'Выступал в составе команды'; }
  }
  if (!teamName && regObj) {
    teamName = `Сборная ${regObj.shortName || regObj.name}`;
  }
  const coachName = athlete.coach || '';
  const rankTitle = athlete.rank_title || athlete.rank || 'Атлет ФМГТО';

  const teammates = (state.athleteIndex || state.athleteLite || []).filter(a => {
    if (Number(a.id) === Number(athlete.id) || a.athlete_id === athlete.athlete_id) return false;
    const aRegId = normalizeRegionName(a.region);
    return regId && aRegId === regId;
  }).sort((a, b) => (Number(b.podiums_count || 0) * 2 + Number(b.competitions_count || 0)) - (Number(a.podiums_count || 0) * 2 + Number(a.competitions_count || 0)));

  // регион старта и рекорда — тем же правилом, что на странице региона (поиск названий внутри слова давал
  // якутянам старты Смоленска: «ленск» в «Смоленск»)
  const regionalEvents = regObj ? GTO_CALENDAR_EVENTS.filter(e => (e.region_id || normalizeRegionName(`${e.city || ''} ${e.location || ''} ${e.title || ''}`)) === regObj.id) : [];
  const regionalRecords = regObj ? (GTO_RECORDS || []).filter(r => normalizeRegionName(r.city || '') === regObj.id && !isBeatenRecord(r)) : [];

  // принадлежность одной строкой: ФМГТО › округ › регион › команда · статус
  const athletePathHtml = `
    <nav class="ath-path" aria-label="Принадлежность атлета">
      <span class="ath-path-step"><b>ФМГТО</b></span>
      <span class="ath-path-step" title="${esc(districtName)}">${esc(regObj ? regObj.district : 'РФ')}</span>
      ${regObj ? `<button type="button" class="ath-path-step is-link" data-open-region="${regObj.id}">${esc(regionDisplayName)}</button>` : `<span class="ath-path-step">${esc(regionDisplayName)}</span>`}
      ${(athlete.team_name || athlete.club) ? `<span class="ath-path-step" title="Клуб">${esc(athlete.team_name || athlete.club)}</span>` : ''}
      <span class="ath-path-tag">${esc(rankTitle)}${coachName ? ` · тренер ${esc(coachName)}` : ''}</span>
    </nav>`;

  // «Трекер формы» (как Tremor Tracker): клетка на каждый старт по времени, цвет — место
  const trackerItems = past.map(c => {
    const ev = findTournamentForCompetition(c);
    const d = ev ? eventDateRange(ev)?.start : null;
    const place = Number(c.overall_place) || parseRank(c.rank);
    return { c, ev, t: d ? d.getTime() : 0, place: place && place < 999999 ? place : 0, id: competitionEventId(c) || ev?.id || '' };
  }).sort((a, b) => a.t - b.t);
  const tone = (pl) => pl === 1 ? 'gold' : pl === 2 ? 'silver' : pl === 3 ? 'bronze' : pl && pl <= 10 ? 'top10' : pl ? 'field' : 'none';
  const bestPlace = trackerItems.reduce((m, x) => x.place && (!m || x.place < m) ? x.place : m, 0);
  const lastItem = trackerItems[trackerItems.length - 1];
  const bests = athleteBests(competitions);
  const topNorm = bests.filter((x) => x.norm).sort((a, b) => b.norm.pct - a.norm.pct)[0];
  const years = new Set(trackerItems.filter((x) => x.t).map((x) => new Date(x.t).getFullYear())).size;
  const badges = athleteBadges({ starts: startsCount, podiums: podiumsCount, wins: winsCount, records: recordsCount, bestNormPct: topNorm?.norm.pct || 0, years, online: competitions.some((c) => c.is_online_platform) });
  const placeChart = trackerItems.filter(x => x.place && x.t).length >= 3;
  const formTrackerHtml = trackerItems.length ? `
    <div class="ath-form">
      <div class="ath-form-head"><span>Форма по стартам</span><small>${trackerItems.length} ${ruPlural(trackerItems.length, 'старт', 'старта', 'стартов')}${bestPlace ? ` · лучшее место — ${bestPlace}` : ''}</small></div>
      <div class="ath-form-track" role="list">${trackerItems.map((x, k) => `<button type="button" role="listitem" class="ath-form-cell ${tone(x.place)}" style="--k:${k}" ${x.id ? `data-event="${esc(x.id)}" data-event-pane="results"` : 'disabled'} title="${esc([x.ev?.title || x.c.tournament_title, x.ev?.period, x.place ? x.place + ' место' : 'без места'].filter(Boolean).join(' · '))}"><span class="sr-only">${esc(x.c.tournament_title || '')}: ${x.place ? x.place + ' место' : 'без места'}</span></button>`).join('')}</div>
      <div class="ath-form-legend"><i class="gold"></i>1 <i class="silver"></i>2 <i class="bronze"></i>3 <i class="top10"></i>4–10 <i class="field"></i>11+ ${lastItem ? `<span class="ath-form-last">последний: ${esc(lastItem.ev?.title || lastItem.c.tournament_title || '')}</span>` : ''}</div>
    </div>` : '';

  // команды атлета: из строк протоколов, где он записан в составе команды
  const teamComps = competitions.filter(c => c.team_name);
  const athleteTeamsHtml = teamComps.length ? `
    <section class="athlete-section ath-teams">
      <div class="athlete-section-title section-title"><span>Команды атлета</span><span class="athlete-section-count">${teamComps.length}</span></div>
      <div class="ath-teams-grid">${teamComps.map(c => {
        const evId = c.id || String(c.event_id || '').replace(/^EVT-0*/i, '');
        const place = Number(c.overall_place) || parseRank(c.rank);
        const medal = place >= 1 && place <= 3 ? `top${place}` : '';
        return `<article class="ath-team ${medal}">
          <div class="ath-team-head"><span class="ath-team-badge"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-users"/></svg>Участник команды</span>${place && place < 999999 ? `<span class="ath-team-place">${place} место</span>` : ''}</div>
          <button type="button" class="ath-team-name" data-open-team="${esc(c.team_name)}">${esc(c.team_name)}<i>→</i></button>
          <div class="ath-team-meta">${esc(c.tournament_title || c.tournament_name || '')}${c.category ? ` · ${esc(c.category)}` : ''}${resultMainText(c.result) ? ` · <b>${esc(resultMainText(c.result))}</b>` : ''}</div>
          <div class="ath-team-roster" data-event="${esc(evId)}" data-team="${esc(c.team_name)}"><span class="ath-team-roster-note">Загружаем состав…</span></div>
        </article>`; }).join('')}</div>
    </section>` : '';
  requestAnimationFrame(() => loadAthleteTeamRosters(athlete));

  const athleteProgramsHtml = `
    <section class="athlete-section athlete-programs-section">
      <div class="athlete-section-title section-title">
        <span>Соревновательные программы атлета</span>
        <span class="athlete-section-count">3 программы</span>
      </div>
      <div class="athlete-programs-grid">
        <div class="athlete-prog-card">
          <div class="apc-head">
            <span class="apc-badge allround">Многоборье</span>
            <span class="apc-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-medal"/></svg></span>
          </div>
          <h3 class="apc-title">Многоборье ГТО</h3>
          <p class="apc-desc">Официальные очные старты ЕКП: полоса препятствий, эстафеты, силовые комплексы на арене.</p>
          <div class="apc-stat">Стартов в протоколах: <b>${startsCount}</b> · Подиумов: <b>${podiumsCount}</b></div>
          ${startsCount ? `<button type="button" class="apc-btn" data-scroll-to="athlete-history-section">Турниры атлета (${startsCount}) ↓</button>` : `<button type="button" class="apc-btn" data-go="events">Календарь стартов →</button>`}
        </div>

        <div class="athlete-prog-card active-flow">
          <div class="apc-head">
            <span class="apc-badge herogto"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-zap"/></svg> Герой ГТО</span>
            <span class="apc-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-video"/></svg></span>
          </div>
          <h3 class="apc-title">Герой ГТО</h3>
          <p class="apc-desc">Онлайн-соревнования и видеоквалификация. Запись соревновательных WOD через таймер и судейство ФМГТО.</p>
          <div class="apc-stat">Личный кабинет, WOD-комплексы и видеозаявки</div>
          <button type="button" class="apc-btn primary" data-go="hero">Личный кабинет Герой ГТО <svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-zap"/></svg></button>
        </div>

        <div class="athlete-prog-card">
          <div class="apc-head">
            <span class="apc-badge records"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-trophy"/></svg> Рекорды</span>
            <span class="apc-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-biceps-flexed"/></svg></span>
          </div>
          <h3 class="apc-title">Иду на рекорд</h3>
          <p class="apc-desc">Индивидуальные попытки установления всероссийских и региональных рекордов ГТО в силовых упражнениях.</p>
          <div class="apc-stat">Рекордов России: <b>${recordsCount}</b></div>
          ${recordsCount ? `<button type="button" class="apc-btn" data-scroll-to="athlete-records-section">Рекорды атлета (${recordsCount}) ↓</button>` : `<button type="button" class="apc-btn" data-go="records">Рекорды России →</button>`}
        </div>
      </div>
    </section>
  `;

  const athleteRegionCommunityHtml = `
    <section class="athlete-section athlete-region-community">
      <div class="athlete-section-title section-title">
        <span>Спортивный регион: ${regionDisplayName}</span>
        ${regObj ? `<button type="button" class="athlete-region-tag-btn" data-open-region="${regObj.id}">Отделение региона →</button>` : ''}
      </div>
      <div class="athlete-region-stats-row">
        <div class="ars-item">
          <span class="ars-val">${teammates.length + 1}</span>
          <span class="ars-lbl">Атлетов в регионе</span>
        </div>
        <div class="ars-item">
          <span class="ars-val">${regionalEvents.length}</span>
          <span class="ars-lbl">Турниров региона</span>
        </div>
        <div class="ars-item">
          <span class="ars-val">${regionalRecords.length}</span>
          <span class="ars-lbl">Рекордов региона</span>
        </div>
      </div>
      ${teammates.length ? `
        <div class="teammates-sub-head">
          <span>Земляки и сборная региона (${teammates.length})</span>
          <small>Нажмите на карточку для перехода в профиль</small>
        </div>
        <div class="teammates-scroll-row" role="group" aria-label="Земляки и сборная региона">
          ${teammates.slice(0, 16).map(t => {
            const tInit = getAthleteInitials(t.name);
            const tColor = getAvatarColorIndex(t.id || t.name);
            const tPhoto = (t.photo_url && !t.photo_url.includes('logo-clean'))
              ? `<img src="${safeImage(t.photo_url)}" alt="" class="tm-avatar-img" data-fb="mono" data-fb-class="tm-avatar-monogram color-${tColor}" data-fb-text="${esc(tInit)}">`
              : `<div class="tm-avatar-monogram color-${tColor}">${esc(tInit)}</div>`;
            return `
              <div class="teammate-mini-card" data-open-athlete-id="${t.id}" role="button" tabindex="0" aria-label="${esc(t.name)}: ${t.competitions_count || 0} ${ruPlural(t.competitions_count || 0, 'старт', 'старта', 'стартов')}">
                <div class="tm-avatar-wrap">${tPhoto}</div>
                <b class="tm-name">${esc(t.name)}</b>
                <span class="tm-meta">${t.competitions_count || 0} ${ruPlural(t.competitions_count || 0, 'старт', 'старта', 'стартов')}</span>
              </div>
            `;
          }).join('')}
          ${teammates.length > 16 && regObj ? `
            <div class="teammate-mini-card tm-more" data-open-region="${regObj.id}">
              <div class="tm-more-circle">+${teammates.length - 16}</div>
              <b>Все атлеты</b>
              <span>в отделении →</span>
            </div>
          ` : ''}
        </div>
      ` : '<div class="empty" style="padding:12px 0">Спортсмен — первый зарегистрированный представитель региона в системе.</div>'}
    </section>
  `;

  // догрузился лёгкий индекс: меняется только блок «Земляки» — не перерисовываем весь профиль с графиками (−0,5–0,9 с работы на телефоне)
  if (opts.communityOnly) {
    const old = container.querySelector('.athlete-region-community');
    if (old) { old.outerHTML = athleteRegionCommunityHtml; return; }
  }

  container.innerHTML = `
    <div class="athlete-hero-card athlete-hero">
      <div class="athlete-hero-top">
        <div class="athlete-hero-avatar-wrap athlete-avatar">
          ${avatarHtml}
        </div>
        <div class="athlete-hero-details">
          <span class="athlete-id-pill athlete-id">${esc(athlete.athlete_id || ('ATH-' + String(athlete.id).padStart(7, '0')))}</span>
          <h1 class="athlete-hero-name athlete-name">${esc(athlete.name)}${nsTagHtml(athlete.namesake?.n)}</h1>
          ${athlete.namesake?.others?.length ? `<p class="ns-others">Полные тёзки: ${athlete.namesake.others.map((o) => `<a href="#athlete/${encodeURIComponent(o.athlete_id || o.id)}">#${o.n}${o.region ? ` · ${esc(o.region)}` : ''}</a>`).join(', ')}</p>` : ''}
          <div class="athlete-hero-meta athlete-location">
            <b>${esc(regionDisplayName)}</b>
            ${athlete.gender ? `<span>•</span> <span>${esc(genderWord(athlete.gender))}</span>` : ''}
          </div>
          ${athletePathHtml}
        </div>
      </div>
      <div class="athlete-hero-actions athlete-actions">
        <button type="button" class="athlete-hero-btn primary btn" data-share-data="${shareData}">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>
          <span>Поделиться карточкой</span>
        </button>
        <button type="button" class="athlete-hero-btn secondary btn" data-copy-athlete-url="${athlete.athlete_id || athlete.id}">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
          <span>Ссылка на профиль</span>
        </button>
        <button type="button" class="athlete-hero-btn secondary btn claim-open-btn" data-claim-athlete="${esc(athlete.athlete_id || '')}" data-claim-name="${esc(athlete.name)}" ${athlete.athlete_id ? '' : 'hidden'}>
          <span>Это вы? Привязать к кабинету</span>
        </button>
        <button type="button" class="athlete-hero-btn secondary btn" data-report-error data-athlete-id="${esc(athlete.athlete_id || '')}" data-context="Профиль: ${esc(athlete.name)}">
          <span>Нашли ошибку?</span>
        </button>
      </div>
    </div>

    <section class="ath-bento" aria-label="Статистика атлета">
      <div class="ath-bento-cell is-main"><span class="ath-num" data-count="${startsCount}">${startsCount}</span><span class="ath-lbl">${ruPlural(startsCount, 'старт', 'старта', 'стартов')} в протоколах</span>${formTrackerHtml}</div>
      <div class="ath-bento-cell gold"><span class="ath-num" data-count="${podiumsCount}">${podiumsCount}</span><span class="ath-lbl">${ruPlural(podiumsCount, 'подиум', 'подиума', 'подиумов')}</span></div>
      <div class="ath-bento-cell red"><span class="ath-num" data-count="${winsCount}">${winsCount}</span><span class="ath-lbl">${ruPlural(winsCount, 'победа', 'победы', 'побед')}</span></div>
      <div class="ath-bento-cell green"><span class="ath-num" data-count="${recordsCount}">${recordsCount}</span><span class="ath-lbl">${ruPlural(recordsCount, 'рекорд', 'рекорда', 'рекордов')} России</span></div>
      <div class="ath-bento-cell blue"><span class="ath-num">${bestPlace || '—'}</span><span class="ath-lbl">лучшее место</span></div>
      ${topNorm ? `<div class="ath-bento-cell violet" title="Процент от золотого знака ГТО своей ступени${topNorm.norm.approx ? ' (ориентир: в ГТО другие условия выполнения)' : ''}"><span class="ath-num">${topNorm.norm.pct}%</span><span class="ath-lbl">от золота ГТО${topNorm.norm.approx ? '*' : ''} · ${esc(topNorm.disc)} · ${esc(topNorm.norm.stage)} ступень</span></div>` : ''}
      ${bests.length ? `<div class="ath-bento-cell wide ath-bests"><span class="ath-cell-title">Личные рекорды</span><ul>${bests.slice(0, 3).map((x) => `<li><span>${esc(x.disc)}</span><b>${esc(x.result)}</b>${x.norm ? `<small class="norm-chip ${x.norm.pct >= 100 ? 'is-gold' : ''}">${x.norm.pct}% ГТО${x.norm.approx ? '*' : ''}</small>` : ''}</li>`).join('')}</ul></div>` : ''}
      <div class="ath-bento-cell wide ath-badges"><span class="ath-cell-title">Значки</span><ul class="ath-badge-list">${badges.list.map((b) => `<li class="ath-badge ${b.ok ? 'is-on' : ''}" title="${esc(b.hint)}"><i aria-hidden="true">${b.ok ? '★' : '☆'}</i>${esc(b.label)}<span class="sr-only">${b.ok ? ' — получен' : ' — ещё нет'}</span></li>`).join('')}</ul>${badges.next ? `<small class="ath-badge-next">${esc(badges.next)}</small>` : ''}</div>
      ${placeChart ? `<div class="ath-bento-cell wide ath-chart"><span class="ath-cell-title">Места по стартам</span><div class="ath-chart-box" id="ath-place-chart" role="img" aria-label="График мест атлета по датам стартов"></div><p class="ath-chart-note">Чем выше точка — тем лучше место. Нажмите на точку, чтобы увидеть турнир.</p></div>` : ''}
    </section>

    ${athleteTeamsHtml}

    ${renderAthleteRatingBlock(athlete)}

    <section class="athlete-section" id="athlete-progress" data-athlete-progress="${esc(athlete.athlete_id || athlete.id || '')}" hidden></section>

    ${upcoming.length ? `
      <section class="athlete-section">
        <div class="athlete-section-title section-title">
          <span>Предстоящие старты</span>
          <span class="athlete-section-count">${upcoming.length}</span>
        </div>
        ${upcoming.map((c, idx) => renderTournCard(c, idx, 'upcoming')).join('')}
      </section>
    ` : ''}

    <section class="athlete-section" id="athlete-history-section">
      <div class="athlete-section-title section-title">
        <span>История турниров</span>
        <span class="athlete-section-count">${past.length}</span>
      </div>
      ${past.length ? past.map((c, idx) => renderTournCard(c, idx, 'past')).join('') : '<div class="empty">Нет завершённых выступлений в протоколах.</div>'}
    </section>

    ${records.length ? `
      <section class="athlete-section" id="athlete-records-section">
        <div class="athlete-section-title section-title">
          <span>Рекорды России</span>
          <span class="athlete-section-count">${records.length}</span>
        </div>
        <div class="athlete-records-grid">
          ${records.map(renderRecordCard).join('')}
        </div>
      </section>
    ` : ''}

    ${athleteProgramsHtml}

    ${athleteRegionCommunityHtml}
  `;
  animateCounters(container);
  drawPlaceChart(trackerItems.filter(x => x.place && x.t));
}

// график «Места по стартам» (uPlot, github.com/leeoniya/uPlot — уже в vendor): ось мест перевёрнута, 1-е место сверху
async function drawPlaceChart(items) {
  const el = $('#ath-place-chart');
  if (!el || items.length < 3) return;
  await whenNearViewport(el);
  if (!el.isConnected) return;
  try { await ensureUPlot(); } catch (_) { el.closest('.ath-chart')?.remove(); return; }
  const xs = items.map(x => Math.floor(x.t / 1000)), ys = items.map(x => x.place);
  const col = (pl) => pl === 1 ? '#f5b93a' : pl === 2 ? '#cfd8e3' : pl === 3 ? '#d9894a' : '#3b82f6';
  const tip = document.createElement('div'); tip.className = 'ath-chart-tip'; tip.hidden = true; el.appendChild(tip);
  const make = () => new uPlot({
    width: Math.max(260, el.clientWidth - 8), height: 220, padding: [14, 12, 0, 0],
    scales: { x: { time: true }, y: { dir: -1, range: (u, mn, mx) => [1, Math.max(4, mx + 1)] } },
    axes: [
      { stroke: '#8ea0bf', grid: { stroke: 'rgba(148,163,184,0.08)' }, ticks: { stroke: 'rgba(148,163,184,0.15)' },   // по одной метке на год
        splits: (u, ai, mn, mx) => { const out = []; for (let y = new Date(mn * 1000).getFullYear() + 1; y <= new Date(mx * 1000).getFullYear(); y++) out.push(Date.UTC(y, 0, 1) / 1000); return out.length ? out : [mn]; },
        values: (u, v) => v.map(t => new Date(t * 1000).getFullYear()) },
      { stroke: '#8ea0bf', grid: { stroke: 'rgba(148,163,184,0.08)' }, size: 36,
        splits: (u, ai, mn, mx) => [1, 2, 3, 5, 10, 15, 20, 30, 50, 100].filter(n => n <= mx), values: (u, v) => v.map(n => n + '') }
    ],
    series: [{}, { stroke: 'rgba(96,165,250,0.7)', width: 2, fill: 'rgba(59,130,246,0.08)', points: { show: false } }],
    hooks: {
      draw: [(u) => {   // точки в цвете места
        const ctx = u.ctx; ctx.save();
        xs.forEach((x, i) => { const cx = u.valToPos(x, 'x', true), cy = u.valToPos(ys[i], 'y', true); ctx.beginPath(); ctx.arc(cx, cy, 6 * devicePixelRatio, 0, 7); ctx.fillStyle = col(ys[i]); ctx.fill(); ctx.lineWidth = 2 * devicePixelRatio; ctx.strokeStyle = '#0b1628'; ctx.stroke(); });
        ctx.restore();
      }],
      setCursor: [(u) => {
        const i = u.cursor.idx;
        if (i == null) { tip.hidden = true; return; }
        const it = items[i]; tip.hidden = false;
        tip.innerHTML = `<b>${it.place} место</b><span>${esc(it.ev?.title || it.c.tournament_title || '')}</span>`;
        tip.style.left = Math.min(u.valToPos(xs[i], 'x'), u.width - 200) + 'px'; tip.style.top = (u.valToPos(ys[i], 'y') + 18) + 'px';
      }]
    },
    cursor: { drag: { x: false, y: false }, points: { show: false } }, legend: { show: false }
  }, [xs, ys], el);
  let plot = make();
  el.addEventListener('click', () => { const i = plot.cursor.idx; if (i != null && items[i].id) location.hash = `#event/${items[i].id}/results`; });
  let w = el.clientWidth;
  new ResizeObserver(() => { if (Math.abs(el.clientWidth - w) > 20) { w = el.clientWidth; plot.setSize({ width: Math.max(260, w - 8), height: 220 }); } }).observe(el);
}

// счётчик цифр (как Magic UI Number Ticker): 0 → значение за ~0.9 с; без анимации при prefers-reduced-motion
function animateCounters(root) {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  root.querySelectorAll('[data-count]').forEach(el => {
    const to = Number(el.dataset.count) || 0;
    if (to < 2) return;
    const t0 = performance.now(), dur = 900;
    const step = (now) => {
      const k = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      el.textContent = String(Math.round(to * e));
      if (k < 1) requestAnimationFrame(step);
    };
    el.textContent = '0'; requestAnimationFrame(step);
  });
}


// карта России: круги-«мишени» мелких регионов невидимы — при наведении на круг подсвечиваем сам регион под ним
const hitRegions = (c) => c.ownerSVGElement?.querySelectorAll(`.russia-region[data-region-id="${CSS.escape(c.dataset.regionId || '')}"]`) || [];
document.addEventListener('pointerover', (e) => { const c = e.target.closest?.('.region-hit-area'); if (c) hitRegions(c).forEach((p) => p.classList.add('is-hovered')); });
document.addEventListener('pointerout', (e) => { const c = e.target.closest?.('.region-hit-area'); if (c) hitRegions(c).forEach((p) => p.classList.remove('is-hovered')); });

// ---------- Встроенный просмотр PDF (standalone PWA / Telegram WebView) ----------
// пол словом: у спортсменов, добавленных вручную в админке (custom_athletes.json), он хранится кодом W/M — на карточке было «• W»
const genderWord = (g) => ({ W: 'Женщины', F: 'Женщины', 'Ж': 'Женщины', M: 'Мужчины', 'М': 'Мужчины' }[String(g || '').trim().toUpperCase()] || g || '');
// меню и кнопка в шапке (справа вверху): вошедший видит своё фото, имя и «Мой кабинет» вместо «Герой ГТО · Вход по e-mail»
// (профиль кабинета — hero_profiles_v1)
function activeHeroProfile() {
  try { const s = JSON.parse(localStorage.getItem('hero_profiles_v1') || 'null'); if (s && !s.isLoggedOut) return (s.profiles || [])[s.active || 0] || null; } catch (_) {}
  return null;
}
function headerAccountChip(btn, p, name) {
  const ava = document.createElement('span'); ava.className = 'hdr-ava'; ava.setAttribute('aria-hidden', 'true');
  const url = String(p?.photo_url || '');
  if (/^(\/|https:\/\/)/.test(url)) { const img = new Image(); img.src = url; img.alt = ''; img.decoding = 'async'; ava.append(img); }
  else ava.textContent = name[0].toUpperCase();
  const text = document.createElement('span'); text.className = 'hdr-acc';
  const small = document.createElement('small'); small.textContent = 'Мой кабинет';
  const b = document.createElement('b'); b.textContent = name;
  text.append(small, b); btn.replaceChildren(ava, text);
}
// кто вошёл — для шапки: что сообщил кабинет (событие fmgto:hero-store, herogto_module.saveStore: запись в браузер может
// не пройти), иначе профиль из localStorage, а если в браузере его нет, но сервер вход узнаёт (Safari стирает localStorage
// через 7 дней без заходов, cookie входа живёт дольше) — имя и фото с сервера (GET /api/account/badge) (09.10.2026)
let heroLive;              // undefined — кабинет на этой странице ничего не сообщал; null — не вошёл
let serverBadge = null;
function syncDrawerAccount() {
  const p = heroLive !== undefined ? heroLive : activeHeroProfile() || serverBadge;
  const name = String(p?.name || p?.fio || '').trim().split(/\s+/).slice(0, 2).join(' ');
  const btn = document.querySelector('.drawer-nav-list [data-go="hero"]');
  const label = btn?.querySelector('.dni-label'), badge = btn?.querySelector('.dni-badge');
  if (label && badge) {
    label.textContent = name || 'Герой ГТО'; badge.textContent = name ? 'Мой кабинет' : 'Вход по e-mail';
    btn.classList.toggle('is-signed', Boolean(name));
  }
  const cta = document.querySelector('.desktop-header-cta');
  if (cta) {
    cta.classList.toggle('is-signed', Boolean(name));
    cta.setAttribute('aria-label', name ? `Мой кабинет: ${name}` : 'Герой ГТО — личный кабинет');
    if (name) headerAccountChip(cta, p, name); else cta.innerHTML = 'Герой ГТО <strong>→</strong>';
  }
}
syncDrawerAccount();
// шапка не показывает «вошедшего», если сервер вход на этом устройстве не узнаёт (09.10.2026, Яворский на Mac: в шапке
// имя, а форма заявки — «Войдите»): раз за загрузку — /api/account/me и, как кабинет (herogto_module.restoreAccountSession),
// пометка «вход устарел»; данные в браузере остаются и после нового входа объединяются с кабинетом
function checkHeaderSession() {
  const raw = () => { try { return localStorage.getItem('hero_profiles_v1'); } catch (_) { return null; } };
  const read = () => { try { return JSON.parse(raw() || 'null'); } catch (_) { return null; } };
  const before = raw(); const s = read(); const p = s && !s.isLoggedOut ? (s.profiles || [])[s.active || 0] : null;
  if (!p) { checkServerBadge(); return; }
  if (!p.server_session) return;
  fetch('/api/account/me', { credentials: 'same-origin', cache: 'no-store' })
    .then((r) => (r.status === 401 ? { ok: false, logged_in: false } : r.ok ? r.json() : null))
    .then((d) => {
      const cur = read();
      if (raw() !== before) return;   // пока шёл запрос, кабинет вошёл или вышел — его состояние главнее
      if (!d || d.ok !== false || d.logged_in !== false || !cur || cur.isLoggedOut) return;   // вошёл, нет связи или уже вышел
      try { localStorage.setItem('hero_profiles_v1', JSON.stringify({ ...cur, isLoggedOut: true, sessionExpired: true })); } catch (_) { return; }
      window.dispatchEvent(new CustomEvent('fmgto:account'));
    }).catch(() => {});
}
// в браузере вошедшего нет — спросить сервер (раз за сеанс вкладки, если не вошёл): только имя и фото
function checkServerBadge() {
  try { if (sessionStorage.getItem('fmgto_badge_no')) return; } catch (_) {}
  fetch('/api/account/badge', { credentials: 'same-origin', cache: 'no-store' })
    .then((r) => (r.ok ? r.json() : null))
    .then((d) => {
      if (!d || !d.ok) return;
      const prof = d.logged_in && d.profile && String(d.profile.name || '').trim() ? { name: String(d.profile.name), photo_url: String(d.profile.photo_url || '') } : null;
      if (!prof) { try { sessionStorage.setItem('fmgto_badge_no', '1'); } catch (_) {} return; }
      if (heroLive !== undefined || activeHeroProfile()) return;   // кабинет за это время сообщил своё
      serverBadge = prof; syncDrawerAccount();
    }).catch(() => {});
}
setTimeout(checkHeaderSession, 1500);   // после первой отрисовки — не мешает загрузке страницы
window.addEventListener('fmgto:account', () => setTimeout(syncDrawerAccount, 0));
window.addEventListener('fmgto:avatar', () => setTimeout(syncDrawerAccount, 0));   // кабинет сначала сохраняет новое фото в профиль
window.addEventListener('fmgto:hero-store', (e) => {
  heroLive = e.detail?.profile || null;
  if (!heroLive) serverBadge = null;
  else { try { sessionStorage.removeItem('fmgto_badge_no'); } catch (_) {} }
  syncDrawerAccount();
});
window.addEventListener('storage', (e) => { if (e.key === 'hero_profiles_v1') { heroLive = undefined; syncDrawerAccount(); } });   // другая вкладка
function isStandaloneApp() {
  try { return (window.matchMedia && matchMedia('(display-mode: standalone)').matches) || navigator.standalone === true || Boolean(window.Telegram?.WebApp?.initData); } catch (_) { return false; }
}
function openPdfViewer(url, title) {
  document.getElementById('pdf-viewer')?.remove();
  const box = document.createElement('div');
  box.id = 'pdf-viewer'; box.className = 'pdf-viewer'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true');
  box.innerHTML = `
    <div class="pdf-viewer-bar">
      <button type="button" class="pdf-viewer-close" aria-label="Закрыть">✕ Закрыть</button>
      <b>${esc(title || 'PDF')}</b>
      <a class="pdf-viewer-dl" href="${esc(url)}" download rel="noopener">Скачать</a>
    </div>
    <iframe class="pdf-viewer-frame" src="${esc(url)}#toolbar=0" title="${esc(title || 'PDF')}"></iframe>
    <p class="pdf-viewer-note">Если файл не отображается — нажмите «Скачать» или откройте сайт в обычном браузере.</p>`;
  document.body.appendChild(box);
  document.body.classList.add('pdf-viewer-open');
  const close = () => { box.remove(); document.body.classList.remove('pdf-viewer-open'); };
  box.querySelector('.pdf-viewer-close').onclick = close;
  document.addEventListener('keydown', function esc_(ev) { if (ev.key === 'Escape') { close(); document.removeEventListener('keydown', esc_); } });
}
window.openPdfViewer = openPdfViewer;

// ---------- Страница команды: все старты команды из протоколов, состав, места ----------
async function openTeam(name, push = true) {
  const teamName = String(name || '').trim();
  if (!teamName) return;
  if (push) { pushRoute({ screen: 'team', params: { id: teamName } }); resetScrollToTop(); }
  const hashTarget = `#team/${encodeURIComponent(teamName)}`;
  if (location.hash !== hashTarget) (push ? history.pushState : history.replaceState).call(history, { screen: 'team', id: teamName }, '', hashTarget);
  go('team', false);
  const box = $('#team-detail');
  if (!box) return;
  box.innerHTML = skeletonHtml('list', 'Загружаем выступления команды…', { rows: 5 });
  try {
    const r = await fetch(`/api/teams/${encodeURIComponent(teamName)}`);
    const d = r.ok ? await r.json() : null;
    if (!d || !d.ok || !d.tournaments.length) { box.innerHTML = `<div class="detail-error">Команда «${esc(teamName)}» в протоколах не найдена.</div>`; return; }
    const members = d.members || [];
    const best = d.tournaments.map(t => t.place).filter(p => p).sort((a, b) => a - b)[0];
    const podiums = d.tournaments.filter(t => t.place && t.place <= 3).length;
    box.innerHTML = `
      <div class="team-hero">
        <span class="eyebrow">Команда · ${esc(d.region || 'Россия')}</span>
        <h1 class="team-title">${esc(d.name)}</h1>
        <div class="team-stats">
          <div><b>${d.tournaments.length}</b><span>${d.tournaments.length === 1 ? 'старт' : d.tournaments.length < 5 ? 'старта' : 'стартов'}</span></div>
          <div><b>${podiums}</b><span>подиум${podiums === 1 ? '' : podiums < 5 ? 'а' : 'ов'}</span></div>
          <div><b>${best ? best + ' место' : '—'}</b><span>лучший результат</span></div>
          <div><b>${members.length}</b><span>в составе</span></div>
        </div>
      </div>
      ${members.length ? `<section class="detail-section"><h2>Состав</h2><div class="team-members">${members.map(m => `
        <button type="button" class="team-member" data-open-athlete-id="${esc(m.athlete_id)}">
          <span class="team-member-avatar">${esc((m.name || '?').split(' ').slice(0, 2).map(w => w[0] || '').join('').toUpperCase())}</span>
          <span><b>${esc(m.name)}</b><small>${esc(m.region || '')}${m.starts > 1 ? ` · ${m.starts} стартов за команду` : ''}</small></span>
        </button>`).join('')}</div></section>` : ''}
      <section class="detail-section"><h2>Выступления</h2><div class="team-starts">${d.tournaments.map(t => `
        <article class="team-start history-card">
          <div class="athlete-tourn-head history-head">
            <div><h3 class="athlete-tourn-title history-title">${esc(t.title)}</h3>
              <div class="athlete-tourn-sub history-meta">${t.date ? `<span>${esc(t.date)}</span>` : ''}${t.city ? `<span>${esc(t.city)}</span>` : ''}${t.category ? `<span>${esc(t.category)}</span>` : ''}</div></div>
            <div>${getResultPlaceBadgeHtml(t.place ? `${t.place} место` : (t.place_raw || 'Участник'))}</div>
          </div>
          ${t.result ? resultCompactHtml(t.result, { label: 'Итог' }) : ''}
          ${t.members && t.members.length ? `<div class="team-start-members">${t.members.map(m => `<button type="button" class="team-start-member" data-open-athlete-id="${esc(m.athlete_id)}">${esc(m.name)}</button>`).join('')}</div>` : ''}
          <div class="athlete-tourn-actions">
            <button type="button" class="athlete-protocol-btn history-protocol-btn is-main" data-event="${t.id}">Открыть турнир →</button>
            <button type="button" class="athlete-protocol-btn history-protocol-btn secondary" data-event="${t.id}" data-event-pane="results">Протокол</button>
          </div>
        </article>`).join('')}</div></section>`;
  } catch (e) {
    box.innerHTML = '<div class="detail-error">Не удалось загрузить данные команды. Проверьте связь.</div>';
  }
}
window.openTeam = openTeam;

async function openAthleteProfile(id, push = true, restoreScrollY = null) {
  const strId = String(id).trim();
  const numId = Number(strId.replace(/^ATH-0*/i, ''));
  state.selectedAthleteId = strId;
  // карточку запрашиваем сразу, параллельно с модулем рейтинга (раньше — после него: +2 запроса подряд до данных профиля)
  const cached = state.athleteMap && (state.athleteMap.get(numId) || state.athleteMap.get(strId));
  const cardPromise = cached ? Promise.resolve(cached) : fetchAthleteCard(strId).catch(() => null);
  await ensureRatingsModule().catch(() => {});   // блок рейтинга в профиле рисуется синхронно
  if (push) {
    pushRoute({ screen: 'athlete', params: { id: strId } });
    resetScrollToTop();
  }
  const container = $('#athlete-profile-detail');
  if (container) {
    container.innerHTML = skeletonHtml('profile', 'Загружаем профиль спортсмена…');
  }
  let athlete = await cardPromise;
  if (!athlete) {   // карточки нет (старая публикация) — как раньше, из полного каталога
    const index = await buildAthleteIndex();
    athlete = index.find(a => Number(a.id) === numId || a.athlete_id === strId);
  }
  if (!athlete) {
    try {
      athlete = await fetchMasterAthlete(strId);
    } catch (_) {}
  }
  if (!athlete) {
    if (container) container.innerHTML = '<div class="empty">Спортсмен не найден в реестре Федерации.</div>';
    // без сброса id go('athlete') снова вызывает openAthleteProfile → бесконечный цикл запросов к /api/athletes
    state.selectedAthleteId = null;
    state.selectedAthlete = null;
    go('athlete', false, restoreScrollY);
    return;
  }
  state.selectedAthlete = athlete;
  go('athlete', false, push ? null : restoreScrollY);
  renderAthleteProfileScreen(athlete);
  try {   // пришли со «Это вы?» через вход по почте — сразу открыть заявку
    if (sessionStorage.getItem('fmgto_claim_open') === athlete.athlete_id) {
      sessionStorage.removeItem('fmgto_claim_open');
      import('./claim_profile.js?v=a515019d').then((m) => m.openClaim(athlete.athlete_id, athlete.name));
    }
  } catch (_) {}
  // атлеты того же региона — из лёгкого индекса (190 КБ): профиль не ждёт его, а дорисовывается, когда индекс придёт
  if (!state.athleteIndex && !state.athleteLite) {
    loadAthleteLite().then(() => { if (state.screen === 'athlete' && state.selectedAthleteId === strId) renderAthleteProfileScreen(athlete, { communityOnly: true }); }).catch(() => {});
  }
  loadAthleteProgress(athlete);
  const hashTarget = `#athlete/${id}`;
  if (push && location.hash !== hashTarget) {
    history.pushState({ screen: 'athlete', id: strId }, '', hashTarget);
  } else if (location.hash !== hashTarget) {
    history.replaceState({ screen: 'athlete', id: strId }, '', hashTarget);
  }
  // сброс прокрутки сразу после отрисовки заставлял браузер синхронно раскладывать весь новый профиль (1,2 с на
  // телефоне, Lighthouse 30.09) — делаем в следующем кадре и только если страница действительно не наверху
  const toTop = () => requestAnimationFrame(() => { if (window.scrollY || document.documentElement.scrollTop) resetScrollToTop(); });
  if (push) {
    toTop();
  } else {
    const y = (typeof restoreScrollY === 'number') ? restoreScrollY : scrollStore.get(`athlete/${id}`);
    if (typeof y === 'number') {
      restoreScrollPosition(y);
    } else {
      toTop();
    }
  }
}

// Поиск атлетов: MiniSearch (github.com/lucaong/minisearch, MIT, 6 КБ) — опечатки, начало слова,
// любой порядок слов («Анастасия Шавыкина»), регион и город («шавыкина москва»), ё = е.
// Библиотека грузится только при первом поиске; если не загрузилась — старый поиск по вхождению.
const normRu = (v) => String(v || '').toLowerCase().replace(/ё/g, 'е');
let athleteSearchIdx = null;
let athleteSearchSeq = 0;
async function getAthleteSearchIndex(index) {
  if (athleteSearchIdx && athleteSearchIdx.src === index) return athleteSearchIdx.ms;
  const { default: MiniSearch } = await import('./vendor/minisearch.min.js?v=3531a1df');
  const ms = new MiniSearch({
    idField: '_i',
    fields: ['name', 'region', 'city'],
    processTerm: (t) => normRu(t),
    searchOptions: { boost: { name: 3 }, prefix: true, fuzzy: 0.25, combineWith: 'AND' }
  });
  ms.addAll(index.map((a, i) => ({ _i: i, name: a.name || '', region: a.region || '', city: a.city || '' })));
  athleteSearchIdx = { src: index, ms };
  return ms;
}

async function renderAthleteSearch() {
  const q = (state.athleteQuery || '').trim().toLowerCase();
  const seq = ++athleteSearchSeq;
  const resContainer = $('#athlete-search-results');
  const countEl = $('#athlete-search-count');
  if (!resContainer || !countEl) return;

  if (!q || q.length < 2) {
    countEl.textContent = `${(state.athleteIndex?.length || 4152).toLocaleString('ru-RU')} профилей спортсменов`;
    resContainer.innerHTML = `
      <div class="athlete-search-guide">
        <div class="asg-card">
          <span class="asg-icon"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-user"/></svg></span>
          <b>Каталог карточек участников соревнований</b>
          <p>В базе собрано ${(state.athleteIndex?.length || 4152).toLocaleString('ru-RU')} спортсменов с официальными фотографиями, действующими рекордами и протоколами всех этапов.</p>
        </div>
        <div class="asg-suggestions">
          <small>Быстрый выбор популярных атлетов:</small>
          <div class="asg-chips">
            <button type="button" class="asg-chip" data-quick-athlete="Шавыкина">Шавыкина Анастасия</button>
            <button type="button" class="asg-chip" data-quick-athlete="Королевский">Королевский Алексей</button>
            <button type="button" class="asg-chip" data-quick-athlete="Петренко">Петренко Наталья</button>
            <button type="button" class="asg-chip" data-quick-athlete="Гущина">Гущина Татьяна</button>
            <button type="button" class="asg-chip" data-quick-athlete="Малюгина">Малюгина Ева</button>
            <button type="button" class="asg-chip" data-quick-athlete="Никешин">Никешин Алексей</button>
          </div>
        </div>
      </div>
    `;
    return;
  }

  countEl.textContent = 'Поиск…';
  if (!state.athleteIndex) {
    // каталог (240 КБ) ещё не скачан — первый ответ берём у сервера, каталог догружается параллельно для нечёткого поиска
    try {
      const r = await fetch(`/api/athletes?search=${encodeURIComponent(q)}&limit=30`);
      const d = r.ok ? await r.json() : null;
      if (seq === athleteSearchSeq && d && Array.isArray(d.athletes) && !state.athleteIndex) {
        const quick = d.athletes.map(a => ({ ...a, kind: 'profile', id: a.id ?? a.legacy_id ?? a.athlete_id, competitions_count: a.competitions_count ?? (a.competitions || []).length, records_count: a.records_count ?? (a.records || []).length, podiums_count: a.podiums_count ?? 0 }));
        countEl.textContent = `Найдено атлетов: ${quick.length}${d.total > quick.length ? ` из ${d.total}` : ''}`;
        resContainer.innerHTML = quick.length ? renderAthleteSearchItems(quick) : '<div class="empty">Спортсмен не найден в опубликованных протоколах соревнований.</div>';
      }
    } catch (_) { /* нет сети — дождёмся каталога */ }
  }
  const index = await loadAthleteLite();
  let hits;
  try {
    const ms = await getAthleteSearchIndex(index);
    hits = ms.search(q).map(r => index[r.id]).filter(Boolean);
  } catch (_) {
    hits = index.filter(x => normRu(x.name).includes(normRu(q)));
  }
  if (seq !== athleteSearchSeq) return; // пока искали, запрос уже поменялся — рисует более свежий вызов
  countEl.textContent = `Найдено атлетов: ${hits.length}`;

  if (!hits.length) {
    resContainer.innerHTML = '<div class="empty">Спортсмен не найден в опубликованных протоколах соревнований.</div>';
    return;
  }

  resContainer.innerHTML = renderAthleteSearchItems(hits);
}

function renderAthleteSearchItems(hits) {
  return hits.slice(0, 50).map(x => {
    if (x.kind === 'profile') {
      const recordsCount = Number(x.records_count ?? (x.records ? x.records.length : 0));
      const compsCount = Number(x.competitions_count ?? (x.competitions ? x.competitions.length : 0));
      const podiumsCount = Number(x.podiums_count ?? 0);
      const initials = regionInitials(x.region || x.name);

      return `
        <article class="athlete-search-item" data-open-athlete-id="${x.id}">
          <div class="athlete-search-item-left">
            ${getAthleteAvatarHtml(x, 52)}
            <div class="athlete-search-item-info">
              <b>${esc(x.name)}</b>
              <small>${esc([x.region, genderWord(x.gender)].filter(Boolean).join(' • ') || 'Участник соревнований')}</small>
              <div class="athlete-search-item-stats">
                <span class="athlete-search-stat-pill starts-blue"><svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg><span>${compsCount} старт.</span></span>
                ${podiumsCount > 0 ? `<span class="athlete-search-stat-pill podium-gold"><svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/><path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.45 1-1 1H7"/><path d="M14 14.66V17c0 .55.45 1 1 1h2"/><path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/></svg><span>${podiumsCount} под.</span></span>` : ''}
                ${recordsCount > 0 ? `<span class="athlete-search-stat-pill record-amber"><svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg><span>${recordsCount} рек.</span></span>` : ''}
              </div>
            </div>
          </div>
          <span class="athlete-search-item-arrow">→</span>
        </article>
      `;
    }
    return `
      <div class="athlete-card">
        <div class="athlete-card-top">
          <b>${esc(x.name)}</b>
          ${x.rank ? `<span class="athlete-rank-pill">${esc(x.rank)} место</span>` : ''}
        </div>
        <div class="athlete-card-meta">
          <span>${esc(x.eventTitle)}</span> · <small>${esc(x.eventPeriod || '')}</small>
        </div>
        ${x.result || x.cat ? `<div class="athlete-card-sub"><span class="badge-cat">${esc(x.cat || x.section)}</span> <strong>${esc(resultMainText(x.result))}</strong></div>` : ''}
        <div class="athlete-card-act">
          <button class="link-action" data-event="${x.eventId}">Открыть протокол турнира →</button>
        </div>
      </div>
    `;
  }).join('') + (hits.length > 50 ? `<p class="legal">Показано 50 из ${hits.length} совпадений. Уточните запрос.</p>` : '');
}

function openTournamentDetailsModal(c, athlete) {
  if (!c) return;
  haptic(10);
  const ev = findTournamentForCompetition(c);
  const title = ev?.title || c.tournament_title || 'Соревнование ГТО';
  const period = ev?.period || c.tournament_date || '';
  const city = ev?.location || c.city || (c.is_online_platform ? 'Онлайн-платформа ФМГТО' : 'Российская Федерация');
  const eventId = competitionEventId(c) || ev?.id || null;
  const events = Array.isArray(c.events) ? c.events : [];
  const badgeHtml = getResultPlaceBadgeHtml(c.rank || (c.overall_place ? `${c.overall_place} место` : 'Участник'));
  const catText = [c.category, c.subgroup].filter(Boolean).join(' · ');
  const isOnline = Boolean(c.is_online_platform || c.hasOnline || ev?.hasOnline || ev?.format === 'ONLINE' || ev?.format === 'Онлайн-турнир');

  document.getElementById('tourn-detail-modal')?.remove();

  const modal = document.createElement('div');
  modal.className = 'share-modal-overlay';
  modal.id = 'tourn-detail-modal';
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.innerHTML = `
    <div class="share-modal-card" style="max-width:560px;padding:24px;background:#0f172a;border:1px solid rgba(255,255,255,0.14);border-radius:20px;color:#f8fafc;box-shadow:0 25px 50px -12px rgba(0,0,0,0.85);max-height:90vh;overflow-y:auto">
      <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:12px;margin-bottom:16px">
        <div>
          <div style="display:flex;align-items:center;gap:8px;margin-bottom:6px">
            <span style="font-size:11px;font-weight:700;color:#38bdf8;text-transform:uppercase;letter-spacing:0.06em">КАРТОЧКА СОРЕВНОВАНИЯ</span>
            ${isOnline ? '<span class="history-chip" style="color:#34d399;border-color:rgba(52,211,153,0.3);font-size:10px;padding:1px 6px"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-zap"/></svg> Онлайн-отбор</span>' : ''}
          </div>
          <h2 style="font-size:18px;font-weight:800;line-height:1.3;margin:0">${esc(title)}</h2>
          <div style="font-size:12px;color:#94a3b8;margin-top:4px;display:flex;gap:10px;flex-wrap:wrap">
            ${period ? `<span><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-calendar"/></svg> ${esc(period)}</span>` : ''}
            ${city ? `<span><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-map-pin"/></svg> ${esc(city)}</span>` : ''}
          </div>
        </div>
        <button type="button" class="share-modal-close" id="tourn-modal-close-btn" aria-label="Закрыть" style="background:rgba(255,255,255,0.08);border:none;color:#94a3b8;width:34px;height:34px;border-radius:50%;cursor:pointer;font-size:16px;display:flex;align-items:center;justify-content:center">✕</button>
      </div>

      <!-- Атлет и результат -->
      <div style="background:rgba(255,255,255,0.03);border:1px solid rgba(255,255,255,0.08);border-radius:14px;padding:14px;margin-bottom:16px">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px">
          <div>
            <div style="font-size:15px;font-weight:700;color:#f8fafc">${esc(athlete?.name || 'Атлет')}</div>
            <div style="font-size:12px;color:#94a3b8">${esc(athlete?.region || c.city || 'Россия')}</div>
          </div>
          <div>${badgeHtml}</div>
        </div>
        <div style="display:flex;gap:6px;flex-wrap:wrap;font-size:12px;color:#cbd5e1;margin-top:6px">
          ${catText ? `<span class="history-chip"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-tag"/></svg> ${esc(catText)}</span>` : ''}
          ${!c.team_name && c.is_team ? `<span class="history-chip" style="color:#60a5fa;border-color:rgba(96,165,250,0.3)"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-users"/></svg> Командный зачёт</span>` : ''}
          ${c.team_name ? `<span class="history-chip" style="color:#60a5fa;border-color:rgba(96,165,250,0.3)"><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-users"/></svg> ${esc(c.team_name)}</span>` : ''}
        </div>
        ${c.result ? resultCompactHtml(c.result, { label: 'Итог' }) : ''}
        ${c.team_name && eventId ? `<div class="team-roster" id="tourn-team-roster" data-event="${eventId}" data-team="${esc(c.team_name)}"><small>Состав команды</small><span class="team-roster-loading">загружаем…</span></div>` : ''}
      </div>

      <!-- Разбор комплексов и этапов -->
      ${events.length ? `
        <div style="margin-bottom:18px">
          <div style="font-size:12px;font-weight:700;color:#cbd5e1;text-transform:uppercase;letter-spacing:0.04em;margin-bottom:8px">
            Выступления по дисциплинам и комплексам (${events.length})
          </div>
          <div style="display:flex;flex-direction:column;gap:6px;max-height:220px;overflow-y:auto;padding-right:4px">
            ${events.map((e, idx) => `
              <div style="display:flex;justify-content:space-between;align-items:center;padding:10px 12px;background:rgba(255,255,255,0.03);border:1px solid rgba(255,255,255,0.06);border-radius:10px;font-size:12px">
                <div>
                  <span style="color:#38bdf8;font-weight:700;margin-right:4px">${idx + 1}.</span>
                  <span style="color:#f8fafc;font-weight:600">${esc(e.event_name || `Комплекс ${idx + 1}`)}</span>
                  ${e.subgroup && e.subgroup !== e.event_name ? `<br><small style="color:#94a3b8">${esc(e.subgroup)}</small>` : ''}
                </div>
                <div style="text-align:right">
                  ${e.result ? `<div style="font-weight:700;color:#38bdf8">${esc(resultMainText(e.result))}</div>` : ''}
                  ${e.rank ? `<small style="color:#94a3b8">${esc(e.rank)}</small>` : ''}
                </div>
              </div>
            `).join('')}
          </div>
        </div>
      ` : ''}

      <!-- Кнопки перехода -->
      <div style="display:flex;gap:10px;flex-wrap:wrap">
        ${eventId ? `
          <button type="button" class="athlete-hero-btn primary btn" id="tourn-modal-open-results" data-event="${eventId}" style="flex:1;justify-content:center;height:42px">
            <span>Протокол турнира <svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-chart-column"/></svg></span>
          </button>
          <button type="button" class="athlete-hero-btn secondary btn" id="tourn-modal-open-about" data-event="${eventId}" style="flex:1;justify-content:center;height:42px">
            <span>Страница турнира ↗</span>
          </button>
        ` : (isOnline ? `
          <button type="button" class="athlete-hero-btn primary btn" id="tourn-modal-open-hero" style="flex:1;justify-content:center;height:42px">
            <span><svg class="ic" aria-hidden="true"><use href="./assets/icons.svg?v=1#i-zap"/></svg> Записать попытку в Герой ГТО</span>
          </button>
        ` : `
          <button type="button" class="athlete-hero-btn primary btn" id="tourn-modal-close-action" style="flex:1;justify-content:center;height:42px">
            <span>Понятно ✓</span>
          </button>
        `)}
      </div>
    </div>
  `;

  document.body.appendChild(modal);
  // состав команды — из протокола турнира (строки той же команды)
  const roster = modal.querySelector('#tourn-team-roster');
  if (roster) {
    fetchResultsJson(roster.dataset.event).then(r => r ? r.json() : null).then(d => {
      const rows = (d && d.results) || [];
      const team = roster.dataset.team;
      const names = [...new Set(rows.filter(x => (x.team || '') === team).map(x => x.display_name).filter(Boolean))];
      const others = names.filter(n => n !== (athlete?.name || ''));
      roster.innerHTML = `<small>Состав команды «${esc(team)}»</small>` + (names.length
        ? `<div class="team-roster-list">${names.map(n => `<span class="team-roster-name ${n === (athlete?.name || '') ? 'is-self' : ''}">${esc(n)}</span>`).join('')}</div>` +
          (others.length ? '' : '<span class="team-roster-note">В протоколе записан только этот участник</span>')
        : '<span class="team-roster-note">Состав в протоколе не указан</span>');
    }).catch(() => { roster.remove(); });
  }

  const closeModal = () => {
    modal.classList.add('closing');
    setTimeout(() => modal.remove(), 180);
  };

  modal.querySelector('#tourn-modal-close-btn')?.addEventListener('click', closeModal);
  modal.querySelector('#tourn-modal-close-action')?.addEventListener('click', closeModal);
  modal.addEventListener('click', e => { if (e.target === modal) closeModal(); });

  modal.querySelector('#tourn-modal-open-results')?.addEventListener('click', () => {
    closeModal();
    if (eventId) openEvent(eventId, 'results');
  });

  modal.querySelector('#tourn-modal-open-about')?.addEventListener('click', () => {
    closeModal();
    if (eventId) openEvent(eventId, 'about');
  });

  modal.querySelector('#tourn-modal-open-hero')?.addEventListener('click', () => {
    closeModal();
    go('hero');
  });
}

// ----------------------------------------------------
// ГЕНЕРАТОР КАРТОЧЕК ДЛЯ СОЦСЕТЕЙ — share_cards.js, грузится при первом «Поделиться»
// ----------------------------------------------------
let shareMod = null, shareModPromise = null;
function shareModule() {
  if (!shareModPromise) shareModPromise = import('./share_cards.js?v=8111fd07').then((m) => (shareMod = m)).catch((err) => { shareModPromise = null; throw err; });
  return shareModPromise;
}
function openShareModal(data) { return shareModule().then((m) => m.openShareModal(data)); }
function closeShareModal() { if (shareMod) shareMod.closeShareModal(); }   // не открывали — закрывать нечего
function doShareCard() { return shareModule().then((m) => m.doShareCard()); }
function downloadCard() { return shareModule().then((m) => m.downloadCard()); }
window.openShareModal = openShareModal;
window.renderShareCard = openShareModal;
// ----------------------------------------------------
// ----------------------------------------------------
// ОБРАБОТЧИКИ СОБЫТИЙ И ИНИЦИАЛИЗАЦИЯ
// ----------------------------------------------------
// Десктопные выпадающие меню («Федерация», «Инструменты»): любой .desktop-nav-dropdown, не только tools
function closeDesktopDropdown(except = null) {
  $$('.desktop-nav-dropdown.open').forEach((dd) => {
    if (dd === except) return;
    dd.classList.remove('open');
    const btn = dd.querySelector('.nav-dropdown-toggle, .desktop-nav-dropdown-toggle');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  });
}

function toggleDesktopDropdown(toggleBtn = null) {
  const btn = toggleBtn || $('#tools-dropdown-btn');
  const dd = btn ? btn.closest('.desktop-nav-dropdown') : null;
  if (!dd || !btn) return;
  closeDesktopDropdown(dd);
  const isOpen = dd.classList.toggle('open');
  btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
}

document.addEventListener('keydown', e => {
  if (e.key === 'Escape') {
    closeMobileDrawer();
    const dd = $('.desktop-nav-dropdown.open');
    if (dd) {
      const btn = dd.querySelector('.nav-dropdown-toggle, .desktop-nav-dropdown-toggle');
      closeDesktopDropdown();
      if (btn) btn.focus();
    }
  }

  const toolsBtn = e.target.closest?.('#tools-dropdown-btn, #fed-dropdown-btn');
  if (toolsBtn) {
    if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      const dd = $('#desktop-tools-dropdown');
      if (dd) {
        dd.classList.add('open');
        toolsBtn.setAttribute('aria-expanded', 'true');
        const firstItem = $('#tools-dropdown-menu [role="menuitem"], #tools-dropdown-menu [data-go]');
        if (firstItem) firstItem.focus();
      }
    }
  }

  const inDropdownMenu = e.target.closest('#tools-dropdown-menu');
  if (inDropdownMenu) {
    const items = Array.from($$('#tools-dropdown-menu [role="menuitem"], #tools-dropdown-menu [data-go]'));
    const currentIndex = items.indexOf(e.target);
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      const nextIndex = (currentIndex + 1) % items.length;
      items[nextIndex]?.focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      const prevIndex = (currentIndex - 1 + items.length) % items.length;
      items[prevIndex]?.focus();
    } else if (e.key === 'Home') {
      e.preventDefault();
      items[0]?.focus();
    } else if (e.key === 'End') {
      e.preventDefault();
      items[items.length - 1]?.focus();
    }
  }
});

document.addEventListener('click', e => {
  const toolsToggle = e.target.closest('#tools-dropdown-btn, #fed-dropdown-btn, .desktop-nav-dropdown-toggle, .nav-dropdown-toggle');
  if (toolsToggle) {
    e.preventDefault();
    toggleDesktopDropdown(toolsToggle);
    return;
  }

  if (!e.target.closest('.desktop-nav-dropdown')) {
    closeDesktopDropdown();
  }

  const toggleBtn = e.target.closest('#mobile-menu-toggle');
  if (toggleBtn) {
    e.preventDefault();
    haptic(10);
    const drawer = $('#mobile-nav-drawer');
    if (drawer && drawer.classList.contains('is-open')) {
      closeMobileDrawer();
    } else {
      openMobileDrawer();
    }
    return;
  }

  const closeBtn = e.target.closest('#mobile-menu-close, #mobile-nav-backdrop');
  if (closeBtn) {
    e.preventDefault();
    haptic(10);
    closeMobileDrawer();
    return;
  }

  const drawerLink = e.target.closest('#mobile-nav-drawer a');
  if (drawerLink) {
    closeMobileDrawer();
  }

  const backBtn = e.target.closest('.detail-back, #header-back-btn, #athlete-detail-back, #athlete-search-back, #record-detail-back');
  if (backBtn) {
    e.preventDefault();
    closeMobileDrawer();
    closeDesktopDropdown();
    navigateBack();
    return;
  }

  // «Турниры атлета ↓», «Рекорды атлета ↓» — прокрутка к своему разделу на той же странице (не в общий календарь)
  const scrollBtn = e.target.closest('[data-scroll-to]');
  if (scrollBtn) {
    const target = document.getElementById(scrollBtn.dataset.scrollTo);
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); return; }
  }

  const g = e.target.closest('[data-go]');
  if (g) {
    e.preventDefault();
    closeMobileDrawer();
    closeDesktopDropdown();
    const target = g.dataset.go;
    const heroTab = g.dataset.heroTab;
    if (target === 'hero' && heroTab && typeof window.setActiveHeroTab === 'function') {
      window.setActiveHeroTab(heroTab);
    }
    go(target);
    return;
  }

  const est = e.target.closest('[data-event-status]');
  if (est) {
    state.eventStatus = est.dataset.eventStatus;
    $$('#event-status button').forEach(x => x.classList.toggle('active', x === est));
    haptic(10);
    renderEvents();
    return;
  }

  const lv = e.target.closest('[data-event-level]');
  if (lv) {
    state.eventLevel = lv.dataset.eventLevel; state.eventsDisplayLimit = 20;
    $$('[data-event-level]').forEach(x => x.classList.toggle('active', x === lv));
    haptic(10);
    renderEvents();
    return;
  }

  const y = e.target.closest('[data-event-year]');
  if (y) {
    state.eventsDisplayLimit = 20;
    state.eventYear = y.dataset.eventYear;
    $$('[data-event-year]').forEach(x => x.classList.toggle('active', x === y));
    haptic(10);
    renderEvents();
    return;
  }

  const ml = e.target.closest('[data-media-link]');
  if (ml) {
    state.mediaLinkFilter = ml.dataset.mediaLink;
    $$('#media-link-filter button').forEach(x => x.classList.toggle('active', x === ml));
    haptic(10);
    renderMedia();
    return;
  }

  const eChip = e.target.closest('[data-event-chip]');
  if (eChip) {
    const k = eChip.dataset.eventChip;
    if (k === 'year') { state.eventYear = 'all'; $$('[data-event-year]').forEach(b => b.classList.toggle('active', b.dataset.eventYear === 'all')); }
    else if (k === 'level') { state.eventLevel = 'all'; $$('[data-event-level]').forEach(b => b.classList.toggle('active', b.dataset.eventLevel === 'all')); }
    else if (k === 'status') { state.eventStatus = 'all'; $$('#event-status button').forEach(b => b.classList.toggle('active', b.dataset.eventStatus === 'all')); }
    else if (k === 'city') { state.eventCity = 'all'; const el = $('#event-city'); if (el) el.value = 'all'; }
    else if (k === 'format') { state.eventFormat = 'all'; const el = $('#event-format'); if (el) el.value = 'all'; }
    else if (k === 'program') { state.eventProgram = 'all'; const el = $('#event-program'); if (el) el.value = 'all'; }
    else if (k === 'type') { state.eventType = 'all'; const el = $('#event-type'); if (el) el.value = 'all'; }
    else if (k === 'query') { state.eventQuery = ''; const el = $('#event-search'); if (el) el.value = ''; }
    haptic(10);
    renderEvents();
    return;
  }

  const evReset = e.target.closest('#events-empty-reset, #events-reset-filters');
  if (evReset) {
    haptic(10);
    resetEventsFilters();
    return;
  }

  const nChip = e.target.closest('[data-news-chip]');
  if (nChip) {
    const k = nChip.dataset.newsChip;
    if (k === 'year') { state.newsYear = 'all'; const el = $('#news-year-filter'); if (el) el.value = 'all'; }
    else if (k === 'region') { state.newsRegion = 'all'; const el = $('#news-region-filter'); if (el) el.value = 'all'; }
    else if (k === 'type') { state.newsType = 'all'; const el = $('#news-type-filter'); if (el) el.value = 'all'; }
    else if (k === 'event') { state.newsEvent = 'all'; const el = $('#news-event-filter'); if (el) el.value = 'all'; }
    else if (k === 'query') { state.newsQuery = ''; const el = $('#news-search'); if (el) el.value = ''; }
    haptic(10);
    renderNews();
    return;
  }

  const nwReset = e.target.closest('#news-empty-reset');
  if (nwReset) {
    haptic(10);
    resetNewsFilters();
    return;
  }

  const icsBtn = e.target.closest('[data-event-ics]');
  if (icsBtn) {
    const evId = icsBtn.dataset.eventIcs;
    const ev = GTO_CALENDAR_EVENTS.find(x => String(x.id) === String(evId)) || { id: evId, title: 'Соревнование ГТО' };
    exportToIcal(ev);
    return;
  }

  const offlineBtn = e.target.closest('[data-event-offline]');
  if (offlineBtn) {
    toggleOfflineEvent(offlineBtn.dataset.eventOffline, offlineBtn);
    return;
  }

  // PDF (протокол, диплом, документ) в приложении «на экране Домой» / встроенном браузере Telegram:
  // target=_blank там уводит окно приложения без кнопки «назад» — показываем файл во встроенном просмотре.
  const pdfLink = e.target.closest('a[href$=".pdf"], a.results-pdf-link, a[href^="/protocol/"], a[href^="/diploma/"]');
  // Chrome на Android PDF в рамке не показывает — пустое окно (отчёты CSP «frame-src заблокировал inline», 02–04.10:
  // человек по три раза открывал свою грамоту). Там файл открывает система: в Telegram — openLink, в приложении — новая вкладка.
  // PDF с другого адреса (документ из админки турнира — live.gto.com.ru/uploads/…) в рамке тоже белый: frame-src сайта его не пускает,
  // а тот сервер шлёт X-Frame-Options (20.10.2026, стандарты Минска на iPhone) — такой файл тоже открывает система.
  if (pdfLink && isStandaloneApp()) {
    e.preventDefault();
    const sameSite = new URL(pdfLink.href, location.href).origin === location.origin;
    if (sameSite && !/Android/i.test(navigator.userAgent)) { openPdfViewer(pdfLink.href, pdfLink.textContent.trim()); return; }
    const tg = window.Telegram?.WebApp;
    if (tg?.initData && tg.openLink) tg.openLink(pdfLink.href); else window.open(pdfLink.href, '_blank', 'noopener');
    return;
  }

  const openTeamEl = e.target.closest('[data-open-team]');
  if (openTeamEl) { e.preventDefault(); openTeam(openTeamEl.dataset.openTeam); return; }

  const modMenu = e.target.closest('[data-mod-menu]');
  if (modMenu) {   // меню модератора: протокол, объявление, скрытое, журнал
    e.preventDefault();
    if (modMenu.dataset.modMenu === 'attention') { import('./mod_attention.js?v=0076cf7f').then((m) => m.openAttentionDialog()).catch(() => showToast('Не удалось открыть — проверьте связь')); return; }
    import('./mod_content.js?v=297d9599').then((m) => ({ protocol: m.openProtocolImport, banner: m.openBannerDialog, hidden: m.openHiddenDialog, audit: m.openAuditDialog })[modMenu.dataset.modMenu]?.())
      .catch(() => showToast('Не удалось открыть — проверьте связь'));
    return;
  }
  // модератор: документы, отделения, видео (формы грузятся только у модератора)
  const modAct = e.target.closest('[data-mod-doc-add],[data-mod-doc-edit],[data-mod-doc-hide],[data-mod-fed-edit],[data-mod-video-add],[data-mod-video-edit],[data-mod-video-hide]');
  if (modAct) {
    e.preventDefault(); e.stopPropagation();
    const ds = modAct.dataset;
    const openVideo = () => SORTED_GTO_VIDEOS.find((v) => v.embedUrl === state.activeMediaVideo) || SORTED_GTO_VIDEOS[0];
    const eventsForSelect = () => getUnifiedEvents().filter((x) => x && x.title).sort((a, b) => (eventDateRange(b)?.start?.getTime() || 0) - (eventDateRange(a)?.start?.getTime() || 0));
    import('./mod_content.js?v=297d9599').then((m) => {
      if ('modDocAdd' in ds) m.openDocDialog(null);
      else if (ds.modDocEdit) m.openDocDialog(overlayList('documents', FED_DOCUMENTS, (d, i) => 'fd-' + i).find((d) => d._cid === ds.modDocEdit));
      else if (ds.modDocHide) m.hideContent('documents', ds.modDocHide, 'документ');
      else if (ds.modFedEdit) { let f = {}; try { f = JSON.parse(ds.modFedJson || '{}'); } catch (_) { f = {}; } m.openFedDialog(ds.modFedEdit, ds.modFedName || '', f); }
      else if ('modVideoAdd' in ds) loadCalendar().then(() => m.openVideoDialog(null, eventsForSelect()));
      else if ('modVideoEdit' in ds) { const v = openVideo(); if (v) loadCalendar().then(() => m.openVideoDialog({ ...v, _cid: v._cid || 'v-' + v.id }, eventsForSelect())); }
      else if ('modVideoHide' in ds) { const v = openVideo(); if (v) m.hideContent('videos', v._cid || 'v-' + v.id, `видео «${v.title}»`); }
    }).catch(() => showToast('Не удалось открыть форму — проверьте связь'));
    return;
  }
  if (e.target.closest('[data-calc-reset]')) { $('#calc-preset-reset')?.click(); return; }   // та же очистка, что у кнопки внизу
  if (e.target.closest('[data-calc-scroll-summary]')) { $('#calc-structure-container')?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); return; }
  const openAthlete = e.target.closest('[data-open-athlete-id]');
  if (openAthlete) {
    state.athleteProfileReturnScreen = state.screen;
    markSharedTransition(openAthlete.querySelector('.athlete-avatar-wrap, .athlete-avatar-monogram'));
    openAthleteProfile(openAthlete.dataset.openAthleteId);
    return;
  }

  // «Поделиться» турниром: ссылка на /share/event/<id> — у неё своё превью (картинка, дата, число участников)
  const shareEventBtn = e.target.closest('[data-share-event]');
  if (shareEventBtn) {
    e.preventDefault();
    const url = `${location.origin}/share/event/${encodeURIComponent(shareEventBtn.dataset.shareEvent)}`;
    const title = shareEventBtn.dataset.shareTitle || 'Турнир по многоборью ГТО';
    if (navigator.share) navigator.share({ title, url }).catch(() => {});
    else navigator.clipboard?.writeText(url).then(() => showToast('✓ Ссылка на турнир скопирована')).catch(() => showToast('Не удалось скопировать ссылку'));
    return;
  }
  const copyAthleteUrl = e.target.closest('[data-copy-athlete-url]');
  if (copyAthleteUrl) {
    // share-страница отдаёт Open Graph превью (фото, старты, медали) в Telegram/VK; внутри — кнопка в приложение
    const url = `${location.origin}/share/athlete/${encodeURIComponent(copyAthleteUrl.dataset.copyAthleteUrl)}`;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(() => {
        haptic(20);
        const span = copyAthleteUrl.querySelector('span');
        if (span) {
          const prev = span.textContent;
          span.textContent = '✓ Скопировано';
          setTimeout(() => { span.textContent = prev; }, 2000);
        }
      });
    }
    return;
  }

  // «Это вы?» — заявка на привязку карточки к своему кабинету (claim_profile.js?v=a515019d). Раньше кнопка без проверки
  // создавала в браузере кабинет под именем любого атлета — от его имени можно было подавать видеозаявки.
  const claimBtn = e.target.closest('[data-claim-athlete]');
  if (claimBtn) {
    import('./claim_profile.js?v=a515019d').then((m) => m.openClaim(claimBtn.dataset.claimAthlete, claimBtn.dataset.claimName || '')).catch(() => showToast('Не удалось открыть окно — обновите страницу'));
    return;
  }

  // 1. Athlete button inside record card or record detail
  const recAthleteBtn = e.target.closest('[data-record-athlete], .rrc-athlete-btn');
  if (recAthleteBtn) {
    e.preventDefault();
    e.stopPropagation();
    haptic(10);
    const aId = recAthleteBtn.dataset.athleteId;
    const aName = recAthleteBtn.dataset.recordAthlete || recAthleteBtn.dataset.athleteQuery;
    if (aId) {
      state.athleteProfileReturnScreen = 'record';
      openAthleteProfile(aId, true);
    } else if (aName) {
      loadAthleteLite().then(() => {
        const match = findAthleteByName(aName);
        if (match) {
          state.athleteProfileReturnScreen = 'record';
          openAthleteProfile(match.id, true);
        } else {
          state.athleteQuery = aName;
          go('athlete-search');
          const input = $('#global-athlete-search');
          if (input) input.value = state.athleteQuery;
          renderAthleteSearch();
        }
      });
    }
    return;
  }

  // 2. Tournament button inside record card or record detail
  const recEventBtn = e.target.closest('[data-record-event], .rrc-event-btn');
  if (recEventBtn) {
    e.preventDefault();
    e.stopPropagation();
    haptic(10);
    const evId = recEventBtn.dataset.eventId;
    const evTitle = recEventBtn.dataset.recordEvent;
    if (evId) {
      openEvent(evId, 'about', true);
    } else if (evTitle) {
      const match = findEventByTitleOrRecord(evTitle);
      if (match) {
        openEvent(match.id, 'about', true);
      } else {
        state.eventQuery = evTitle;
        go('events');
        const input = $('#event-search');
        if (input) input.value = evTitle;
        renderEvents();
      }
    }
    return;
  }

  // 2b. Share button inside unified record card
  const recShareBtn = e.target.closest('.urc-share-btn, [data-share-record]');
  if (recShareBtn) {
    e.preventDefault();
    e.stopPropagation();
    haptic(10);
    const card = recShareBtn.closest('.unified-record-card');
    let shareData = null;
    if (card && card.dataset.shareData) {
      try { shareData = JSON.parse(card.dataset.shareData); } catch (_) {}
    }
    const recTitle = shareData ? `${shareData.discipline}: ${shareData.result} (${shareData.holder})` : 'Рекорд России';
    const recText = shareData ? `Рекорд России по многоборью ГТО: ${shareData.holder} — ${shareData.discipline} (${shareData.result})` : 'Рекорд России по многоборью ГТО';
    const recUrl = `${location.origin}${location.pathname}#records`;
    if (navigator.share) {
      navigator.share({ title: recTitle, text: recText, url: recUrl }).catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(`${recText}\n${recUrl}`).then(() => {
        showToast('✓ Рекорд скопирован в буфер обмена!');
      }).catch(() => {
        showToast('✓ Ссылка скопирована: ' + recUrl);
      });
    } else {
      showToast('✓ Ссылка: ' + recUrl);
    }
    return;
  }

  // 3. Whole record card tap. Кнопки модератора («Редактировать», «Удалить» — на карточке и на странице рекорда) несут
  // тот же data-record-id: раньше их клик открывал рекорд заново и до правки/удаления не доходил («Не могу удалить», 05.10)
  const recCard = e.target.closest('[data-record-id], .unified-record-card');
  const recModBtn = e.target.closest('.btn-card-mod-edit-record, .btn-card-mod-del-record, #btn-mod-edit-record-detail, #btn-mod-del-record-detail');
  if (recCard && recCard.dataset.recordId && !recModBtn) {
    e.preventDefault();
    haptic(10);
    const rr = regionalRecordById(recCard.dataset.recordId);   // рекорд региона: своей карточки нет — ведём в турнир («Иду на рекорд») или к атлету
    if (rr) { if (rr.eventId) openEvent(rr.eventId, 'record-run'); else if (rr.athlete_id) openAthleteProfile(rr.athlete_id); return; }
    openRecordDetail(recCard.dataset.recordId, true);
    return;
  }

  // 4. Open region from record detail or tournament results
  const openRegBtn = e.target.closest('[data-open-region]');
  if (openRegBtn) {
    e.preventDefault();
    haptic(10);
    if (state.screen === 'event') {
      state.regionReturnScreen = 'event';
    } else if (state.screen !== 'region') {
      state.regionReturnScreen = state.screen;
    }
    openRegion(openRegBtn.dataset.openRegion, true);
    return;
  }

  const shareBtn = e.target.closest('[data-results-share]');
  if (shareBtn) {
    const url = location.origin + location.pathname + resultsShareHash();
    const title = (state.currentEventResults?.title || 'Протокол') + (state.eventResultCategory !== 'all' ? ` · ${state.eventResultCategory}` : '') + (state.eventResultRegion !== 'all' ? ` · ${state.eventResultRegion}` : '');
    if (navigator.share) navigator.share({ title, url }).catch(() => {});
    else navigator.clipboard?.writeText(url).then(() => showToast('✓ Ссылка скопирована — откроется с тем же выбором')).catch(() => showToast(url));
    return;
  }
  // протокол: порядок по комплексу, «★ Мои», «Как считаются очки?»
  const rtSort = e.target.closest('[data-rt-sort]');
  if (rtSort) { const k = rtSort.dataset.rtSort; state.eventResultSort = k && state.eventResultSort === k ? '' : k; renderEventResults(); return; }
  const rtFav = e.target.closest('[data-rt-fav]');
  if (rtFav) {
    const name = rtFav.dataset.rtFav; const on = toggleFav(name); const k = nameKey(name);
    $$('[data-rt-name]').forEach((x) => { if (x.dataset.rtName === k) x.classList.toggle('is-fav', on); });
    $$('[data-rt-fav]').forEach((b) => { if (nameKey(b.dataset.rtFav) !== k) return; b.setAttribute('aria-pressed', String(on)); b.textContent = on ? '★' : '☆'; b.setAttribute('aria-label', `${on ? 'Убрать из «Моих»' : 'Добавить в «Мои»'}: ${name}`); });
    renderMineStrip(); return;
  }
  const recSortBtn = e.target.closest('[data-rec-sort]');
  if (recSortBtn) {
    state.recSort = recSortBtn.dataset.recSort;
    const wrap = recSortBtn.closest('.rec-wrap');
    if (wrap && recProtocol) { wrap.outerHTML = tournamentRecordsHtml(recProtocol); document.querySelector(`[data-rec-sort="${state.recSort}"]`)?.focus(); }
    return;
  }
  // «Иду на рекорд»: дисциплина и группа (пол, возраст) — кнопками сверху; выбор перерисовывает список, фокус — на нажатой кнопке
  const recPick = e.target.closest('[data-rec-disc], [data-rec-sub]');
  if (recPick) {
    const isDisc = recPick.hasAttribute('data-rec-disc');
    if (isDisc) { state.recDisc = recPick.dataset.recDisc; state.recSub = ''; } else state.recSub = recPick.dataset.recSub;
    const wrap = recPick.closest('.rec-wrap');
    if (wrap && recProtocol) {
      const sel = isDisc ? `[data-rec-disc="${CSS.escape(state.recDisc)}"]` : `[data-rec-sub="${CSS.escape(state.recSub)}"]`;
      wrap.outerHTML = tournamentRecordsHtml(recProtocol); document.querySelector(sel)?.focus({ preventScroll: true });
    }
    return;
  }
  const subTab = e.target.closest('[data-result-sub]');
  if (subTab) {
    state.eventResultSub = subTab.dataset.resultSub; renderEventResults();
    document.querySelector(`[data-result-sub="${CSS.escape(state.eventResultSub)}"]`)?.focus({ preventScroll: true });
    return;
  }
  const recMore = e.target.closest('[data-rec-more]');
  if (recMore) { const make = recMoreStore.get(recMore.dataset.recMore); if (make) { recMore.insertAdjacentHTML('beforebegin', make()); recMoreStore.delete(recMore.dataset.recMore); } recMore.remove(); return; }
  const rtMore = e.target.closest('[data-rt-more]');
  if (rtMore) {
    (state.rtExpanded ||= new Set()).add(rtMore.dataset.rtMore); renderEventResults(); return;
  }
  const rtShare = e.target.closest('[data-rt-share]');
  if (rtShare) { shareResultRow(rtShare.dataset.rtShare, rtShare.dataset.rtCat, rtShare.dataset.rtLabel); return; }
  const rtJump = e.target.closest('[data-rt-jump]');
  if (rtJump) {
    jumpToResultRow(rtJump.dataset.rtJump, rtJump.dataset.rtCat);
    return;
  }
  const rtHow = e.target.closest('[data-rt-how]');
  if (rtHow) { const d = rtHow.closest('.rt-block')?.querySelector('.rt-how'); if (d) { d.open = true; d.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } return; }
  const progTab = e.target.closest('[data-result-program]');
  if (progTab) {
    state.eventResultProgram = progTab.dataset.resultProgram; state.eventResultCategory = 'all';
    refreshResultCats(); renderEventResults(); return;
  }
  const catChip = e.target.closest('[data-result-cat]');
  if (catChip) {
    state.eventResultCategory = catChip.dataset.resultCat; state.eventResultSub = '';
    $$('[data-result-cat]').forEach(x => x.classList.toggle('active', x === catChip));
    catChip.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    renderEventResults(); return;
  }
  const viewBtn = e.target.closest('[data-result-view]');
  if (viewBtn) { state.eventResultView = viewBtn.dataset.resultView; try { localStorage.setItem('gto_results_view', state.eventResultView); } catch (_) {} $$('[data-result-view]').forEach(x => x.classList.toggle('active', x === viewBtn)); renderEventResults(); return; }
  const stationBtn = e.target.closest('[data-station]');
  if (stationBtn) { e.preventDefault(); openStationModal(stationBtn.dataset.station); return; }
  const catBtn = e.target.closest('[data-result-category]');
  if (catBtn && state.screen === 'event') {
    state.eventResultCategory = state.eventResultCategory === catBtn.dataset.resultCategory ? 'all' : catBtn.dataset.resultCategory; state.eventResultSub = '';
    $$('[data-result-cat]').forEach(x => x.classList.toggle('active', x.dataset.resultCat === state.eventResultCategory));
    renderEventResults(); $('#event-result-summary')?.scrollIntoView({ behavior: 'smooth', block: 'start' }); return;
  }
  const athleteQuery = e.target.closest('[data-athlete-query]');
  if (athleteQuery) {
    const qName = athleteQuery.dataset.athleteQuery;
    state.athleteQuery = qName;
    if (state.screen === 'event') {
      state.athleteReturnScreen = 'event';
      state.athleteReturnEventId = state.currentEventId;
      const activeTab = $('.detail-tabs button.active');
      state.athleteReturnPane = activeTab ? activeTab.dataset.pane : 'results';
      state.athleteProfileReturnScreen = 'event';
    } else if (state.screen !== 'athlete-search' && state.screen !== 'athlete') {
      state.athleteReturnScreen = state.screen;
      state.athleteReturnEventId = null;
      state.athleteProfileReturnScreen = state.screen;
    }
    loadAthleteLite().then(index => {
      const match = findAthleteByName(qName);
      if (match) {
        openAthleteProfile(match.id);
      } else {
        go('athlete-search');
        const input = $('#global-athlete-search');
        if (input) input.value = state.athleteQuery;
        const backBtn = $('#athlete-search-back');
        if (backBtn) {
          if (state.athleteReturnScreen === 'event' && state.athleteReturnEventId) {
            backBtn.textContent = '← Назад к турниру';
            backBtn.dataset.returnEvent = String(state.athleteReturnEventId);
            backBtn.dataset.returnPane = state.athleteReturnPane || 'results';
          } else {
            backBtn.textContent = '← Старты';
            delete backBtn.dataset.returnEvent;
            delete backBtn.dataset.returnPane;
          }
        }
        renderAthleteSearch();
      }
    });
    return;
  }

  // Карточка старта в профиле атлета
  const tournCardBtn = e.target.closest('[data-open-tourn-modal]');
  if (tournCardBtn) {
    e.preventDefault();
    const idx = parseInt(tournCardBtn.dataset.openTournModal, 10);
    const listType = tournCardBtn.dataset.tournList || 'past';
    const athlete = state.selectedAthlete;
    const comps = athlete ? (listType === 'upcoming' ? athlete._upcomingCompetitions : athlete._pastCompetitions) : null;
    if (comps && comps[idx]) {
      openTournamentDetailsModal(comps[idx], athlete);
    }
    return;
  }

  const tournCard = e.target.closest('[data-tourn-card-idx]');
  if (tournCard && !e.target.closest('button, a, summary, [data-event]')) {
    e.preventDefault();
    const idx = parseInt(tournCard.dataset.tournCardIdx, 10);
    const listType = tournCard.dataset.tournList || 'past';
    const athlete = state.selectedAthlete;
    const comps = athlete ? (listType === 'upcoming' ? athlete._upcomingCompetitions : athlete._pastCompetitions) : null;
    if (comps && comps[idx]) {
      openTournamentDetailsModal(comps[idx], athlete);
    }
    return;
  }

  // Переход в Герой ГТО из онлайн-турнира
  const heroTournBtn = e.target.closest('[data-go-herogto-tourn]');
  if (heroTournBtn) {
    e.preventDefault();
    const tournId = heroTournBtn.dataset.goHerogtoTourn;
    const base = GTO_CALENDAR_EVENTS.find(x => String(x.id) === String(tournId));
    setHeroActiveTournament(tournId, base?.title || 'Онлайн-турнир ГТО', base?.wodExercises || []);
    go('herohub');
    return;
  }

  // Пагинация списков: Показать ещё
  const eventsMoreBtn = e.target.closest('#events-load-more');
  if (eventsMoreBtn) {
    state.eventsDisplayLimit = (state.eventsDisplayLimit || 20) + 20;
    renderEvents();
    return;
  }
  const newsMoreBtn = e.target.closest('#news-load-more');
  if (newsMoreBtn) {
    state.newsDisplayLimit = (state.newsDisplayLimit || 20) + 20;
    renderNews();
    return;
  }
  const resultsMoreBtn = e.target.closest('#results-load-more');
  if (resultsMoreBtn) {
    state.resultsDisplayLimit = (state.resultsDisplayLimit || 20) + 20;
    renderResultsScreen();
    return;
  }

  // Переход в раздел Результаты
  const allResultsBtn = e.target.closest('[data-event-all-results]');
  if (allResultsBtn) {
    e.preventDefault();
    go('results');
    return;
  }

  // Moderator actions on event cards and feed
  const cardModEditEvent = e.target.closest('.btn-card-mod-edit-event');
  if (cardModEditEvent) {
    e.preventDefault();
    e.stopPropagation();
    const evId = cardModEditEvent.dataset.eventId;
    const ev = getUnifiedEvents().find(x => String(x.id) === String(evId)) || GTO_CALENDAR_EVENTS.find(x => String(x.id) === String(evId));
    if (ev) openModEventDialog(ev);
    return;
  }

  const cardModDelEvent = e.target.closest('.btn-card-mod-del-event');
  if (cardModDelEvent) {
    e.preventDefault();
    e.stopPropagation();
    const evId = cardModDelEvent.dataset.eventId;
    const ev = getUnifiedEvents().find(x => String(x.id) === String(evId)) || GTO_CALENDAR_EVENTS.find(x => String(x.id) === String(evId));
    if (ev && confirm(`Удалить соревнование «${ev.title}» из календаря сайта?`)) {
      deleteUnifiedEvent(evId).then((res) => { renderEvents(); if (!res.ok) { showToast(`Не удалено: ${res.error}`); return; } offerUndo(`Соревнование «${ev.title}» удалено`, () => restoreUnifiedEvent(evId).then((r) => { renderEvents(); return r; })); });
    }
    return;
  }

  const feedModAddEvent = e.target.closest('#btn-mod-add-event-feed');
  if (feedModAddEvent) {
    e.preventDefault();
    openModEventDialog(null);
    return;
  }

  // Moderator actions on detail screens
  const detailModEditEvent = e.target.closest('#btn-mod-edit-event-detail');
  if (detailModEditEvent) {
    e.preventDefault();
    const evId = state.currentEventId;
    const ev = getUnifiedEvents().find(x => String(x.id) === String(evId)) || GTO_CALENDAR_EVENTS.find(x => String(x.id) === String(evId));
    if (ev) openModEventDialog(ev);
    return;
  }

  // ★ «Главные события» на главной: добавить турнир в конец списка или убрать (правка home/main)
  const modMainBtn = e.target.closest('#btn-mod-main-event');
  if (modMainBtn) {
    e.preventDefault();
    const evId = String(state.currentEventId); const ids = mainEventIds(); const on = ids.includes(evId);
    modMainBtn.disabled = true;
    import('./mod_content.js?v=297d9599').then((m) => m.saveMainEvents(on ? ids.filter((x) => x !== evId) : [...ids, evId])).then((ok) => {
      if (!ok) return;
      modMainBtn.setAttribute('aria-pressed', on ? 'false' : 'true');
      modMainBtn.textContent = on ? '★ В главные события' : '★ Убрать из главных событий';
      showToast(on ? '✓ Убрано из главных событий' : '✓ Добавлено в главные события — на главной последним');
    }).finally(() => { modMainBtn.disabled = false; });
    return;
  }

  const detailModDelEvent = e.target.closest('#btn-mod-del-event-detail');
  if (detailModDelEvent) {
    e.preventDefault();
    const evId = state.currentEventId;
    const ev = getUnifiedEvents().find(x => String(x.id) === String(evId)) || GTO_CALENDAR_EVENTS.find(x => String(x.id) === String(evId));
    if (ev && confirm(`Удалить соревнование «${ev.title}» из календаря?`)) {
      deleteUnifiedEvent(evId).then((res) => { if (!res.ok) { showToast(`Не удалено: ${res.error}`); return; } go('events'); offerUndo(`Соревнование «${ev.title}» удалено`, () => restoreUnifiedEvent(evId).then((r) => { renderEvents(); return r; })); });
    }
    return;
  }

  // Moderator actions on record cards and feed
  const cardModEditRec = e.target.closest('.btn-card-mod-edit-record');
  if (cardModEditRec) {
    e.preventDefault();
    e.stopPropagation();
    const recId = cardModEditRec.dataset.recordId;
    const rec = getUnifiedRecords().find(x => String(x.id) === String(recId));
    if (rec) openModRecordDialog(rec);
    return;
  }

  const cardModDelRec = e.target.closest('.btn-card-mod-del-record');
  if (cardModDelRec) {
    e.preventDefault();
    e.stopPropagation();
    const recId = cardModDelRec.dataset.recordId;
    const rec = getUnifiedRecords().find(x => String(x.id) === String(recId));
    if (rec && confirm(`Удалить рекорд «${rec.discipline}» (${rec.holder})?`)) {
      deleteUnifiedRecord(recId).then((res) => { renderRecords(); if (!res.ok) { showToast(`Не удалено: ${res.error}`); return; } offerUndo('Рекорд удалён', () => restoreUnifiedRecord(recId).then((r) => { renderRecords(); return r; })); });
    }
    return;
  }

  const feedModAddRec = e.target.closest('#btn-mod-add-record-feed');
  if (feedModAddRec) {
    e.preventDefault();
    openModRecordDialog(null);
    return;
  }

  const feedModAddNews = e.target.closest('#btn-mod-add-news-feed');
  if (feedModAddNews) {
    e.preventDefault();
    openModCreateNewsDialog();
    return;
  }

  const detailModEditRec = e.target.closest('#btn-mod-edit-record-detail');
  if (detailModEditRec) {
    e.preventDefault();
    const recId = detailModEditRec.dataset.recordId || state.selectedRecordId;
    const rec = getUnifiedRecords().find(x => String(x.id) === String(recId));
    if (rec) openModRecordDialog(rec);
    return;
  }

  const detailModDelRec = e.target.closest('#btn-mod-del-record-detail');
  if (detailModDelRec) {
    e.preventDefault();
    const recId = detailModDelRec.dataset.recordId || state.selectedRecordId;
    const rec = getUnifiedRecords().find(x => String(x.id) === String(recId));
    if (rec && confirm(`Удалить рекорд «${rec.discipline}» (${rec.holder})?`)) {
      deleteUnifiedRecord(recId).then((res) => { if (!res.ok) { showToast(`Не удалено: ${res.error}`); return; } go('records'); offerUndo('Рекорд удалён', () => restoreUnifiedRecord(recId).then((r) => { renderRecords(); return r; })); });
    }
    return;
  }

  const event = e.target.closest('[data-event]');
  if (event) { markSharedTransition(event.closest('.event-card')?.querySelector('.evc-media')); openEvent(event.dataset.event, event.dataset.eventPane || 'about'); return; }

  const cardModEdit = e.target.closest('.btn-card-mod-edit');
  if (cardModEdit) {
    e.preventDefault();
    e.stopPropagation();
    const aId = cardModEdit.dataset.articleId;
    const targetNews = getUnifiedNews().find(n => String(n.id) === String(aId));
    if (targetNews) openModEditDialog(targetNews);
    return;
  }

  const cardModDel = e.target.closest('.btn-card-mod-delete');
  if (cardModDel) {
    e.preventDefault();
    e.stopPropagation();
    const aId = cardModDel.dataset.articleId;
    const targetNews = getUnifiedNews().find(n => String(n.id) === String(aId));
    if (targetNews) handleModDeleteArticle(targetNews);
    return;
  }

  const article = e.target.closest('[data-article]');
  if (article) { openArticle(article.dataset.article); return; }

  const pane = e.target.closest('[data-pane]');
  if (pane) {
    let targetPane = pane.dataset.pane;
    if (targetPane === 'event-media') targetPane = 'event-photos';
    if ((targetPane === 'event-photos' || targetPane === 'about') && state.eventMediaStale && state.eventMediaStale === state.currentEventId) {   // альбомы пришли позже — дорисовываем при переходе на вкладку с фото
      const evId = state.eventMediaStale; state.eventMediaStale = null; state.currentEventId = null;
      openEvent(evId, targetPane, false, window.scrollY);
      return;
    }
    const activeTab = $(`.detail-tabs [data-pane="${targetPane}"]`);
    if (activeTab) {
      $$('.detail-tabs button').forEach(x => x.classList.toggle('active', x === activeTab));
      $$('.detail-pane').forEach(x => x.classList.toggle('active', x.dataset.paneContent === targetPane));
      if (!pane.closest('.detail-tabs')) {
        const tabsEl = $('.detail-tabs');
        if (tabsEl) tabsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      if (state.lastEventId) {
        state.lastEventPane = targetPane;
        if (appNavigationStack.length && appNavigationStack[appNavigationStack.length - 1].screen === 'event') {
          appNavigationStack[appNavigationStack.length - 1].params = appNavigationStack[appNavigationStack.length - 1].params || {};
          appNavigationStack[appNavigationStack.length - 1].params.pane = targetPane;
        }
        const hashTarget = `#event/${state.lastEventId}` + (targetPane !== 'about' ? `/${targetPane}` : '');
        history.replaceState({ screen: 'event', id: state.lastEventId, pane: targetPane }, '', hashTarget);
      }
    }
    haptic(10);
    return;
  }

  const resultSexFilter = e.target.closest('[data-result-sex]');
  if (resultSexFilter) {
    state.eventResultSex = resultSexFilter.dataset.resultSex;
    $$('[data-result-sex]').forEach(x => x.classList.toggle('active', x === resultSexFilter));
    renderEventResults();
    return;
  }

  const resultStandingFilter = e.target.closest('[data-result-standing]');
  if (resultStandingFilter) {
    state.eventResultStanding = resultStandingFilter.dataset.resultStanding;
    $$('[data-result-standing]').forEach(x => x.classList.toggle('active', x === resultStandingFilter));
    renderEventResults();
    return;
  }

  const resultExport = e.target.closest('[data-results-export]');
  if (resultExport) {
    resultExport.dataset.resultsExport === 'csv' ? exportEventResultsCsv() : printEventResults();
    return;
  }

  const loadMoreRecords = e.target.closest('#records-load-more');
  if (loadMoreRecords) {
    e.preventDefault();
    haptic(10);
    state.recordLimit = (state.recordLimit || 30) + 30;
    renderRecords();
    return;
  }

  const sex = e.target.closest('[data-sex]');
  if (sex) {
    state.recordLimit = 30;
    state.sex = sex.dataset.sex;
    $$('#record-chips button').forEach(x => x.classList.toggle('active', x === sex));
    haptic(10);
    renderRecords();
    return;
  }

  const media = e.target.closest('[data-media]');
  if (media) {
    state.media = media.dataset.media;
    $$('#media-tabs button').forEach(x => x.classList.toggle('active', x.dataset.media === state.media));
    haptic(10);
    renderMedia();
    return;
  }

  const video = e.target.closest('[data-video]');
  if (video) {
    const videoUrl = video.dataset.video;
    state.activeMediaVideo = videoUrl;
    haptic(10);
    const mediaSlot = $('#media-video-player-slot');
    if (state.screen === 'media' && mediaSlot) {
      mediaSlot.innerHTML = `<iframe id="video-player" class="video-feature" src="${safeUrl(videoUrl)}" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Видео"></iframe>`;
      $$('.media-card').forEach(card => card.classList.toggle('playing', card.dataset.video === videoUrl));
      mediaSlot.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    const slot = $('#event-video-player-slot');
    if (slot) {
      slot.innerHTML = `<iframe class="video-feature" src="${safeUrl(videoUrl)}" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Видео соревнования"></iframe>`;
      $$('.event-videos-pane .media-card, .event-media-pane .media-card').forEach(card => card.classList.toggle('playing', card.dataset.video === videoUrl));
      slot.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    return;
  }

  const album = e.target.closest('[data-album]');
  if (album) { openAlbum(album.dataset.album); return; }

  const eventMediaBack = e.target.closest('[data-event-photos-back], [data-event-media-back]');
  if (eventMediaBack) {
    const target = $('[data-pane-content="event-photos"]') || $('[data-pane-content="event-media"]');
    if (target && (state.currentEventPhotosHtml || state.currentEventMediaHtml)) {
      target.innerHTML = state.currentEventPhotosHtml || state.currentEventMediaHtml;
    }
    return;
  }

  const resultGroup = e.target.closest('[data-result-group]');
  if (resultGroup) {
    state.eventResultGroupBy = resultGroup.dataset.resultGroup;
    $$('[data-result-group]').forEach(x => x.classList.toggle('active', x === resultGroup));
    haptic(10);
    renderEventResults();
    return;
  }

  const resultsMore = e.target.closest('[data-results-more]');
  if (resultsMore) {
    state.eventResultLimit = (state.eventResultLimit || 120) + 120;
    renderEventResults();
    return;
  }

  const my = e.target.closest('[data-media-year]');
  if (my) {
    state.mediaYear = my.dataset.mediaYear;
    haptic(10);
    renderMedia();
    return;
  }

  const mr = e.target.closest('[data-media-reset]');
  if (mr) {
    state.mediaYear = 'all';
    state.videoPlatform = 'all';
    state.mediaQuery = '';
    haptic(10);
    renderMedia();
    return;
  }

  const vplat = e.target.closest('[data-vplat]');
  if (vplat) {
    state.videoPlatform = vplat.dataset.vplat;
    haptic(10);
    renderVideoTab();
    return;
  }

  const albumMore = e.target.closest('[data-album-more]');
  if (albumMore) { openAlbum(albumMore.dataset.albumMore, Number(albumMore.dataset.limit)); return; }

  const cAlt = e.target.closest('[data-alt-group]');
  if (cAlt) {
    e.preventDefault();
    const grp = cAlt.dataset.altGroup;
    const tid = cAlt.dataset.testId;
    state.calcSelectedAlt = state.calcSelectedAlt || {};
    state.calcSelectedAlt[grp] = tid;
    haptic(10);
    renderCalculator();
    return;
  }

  const rulesToggle = e.target.closest('#calc-rules-toggle-btn');
  if (rulesToggle) {
    e.preventDefault();
    state.calcGuideOpen = !state.calcGuideOpen;
    rulesToggle.classList.toggle('open', state.calcGuideOpen);
    const dd = $('#calc-rules-dropdown');
    if (dd) dd.hidden = !state.calcGuideOpen;
    haptic(8);
    return;
  }

  const cSex = e.target.closest('[data-calc-sex]');
  if (cSex) {
    e.preventDefault();
    state.calcSex = cSex.dataset.calcSex;
    state.calcSelectedAlt = state.calcSelectedAlt || {};
    if (state.calcSex === 'W' && state.calcSelectedAlt.strength === 'pull_up') {
      state.calcSelectedAlt.strength = 'push_up';
    } else if (state.calcSex === 'M' && state.calcSelectedAlt.strength === 'pull_up_low') {
      state.calcSelectedAlt.strength = 'pull_up';
    }
    haptic(10);
    renderCalculator();
    return;
  }

  const cMode = e.target.closest('[data-calc-mode]');
  if (cMode) {
    e.preventDefault();
    state.calcMode = cMode.dataset.calcMode;
    haptic(10);
    renderCalculator();
    return;
  }

  const cOvz = e.target.closest('[data-calc-ovz]');
  if (cOvz) {
    e.preventDefault();
    state.calcOvzCategory = cOvz.dataset.calcOvz;
    haptic(10);
    renderCalculator();
    return;
  }

  const pGold = e.target.closest('#calc-preset-gold');
  if (pGold) {
    e.preventDefault();
    applyCalculatorPreset('gold');
    haptic(15);
    return;
  }

  const pSilver = e.target.closest('#calc-preset-silver');
  if (pSilver) {
    e.preventDefault();
    applyCalculatorPreset('silver');
    haptic(15);
    return;
  }

  const calcShare = e.target.closest('.calc-share-btn');
  if (calcShare) {
    e.preventDefault();
    haptic(15);
    const url = `${location.origin}${location.pathname}#calculator`;
    let title = 'Мои результаты ГТО';
    let text = 'Проверьте свои нормативы ГТО в онлайн-калькуляторе!';
    try {
      const data = JSON.parse(calcShare.dataset.shareData || '{}');
      if (data.badge && data.badge !== 'none') {
        const badgeName = data.badge === 'gold' ? 'Золотой знак отличия ГТО' : data.badge === 'silver' ? 'Серебряный знак отличия ГТО' : 'Бронзовый знак отличия ГТО';
        text = `Я выполнил нормативы на ${badgeName} (${data.stage}, ${data.sex}, ${data.age} лет)!`;
      }
    } catch (err) {}

    if (navigator.share) {
      navigator.share({ title, text, url }).catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(`${text}\n${url}`).then(() => {
        showToast('✓ Результат скопирован в буфер обмена!');
      }).catch(() => {
        showToast('✓ Ссылка скопирована: ' + url);
      });
    } else {
      showToast('✓ Ссылка: ' + url);
    }
    return;
  }

  const pReset = e.target.closest('#calc-preset-reset');
  if (pReset) {
    e.preventDefault();
    state.calcValues = {};
    try { localStorage.removeItem('gto_calc_v1'); } catch (e) {}
    haptic(10);
    renderCalculator();
    showToast('✓ Результаты калькулятора сброшены');
    return;
  }

  const ageMinus = e.target.closest('#calc-age-minus');
  if (ageMinus) {
    e.preventDefault();
    if (state.calcAge > 6) {
      state.calcAge--;
      haptic(10);
      renderCalculator();
    }
    return;
  }

  const agePlus = e.target.closest('#calc-age-plus');
  if (agePlus) {
    e.preventDefault();
    if (state.calcAge < 79) {
      state.calcAge++;
      haptic(10);
      renderCalculator();
    }
    return;
  }

  const setNormBtn = e.target.closest('[data-set-test-val]');
  if (setNormBtn) {
    e.preventDefault();
    const testId = setNormBtn.dataset.testId;
    const targetVal = setNormBtn.dataset.setTestVal;
    haptic(12);
    updateCalculatorValue(testId, targetVal, 'all');
    return;
  }

  const faqCat = e.target.closest('[data-faq-cat]');
  if (faqCat) {
    state.faqCategory = faqCat.dataset.faqCat;
    haptic(10);
    renderFaq();
    return;
  }

  const faqTgl = e.target.closest('[data-faq-toggle]');
  if (faqTgl) {
    const id = faqTgl.dataset.faqToggle;
    if (state.faqExpanded.has(id)) {
      state.faqExpanded.delete(id);
    } else {
      state.faqExpanded.add(id);
    }
    haptic(10);
    renderFaq();
    return;
  }

  const sData = e.target.closest('[data-share-data]');
  if (sData) {
    try {
      const parsed = JSON.parse(sData.dataset.shareData);
      openShareModal(parsed);
    } catch (_) {}
    return;
  }

  // District filter clicks
  const dist = e.target.closest('[data-district]');
  if (dist) {
    state.districtQuery = dist.dataset.district;
    $$('#region-district-chips button').forEach(x => x.classList.toggle('active', x === dist));
    haptic(10);
    renderRegions();
    focusDistrictOnMap(state.districtQuery);
    return;
  }

  // Standards category clicks
  const stdCat = e.target.closest('[data-std-cat]');
  if (stdCat) {
    state.standardCat = stdCat.dataset.stdCat;
    $$('#standards-chips button').forEach(x => x.classList.toggle('active', x === stdCat));
    haptic(10);
    renderStandards();
    return;
  }

  // Quick athlete chips in athlete-search
  const quickAth = e.target.closest('[data-quick-athlete]');
  if (quickAth) {
    haptic(10);
    const qName = quickAth.dataset.quickAthlete;
    state.athleteQuery = qName;
    const input = $('#global-athlete-search');
    if (input) input.value = qName;
    renderAthleteSearch();
    return;
  }

  // Таймер и запись отбора — timer_screen.js (модуль загружен вместе с экраном #timer)
  if (timerMod && timerMod.handleTimerClick(e)) return;

  // Copy 6-week training plan
  const copyPlanBtn = e.target.closest('#calc-copy-plan-btn');
  if (copyPlanBtn) {
    haptic(15);
    const planTextEl = $('#calc-plan-raw-text');
    const textToCopy = planTextEl ? (planTextEl.innerText || planTextEl.textContent).trim() : '';
    if (textToCopy && navigator.clipboard) {
      navigator.clipboard.writeText(textToCopy).then(() => {
        showToast('✓ Персональный 6-недельный план скопирован в буфер!');
      }).catch(() => {
        showToast('Скопируйте текст из карточки плана вручную');
      });
    } else {
      showToast('✓ Персональный 6-недельный план скопирован!');
    }
    return;
  }

  // Regions view switch (Leaderboard / Catalog)
  const rvTab = e.target.closest('[data-regions-view]');
  if (rvTab) {
    haptic(10);
    state.regionsView = rvTab.dataset.regionsView;
    renderRegions();
    return;
  }

  // Regions leaderboard sort
  const rlSortBtn = e.target.closest('[data-rl-sort]');
  if (rlSortBtn) {
    haptic(10);
    state.regionsSortBy = rlSortBtn.dataset.rlSort;
    renderRegionsLeaderboard();
    return;
  }

  // Regions leaderboard row or podium card click -> map sync
  const rlRow = e.target.closest('.rl-table tbody tr[data-region-id], .podium-card[data-region-id]');
  if (rlRow) {
    const regId = Number(rlRow.dataset.regionId);
    if (regId) {
      haptic(15);
      selectRegion(regId, { source: 'search' });
      const mapContainer = $('#russia-map-container');
      if (mapContainer) {
        mapContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
    return;
  }

  const openReg = e.target.closest('[data-open-region-id]');
  if (openReg) {
    hideRegionBottomSheet();
    openRegion(openReg.dataset.openRegionId);
    return;
  }

  const closeSheet = e.target.closest('#region-sheet-close, .bottom-sheet-close, #region-bottom-sheet-backdrop');
  if (closeSheet) {
    hideRegionBottomSheet();
    return;
  }

  const rDot = e.target.closest('#region-map [data-region]');
  if (rDot) { openRegion(rDot.dataset.region); return; }

  const rOpen = e.target.closest('[data-region-open]');
  if (rOpen) { openRegion(rOpen.dataset.regionOpen); return; }

  const p = e.target.closest('[data-photo]');
  if (p) { showPhoto(Number(p.dataset.photoAlbum), Number(p.dataset.photo)); return; }

  if (e.target.closest?.('[data-lightbox-close]') || e.target === $('#lightbox')) { closeLightbox(); return; }
  if (e.target.closest('[data-lightbox-prev]') && state.gallery) { showPhoto(state.gallery.albumIndex, state.gallery.index - 1); return; }
  if (e.target.closest('[data-lightbox-next]') && state.gallery) { showPhoto(state.gallery.albumIndex, state.gallery.index + 1); return; }

  if (e.target.closest?.('#share-close') || e.target === $('#share-modal')) { closeShareModal(); return; }
  if (e.target.closest('#btn-do-share')) { doShareCard(); return; }
  if (e.target.closest('#btn-download-card')) { downloadCard(); return; }

  if (e.target.closest('#pwa-install-btn')) {
    if (state.deferredPrompt) {
      state.deferredPrompt.prompt();
      state.deferredPrompt = null;
    }
    $('#pwa-install-banner').hidden = true; pwaMute(true);
    return;
  }

  if (e.target.closest('#pwa-dismiss-btn')) {
    $('#pwa-install-banner').hidden = true; pwaMute(false);
    return;
  }
});

function debounce(fn, delay = 200) {
  let timer = null;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
}

const debouncedRenderEvents = debounce(() => renderEvents(), 200);
const debouncedRenderNews = debounce(() => renderNews(), 200);
const debouncedRenderResults = debounce(() => renderResultsScreen(), 200);

$('#event-search')?.addEventListener('input', e => {
  state.eventsDisplayLimit = 20;
  state.eventQuery = e.target.value.trim();
  debouncedRenderEvents();
});
$('#event-format')?.addEventListener('change', e => { state.eventsDisplayLimit = 20; state.eventFormat = e.target.value; renderEvents(); });
$('#event-program')?.addEventListener('change', e => { state.eventsDisplayLimit = 20; state.eventProgram = e.target.value; renderEvents(); });
$('#event-city')?.addEventListener('change', e => { state.eventsDisplayLimit = 20; state.eventCity = e.target.value; renderEvents(); });
$('#event-type')?.addEventListener('change', e => { state.eventsDisplayLimit = 20; state.eventType = e.target.value; renderEvents(); });
$('#event-year')?.addEventListener('change', e => { state.eventsDisplayLimit = 20; state.eventYear = e.target.value; renderEvents(); });

$('#news-search')?.addEventListener('input', e => {
  state.newsDisplayLimit = 20;
  state.newsQuery = e.target.value.trim();
  debouncedRenderNews();
});

$('#results-search')?.addEventListener('input', e => {
  state.resultsDisplayLimit = 20;
  state.resultsQuery = e.target.value.trim();
  debouncedRenderResults();
});
$('#results-year-filter')?.addEventListener('change', e => { state.resultsDisplayLimit = 20; state.resultsYear = e.target.value; renderResultsScreen(); });
$('#results-program-filter')?.addEventListener('change', e => { state.resultsDisplayLimit = 20; state.resultsProgram = e.target.value; renderResultsScreen(); });
$('#results-city-filter')?.addEventListener('change', e => { state.resultsDisplayLimit = 20; state.resultsCity = e.target.value; renderResultsScreen(); });

// Доступность: управление с клавиатуры для карточек соревнований
document.addEventListener('keydown', e => {
  if (e.key === 'Enter' || e.key === ' ' || e.code === 'Space') {
    const cardMain = e.target.closest('.event-card-main');
    if (cardMain && cardMain.dataset.event) {
      e.preventDefault();
      openEvent(cardMain.dataset.event, cardMain.dataset.eventPane || 'about');
    }
  }
});
$('#record-search').addEventListener('input', e => { state.recordLimit = 30; state.recordQuery = e.target.value.trim(); renderRecords(); });
$('#region-search').addEventListener('input', e => { state.regionQuery = e.target.value.trim(); renderRegions(); });
$('#record-region')?.addEventListener('change', e => { setRecordRegion(e.target.value); });
$('#record-age').addEventListener('change', e => { state.recordLimit = 30; state.age = e.target.value; renderRecords(); });
$('#record-discipline').addEventListener('change', e => { state.recordLimit = 30; state.discipline = e.target.value; renderRecords(); });
$('#record-group').addEventListener('change', e => { state.recordLimit = 30; state.group = e.target.value; renderRecords(); });
document.addEventListener('change', e => { if (e.target.id === 'calc-age-range') renderCalculator(); });
document.addEventListener('change', e => {
  if (e.target.id === 'event-result-category') {
    state.eventResultCategory = e.target.value; state.eventResultSub = '';
    renderEventResults();
  }
  if (e.target.id === 'event-result-age') {
    state.eventResultAge = e.target.value;
    renderEventResults();
  }
  if (e.target.id === 'event-result-complex') {
    state.eventResultComplex = e.target.value;
    renderEventResults();
  }
  if (e.target.id === 'event-result-region') {
    state.eventResultRegion = e.target.value;
    renderEventResults();
  }
  if (e.target.matches?.('[data-rt-sort-select]')) {
    state.eventResultSort = e.target.value;
    renderEventResults();
  }
});

// Calculator & Camera inputs
document.addEventListener('input', e => {
  if (timerMod && timerMod.handleTimerInput(e)) return;   // запись отбора — timer_screen.js
  if (e.target.id === 'event-result-search') {
    state.eventResultQuery = e.target.value.trim();
    renderEventResults();
    return;
  }
  if (e.target.id === 'faq-search-input') {
    state.faqQuery = e.target.value;
    renderFaq();
    return;
  }
  if (e.target.id === 'calc-age-range') {
    // Плавность: во время перетаскивания обновляем только текст, не перерисовывая слайдер.
    state.calcAge = Number(e.target.value);
    const ageVal = $('#calc-age-val');
    if (ageVal) ageVal.textContent = `${state.calcAge} лет`;
    // нормативы грузятся при открытии калькулятора; ползунок мог сдвинуться раньше — «getStageByAge is not a function» (сторож, 05–07.10)
    if (typeof getStageByAge !== 'function') { ensureNormsData().then(() => e.target.dispatchEvent(new Event('input', { bubbles: true }))).catch(() => {}); return; }
    const stage = getStageByAge(state.calcAge);
    const badge = $('.calc-stage-badge');
    if (badge) badge.textContent = stage.label;
    const info = $('.calc-stage-info b');
    if (info) info.textContent = stage.ageRange;
    return;
  }
  if (e.target.classList && e.target.classList.contains('calc-touch-slider')) {
    const testId = e.target.dataset.testId;
    if (!GTO_STAGES || !calcMod) return;   // калькулятор ещё не загрузил нормативы / модуль
    const tests = calcMod.getActiveCalculatorTests();
    const t = tests.find(x => x.id === testId);
    if (t) {
      const rawNum = parseFloat(e.target.value);
      const formattedVal = t.isTime
        ? calcMod.formatNormVal(t, Math.round(rawNum))
        : (t.lowerIsBetter ? rawNum.toFixed(1) : String(rawNum % 1 === 0 ? rawNum : rawNum.toFixed(1)));
      updateCalculatorValue(testId, formattedVal, 'slider');
    }
    return;
  }
  if (e.target.dataset.testId) {
    updateCalculatorValue(e.target.dataset.testId, e.target.value, 'text');
    return;
  }
  if (e.target.id === 'global-athlete-search') {
    state.athleteQuery = e.target.value;
    renderAthleteSearch();
  }
  if (e.target.id === 'event-athletes-filter') {
    const q = (e.target.value || '').toLowerCase().trim();
    const cards = $$('#event-athletes-list .event-athlete-card');
    cards.forEach(c => {
      const txt = c.textContent.toLowerCase();
      c.style.display = (!q || txt.includes(q)) ? '' : 'none';
    });
  }
});

addEventListener('popstate', () => {
  const fullHash = location.hash || '';
  const tokenMatch = fullHash.match(/[?&]token=([^&]+)/) || (location.search || '').match(/[?&]token=([^&]+)/);
  if (tokenMatch) {
    try { localStorage.setItem('fmgto_hub_token', decodeURIComponent(tokenMatch[1])); } catch (_) {}
  }
  const queryMatch = fullHash.match(/[?&]id=([^&]+)/);
  const queryId = queryMatch ? decodeURIComponent(queryMatch[1]) : null;
  const cleanHash = fullHash.replace(/^#[/]?/, '').split('?')[0];
  const hashParts = cleanHash.split('/');
  let scr = hashParts[0] || 'home';
  if (scr === 'herogto' || scr === 'hero-gto') scr = 'hero';
  const id = hashParts[1] || queryId || null;
  const pane = hashParts[2] || null;

  if (scr === 'athletes') scr = 'athlete';
  if (scr === 'events' && id) scr = 'event';
  if (scr === 'regions' && id) scr = 'region';
  if (scr === 'federations' && id) scr = 'region';

  let restoreScrollY = null;
  // If stack has previous item matching this route, pop the top
  if (appNavigationStack.length > 1) {
    const prev = appNavigationStack[appNavigationStack.length - 2];
    if (prev && prev.screen === scr && (!id || String(prev.params?.id) === String(id))) {
      appNavigationStack.pop();
      restoreScrollY = (typeof prev.scrollY === 'number') ? prev.scrollY : null;
    }
  }

  if (scr === 'event') {
    const eventId = id || state.lastEventId || 104;
    const initialPane = pane || 'about';
    openEvent(eventId, initialPane, false, restoreScrollY);
  } else if (scr === 'article' && id) {
    openArticle(id, false, restoreScrollY);
  } else if (scr === 'region' && id) {
    openRegion(id, false, restoreScrollY);
  } else if (scr === 'athlete' && id) {
    openAthleteProfile(id, false, restoreScrollY);
  } else if ((scr === 'record' || scr === 'records') && id) {
    openRecordDetail(id, false, restoreScrollY);
  } else if (scr === 'ratings') {
    if (id === 'region' && pane) {
      openRatingsRegionDrilldown(pane, hashParts[3] || 'overview', hashParts[4] || 'all');
    } else {
      if (id && ['regions', 'athletes', 'medals', 'teams'].includes(id)) {
        ratingsState.activeTab = id;
      }
      go('ratings', false, restoreScrollY);
    }
  } else {
    go(scr, false, restoreScrollY);
  }
});

window.addEventListener('hashchange', () => {
  window.dispatchEvent(new PopStateEvent('popstate'));
});


$('#nearest-region').addEventListener('click', () => {
  if (!navigator.geolocation) return;
  $('#nearest-region').textContent = 'Определяем…';
  navigator.geolocation.getCurrentPosition(pos => {
    const rad = x => x * Math.PI / 180;
    const dist = f => {
      const [a, b] = f.coords || [];
      if (!a) return Infinity;
      const dlat = rad(a - pos.coords.latitude), dlon = rad(b - pos.coords.longitude);
      return 6371 * 2 * Math.asin(Math.sqrt(Math.sin(dlat / 2) ** 2 + Math.cos(rad(pos.coords.latitude)) * Math.cos(rad(a)) * Math.sin(dlon / 2) ** 2));
    };
    const nearest = GTO_FEDERATIONS.filter(f => f.coords).sort((a, b) => dist(a) - dist(b))[0];
    $('#nearest-region').textContent = `Ближайшее: ${nearest.region} · ${Math.round(dist(nearest))} км`;
    openRegion(nearest.id);
  }, () => {
    $('#nearest-region').textContent = 'Не удалось получить геопозицию';
  });
});

let swipeX = 0;
document.addEventListener('touchstart', e => {
  if (!state.gallery) return;
  const touch = e.touches[0];
  if (touch && touch.clientX <= 30) return; // Leave native iOS edge swipe gesture intact
  swipeX = touch.clientX;
}, { passive: true });
document.addEventListener('touchend', e => {
  if (!state.gallery) return;
  const dx = e.changedTouches[0].clientX - swipeX;
  if (Math.abs(dx) > 45) showPhoto(state.gallery.albumIndex, state.gallery.index + (dx < 0 ? 1 : -1));
}, { passive: true });

addEventListener('keydown', e => {
  if (e.key === 'Escape') {
    closeLightbox();
    closeShareModal();
    return;
  }
  const shareModal = $('#share-modal');
  if (shareModal && !shareModal.hidden && e.key === 'Tab') {
    const controls = [...shareModal.querySelectorAll('button:not([disabled]), a[href]')];
    if (!controls.length) return;
    const i = controls.indexOf(document.activeElement);
    if (e.shiftKey && i <= 0) { e.preventDefault(); controls.at(-1).focus(); }
    else if (!e.shiftKey && i === controls.length - 1) { e.preventDefault(); controls[0].focus(); }
    return;
  }
  if (!state.gallery) return;
  if (e.key === 'Tab') {
    const controls = [...$$('#lightbox button')];
    if (!controls.length) return;
    const i = controls.indexOf(document.activeElement);
    if (e.shiftKey && i <= 0) { e.preventDefault(); controls.at(-1).focus(); }
    else if (!e.shiftKey && i === controls.length - 1) { e.preventDefault(); controls[0].focus(); }
  }
  if (e.key === 'ArrowRight') showPhoto(state.gallery.albumIndex, state.gallery.index + 1);
  if (e.key === 'ArrowLeft') showPhoto(state.gallery.albumIndex, state.gallery.index - 1);
});

// PWA and Connectivity
// «Установить приложение»: закрыли — не показываем 30 дней, установили — больше не показываем
const PWA_KEY = 'fmgto_pwa_dismissed';
const pwaMuted = () => { try { const t = Number(localStorage.getItem(PWA_KEY) || 0); return t && (t < 0 || Date.now() - t < 30 * 864e5); } catch (_) { return false; } };
const pwaMute = (forever) => { try { localStorage.setItem(PWA_KEY, forever ? '-1' : String(Date.now())); } catch (_) {} };
// «Установить приложение» (08.10.2026, жалоба участницы: плашки «много-много раз»): не в первый визит, не вместе с плашкой
// cookie, не чаще раза за визит; «×» — 30 дней тишины (pwaMute). На iOS beforeinstallprompt нет — подсказку не показываем.
const PWA_VISITS = 'fmgto_visits';
let pwaShownThisVisit = false;
try {
  if (!sessionStorage.getItem('fmgto_visit_counted')) {
    sessionStorage.setItem('fmgto_visit_counted', '1');
    localStorage.setItem(PWA_VISITS, String(Number(localStorage.getItem(PWA_VISITS) || 0) + 1));
  }
} catch (_) { /* хранилища нет — визиты не считаем, плашку не показываем */ }
function pwaMayShow() {
  if (pwaShownThisVisit || pwaMuted() || document.getElementById('cookie-notice')) return false;
  try { return Number(localStorage.getItem(PWA_VISITS) || 0) >= 2; } catch (_) { return false; }
}
window.addEventListener('beforeinstallprompt', e => {
  e.preventDefault();
  state.deferredPrompt = e;
  const banner = $('#pwa-install-banner');
  if (banner && pwaMayShow()) { banner.hidden = false; pwaShownThisVisit = true; }
});

window.addEventListener('online', () => { const el = $('#offline-badge'); if (el) el.hidden = true; });
window.addEventListener('offline', () => { const el = $('#offline-badge'); if (el) el.hidden = false; });
if (!navigator.onLine) { const el = $('#offline-badge'); if (el) el.hidden = false; }


function syncDatasetCounts() {
  // табло цифр на Главной (телефон и ПК) — только kinetic.js из /api/health; здесь его больше не трогаем

  // пока справочник отделений не загружен, длина 0 — не затираем верные цифры из разметки нулём
  const feds = regionalFedCount();   // без центрального аппарата (code RU) — только региональные отделения
  const moreFacts = $$('[data-screen="more"] .fact-grid b');
  if (moreFacts[2] && feds > 0) moreFacts[2].textContent = String(feds);
  const regionLink = $('[data-screen="more"] .link-stack [data-go="regions"] small');
  if (regionLink && feds > 0) regionLink.textContent = `${feds} ${ruPlural(feds, 'отделение', 'отделения', 'отделений')} — адреса и контакты`;

  const offline = $('#offline-badge');
  const offlineText = offline ? [...offline.childNodes].find(node => node.nodeType === Node.TEXT_NODE && /старт/.test(node.nodeValue || '')) : null;
  if (offlineText) offlineText.nodeValue = ` · Все ${GTO_CALENDAR_EVENTS.length} стартов, рекорды и фото доступны из кэша`;
  const athleteScope = $('#athlete-search-count')?.nextElementSibling;
  if (athleteScope) athleteScope.textContent = `${(state.athleteIndex?.length || 4152).toLocaleString('ru-RU')} профилей`;
}

async function init() {
  syncFactGrids();   // «Ещё»: сводные цифры вместо вписанных вручную
  syncDatasetCounts();
  $$('.search > span').forEach(icon => {
    icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-4-4"></path></svg>';
  });
  $$('.search input').forEach(input => {
    if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', input.placeholder || 'Поиск');
  });
  // Load secondary media metadata in background without blocking initial app startup
  Promise.all([
    fetch('./data/events/manifest.json?v=25').then(r => r.json()),
    fetch('./data/vk_media.json?v=25').then(r => r.json()),
    fetch('./data/video_thumbs.json?v=25').then(r => r.json())
  ]).then(([events, vk, thumbs]) => {
    state.eventManifest = events;
    state.vkLocal = vk;
    state.videoThumbs = thumbs;
  }).catch(() => {});

  const fullHash = location.hash || '';
  const tokenMatch = fullHash.match(/[?&]token=([^&]+)/) || (location.search || '').match(/[?&]token=([^&]+)/);
  if (tokenMatch) {
    try { localStorage.setItem('fmgto_hub_token', decodeURIComponent(tokenMatch[1])); } catch (_) {}
  }
  const queryMatch = fullHash.match(/[?&]id=([^&]+)/);
  const queryId = queryMatch ? decodeURIComponent(queryMatch[1]) : null;
  const rawHash = fullHash.replace(/^#[/]?/, '').split('?')[0];
  const hashParts = rawHash.split('/');
  let scr = hashParts[0] || 'home';
  if (scr === 'herogto' || scr === 'hero-gto') scr = 'hero';
  const id = hashParts[1] || queryId || null;
  const pane = hashParts[2] || null;

  if (scr === 'athletes') scr = 'athlete';
  if (scr === 'events' && id) scr = 'event';
  if (scr === 'regions' && id) scr = 'region';
  if (scr === 'federations' && id) scr = 'region';
  appNavigationStack.length = 0;
  appNavigationStack.push({ screen: scr, params: { id, pane } });

  // Прямая ссылка (#ratings, #event/5…): пока грузятся данные (рейтинг — 6,5 МБ), сразу показываем нужный
  // раздел с «Загружаем…», а не главную — иначе кажется, что ссылка ведёт не туда.
  const bootEl = scr !== 'home' ? $(`.screen[data-screen="${scr}"]`) : null;
  if (bootEl) {
    $$('.screen').forEach(x => x.classList.toggle('active', x === bootEl));
    bootEl.dataset.booting = '1';
  }

  await ensureScreenData(scr);
  if (bootEl) delete bootEl.dataset.booting;

  // Пока грузились данные стартового экрана, человек мог уже нажать «Старты» или открыть ссылку.
  // Раньше стартовый go(scr) после await перебивал его выбор и возвращал на главную.
  const userNavigatedDuringBoot = (location.hash || '') !== fullHash;

  if (userNavigatedDuringBoot) {
    // экран уже открыт обработчиком клика/hashchange — ничего не перерисовываем
  } else if (scr === 'event') {
    const eventId = id || state.lastEventId || 104;
    const initialPane = pane || 'about';
    openEvent(eventId, initialPane, false);
  } else if (scr === 'article' && id) {
    openArticle(id, false);
  } else if (scr === 'region' && id) {
    openRegion(id, false);
  } else if (scr === 'team' && id) {
    openTeam(decodeURIComponent(id), false);
  } else if (scr === 'athlete' && id) {
    openAthleteProfile(id, false);
  } else if ((scr === 'record' || scr === 'records') && id) {
    openRecordDetail(id, false);
  } else if (scr === 'ratings') {
    if (id === 'region' && pane) {
      openRatingsRegionDrilldown(pane, hashParts[3] || 'overview', hashParts[4] || 'all');
    } else {
      if (id && ['regions', 'athletes', 'medals', 'teams'].includes(id)) {
        ratingsState.activeTab = id;
      }
      go('ratings', false);
    }
  } else {
    go(scr, false);
  }
  renderModeratorBar();
  // Страховка стартового экрана: на телефоне прямая ссылка #hero иногда оставалась пустой (гонка при загрузке:
  // отрисовка кабинета пропускалась, модуль не запрашивался). Если hash всё ещё ведёт в кабинет, а он пуст — дорисовываем.
  setTimeout(() => {
    const cur = (location.hash || '').replace(/^#[/]?/, '').split(/[/?]/)[0] || 'home';
    const heroRoot = $('#hero-gto-root');
    if ((cur === 'hero' || cur === 'herogto' || cur === 'hero-gto') && heroRoot && !heroRoot.innerHTML.trim()) initHeroGtoScreen();
  }, 800);

  // слушатели рейтинга вешаются при первой загрузке модуля (ensureRatingsModule)

  const scrollTopBtn = $('#scroll-top-btn');
  if (scrollTopBtn) {
    let scrollScheduled = false;
    window.addEventListener('scroll', () => {
      if (!scrollScheduled) {
        scrollScheduled = true;
        requestAnimationFrame(() => {
          scrollScheduled = false;
          const show = window.scrollY > 350;
          scrollTopBtn.hidden = !show;
          scrollTopBtn.classList.toggle('visible', show);
        });
      }
    }, { passive: true });
    scrollTopBtn.addEventListener('click', () => {
      haptic(10);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
  // признак «приложение загрузилось» — для автотестов и отладки
  document.documentElement.dataset.appReady = '1';
  // Web Push: карточка «Уведомления» на экране «Ещё» (модуль грузится после старта, чтобы не задерживать первый экран)
  setTimeout(() => import('./push_client.js?v=e74c50b2').then(m => m.initPushCard()).catch(() => {}), 1500);
}

init();
// плашка про cookie — после запуска страницы, чтобы не задерживать первый экран (cookie_notice.js?v=c1aac28d)
import('./metrika.js?v=45bdad14').then((m) => m.initMetrika()).catch(() => {});   // Метрика — только с номером счётчика (metrika.js?v=45bdad14)
import('./cookie_notice.js?v=c1aac28d').then((m) => m.mountCookieNotice()).catch(() => {});

window.addEventListener('gto-ecosystem-sync', () => {
  if (state.screen === 'records') {
    renderRecords();
  }
});

// сайт обновился. Новая версия применяется сама, когда это незаметно: до первого касания после запуска или когда
// вкладку/приложение свернули — если ничего не начато вводить, не открыто окно и не снимает камера «Героя ГТО».
// Иначе — плашка «Обновить»: человек мог уйти в почту за кодом входа, перезагрузка стёрла бы введённое.
let formDirty = false;
document.addEventListener('input', (e) => { if (e.target.matches?.('input:not([type=search]), textarea, select')) formDirty = true; }, true);
function safeToReload() {
  return !formDirty && !document.querySelector('.identity-overlay, .pdf-viewer, [aria-modal="true"]') && ![...document.querySelectorAll('video')].some((v) => v.srcObject);
}
// Новая версия (08.10.2026, жалоба участницы: «просит обновить сайт много-много раз»): без плашки — тихая перезагрузка
// при следующей смене экрана или сворачивании, если ничего не вводится и не открыт диалог. Не чаще раза в 2 минуты на
// вкладку (sessionStorage) — без петли, если новый воркер ещё не взял управление. Плашка — только если человек 2 минуты
// так и не вышел из формы.
const UPDATE_RELOAD_KEY = 'fmgto_update_reload_at';
function reloadForUpdate() {
  try {
    if (Date.now() - Number(sessionStorage.getItem(UPDATE_RELOAD_KEY) || 0) < 120000) return false;
    sessionStorage.setItem(UPDATE_RELOAD_KEY, String(Date.now()));
  } catch (_) { /* без хранилища — просто перезагружаем */ }
  location.reload();
  return true;
}
function onAppUpdate() {
  if (!userActive && safeToReload()) { reloadForUpdate(); return; }
  const tryNow = () => { if (safeToReload() && reloadForUpdate()) stop(); };
  const onVis = () => { if (document.visibilityState === 'hidden') tryNow(); };
  const timer = setTimeout(() => { if (!safeToReload()) offerAppUpdate(); }, 120000);
  function stop() { window.removeEventListener('hashchange', tryNow); document.removeEventListener('visibilitychange', onVis); clearTimeout(timer); }
  window.addEventListener('hashchange', tryNow);
  document.addEventListener('visibilitychange', onVis);
}
function offerAppUpdate() {
  if (document.querySelector('.app-update-bar')) return;
  const bar = document.createElement('div');
  bar.className = 'app-update-bar'; bar.setAttribute('role', 'status');
  bar.innerHTML = '<span>Доступна новая версия сайта</span><button type="button" data-act="reload">Обновить</button><button type="button" class="aub-x" aria-label="Скрыть">×</button>';
  bar.querySelector('.aub-x').addEventListener('click', () => bar.remove());
  // «Обновить» не делал ничего — у кнопки не было обработчика, плашка висела и после нажатия (Соня, 16.10.2026)
  bar.querySelector('[data-act="reload"]').addEventListener('click', () => {
    try { sessionStorage.setItem(UPDATE_RELOAD_KEY, String(Date.now())); } catch (_) { /* без хранилища — просто перезагружаем */ }
    bar.remove(); location.reload();
  });
  document.body.appendChild(bar);
}
const hadController = 'serviceWorker' in navigator && Boolean(navigator.serviceWorker.controller);
if ('serviceWorker' in navigator) {
  // Graceful updates: do NOT reload the page during an active user session.
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    console.info('[PWA] Service Worker controller updated.');
    if (hadController) onAppUpdate();   // первая установка — не обновление
    fetchHubNews().then(() => {
      if (state.screen === 'home') renderHome();
      else if (state.screen === 'news') renderNews();
    }).catch(() => {});
  });
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'NEW_VERSION') {
      console.info('[PWA] New version ready.');
      fetchHubNews().then(() => {
        if (state.screen === 'home') renderHome();
        else if (state.screen === 'news') renderNews();
      }).catch(() => {});
    }
  });
  addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js', { updateViaCache: 'none' }).then((reg) => {
      // проверка обновления на плохой сети падает — это не ошибка сайта (раньше попадала в журнал как «Failed to update a ServiceWorker»)
      const check = () => reg.update().catch(() => {});
      check();
      setInterval(check, 60000);
    }).catch(() => {});
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      navigator.serviceWorker.getRegistration().then(reg => reg && reg.update()).catch(() => {});
    }
  });
  if (typeof window !== 'undefined') {
    window.__GTO_APP_READY__ = true;
  }
}

// фоновое видео главной: только когда открыта главная, на быстрой сети и без «уменьшить движение».
// Файл выбирается при первом запуске: на широком экране и экранах с высокой плотностью — 1080p (≈20 МБ), иначе 720p (≈8 МБ).
// Раньше оно качалось на любой странице (главная в DOM всегда, просто скрыта) — больше половины трафика «Новостей».
function syncHeroVideo() {
  const v = $('.hero video'); if (!v) return;
  if (state.screen !== 'home') { if (!v.paused) v.pause(); return; }
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const c = navigator.connection || {};
  if (c.saveData || /(^|[^4])(2g|3g)$/.test(String(c.effectiveType || ''))) return;
  if (!v.getAttribute('src')) v.src = (innerWidth >= 900 || innerWidth * (window.devicePixelRatio || 1) >= 1300) && v.dataset.srcWide ? v.dataset.srcWide : v.dataset.src;
  if (v.paused) (window.requestIdleCallback || ((cb) => setTimeout(cb, 1500)))(() => { if (state.screen === 'home') v.play().catch(() => {}); }, { timeout: 2500 });
}
addEventListener('load', syncHeroVideo);

window.addEventListener('gto-ecosystem-sync', (e) => {
  try {
    if (state.screen === 'home') renderHome();
    else if (state.screen === 'news') renderNews();
    else if (state.screen === 'records') renderRecords();
    else if (state.screen === 'events') renderEvents();
  } catch (_) {}
});
